export default {
    "scalars": [
        1,
        5,
        7,
        8,
        9,
        11,
        12,
        15,
        21,
        23,
        27,
        28,
        36,
        38,
        41,
        68,
        77,
        81,
        118,
        124,
        125,
        128,
        132,
        135,
        147,
        153,
        156,
        162,
        165,
        166,
        175,
        178,
        182,
        184,
        185,
        186,
        187,
        189,
        191,
        195,
        197,
        200,
        201,
        205,
        208,
        213,
        217,
        219,
        222,
        223,
        227,
        228,
        232,
        240,
        241,
        243,
        244,
        245,
        246,
        252,
        253,
        256,
        257,
        258,
        259,
        260,
        263,
        264,
        265,
        266,
        268,
        269,
        278,
        280,
        299,
        300,
        301,
        314,
        325,
        326,
        328,
        334,
        337,
        340,
        347,
        358,
        407,
        409,
        412,
        413,
        415,
        427,
        445,
        455,
        463,
        464,
        470,
        471,
        472,
        474,
        475,
        499,
        549,
        561,
        562,
        581,
        642,
        654,
        657,
        664,
        668,
        670,
        674,
        679,
        681,
        705,
        719,
        725,
        738,
        739,
        742,
        745,
        751,
        752,
        753,
        760,
        762,
        765,
        768,
        803,
        805,
        815,
        898,
        910,
        911,
        919,
        923,
        941,
        959,
        960,
        971,
        989,
        999,
        1002,
        1003,
        1043,
        1047,
        1048,
        1050,
        1052,
        1053,
        1068,
        1072,
        1078,
        1079,
        1086,
        1096,
        1104,
        1110,
        1111,
        1113,
        1128,
        1129,
        1136,
        1138,
        1142,
        1144,
        1145,
        1150,
        1151,
        1155,
        1156,
        1158,
        1160,
        1161,
        1165,
        1170,
        1180,
        1186,
        1193,
        1194,
        1195,
        1224,
        1227,
        1232,
        1241,
        1242,
        1250,
        1253,
        1278,
        1279,
        1289,
        1292,
        1295,
        1296,
        1303,
        1306,
        1307,
        1310,
        1311,
        1312,
        1313,
        1314,
        1315,
        1316,
        1317,
        1321,
        1323,
        1324,
        1326,
        1327,
        1330,
        1331,
        1334,
        1335,
        1338,
        1339,
        1343,
        1344,
        1345,
        1346,
        1347,
        1352,
        1357,
        1363,
        1366,
        1371,
        1372,
        1401,
        1415,
        1425,
        1431,
        1436,
        1440,
        1442,
        1444,
        1469,
        1470,
        1471,
        1476,
        1492,
        1494,
        1495,
        1498,
        1501,
        1502,
        1507,
        1508,
        1509,
        1510,
        1518,
        1527,
        1528,
        1537,
        1539,
        1542,
        1546,
        1548,
        1549,
        1558,
        1560,
        1565,
        1570,
        1577,
        1580,
        1584,
        1585,
        1586,
        1587,
        1599,
        1607,
        1631,
        1635,
        1637,
        1638,
        1639,
        1645,
        1646,
        1647,
        1649,
        1655,
        1680,
        1681,
        1686,
        1688,
        1691,
        1695,
        1700,
        1703,
        1714,
        1719,
        1721,
        1742,
        1762,
        1772,
        1773,
        1777,
        1779,
        1780,
        1784,
        1786,
        1802,
        1803,
        1804,
        1805,
        1807,
        1816,
        1820,
        1821,
        1825,
        1853,
        1854,
        1865,
        1871,
        1874,
        1875,
        1882,
        1906,
        1907,
        1912,
        1913,
        1914,
        1919,
        1926,
        1961,
        1962,
        1963,
        1966,
        1983,
        2018,
        2035,
        2046,
        2075,
        2079,
        2093,
        2094,
        2096,
        2103,
        2106,
        2112,
        2128,
        2139,
        2144,
        2150,
        2162,
        2164,
        2165,
        2167,
        2179,
        2180,
        2196,
        2213,
        2235,
        2236,
        2312,
        2365,
        2373,
        2374,
        2386,
        2388,
        2389,
        2390,
        2394,
        2400,
        2403,
        2415,
        2421,
        2430,
        2431,
        2432,
        2448,
        2459,
        2460,
        2462,
        2474,
        2476,
        2486,
        2490,
        2498,
        2501,
        2507
    ],
    "types": {
        "AcceptedInviteCompanyInfo": {
            "id": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "String": {},
        "AcceptInvitationArgs": {
            "invitationCode": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AcceptInvitationResponse": {
            "userInvitation": [
                2344
            ],
            "__typename": [
                1
            ]
        },
        "AccountBalance": {
            "accountRole": [
                1
            ],
            "balance": [
                5
            ],
            "asOfDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "Float": {},
        "AccountingInfo": {
            "isSalesAffecting": [
                7
            ],
            "isCogsAffecting": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "Boolean": {},
        "AccountingMethod": {},
        "AccountingServicesTypes": {},
        "AccountRole": {
            "name": [
                1
            ],
            "groupId": [
                1
            ],
            "isClearingAccount": [
                7
            ],
            "reportsHierarchy": [
                1904
            ],
            "__typename": [
                1
            ]
        },
        "AccountState": {},
        "AccountStatus": {},
        "AccountValidation": {
            "openingBalanceValue": [
                5
            ],
            "lastValidAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "accountState": [
                11
            ],
            "potentialOpeningValue": [
                5
            ],
            "status": [
                12
            ],
            "madePrivateAt": [
                581
            ],
            "accountBalanceDiffValue": [
                5
            ],
            "lastMetricCreatedAt": [
                581
            ],
            "lastMetricEventTime": [
                581
            ],
            "companyIntegrationLastSuccessfulUpdate": [
                581
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Accrual": {
            "id": [
                15
            ],
            "accrualsData": [
                18
            ],
            "bankTransactionId": [
                15
            ],
            "companyId": [
                15
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "archivedAt": [
                581
            ],
            "createdBy": [
                38
            ],
            "createdById": [
                1
            ],
            "latestActorType": [
                38
            ],
            "latestActorId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ID": {},
        "AccrualCategorizationInput": {
            "bankTransactionId": [
                15
            ],
            "merchant": [
                1409
            ],
            "classifications": [
                17
            ],
            "recommendations": [
                388
            ],
            "__typename": [
                1
            ]
        },
        "AccrualClassificationInput": {
            "amount": [
                5
            ],
            "amountInPercentage": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "affiliatedEntityId": [
                15
            ],
            "classificationTagId": [
                15
            ],
            "classificationText": [
                15
            ],
            "businessEvent": [
                1
            ],
            "pairedEntityId": [
                1
            ],
            "pairedEntityType": [
                1637
            ],
            "pairingType": [
                1638
            ],
            "askTheUserResult": [
                1242
            ],
            "extraData": [
                1242
            ],
            "description": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AccrualData": {
            "classificationTagId": [
                15
            ],
            "businessEventType": [
                1
            ],
            "spreadType": [
                2106
            ],
            "residualAmount": [
                5
            ],
            "specificDate": [
                2097
            ],
            "spreadOverTime": [
                2104
            ],
            "customSpread": [
                567
            ],
            "customSpreadOptions": [
                569
            ],
            "defaultFixedAssetsData": [
                593
            ],
            "customFixedAssetsData": [
                565
            ],
            "canceledAt": [
                581
            ],
            "canceledBy": [
                1
            ],
            "canceledAccrualsData": [
                366
            ],
            "__typename": [
                1
            ]
        },
        "AccrualDataInput": {
            "classificationTagId": [
                1
            ],
            "businessEventType": [
                1
            ],
            "spreadType": [
                2106
            ],
            "specificDate": [
                2098
            ],
            "spreadOverTime": [
                2105
            ],
            "customSpread": [
                568
            ],
            "customSpreadOptions": [
                570
            ],
            "defaultFixedAssetsData": [
                594
            ],
            "customFixedAssetsData": [
                566
            ],
            "__typename": [
                1
            ]
        },
        "AccrualEntity": {
            "on_BankTransaction": [
                270
            ],
            "on_Bill": [
                312
            ],
            "__typename": [
                1
            ]
        },
        "AccrualEntityType": {},
        "AccrualRecordResponse": {
            "spreadItems": [
                24
            ],
            "totalAmount": [
                5
            ],
            "amountAsOfDate": [
                5
            ],
            "businessEventType": [
                1
            ],
            "entity": [
                20
            ],
            "source": [
                23
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "category": [
                1
            ],
            "depreciationMethod": [
                642
            ],
            "depreciationType": [
                2103
            ],
            "depreciationPeriod": [
                1
            ],
            "vendor": [
                1
            ],
            "entityDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "AccrualRecordSource": {},
        "AccrualRecordSpreadItem": {
            "date": [
                581
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "AccrualsSpread": {
            "id": [
                1
            ],
            "amount": [
                5
            ],
            "postedAt": [
                581
            ],
            "endDate": [
                581
            ],
            "classificationTag": [
                392
            ],
            "businessEventType": [
                1
            ],
            "isRemainingExpenses": [
                7
            ],
            "isResidualAmount": [
                7
            ],
            "fixedAssetsOptions": [
                756
            ],
            "__typename": [
                1
            ]
        },
        "AccrualsSpreadResponse": {
            "amount": [
                5
            ],
            "postedAt": [
                581
            ],
            "endDate": [
                581
            ],
            "classificationTag": [
                392
            ],
            "bankTransaction": [
                270
            ],
            "businessEventType": [
                1
            ],
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "accrualId": [
                1
            ],
            "bankTransactionId": [
                15
            ],
            "isRemainingExpenses": [
                7
            ],
            "isResidualAmount": [
                7
            ],
            "fixedAssetsOptions": [
                756
            ],
            "spreadBasisType": [
                2103
            ],
            "__typename": [
                1
            ]
        },
        "AccrualsStatus": {},
        "AccrualType": {},
        "AccrualV2": {
            "id": [
                15
            ],
            "accrualsData": [
                18
            ],
            "entity": [
                20
            ],
            "entityType": [
                21
            ],
            "entityId": [
                15
            ],
            "companyId": [
                15
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "archivedAt": [
                581
            ],
            "createdBy": [
                38
            ],
            "createdById": [
                1
            ],
            "latestActorType": [
                38
            ],
            "latestActorId": [
                1
            ],
            "spreads": [
                25
            ],
            "__typename": [
                1
            ]
        },
        "AckInvalidNoUnitsValidationInput": {
            "companyId": [
                15
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "quantityDiff": [
                5
            ],
            "costDiff": [
                5
            ],
            "businessEventsCostDiff": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "AcknowledgeLoansChanges": {
            "loans": [
                1287
            ],
            "__typename": [
                1
            ]
        },
        "AcknowledgeLoansChangesInput": {
            "loans": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "AcknowledgeUnitsTrackingPhysicalCountProductQuantitiesAmountsInput": {
            "companyId": [
                1
            ],
            "physicalCountId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ActionChange": {
            "accountRole": [
                1
            ],
            "accountRoleV2": [
                10
            ],
            "moneyDirection": [
                36
            ],
            "__typename": [
                1
            ]
        },
        "ActionChangeInput": {
            "accountRole": [
                1
            ],
            "moneyDirection": [
                36
            ],
            "__typename": [
                1
            ]
        },
        "ActionChangeMoneyDirection": {},
        "ActorContextInput": {
            "actorType": [
                38
            ],
            "actorId": [
                1
            ],
            "classifiedAt": [
                581
            ],
            "metadata": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "ActorType": {},
        "Ad": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "name": [
                1
            ],
            "status": [
                1
            ],
            "insights": [
                64
            ],
            "__typename": [
                1
            ]
        },
        "AdAccount": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "externalId": [
                15
            ],
            "adPlatform": [
                1762
            ],
            "adBusinessId": [
                1
            ],
            "updatedAt": [
                581
            ],
            "name": [
                1
            ],
            "status": [
                1
            ],
            "paymentMethod": [
                1
            ],
            "timezoneOffset": [
                41
            ],
            "rollingBalance": [
                5
            ],
            "currency": [
                1
            ],
            "minDailyBudget": [
                41
            ],
            "adCampaigns": [
                43
            ],
            "__typename": [
                1
            ]
        },
        "Int": {},
        "AdAccountInput": {
            "companyId": [
                15
            ],
            "page": [
                41
            ],
            "status": [
                1
            ],
            "platform": [
                1762
            ],
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AdCampaign": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "status": [
                1
            ],
            "endTime": [
                581
            ],
            "companyId": [
                15
            ],
            "startTime": [
                581
            ],
            "adAccount": [
                40
            ],
            "dailyBudget": [
                5
            ],
            "lifetimeBudget": [
                5
            ],
            "remainingBudget": [
                5
            ],
            "clicks": [
                41
            ],
            "impressions": [
                41
            ],
            "reach": [
                41
            ],
            "spend": [
                5
            ],
            "adSets": [
                69
            ],
            "__typename": [
                1
            ]
        },
        "AdCampaignInput": {
            "companyId": [
                15
            ],
            "page": [
                41
            ],
            "status": [
                1
            ],
            "platform": [
                1762
            ],
            "name": [
                1
            ],
            "dateFrom": [
                581
            ],
            "dateTo": [
                581
            ],
            "adAccountId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "AddBankTransactionAttachmentInput": {
            "companyId": [
                15
            ],
            "bankTransactionId": [
                15
            ],
            "attachmentLink": [
                1
            ],
            "attachmentName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AddClassificationTagInput": {
            "name": [
                1
            ],
            "moneyDirection": [
                1436
            ],
            "isHidden": [
                7
            ],
            "isRelevantToBills": [
                7
            ],
            "isRelevantToApplyAlways": [
                7
            ],
            "displayNameForReports": [
                1
            ],
            "keywords": [
                1
            ],
            "moneyInBusinessEvent": [
                15
            ],
            "moneyOutBusinessEvent": [
                15
            ],
            "isApplicableForRefund": [
                7
            ],
            "reportsDisplayNameForTagSelection": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AddCompanyToParkerUserArgs": {
            "companyId": [
                1
            ],
            "companyName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AddDepreciationBonus": {
            "date": [
                581
            ],
            "percent": [
                5
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "AddDepreciationBonusInput": {
            "date": [
                1
            ],
            "percent": [
                5
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "AdditionalErrorInfo": {
            "expectedValue": [
                1
            ],
            "actualValue": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AddMissingBillsTask": {
            "id": [
                334
            ],
            "status": [
                337
            ],
            "stateKey": [
                1
            ],
            "state": [
                52
            ],
            "history": [
                53
            ],
            "__typename": [
                1
            ]
        },
        "AddMissingBillsTaskState": {
            "markedAsCompletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "AddMissingBillsTaskStateChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                2507
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                52
            ],
            "newValue": [
                52
            ],
            "__typename": [
                1
            ]
        },
        "AddMissingInvoicesTask": {
            "id": [
                1224
            ],
            "status": [
                1227
            ],
            "stateKey": [
                1
            ],
            "state": [
                55
            ],
            "history": [
                56
            ],
            "__typename": [
                1
            ]
        },
        "AddMissingInvoicesTaskState": {
            "markedAsCompletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "AddMissingInvoicesTaskStateChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                2507
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                55
            ],
            "newValue": [
                55
            ],
            "__typename": [
                1
            ]
        },
        "AddPriorYearAdjustmentInput": {
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "Address": {
            "country": [
                1
            ],
            "state": [
                1
            ],
            "city": [
                1
            ],
            "postalCode": [
                1
            ],
            "line1": [
                1
            ],
            "line2": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AddressArgs": {
            "country": [
                1
            ],
            "state": [
                1
            ],
            "city": [
                1
            ],
            "postalCode": [
                1
            ],
            "line1": [
                1
            ],
            "line2": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AddRoleToAffiliatedEntityInput": {
            "companyId": [
                15
            ],
            "sourceEntityOneOf": [
                75
            ],
            "role": [
                427
            ],
            "metadata": [
                61
            ],
            "__typename": [
                1
            ]
        },
        "AddRoleToAffiliatedEntityMetadataInput": {
            "creatorEmail": [
                1
            ],
            "source": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AddRoleToAffiliatedEntityResult": {
            "createdEntityId": [
                15
            ],
            "affiliatedEntity": [
                72
            ],
            "__typename": [
                1
            ]
        },
        "AdInsight": {
            "adId": [
                15
            ],
            "companyId": [
                15
            ],
            "date": [
                581
            ],
            "country": [
                1
            ],
            "region": [
                1
            ],
            "impressions": [
                41
            ],
            "spend": [
                5
            ],
            "clicks": [
                41
            ],
            "cpm": [
                5
            ],
            "ctr": [
                5
            ],
            "cpc": [
                5
            ],
            "reach": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "AdInsightsByDate": {
            "date": [
                581
            ],
            "metrics": [
                63
            ],
            "__typename": [
                1
            ]
        },
        "AdjustmentRestockingAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "salesChannel": [
                2398
            ],
            "sku": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AdjustmentsReason": {
            "code": [
                1
            ],
            "quantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "AdjustmentsValidation": {
            "adjustments": [
                1855
            ],
            "cogs": [
                1855
            ],
            "source": [
                1855
            ],
            "diff": [
                1855
            ],
            "isValid": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "AdjustmentType": {},
        "AdSet": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "name": [
                1
            ],
            "status": [
                1
            ],
            "startTime": [
                581
            ],
            "endTime": [
                581
            ],
            "adAccount": [
                40
            ],
            "adCampaign": [
                43
            ],
            "dailyBudget": [
                5
            ],
            "lifetimeBudget": [
                5
            ],
            "remainingBudget": [
                5
            ],
            "impressions": [
                41
            ],
            "spend": [
                5
            ],
            "clicks": [
                41
            ],
            "cpm": [
                5
            ],
            "ctr": [
                5
            ],
            "cpc": [
                5
            ],
            "frequency": [
                5
            ],
            "reach": [
                41
            ],
            "conversions": [
                41
            ],
            "ads": [
                39
            ],
            "__typename": [
                1
            ]
        },
        "AdSetInput": {
            "companyId": [
                15
            ],
            "page": [
                41
            ],
            "status": [
                1
            ],
            "platform": [
                1762
            ],
            "name": [
                1
            ],
            "dateFrom": [
                581
            ],
            "dateTo": [
                581
            ],
            "adAccountId": [
                15
            ],
            "adCampaignId": [
                15
            ],
            "country": [
                1
            ],
            "region": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AffectedTransactionsIds": {
            "transactionsIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "AffiliatedEntity": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "institutions": [
                1074
            ],
            "name": [
                1
            ],
            "companyAffiliates": [
                422
            ],
            "holders": [
                1034
            ],
            "safeHolders": [
                1917
            ],
            "relatedParties": [
                1894
            ],
            "unpaidInventoryAmount": [
                5
            ],
            "lenders": [
                1446
            ],
            "employees": [
                673
            ],
            "contractors": [
                487
            ],
            "vendors": [
                2375
            ],
            "__typename": [
                1
            ]
        },
        "AffiliatedEntityByIdInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "AffiliatedEntityByIdsInput": {
            "ids": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "AffiliateSourceInput": {
            "affiliatedEntityId": [
                15
            ],
            "companyAffiliateId": [
                15
            ],
            "vendorId": [
                15
            ],
            "institutionId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "AgingAggregationItem": {
            "preset": [
                1570
            ],
            "balance": [
                5
            ],
            "count": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "AllowClassificationForVersion": {},
        "AllSkusInput": {
            "companyId": [
                15
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "breakdown": [
                1
            ],
            "timezone": [
                1
            ],
            "comparisonPeriod": [
                1
            ],
            "stores": [
                1
            ],
            "sources": [
                2096
            ],
            "salesChannels": [
                1
            ],
            "searchText": [
                1
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "sortBy": [
                80
            ],
            "__typename": [
                1
            ]
        },
        "AllSkusResponse": {
            "title": [
                1
            ],
            "updatedAt": [
                581
            ],
            "data": [
                2090
            ],
            "sources": [
                2096
            ],
            "__typename": [
                1
            ]
        },
        "AllSkusSortBy": {
            "field": [
                81
            ],
            "direction": [
                2094
            ],
            "__typename": [
                1
            ]
        },
        "AllSkusSortField": {},
        "AlterBankTransactionsLifecycleStateInput": {
            "companyId": [
                15
            ],
            "bankTransactionIds": [
                15
            ],
            "actorType": [
                38
            ],
            "actorId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AlterBankTransactionsLifecycleStateResult": {
            "processedIds": [
                15
            ],
            "unprocessed": [
                84
            ],
            "__typename": [
                1
            ]
        },
        "AlterBankTransactionsLifecycleStateUnprocessedResult": {
            "id": [
                15
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AmazonAvailableMarketplace": {
            "displayName": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "marketplaceId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AmazonAvailableValidationDataInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "AmazonAvailableValidationDataResponse": {
            "integrationAccountIdsData": [
                88
            ],
            "__typename": [
                1
            ]
        },
        "AmazonIntegrationAccountIdAvailableData": {
            "availableMarketplaces": [
                85
            ],
            "shipmentsReportEndTime": [
                581
            ],
            "returnsReportEndTime": [
                581
            ],
            "integrationAccountId": [
                1
            ],
            "impactOnBooksSince": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "AmazonOrdersDiffResponse": {
            "data": [
                1241
            ],
            "__typename": [
                1
            ]
        },
        "AmazonProduct": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "finaloopId": [
                1
            ],
            "lineOfBusinessId": [
                1
            ],
            "sku": [
                1
            ],
            "price": [
                5
            ],
            "displayName": [
                1
            ],
            "imageUrl": [
                1
            ],
            "listedChannels": [
                1940
            ],
            "appliedCosts": [
                1771
            ],
            "dailySalesData": [
                1942,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "totalSold": [
                41
            ],
            "avgCostPerUnit": [
                5
            ],
            "asin": [
                1
            ],
            "canEditLatestAppliedCost": [
                7
            ],
            "isFractional": [
                7
            ],
            "isHidden": [
                7
            ],
            "salesData": [
                1959,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "rawRecipes": [
                1861,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "componentOfProducts": [
                1769
            ],
            "isAmbiguousSku": [
                7
            ],
            "analyticsOverview": [
                1770,
                {
                    "input": [
                        110
                    ]
                }
            ],
            "warehousesAnalyticsOverview": [
                1837,
                {
                    "input": [
                        110
                    ]
                }
            ],
            "tags": [
                1
            ],
            "isCreatedManually": [
                7
            ],
            "isDataSyncing": [
                7
            ],
            "mergeHistory": [
                1799
            ],
            "isDropshipping": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "AmazonProductsReconciliationResponse": {
            "validationId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AmazonProductsValidationReadyResponse": {
            "checkStartTime": [
                581
            ],
            "checkEndTime": [
                581
            ],
            "data": [
                102
            ],
            "summary": [
                101
            ],
            "isTrackstarConnected": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "AmazonReconciliationAdjustmentsData": {
            "onlyAdjustments": [
                7
            ],
            "adjustments": [
                5
            ],
            "sourceAdjustments": [
                5
            ],
            "adjustmentsDiff": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "AmazonReconciliationEntityData": {
            "restocked": [
                41
            ],
            "mfn": [
                41
            ],
            "afn": [
                41
            ],
            "totalSold": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "AmazonReconciliationEntityEntityValidationStatus": {
            "restockedDiff": [
                41
            ],
            "afnDiff": [
                41
            ],
            "mfnDiff": [
                41
            ],
            "mcfDiff": [
                41
            ],
            "reportDiff": [
                41
            ],
            "totalDiff": [
                41
            ],
            "adjustmentsDiff": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "AmazonReconciliationProductData": {
            "unitsSold": [
                41
            ],
            "unitsRestocked": [
                41
            ],
            "unitsGiveaway": [
                41
            ],
            "ambiguousSkuQuantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "AmazonReconciliationProductValidationStatus": {
            "soldDiff": [
                41
            ],
            "restockedDiff": [
                41
            ],
            "totalDiff": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "AmazonReconciliationRestockedReportData": {
            "mcf": [
                41
            ],
            "afn": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "AmazonReconciliationSalesOrderIds": {
            "recentInvoices": [
                1
            ],
            "oldInvoices": [
                1
            ],
            "notInTimeRange": [
                1
            ],
            "mfn": [
                1
            ],
            "afn": [
                1
            ],
            "all": [
                1
            ],
            "restocked": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AmazonReconciliationSalesReportData": {
            "recentInvoices": [
                41
            ],
            "oldInvoices": [
                41
            ],
            "notInTimeRange": [
                41
            ],
            "mcf": [
                41
            ],
            "afn": [
                41
            ],
            "total": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "AmazonReconciliationSummary": {
            "entityData": [
                94
            ],
            "entityValidationStatus": [
                95
            ],
            "salesReportData": [
                100
            ],
            "restocksReportData": [
                98
            ],
            "productData": [
                96
            ],
            "productValidationStatus": [
                97
            ],
            "adjustmentsData": [
                93
            ],
            "__typename": [
                1
            ]
        },
        "AmazonSkuReconciliationData": {
            "comments": [
                1
            ],
            "sku": [
                1
            ],
            "orderIds": [
                99
            ],
            "summary": [
                101
            ],
            "__typename": [
                1
            ]
        },
        "AmazonValidationAdjustSkuQuantitiesInput": {
            "companyId": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "marketplaceId": [
                1
            ],
            "sku": [
                1
            ],
            "reportQuantity": [
                41
            ],
            "finaloopQuantity": [
                41
            ],
            "orderId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AmazonValidationInput": {
            "startTime": [
                581
            ],
            "endTime": [
                581
            ],
            "integrationAccountId": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "companyId": [
                15
            ],
            "marketplaceId": [
                1
            ],
            "ignoreCached": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "AmountRange": {
            "from": [
                5
            ],
            "to": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "AmountRangeInput": {
            "from": [
                5
            ],
            "to": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "Amounts": {
            "amount": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "currency": [
                549
            ],
            "__typename": [
                1
            ]
        },
        "AnalyticsEventDedupKey": {
            "key": [
                1
            ],
            "ttlSeconds": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "AnalyticsEventsData": {
            "name": [
                1
            ],
            "data": [
                1241
            ],
            "dedupKey": [
                108
            ],
            "__typename": [
                1
            ]
        },
        "AnalyticsOverviewInput": {
            "asOfDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "AnyActiveProductWithoutQuantities": {
            "anyActiveProductWithoutQuantities": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "APAccountBalance": {
            "accountRole": [
                1
            ],
            "balance": [
                5
            ],
            "asOfDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "AppendProcessingLogToBankTransactionsUploadInput": {
            "companyId": [
                15
            ],
            "bankTransactionsUploadId": [
                1
            ],
            "originFileId": [
                1
            ],
            "processingLog": [
                298
            ],
            "status": [
                301
            ],
            "__typename": [
                1
            ]
        },
        "ApplyInventoryPurchaseRulesInput": {
            "companyId": [
                15
            ],
            "operations": [
                115
            ],
            "__typename": [
                1
            ]
        },
        "ApplyInventoryPurchaseRulesOperation": {
            "id": [
                1
            ],
            "affiliatedEntityId": [
                1
            ],
            "categoryName": [
                1136
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "condition": [
                1145
            ],
            "amount": [
                5
            ],
            "operation": [
                1144
            ],
            "__typename": [
                1
            ]
        },
        "ApplyNoUnitsPhysicalCountProductQuantitiesPendingAdjustmentsInput": {
            "physicalCountId": [
                1
            ],
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ApplyPendingSalesDataAdjustmentsInput": {
            "companyId": [
                15
            ],
            "managementMethodId": [
                1
            ],
            "mode": [
                118
            ],
            "type": [
                1780
            ],
            "salesChannels": [
                1946
            ],
            "__typename": [
                1
            ]
        },
        "ApplyPendingSalesDataAdjustmentsMode": {},
        "ApplyPendingWarehouseOpeningBalanceInput": {
            "companyId": [
                15
            ],
            "date": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ApplySalesChannelChangesInput": {
            "companyId": [
                15
            ],
            "add": [
                1941
            ],
            "update": [
                1958
            ],
            "delete": [
                1944
            ],
            "__typename": [
                1
            ]
        },
        "ApplySalesChannelChangesResult": {
            "success": [
                7
            ],
            "salesChannels": [
                1945
            ],
            "__typename": [
                1
            ]
        },
        "ArtificialTransactionsByMonth": {
            "type": [
                124
            ],
            "integrationType": [
                1
            ],
            "count": [
                41
            ],
            "sum": [
                5
            ],
            "month": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "ArtificialTransactionsByMonthResponse": {
            "payments": [
                122
            ],
            "refunds": [
                122
            ],
            "__typename": [
                1
            ]
        },
        "ArtificialTransactionsType": {},
        "AskTheUserFlowType": {},
        "AskTheUserNotificationInput": {
            "companyId": [
                15
            ],
            "notificationType": [
                128
            ],
            "notificationData": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "AskTheUserNotificationServiceResult": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "AskTheUserNotificationType": {},
        "AskTheUserResult": {
            "type": [
                1
            ],
            "data": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "AssembledByMap": {
            "id": [
                1
            ],
            "assembled": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "Assembly": {
            "companyId": [
                15
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "amount": [
                5
            ],
            "assemblyItems": [
                133
            ],
            "inventoryPaymentGroupLinks": [
                1121
            ],
            "unpaidAmounts": [
                2211
            ],
            "__typename": [
                1
            ]
        },
        "AssemblyDeletedReason": {},
        "AssemblyItem": {
            "on_ManualAssembly": [
                1373
            ],
            "on_OnDemandAssemblyVendorCosts": [
                1481
            ],
            "__typename": [
                1
            ]
        },
        "AssemblyListItem": {
            "type": [
                135
            ],
            "date": [
                581
            ],
            "amount": [
                5
            ],
            "recipe": [
                1861
            ],
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "AssemblyType": {},
        "AssignCompanyToUser": {
            "email": [
                1
            ],
            "companyId": [
                1
            ],
            "roles": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AssignCompanyToUserResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "AttachmentTargetURL": {
            "fileName": [
                1
            ],
            "url": [
                1
            ],
            "signedUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "AttachmentTargetURLS": {
            "signedUrls": [
                138
            ],
            "__typename": [
                1
            ]
        },
        "AttachRelationsToLoanInput": {
            "ids": [
                15
            ],
            "loanId": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "AttachTransactionToCompanyLoanTransactionInput": {
            "transactionId": [
                1
            ],
            "classifications": [
                511
            ],
            "__typename": [
                1
            ]
        },
        "AttemptToClassifyTransactionsInput": {
            "classificationRequests": [
                390
            ],
            "actorContext": [
                37
            ],
            "__typename": [
                1
            ]
        },
        "Auth0UserLookupInput": {
            "email": [
                1
            ],
            "accessKey": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Auth0UserLookupResponse": {
            "exists": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "AwaitedExportResponse": {
            "requestId": [
                1
            ],
            "status": [
                719
            ],
            "signedUrl": [
                1
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BackOfficeBankStatementRequestsFiltersResponse": {
            "years": [
                1
            ],
            "tiers": [
                463
            ],
            "statuses": [
                263
            ],
            "types": [
                265
            ],
            "__typename": [
                1
            ]
        },
        "BackOfficeCreateBankReconciliationRequestType": {},
        "BalanceAdjustment": {
            "value": [
                5
            ],
            "forDate": [
                1
            ],
            "actorType": [
                162
            ],
            "actorId": [
                1
            ],
            "createdAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BalanceByCurrency": {
            "currency": [
                1
            ],
            "balance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "BalanceLocation": {
            "balance": [
                5
            ],
            "balanceAtIso": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BalanceSheetDependency": {
            "blocked": [
                7
            ],
            "resolvedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BalanceSheetItem": {
            "state": [
                158
            ],
            "data": [
                1242
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BalanceSheetItemType": {},
        "BalanceSheetSetup": {
            "id": [
                15
            ],
            "state": [
                159
            ],
            "userUnresponsive": [
                2359
            ],
            "isPreviewEnabled": [
                7
            ],
            "email": [
                1
            ],
            "intercomLink": [
                1
            ],
            "items": [
                157
            ],
            "__typename": [
                1
            ]
        },
        "BalanceSheetSetupInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BalanceSheetSetupItemErrorMessage": {},
        "BalanceSheetSetupItems": {
            "businessAndTaxInformation": [
                152
            ],
            "banks": [
                152
            ],
            "loans": [
                152
            ],
            "taxReturnDocument": [
                152
            ],
            "balanceSheetDocument": [
                152
            ],
            "acquisitionAgreementDocument": [
                152
            ],
            "__typename": [
                1
            ]
        },
        "BalanceSheetSetupItemStateResponse": {
            "value": [
                1048
            ],
            "history": [
                1049
            ],
            "__typename": [
                1
            ]
        },
        "BalanceSheetSetupStateResponse": {
            "value": [
                1050
            ],
            "history": [
                1051
            ],
            "__typename": [
                1
            ]
        },
        "BalanceSheetStatus": {
            "status": [
                1
            ],
            "updatedAt": [
                581
            ],
            "updatedBy": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankAccount": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "integrationAccountId": [
                15
            ],
            "source": [
                1113
            ],
            "externalSourceId": [
                1
            ],
            "externalInstitutionId": [
                1
            ],
            "type": [
                191
            ],
            "subtype": [
                189
            ],
            "currency": [
                1
            ],
            "currentBalance": [
                5
            ],
            "institution": [
                1074
            ],
            "institutionId": [
                1
            ],
            "institutionName": [
                1
            ],
            "name": [
                1
            ],
            "fullName": [
                1
            ],
            "displayName": [
                1
            ],
            "mask": [
                1
            ],
            "connectedAt": [
                581
            ],
            "isHistoricalUpdateCompleted": [
                7
            ],
            "isMissingHistoricalTransactions": [
                7
            ],
            "userSaidThereAreNoMissingTransactions": [
                7
            ],
            "locks": [
                170
            ],
            "rawData": [
                1242
            ],
            "closingBalanceLogs": [
                164
            ],
            "balanceAdjustments": [
                148
            ],
            "latestAccountingEventIds": [
                1
            ],
            "transactionsImportStatus": [
                190
            ],
            "deletedByUserAt": [
                581
            ],
            "deletedByUserId": [
                1
            ],
            "createdAt": [
                581
            ],
            "createdBy": [
                1
            ],
            "shouldUpdateAccountDetailsOnNextUpdate": [
                7
            ],
            "vendor": [
                2375
            ],
            "duplicateOfBankAccountId": [
                1
            ],
            "hasRecurringMission": [
                7
            ],
            "lockStatus": [
                173,
                {
                    "year": [
                        41
                    ]
                }
            ],
            "accountValidation": [
                13
            ],
            "markedAsClosedByCustomerAt": [
                581
            ],
            "forwardTransactionsToBankAccountId": [
                1
            ],
            "isManagedByFinaloop": [
                7
            ],
            "hasNotifiedUponNoHistoricalUpdate": [
                7
            ],
            "accountRole": [
                1
            ],
            "connectionStatus": [
                166
            ],
            "accountStatus": [
                195
            ],
            "status": [
                187
            ],
            "institutionLogo": [
                1
            ],
            "integrationType": [
                1113
            ],
            "deletedAt": [
                581
            ],
            "deletedBy": [
                1
            ],
            "isManual": [
                7
            ],
            "isRefreshRequired": [
                7
            ],
            "isDisconnected": [
                7
            ],
            "convertedToManualAt": [
                581
            ],
            "convertedToManualBy": [
                1
            ],
            "transactionsCount": [
                41,
                {
                    "fromDate": [
                        581
                    ],
                    "untilDate": [
                        581
                    ]
                }
            ],
            "minimumTransactionDate": [
                581,
                {
                    "fromBooksStartTime": [
                        7
                    ]
                }
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountBalanceAdjustmentActorType": {},
        "BankAccountBalanceInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                15
            ],
            "balanceDateInISO": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountClosingBalance": {
            "value": [
                5
            ],
            "forDate": [
                1
            ],
            "actorType": [
                165
            ],
            "actorId": [
                1
            ],
            "createdAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountClosingBalanceActorType": {},
        "BankAccountConnectionStatus": {},
        "BankAccountEventIdsInput": {
            "bankAccountId": [
                15
            ],
            "eventIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountInternalInput": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountLock": {
            "type": [
                1
            ],
            "startTime": [
                581
            ],
            "endTime": [
                581
            ],
            "lockedAt": [
                581
            ],
            "actorType": [
                38
            ],
            "actorId": [
                1
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountLockByTypeInput": {
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "lockedAt": [
                581
            ],
            "actorType": [
                38
            ],
            "actorId": [
                1
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountLockInput": {
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "lockedAt": [
                581
            ],
            "actorType": [
                38
            ],
            "actorId": [
                1
            ],
            "type": [
                1
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountLockStatus": {
            "lockedAt": [
                581
            ],
            "minimumAllowedEventTime": [
                581
            ],
            "year": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountNewOwner": {
            "type": [
                175
            ],
            "id": [
                15
            ],
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountNewOwnerType": {},
        "BankAccountReconciliation": {
            "id": [
                15
            ],
            "bankAccount": [
                161
            ],
            "companyId": [
                1
            ],
            "status": [
                178
            ],
            "transactionsFileLocations": [
                737
            ],
            "statementFileLocations": [
                737
            ],
            "balanceLocation": [
                150
            ],
            "reconciliationDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountReconciliationsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountReconciliationStatus": {},
        "BankAccountsByIdsInput": {
            "companyId": [
                15
            ],
            "bankAccountIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountsInput": {
            "companyId": [
                15
            ],
            "sources": [
                1113
            ],
            "statuses": [
                187
            ],
            "types": [
                191
            ],
            "subtypes": [
                189
            ],
            "withDisabled": [
                7
            ],
            "withDeleted": [
                7
            ],
            "withDuplicate": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountsInternalInput": {
            "bankAccountIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountStatementFileType": {},
        "BankAccountStatementRequest": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "bankAccount": [
                233
            ],
            "type": [
                186
            ],
            "subType": [
                185
            ],
            "customerData": [
                234
            ],
            "finaloopData": [
                247
            ],
            "status": [
                184
            ],
            "fileNames": [
                1
            ],
            "displayedBalance": [
                5
            ],
            "csvUploads": [
                548
            ],
            "balanceId": [
                1
            ],
            "markedAsClosedByCustomerAt": [
                581
            ],
            "lockedStatus": [
                1353
            ],
            "originalBankAccountId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountStatementRequestStatus": {},
        "BankAccountStatementRequestSubType": {},
        "BankAccountStatementRequestType": {},
        "BankAccountStatus": {},
        "BankAccountStopImportNewOwner": {
            "id": [
                1
            ],
            "type": [
                175
            ],
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountSubtype": {},
        "BankAccountTransactionsImportStatus": {
            "changedBy": [
                1
            ],
            "changedAt": [
                581
            ],
            "stopImportFromDate": [
                581
            ],
            "balanceAtStopImportFromDate": [
                5
            ],
            "newOwner": [
                188
            ],
            "__typename": [
                1
            ]
        },
        "BankAccountType": {},
        "BankConnection": {
            "companyId": [
                15
            ],
            "integrationType": [
                1113
            ],
            "integrationAccountId": [
                15
            ],
            "institutionName": [
                1
            ],
            "institutionId": [
                1
            ],
            "institutionLogo": [
                1
            ],
            "isTest": [
                7
            ],
            "accounts": [
                161
            ],
            "isRefreshRequired": [
                7
            ],
            "isDisconnected": [
                7
            ],
            "syncStatus": [
                202
            ],
            "impactOnBooksSince": [
                581
            ],
            "deletedAt": [
                581
            ],
            "deletedBy": [
                1
            ],
            "status": [
                201
            ],
            "__typename": [
                1
            ]
        },
        "BankConnectionAccount": {
            "id": [
                15
            ],
            "minimumTransactionDate": [
                581,
                {
                    "fromBooksStartTime": [
                        7
                    ]
                }
            ],
            "__typename": [
                1
            ]
        },
        "BankConnectionAccountLock": {
            "startTime": [
                581
            ],
            "endTime": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BankConnectionAccountStatus": {},
        "BankConnectionAccountTransactionsImportStatus": {
            "changedBy": [
                1
            ],
            "changedAt": [
                581
            ],
            "stopImportFromDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BankConnectionMetricsEventType": {},
        "BankConnectionMetricsInput": {
            "companyId": [
                15
            ],
            "eventType": [
                197
            ],
            "integrationAccountId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankConnectionsInput": {
            "companyId": [
                15
            ],
            "withDeleted": [
                7
            ],
            "withDuplicate": [
                7
            ],
            "sources": [
                1113
            ],
            "statuses": [
                187
            ],
            "accountTypes": [
                191
            ],
            "accountSubtypes": [
                189
            ],
            "__typename": [
                1
            ]
        },
        "BankConnectionSortType": {},
        "BankConnectionStatus": {},
        "BankConnectionSyncStatus": {
            "lastSuccessfulTransactionsUpdate": [
                581
            ],
            "lastFailedTransactionsUpdate": [
                581
            ],
            "updatedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BankDetails": {
            "name": [
                1
            ],
            "lastFourDigits": [
                1
            ],
            "type": [
                1
            ],
            "missingBank": [
                7
            ],
            "accountName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankingAudit": {
            "entityType": [
                1
            ],
            "entityId": [
                1
            ],
            "field": [
                1
            ],
            "beforeValue": [
                1
            ],
            "afterValue": [
                1
            ],
            "timestamp": [
                581
            ],
            "correlationId": [
                1
            ],
            "action": [
                205
            ],
            "__typename": [
                1
            ]
        },
        "BankingAuditAction": {},
        "BankingAuditsInput": {
            "entityType": [
                1
            ],
            "entityId": [
                1
            ],
            "field": [
                1
            ],
            "action": [
                205
            ],
            "__typename": [
                1
            ]
        },
        "BankingMetric": {
            "companyId": [
                15
            ],
            "eventTime": [
                581
            ],
            "eventType": [
                1
            ],
            "integrationType": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "data": [
                1241
            ],
            "__typename": [
                1
            ]
        },
        "BankingMetricEventType": {},
        "BankingMetricInput": {
            "companyId": [
                1
            ],
            "eventTime": [
                581
            ],
            "eventType": [
                208
            ],
            "integrationType": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "data": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "BankingMissionResult": {
            "hasMissions": [
                7
            ],
            "hasBankConnectionMissions": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "BankOverviewPageAccount": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "bankAccount": [
                161
            ],
            "virtualCurrencies": [
                1
            ],
            "balancesByCurrency": [
                149
            ],
            "isTestAccount": [
                7
            ],
            "syncStatus": [
                202
            ],
            "connectionStatus": [
                1631
            ],
            "reconciliationStatus": [
                1882
            ],
            "accountCurrentBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "BankOverviewPageInput": {
            "companyId": [
                15
            ],
            "withDeleted": [
                7
            ],
            "sources": [
                1113
            ],
            "accountTypes": [
                191
            ],
            "accountSubtypes": [
                189
            ],
            "accountIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BankReconciliationConfigurableRequestType": {},
        "BankReconciliationGraphPoint": {
            "date": [
                581
            ],
            "source": [
                1
            ],
            "actualBalance": [
                5
            ],
            "finaloopBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "BankReconciliationGraphPointsInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BankReconciliationRequest": {
            "id": [
                15
            ],
            "bankAccount": [
                161
            ],
            "companyId": [
                1
            ],
            "company": [
                418
            ],
            "requestType": [
                265
            ],
            "requestCategory": [
                260
            ],
            "originalBankAccountId": [
                1
            ],
            "resolutionComment": [
                1
            ],
            "internalMessage": [
                1
            ],
            "finaloopMessage": [
                1
            ],
            "finaloopMessageSender": [
                1
            ],
            "expectedStartDate": [
                581
            ],
            "expectedEndDate": [
                581
            ],
            "customerSelectedDate": [
                581
            ],
            "booksBalanceAtDate": [
                5
            ],
            "customerBalanceByStatement": [
                5
            ],
            "customerConfirmedBooksBalanceAtDate": [
                7
            ],
            "resolutionType": [
                258
            ],
            "customerForceSubmitted": [
                7
            ],
            "irrelevantReason": [
                257
            ],
            "transferredEntity": [
                259
            ],
            "configurationId": [
                1
            ],
            "defaultEndDate": [
                581
            ],
            "status": [
                263
            ],
            "isBankAccountValid": [
                7
            ],
            "latestActorId": [
                1
            ],
            "latestActorType": [
                38
            ],
            "statementFiles": [
                1881
            ],
            "hasTransactionsBeforeBSD": [
                7
            ],
            "completedStandardOpeningBalance": [
                7
            ],
            "accountCurrentBalance": [
                5
            ],
            "lastAccountTransaction": [
                1245
            ],
            "isAccountValidOnSubmission": [
                7
            ],
            "isOngoingReconciliation": [
                7
            ],
            "createdById": [
                1
            ],
            "createdByActorType": [
                38
            ],
            "deletedAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "completedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BankReconciliationRequestCategory": {},
        "BankReconciliationRequestConfiguration": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "bankAccount": [
                161
            ],
            "requestType": [
                213
            ],
            "requestCategory": [
                217
            ],
            "recurrence": [
                223
            ],
            "startDate": [
                581
            ],
            "lastRunAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "createdById": [
                1
            ],
            "createdByActorType": [
                38
            ],
            "updatedAt": [
                581
            ],
            "latestActorId": [
                1
            ],
            "latestActorType": [
                38
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BankReconciliationRequestFilesStatus": {},
        "BankReconciliationRequestFiltersInput": {
            "statusCategory": [
                227
            ],
            "requestTypes": [
                742
            ],
            "requestCategories": [
                217
            ],
            "withDeleted": [
                7
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "BankReconciliationRequestInput": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankReconciliationRequestMachineStatus": {},
        "BankReconciliationRequestRecurrence": {},
        "BankReconciliationRequestSettingsInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                15
            ],
            "requestTypes": [
                228
            ],
            "tiers": [
                463
            ],
            "withDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "BankReconciliationRequestSettingsResponse": {
            "configurations": [
                218
            ],
            "requests": [
                216
            ],
            "__typename": [
                1
            ]
        },
        "BankReconciliationRequestsInput": {
            "ids": [
                1
            ],
            "companyId": [
                1
            ],
            "bankAccountIds": [
                1
            ],
            "filters": [
                220
            ],
            "__typename": [
                1
            ]
        },
        "BankReconciliationRequestStatusCategories": {},
        "BankReconciliationSettingsRequestTypes": {},
        "BankReconciliationStatementAutoProcessingResultsInput": {
            "companyId": [
                1
            ],
            "requestId": [
                1
            ],
            "status": [
                232
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementAccountHolder": {
            "firstName": [
                1
            ],
            "lastName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementAccountHolderInput": {
            "firstName": [
                1
            ],
            "lastName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementAutoProcessingStatus": {},
        "BankStatementBankAccount": {
            "id": [
                15
            ],
            "integrationAccountId": [
                15
            ],
            "name": [
                1
            ],
            "type": [
                191
            ],
            "subtype": [
                189
            ],
            "institutionName": [
                1
            ],
            "institutionId": [
                1
            ],
            "currency": [
                1
            ],
            "mask": [
                1
            ],
            "source": [
                1113
            ],
            "transactionsImportStatus": [
                2166
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementCustomerData": {
            "fileNames": [
                1
            ],
            "csvFileNames": [
                1
            ],
            "noCSVFiles": [
                7
            ],
            "noPDFFiles": [
                7
            ],
            "displayedBalance": [
                5
            ],
            "realBalance": [
                5
            ],
            "cycleStart": [
                581
            ],
            "cycleEnd": [
                581
            ],
            "isConfirmed": [
                7
            ],
            "irrelevantReason": [
                1
            ],
            "irrelevantType": [
                1232
            ],
            "isMachineReconciled": [
                7
            ],
            "newOwner": [
                1
            ],
            "newOwnerType": [
                175
            ],
            "newOwnerId": [
                1
            ],
            "newOwnerName": [
                1
            ],
            "bankDetails": [
                203
            ],
            "transferDate": [
                581
            ],
            "closedDate": [
                581
            ],
            "relatedMissionId": [
                1
            ],
            "isIntegrationTransfers": [
                7
            ],
            "isClosedThisYear": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementFile": {
            "id": [
                15
            ],
            "bankAccount": [
                161
            ],
            "bankStatementRequestId": [
                1
            ],
            "companyId": [
                1
            ],
            "fileName": [
                1
            ],
            "s3Bucket": [
                1
            ],
            "s3Key": [
                1
            ],
            "fileType": [
                182
            ],
            "originalBankAccountId": [
                1
            ],
            "originFileId": [
                1
            ],
            "uploadOriginator": [
                266
            ],
            "uploadedAt": [
                581
            ],
            "uploadedByActor": [
                38
            ],
            "uploadedById": [
                1
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "status": [
                243
            ],
            "processingLogs": [
                238
            ],
            "companyAffiliateType": [
                1
            ],
            "companyAffiliateId": [
                1
            ],
            "system": [
                246
            ],
            "subSystem": [
                244
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementFileByCompanyIdInput": {
            "companyId": [
                15
            ],
            "bankAccountIds": [
                15
            ],
            "withPayoutTopUpFilter": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementFileByIdInput": {
            "companyId": [
                15
            ],
            "fileId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementFileProcessingLog": {
            "processorType": [
                241
            ],
            "state": [
                240
            ],
            "processorId": [
                1
            ],
            "metadata": [
                1242
            ],
            "message": [
                1
            ],
            "createdAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementFileProcessingLogInput": {
            "processorType": [
                241
            ],
            "processorId": [
                1
            ],
            "state": [
                240
            ],
            "message": [
                1
            ],
            "metadata": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementFileProcessingLogState": {},
        "BankStatementFileProcessorType": {},
        "BankStatementFilesInput": {
            "withPayoutTopUpFilter": [
                7
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementFileStatus": {},
        "BankStatementFileSubSystem": {},
        "BankStatementFilesValidationProvider": {},
        "BankStatementFileSystem": {},
        "BankStatementFinaloopData": {
            "comment": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementParsedTransaction": {
            "date": [
                1
            ],
            "description": [
                1
            ],
            "amount": [
                5
            ],
            "runningBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementParsedTransactionInput": {
            "date": [
                1
            ],
            "description": [
                1
            ],
            "amount": [
                5
            ],
            "runningBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementParsingRequest": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "bankTransactionsUploadId": [
                1
            ],
            "bankStatementFileId": [
                1
            ],
            "provider": [
                252
            ],
            "providerModel": [
                1
            ],
            "queryVersion": [
                41
            ],
            "requestPayload": [
                1242
            ],
            "runStatus": [
                253
            ],
            "rawResponse": [
                1242
            ],
            "startTime": [
                581
            ],
            "endTime": [
                581
            ],
            "responseTimeMs": [
                5
            ],
            "failureReason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementParsingRequestInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "bankTransactionsUploadId": [
                1
            ],
            "bankStatementFileId": [
                1
            ],
            "provider": [
                252
            ],
            "providerModel": [
                1
            ],
            "queryVersion": [
                41
            ],
            "requestPayload": [
                1242
            ],
            "runStatus": [
                253
            ],
            "rawResponse": [
                1242
            ],
            "startTime": [
                581
            ],
            "endTime": [
                581
            ],
            "responseTimeMs": [
                5
            ],
            "failureReason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementParsingRequestsProvider": {},
        "BankStatementParsingRequestsRunStatus": {},
        "BankStatementParsingResult": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "bankStatementParsingRequestId": [
                1
            ],
            "bankTransactionsUploadId": [
                1
            ],
            "bankStatementFileId": [
                1
            ],
            "provider": [
                252
            ],
            "providerModel": [
                1
            ],
            "queryVersion": [
                41
            ],
            "status": [
                256
            ],
            "institutionName": [
                1
            ],
            "accountName": [
                1
            ],
            "mask": [
                1
            ],
            "openingBalance": [
                5
            ],
            "closingBalance": [
                5
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "isReconciled": [
                7
            ],
            "isReconciledByProvider": [
                7
            ],
            "transactions": [
                248
            ],
            "accountHolders": [
                230
            ],
            "transactionsCount": [
                41
            ],
            "totalTransactionsAmount": [
                5
            ],
            "balanceChange": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementParsingResultsInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "bankStatementParsingRequestId": [
                1
            ],
            "bankTransactionsUploadId": [
                1
            ],
            "bankStatementFileId": [
                1
            ],
            "provider": [
                252
            ],
            "providerModel": [
                1
            ],
            "queryVersion": [
                41
            ],
            "institutionName": [
                1
            ],
            "accountName": [
                1
            ],
            "mask": [
                1
            ],
            "openingBalance": [
                5
            ],
            "closingBalance": [
                5
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "isReconciled": [
                7
            ],
            "isReconciledByProvider": [
                7
            ],
            "transactions": [
                249
            ],
            "accountHolders": [
                231
            ],
            "transactionsCount": [
                41
            ],
            "totalTransactionsAmount": [
                5
            ],
            "balanceChange": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementParsingResultStatus": {},
        "BankStatementReconciliationIrrelevantReason": {},
        "BankStatementReconciliationResolutionType": {},
        "BankStatementReconciliationTransferredEntity": {},
        "BankStatementRequestCategory": {},
        "BankStatementRequestResolutionInput": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "resolutionType": [
                258
            ],
            "irrelevantReason": [
                257
            ],
            "transferredEntity": [
                259
            ],
            "customerConfirmedBooksBalanceAtDate": [
                7
            ],
            "customerBalanceByStatement": [
                5
            ],
            "customerSelectedDate": [
                581
            ],
            "booksBalanceAtDate": [
                5
            ],
            "statementFiles": [
                2107
            ],
            "forceSubmit": [
                7
            ],
            "fileIds": [
                1
            ],
            "originator": [
                266
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementRequestResolutionResponse": {
            "status": [
                263
            ],
            "submissionStatus": [
                264
            ],
            "fileValidationStatus": [
                219
            ],
            "fileIds": [
                1
            ],
            "errors": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementRequestStatus": {},
        "BankStatementRequestSubmissionStatus": {},
        "BankStatementRequestType": {},
        "BankStatementResolutionOriginator": {},
        "BankStatementValidationResults": {
            "fileId": [
                15
            ],
            "runStatus": [
                268
            ],
            "failureReason": [
                1
            ],
            "matchConfidence": [
                5
            ],
            "matchedComponents": [
                269
            ],
            "institution": [
                1
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "openingBalance": [
                5
            ],
            "closingBalance": [
                5
            ],
            "accountNumber": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankStatementValidationRunStatus": {},
        "BankStatementVerificationComponents": {},
        "BankTransaction": {
            "id": [
                15
            ],
            "accrual": [
                14
            ],
            "companyId": [
                15
            ],
            "bankAccount": [
                161
            ],
            "postedAt": [
                581
            ],
            "amount": [
                5
            ],
            "currency": [
                1
            ],
            "amountInUsd": [
                5
            ],
            "merchant": [
                1405
            ],
            "businessEvent": [
                272
            ],
            "classificationMetadata": [
                381
            ],
            "description": [
                1
            ],
            "processedByMachineAt": [
                581
            ],
            "lastProcessedByMachineAt": [
                581
            ],
            "applyingClassificationJobId": [
                1
            ],
            "source": [
                1
            ],
            "sourceSpecificData": [
                1242
            ],
            "userMemo": [
                283
            ],
            "attachments": [
                271
            ],
            "classificationVersion": [
                41
            ],
            "deletedAt": [
                581
            ],
            "recommendations": [
                286
            ],
            "loan": [
                453
            ],
            "loanInfo": [
                2163
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionAttachment": {
            "signedUrl": [
                1
            ],
            "url": [
                1
            ],
            "name": [
                1
            ],
            "addedBy": [
                1
            ],
            "createdAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionBusinessEvent": {
            "classifiedAt": [
                581
            ],
            "classifierType": [
                1
            ],
            "classifiedBy": [
                1
            ],
            "classifications": [
                273
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionBusinessEventClassification": {
            "classificationId": [
                15
            ],
            "businessEvent": [
                1
            ],
            "amount": [
                5
            ],
            "amountInPercentage": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "affiliatedEntityId": [
                1
            ],
            "affiliatedEntity": [
                72
            ],
            "pairedEntityId": [
                1
            ],
            "pairedEntityType": [
                1637
            ],
            "pairingType": [
                1638
            ],
            "classificationTagId": [
                1
            ],
            "classificationTagText": [
                1
            ],
            "classificationText": [
                1
            ],
            "description": [
                1
            ],
            "extraData": [
                1242
            ],
            "askTheUserResult": [
                129
            ],
            "pairedEntity": [
                1636
            ],
            "classificationTag": [
                392
            ],
            "businessEventV2": [
                348
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionByMerchant": {
            "groupId": [
                15
            ],
            "merchant": [
                1405
            ],
            "transactions": [
                270
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionByMerchantResult": {
            "groups": [
                274
            ],
            "total": [
                41
            ],
            "nextToken": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionCategorizationInput": {
            "bankTransactionId": [
                15
            ],
            "merchant": [
                1409
            ],
            "classifications": [
                279
            ],
            "recommendations": [
                388
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionCategorizationResult": {
            "bankTransaction": [
                270
            ],
            "status": [
                278
            ],
            "error": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionCategorizationResultStatus": {},
        "BankTransactionClassificationInput": {
            "amount": [
                5
            ],
            "amountInPercentage": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "affiliatedEntityId": [
                15
            ],
            "classificationTagId": [
                15
            ],
            "classificationText": [
                15
            ],
            "businessEvent": [
                1
            ],
            "pairedEntityId": [
                1
            ],
            "pairedEntityType": [
                1637
            ],
            "pairingType": [
                1638
            ],
            "askTheUserResult": [
                1242
            ],
            "extraData": [
                1242
            ],
            "description": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionClassifierType": {},
        "BankTransactionCursorInput": {
            "offset": [
                41
            ],
            "limit": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionInput": {
            "companyId": [
                15
            ],
            "transactionId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionMemo": {
            "content": [
                1
            ],
            "updatedAt": [
                581
            ],
            "updatedBy": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionPairingInput": {
            "pairedEntityType": [
                1637
            ],
            "pairedEntityId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionPairingResult": {
            "pairedEntityType": [
                1637
            ],
            "pairedEntityId": [
                1
            ],
            "bankTransactions": [
                270
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionRecommendation": {
            "classificationTag": [
                392
            ],
            "score": [
                5
            ],
            "model": [
                1
            ],
            "recommendationsSource": [
                1874
            ],
            "recommendedBy": [
                1875
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionResponse": {
            "bankTransactions": [
                270
            ],
            "nextOffset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionsByMerchantInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                15
            ],
            "dateRange": [
                583
            ],
            "merchantIds": [
                15
            ],
            "merchantIdsOperator": [
                745
            ],
            "nextToken": [
                15
            ],
            "limit": [
                41
            ],
            "searchTerm": [
                1
            ],
            "amountRange": [
                106
            ],
            "absoluteAmounts": [
                7
            ],
            "moneyDirection": [
                1436
            ],
            "searchMerchantsByName": [
                7
            ],
            "source": [
                1113
            ],
            "excludeLocked": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionsByPairingsInput": {
            "pairings": [
                284
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionsInput": {
            "companyId": [
                15
            ],
            "bankTransactionIds": [
                15
            ],
            "bankAccountIds": [
                15
            ],
            "bankAccountIdsOperator": [
                745
            ],
            "businessEvents": [
                1
            ],
            "businessEventsOperator": [
                745
            ],
            "searchTerm": [
                1
            ],
            "endDate": [
                581
            ],
            "startDate": [
                581
            ],
            "amountLte": [
                5
            ],
            "amountGte": [
                5
            ],
            "checkAgainstOriginalAmount": [
                7
            ],
            "absoluteAmounts": [
                7
            ],
            "source": [
                1113
            ],
            "merchantIds": [
                15
            ],
            "searchMerchantsByName": [
                7
            ],
            "merchantIdsOperator": [
                745
            ],
            "withMerchantIdsAsPairedEntities": [
                7
            ],
            "onlyPendingUserInput": [
                7
            ],
            "moneyDirection": [
                1436
            ],
            "cursor": [
                281
            ],
            "excludePairedEntityTypes": [
                1637
            ],
            "showOnlySpreadTransactions": [
                7
            ],
            "excludeLocked": [
                7
            ],
            "showOnlySplitTransactions": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionsResponse": {
            "bankTransactions": [
                270
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionsSort": {
            "closeToAmount": [
                5
            ],
            "closeToDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionsSummary": {
            "amountInUsd": [
                5
            ],
            "count": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionsUpload": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "bankAccount": [
                161
            ],
            "fileLocation": [
                296
            ],
            "uploadOriginator": [
                1
            ],
            "uploadedBy": [
                38
            ],
            "uploadedById": [
                1
            ],
            "uploadedAt": [
                581
            ],
            "processingLogs": [
                297
            ],
            "status": [
                301
            ],
            "bankStatementRequestId": [
                1
            ],
            "originFileId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionsUploadFileInput": {
            "companyId": [
                15
            ],
            "bankTransactionsUploadFileId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionsUploadFileLocation": {
            "bucket": [
                1
            ],
            "key": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionsUploadProcessingLog": {
            "processorType": [
                300
            ],
            "processorId": [
                1
            ],
            "createdAt": [
                581
            ],
            "state": [
                299
            ],
            "metadata": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionsUploadProcessingLogInput": {
            "processorType": [
                300
            ],
            "processorId": [
                1
            ],
            "state": [
                299
            ],
            "message": [
                1
            ],
            "metadata": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "BankTransactionsUploadProcessingLogState": {},
        "BankTransactionsUploadProcessorType": {},
        "BankTransactionsUploadStatus": {},
        "BankTransactionToLinkInput": {
            "transactionId": [
                15
            ],
            "amountInHomeCurrency": [
                5
            ],
            "amount": [
                5
            ],
            "currency": [
                549
            ],
            "__typename": [
                1
            ]
        },
        "BankTxSaleTransaction": {
            "id": [
                15
            ],
            "integrationInfo": [
                1093
            ],
            "integrationAccountId": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "amount": [
                5
            ],
            "postedAt": [
                581
            ],
            "currency": [
                549
            ],
            "amountInHomeCurrency": [
                5
            ],
            "type": [
                2167
            ],
            "finaloopPaymentGateway": [
                1
            ],
            "originalPaymentGateway": [
                1
            ],
            "paymentGatewayVariant": [
                1
            ],
            "isIndication": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "BaseAffiliatedEntity": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BigValidationAccountRoleAmount": {
            "amount": [
                5
            ],
            "accountRole": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BigValidationAdjustment": {
            "date": [
                581
            ],
            "amount": [
                5
            ],
            "comment": [
                1
            ],
            "type": [
                1
            ],
            "setBy": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BigValidationData": {
            "method": [
                1366
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "entityData": [
                309
            ],
            "booksData": [
                309
            ],
            "status": [
                311
            ],
            "isGreen": [
                7
            ],
            "adjustment": [
                306
            ],
            "__typename": [
                1
            ]
        },
        "BigValidationInventoryBalanceData": {
            "inventory": [
                5
            ],
            "inventoryInProcess": [
                5
            ],
            "inventoryInTransit": [
                5
            ],
            "inventoryInTransitInternal": [
                5
            ],
            "legacyInventory": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "BigValidationPeriodData": {
            "cogs": [
                305
            ],
            "purchases": [
                305
            ],
            "endOfYearAdjustments": [
                5
            ],
            "inventoryEndingBalance": [
                308
            ],
            "inventoryOpeningBalance": [
                5
            ],
            "physicalCount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "BigValidationResponse": {
            "data": [
                307
            ],
            "__typename": [
                1
            ]
        },
        "BigValidationStatus": {
            "openingBalance": [
                7
            ],
            "cogs": [
                7
            ],
            "methodChangeAdjustments": [
                7
            ],
            "endOfYearAdjustments": [
                7
            ],
            "endingBalance": [
                7
            ],
            "purchases": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "Bill": {
            "id": [
                15
            ],
            "accrual": [
                29
            ],
            "companyId": [
                15
            ],
            "billNumber": [
                1
            ],
            "currency": [
                1
            ],
            "amount": [
                5
            ],
            "dueDate": [
                581
            ],
            "createdDate": [
                581
            ],
            "deletedAt": [
                581
            ],
            "vendor": [
                2375
            ],
            "categories": [
                372
            ],
            "balance": [
                5,
                {
                    "input": [
                        315
                    ]
                }
            ],
            "payments": [
                322
            ],
            "indicativePayments": [
                322
            ],
            "credits": [
                316
            ],
            "adjustments": [
                313
            ],
            "refunds": [
                327
            ],
            "source": [
                1113
            ],
            "externalSourceData": [
                317
            ],
            "latestAccountingEventIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BillAdjustment": {
            "id": [
                15
            ],
            "type": [
                314
            ],
            "amount": [
                5
            ],
            "currency": [
                549
            ],
            "actionTime": [
                581
            ],
            "eventTime": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BillAdjustmentType": {},
        "BillBalanceInput": {
            "asOfDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BillCredit": {
            "creditDate": [
                581
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "BillExternalSourceData": {
            "integrationAccountId": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "balance": [
                5
            ],
            "link": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Billing": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BillingPayment": {
            "on_RecurringPayment": [
                1888
            ],
            "on_OneTimePayment": [
                1483
            ],
            "__typename": [
                1
            ]
        },
        "BillInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BillItemToReconcile": {
            "companyId": [
                15
            ],
            "billId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BillPayment": {
            "id": [
                15
            ],
            "paymentDate": [
                581
            ],
            "amount": [
                5
            ],
            "feeAmount": [
                5
            ],
            "amountInUSD": [
                5
            ],
            "currency": [
                549
            ],
            "vendor": [
                2375
            ],
            "settlementType": [
                326
            ],
            "voidedAt": [
                581
            ],
            "source": [
                1113
            ],
            "categoriesProration": [
                5
            ],
            "financing": [
                323
            ],
            "bulkPaymentData": [
                343
            ],
            "__typename": [
                1
            ]
        },
        "BillPaymentFinancing": {
            "type": [
                325
            ],
            "feeBillIds": [
                1
            ],
            "financedAmount": [
                5
            ],
            "totalDays": [
                41
            ],
            "periods": [
                41
            ],
            "periodDays": [
                41
            ],
            "installments": [
                324
            ],
            "__typename": [
                1
            ]
        },
        "BillPaymentFinancingInstallment": {
            "installmentTime": [
                581
            ],
            "principalAmount": [
                5
            ],
            "interestAmount": [
                5
            ],
            "totalAmount": [
                5
            ],
            "status": [
                751
            ],
            "isRefund": [
                7
            ],
            "externalId": [
                1
            ],
            "refundedExternalIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BillPaymentFinancingType": {},
        "BillPaymentSettlementType": {},
        "BillRefund": {
            "id": [
                15
            ],
            "refundDate": [
                581
            ],
            "amount": [
                5
            ],
            "amountInUSD": [
                5
            ],
            "currency": [
                549
            ],
            "settlementType": [
                328
            ],
            "isVoidedPayment": [
                7
            ],
            "source": [
                1113
            ],
            "__typename": [
                1
            ]
        },
        "BillRefundSettlementType": {},
        "BillsAgingReportInput": {
            "companyId": [
                15
            ],
            "balanceAsOfDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "BillsDueDateSummary": {
            "total": [
                667
            ],
            "totalBalanceDue": [
                667
            ],
            "pastDue": [
                667
            ],
            "dueNext7Days": [
                667
            ],
            "dueAfterNext7Days": [
                667
            ],
            "__typename": [
                1
            ]
        },
        "BillsDueDateSummaryInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BillsYearEnd": {
            "fiscalYearStartDate": [
                581
            ],
            "fiscalYearEndDate": [
                581
            ],
            "domainState": [
                2476
            ],
            "hubReportedDomainState": [
                2476
            ],
            "tasks": [
                333
            ],
            "__typename": [
                1
            ]
        },
        "BillsYearEndTask": {
            "id": [
                334
            ],
            "stateKey": [
                1
            ],
            "status": [
                337
            ],
            "on_AddMissingBillsTask": [
                51
            ],
            "on_CategorizeUncategorizedBillsTask": [
                371
            ],
            "on_CloseOpenBillsTask": [
                400
            ],
            "on_ConfirmApBalanceTask": [
                480
            ],
            "__typename": [
                1
            ]
        },
        "BillsYearEndTaskId": {},
        "BillsYearEndTasksInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BillsYearEndTasksResponse": {
            "yearEnd": [
                332
            ],
            "__typename": [
                1
            ]
        },
        "BillsYearEndTaskStatus": {},
        "BooleanChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                1052
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                7
            ],
            "newValue": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "BooleanResult": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "BreakdownType": {},
        "BulkEditCsvTemplateInput": {
            "companyId": [
                15
            ],
            "isEmpty": [
                7
            ],
            "managementMethodId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BulkEditCsvTemplateResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BulkPaymentData": {
            "id": [
                1
            ],
            "amount": [
                5
            ],
            "amountInUsd": [
                5
            ],
            "paymentType": [
                1
            ],
            "feeAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "BulkRecoveryUnitsTrackingFailureResult": {
            "company": [
                418
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BulkRecoveryUnitsTrackingInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BulkRecoveryUnitsTrackingResult": {
            "failureResults": [
                344
            ],
            "successResults": [
                418
            ],
            "__typename": [
                1
            ]
        },
        "BusinessCreationType": {},
        "BusinessEventActionsConfiguration": {
            "type": [
                1
            ],
            "variant": [
                1
            ],
            "id": [
                15
            ],
            "accrualConfig": [
                1239
            ],
            "cashConfig": [
                1239
            ],
            "presentationalAccountRole": [
                10
            ],
            "businessEventDefinition": [
                353
            ],
            "__typename": [
                1
            ]
        },
        "BusinessEventActionsConfigurationByType": {
            "type": [
                1
            ],
            "variant": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BusinessEventCategorizationInput": {
            "classifications": [
                380
            ],
            "shouldApplyAlways": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "BusinessEventClassificationInput": {
            "businessEvent": [
                1
            ],
            "amount": [
                5
            ],
            "amountInPercentage": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "affiliatedEntityId": [
                15
            ],
            "pairedEntityId": [
                1
            ],
            "pairedEntityType": [
                1637
            ],
            "pairingType": [
                1638
            ],
            "classificationTagId": [
                1
            ],
            "classificationTagText": [
                1
            ],
            "classificationText": [
                1
            ],
            "description": [
                1
            ],
            "extraData": [
                1242
            ],
            "askTheUserResult": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "BusinessEventData": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BusinessEventDefinition": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "customerDisplayName": [
                1
            ],
            "groups": [
                1
            ],
            "vendorRequired": [
                7
            ],
            "requiredAffiliatedEntityType": [
                1
            ],
            "irrelevantForVendor": [
                7
            ],
            "hideForManualClassification": [
                7
            ],
            "forceShowInEventsListings": [
                7
            ],
            "moneyDirection": [
                1436
            ],
            "customerDescriptionTemplate": [
                1
            ],
            "isRelevantToAccruals": [
                7
            ],
            "isRelevantToAccrualsFixedAsset": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "BusinessEventDefinitionsByGroups": {
            "groups": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BusinessEventDefinitionsByIds": {
            "ids": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "BusinessEventInput": {
            "classifications": [
                351
            ],
            "__typename": [
                1
            ]
        },
        "BusinessEventItemToReconcile": {
            "companyId": [
                15
            ],
            "businessEventId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "BusinessEventRuleType": {},
        "BusinessEventsAccrualsConfig": {
            "id": [
                15
            ],
            "isRelevantToAccruals": [
                7
            ],
            "isRelevantToAccrualsFixedAsset": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "BusinessEventsAccrualsConfigV2": {
            "companyId": [
                15
            ],
            "event": [
                353
            ],
            "isRelevantToAccruals": [
                7
            ],
            "isRelevantToAccrualsFixedAsset": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "CalculateInvoiceInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "companyAddressId": [
                15
            ],
            "customerId": [
                15
            ],
            "shippingAddressId": [
                15
            ],
            "billingAddressId": [
                15
            ],
            "displayName": [
                1
            ],
            "postedAt": [
                581
            ],
            "dueDate": [
                581
            ],
            "taxFixedAmount": [
                5
            ],
            "taxType": [
                1963
            ],
            "lineItems": [
                1924
            ],
            "discounts": [
                652
            ],
            "paymentMethodIds": [
                15
            ],
            "customerNote": [
                1
            ],
            "issueInvoice": [
                7
            ],
            "currency": [
                549
            ],
            "__typename": [
                1
            ]
        },
        "CalendlyEventInput": {
            "eventId": [
                1
            ],
            "inviteeId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CalendlyEventResponse": {
            "email": [
                1
            ],
            "name": [
                1
            ],
            "phoneNumber": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CancelAccrualInput": {
            "companyId": [
                15
            ],
            "bankTransactionId": [
                15
            ],
            "canceledAtData": [
                367
            ],
            "__typename": [
                1
            ]
        },
        "CancelAccrualV2Input": {
            "companyId": [
                15
            ],
            "entityType": [
                21
            ],
            "entityId": [
                15
            ],
            "canceledAtData": [
                367
            ],
            "__typename": [
                1
            ]
        },
        "CanceledAccrualData": {
            "classificationTagId": [
                15
            ],
            "businessEventType": [
                1
            ],
            "spreadType": [
                2106
            ],
            "residualAmount": [
                5
            ],
            "specificDate": [
                2097
            ],
            "spreadOverTime": [
                2104
            ],
            "customSpread": [
                567
            ],
            "customSpreadOptions": [
                569
            ],
            "defaultFixedAssetsData": [
                593
            ],
            "customFixedAssetsData": [
                565
            ],
            "__typename": [
                1
            ]
        },
        "CanceledAtDataItem": {
            "canceledAt": [
                1
            ],
            "classificationTagId": [
                1
            ],
            "businessEventType": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CancelInvalidInventoryPaymentGroupsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CancelInvalidInventoryPaymentGroupsResponse": {
            "canceledGroupIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CategorizeBankTransactionsInput": {
            "companyId": [
                15
            ],
            "categorizations": [
                276
            ],
            "__typename": [
                1
            ]
        },
        "CategorizeUncategorizedBillsTask": {
            "id": [
                334
            ],
            "status": [
                337
            ],
            "stateKey": [
                1
            ],
            "amount": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "Category": {
            "description": [
                1
            ],
            "amount": [
                5
            ],
            "classificationTag": [
                392
            ],
            "__typename": [
                1
            ]
        },
        "CategoryBreakdown": {
            "category": [
                409
            ],
            "amount": [
                5
            ],
            "costType": [
                499
            ],
            "__typename": [
                1
            ]
        },
        "ChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                2507
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "on_AddMissingBillsTaskStateChangeLog": [
                53
            ],
            "on_AddMissingInvoicesTaskStateChangeLog": [
                56
            ],
            "on_CloseOpenBillsTaskStateChangeLog": [
                402
            ],
            "on_CloseOpenInvoicesTaskStateChangeLog": [
                405
            ],
            "on_ConfirmApBalanceTaskStateChangeLog": [
                482
            ],
            "on_ConfirmArBalanceTaskStateChangeLog": [
                485
            ],
            "on_LinkInvoicePaymentsTaskStateChangeLog": [
                1263
            ],
            "on_YearEndDomainStateChangeLog": [
                2477
            ],
            "on_YearEndDomainStateDataChangeLog": [
                2478
            ],
            "on_YearEndEmailChangeLog": [
                2494
            ],
            "on_YearEndIntercomLinkChangeLog": [
                2496
            ],
            "on_YearEndStateChangeLog": [
                2500
            ],
            "on_YearEndUserUnresponsiveChangeLog": [
                2515
            ],
            "__typename": [
                1
            ]
        },
        "ChangeProductsHiddenStatusInput": {
            "companyId": [
                15
            ],
            "productStatusChange": [
                1826
            ],
            "__typename": [
                1
            ]
        },
        "Chargeback": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "source": [
                1113
            ],
            "integrationAccountId": [
                15
            ],
            "integrationAccountName": [
                1
            ],
            "amount": [
                5
            ],
            "currency": [
                1
            ],
            "postedAt": [
                581
            ],
            "disputeId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ChartDataInput": {
            "companyId": [
                15
            ],
            "chartName": [
                1
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "breakdown": [
                1
            ],
            "timezone": [
                1
            ],
            "comparisonPeriod": [
                1
            ],
            "view": [
                2390
            ],
            "__typename": [
                1
            ]
        },
        "ChartDataResponse": {
            "title": [
                1
            ],
            "updatedAt": [
                581
            ],
            "category": [
                1
            ],
            "data": [
                580
            ],
            "labels": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CheckAwaitedExportStatusInput": {
            "companyId": [
                15
            ],
            "requestId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationInput": {
            "businessEvent": [
                1
            ],
            "amount": [
                5
            ],
            "description": [
                1
            ],
            "pairedEntityId": [
                1
            ],
            "pairedEntityType": [
                1637
            ],
            "pairingType": [
                1638
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationMetadata": {
            "enrichmentRuleType": [
                674
            ],
            "enrichmentRuleId": [
                1
            ],
            "businessEventRuleType": [
                358
            ],
            "businessEventRuleId": [
                1
            ],
            "isAugmented": [
                7
            ],
            "actorType": [
                38
            ],
            "actorId": [
                1
            ],
            "classifiedAt": [
                581
            ],
            "recommendations": [
                383
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationMetadataInput": {
            "enrichmentRuleType": [
                674
            ],
            "enrichmentRuleId": [
                1
            ],
            "businessEventRuleType": [
                358
            ],
            "businessEventRuleId": [
                1
            ],
            "isAugmented": [
                7
            ],
            "metadata": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationMetadataRecommendation": {
            "chosenRecommendation": [
                387
            ],
            "mechanism": [
                1875
            ],
            "value": [
                386
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationMetadataRecommendationOptionValue": {
            "seenOptions": [
                387
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationMetadataRecommendationPromptValue": {
            "prompt": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationMetadataRecommendationValue": {
            "on_ClassificationMetadataRecommendationOptionValue": [
                384
            ],
            "on_ClassificationMetadataRecommendationPromptValue": [
                385
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationRecommendation": {
            "tagId": [
                1
            ],
            "score": [
                5
            ],
            "model": [
                1
            ],
            "recommendationsSource": [
                1874
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationRecommendationsInput": {
            "chosenRecommendation": [
                389
            ],
            "mechanism": [
                1875
            ],
            "optionValue": [
                591
            ],
            "promptValue": [
                592
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationRecommendationTag": {
            "tagId": [
                1
            ],
            "score": [
                5
            ],
            "model": [
                1
            ],
            "recommendationsSource": [
                1874
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationRequestInput": {
            "id": [
                15
            ],
            "merchant": [
                1409
            ],
            "businessEvent": [
                356
            ],
            "allowClassificationForVersion": [
                77
            ],
            "classificationMetadata": [
                382
            ],
            "recommendations": [
                388
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationResult": {
            "current": [
                270
            ],
            "previous": [
                270
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationTag": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "moneyDirection": [
                1436
            ],
            "isHidden": [
                7
            ],
            "isRelevantToBills": [
                7
            ],
            "isRelevantToApplyAlways": [
                7
            ],
            "displayNameForReports": [
                1
            ],
            "keywords": [
                1
            ],
            "classification": [
                394
            ],
            "isApplicableForRefund": [
                7
            ],
            "weight": [
                41
            ],
            "reportsDisplayNameForTagSelection": [
                1
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "lastUpdatedBy": [
                1
            ],
            "classificationBusinessEventEffects": [
                393
            ],
            "triggeringClassificationFlowsConditions": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationTagBusinessEventEffects": {
            "moneyInBusinessEvent": [
                348
            ],
            "moneyOutBusinessEvent": [
                348
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationTagClassification": {
            "in": [
                1
            ],
            "out": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationTagsByIdsInput": {
            "ids": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationTagsInput": {
            "forBillsOnly": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationTagSuggestionsResponse": {
            "suggestions": [
                398
            ],
            "debuggingInfo": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "ClassificationTagWithSuggestionReason": {
            "classificationTag": [
                392
            ],
            "confidenceScore": [
                5
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ClassifyIntegrationTransferInput": {
            "companyId": [
                15
            ],
            "classifications": [
                1100
            ],
            "__typename": [
                1
            ]
        },
        "CloseOpenBillsTask": {
            "id": [
                334
            ],
            "status": [
                337
            ],
            "stateKey": [
                1
            ],
            "currentBillsHash": [
                1
            ],
            "state": [
                401
            ],
            "history": [
                402
            ],
            "__typename": [
                1
            ]
        },
        "CloseOpenBillsTaskState": {
            "confirmedBillsHash": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CloseOpenBillsTaskStateChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                2507
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                401
            ],
            "newValue": [
                401
            ],
            "__typename": [
                1
            ]
        },
        "CloseOpenInvoicesTask": {
            "id": [
                1224
            ],
            "status": [
                1227
            ],
            "stateKey": [
                1
            ],
            "currentInvoicesHash": [
                1
            ],
            "state": [
                404
            ],
            "history": [
                405
            ],
            "__typename": [
                1
            ]
        },
        "CloseOpenInvoicesTaskState": {
            "confirmedInvoicesHash": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CloseOpenInvoicesTaskStateChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                2507
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                404
            ],
            "newValue": [
                404
            ],
            "__typename": [
                1
            ]
        },
        "ClosingBalance": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "source": [
                1113
            ],
            "integrationAccountId": [
                15
            ],
            "integrationAccountName": [
                1
            ],
            "amount": [
                5
            ],
            "currency": [
                1
            ],
            "appliedAt": [
                581
            ],
            "type": [
                407
            ],
            "__typename": [
                1
            ]
        },
        "ClosingBalanceType": {},
        "COGSBreakdownItem": {
            "product": [
                1769
            ],
            "quantity": [
                41
            ],
            "avgCostPerUnit": [
                5
            ],
            "totalCogs": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "CogsCategory": {},
        "COGSEvent": {
            "id": [
                1
            ],
            "groupName": [
                1
            ],
            "period": [
                411
            ],
            "amount": [
                5
            ],
            "salesChannel": [
                1940
            ],
            "lineOfBusinessId": [
                1
            ],
            "memo": [
                1
            ],
            "type": [
                415
            ],
            "source": [
                412
            ],
            "isFullyProcessed": [
                7
            ],
            "costType": [
                499
            ],
            "categoryBreakdown": [
                373
            ],
            "__typename": [
                1
            ]
        },
        "COGSEventPeriod": {
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "COGSEventSource": {},
        "CogsSource": {},
        "COGSSummaryV2": {
            "groupName": [
                1
            ],
            "type": [
                415
            ],
            "sum": [
                5
            ],
            "salesChannel": [
                1940
            ],
            "realtimeSum": [
                5
            ],
            "manualSum": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "CogsType": {},
        "CommonAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CommonWarehouseTransfersFilterInput": {
            "companyId": [
                1
            ],
            "productIds": [
                1
            ],
            "warehouseTransferIds": [
                1
            ],
            "shippingDate": [
                2434
            ],
            "arrivalDate": [
                2434
            ],
            "warehouse": [
                2402
            ],
            "textSearch": [
                1
            ],
            "withDeleted": [
                7
            ],
            "vendorId": [
                1
            ],
            "paidStatus": [
                1635
            ],
            "__typename": [
                1
            ]
        },
        "Company": {
            "id": [
                15
            ],
            "billing": [
                436
            ],
            "name": [
                1
            ],
            "userName": [
                1
            ],
            "refferalCode": [
                1
            ],
            "source": [
                1242
            ],
            "email": [
                1
            ],
            "isManufacturer": [
                7
            ],
            "phoneNumber": [
                1
            ],
            "address": [
                58
            ],
            "accountingMethod": [
                8
            ],
            "booksStartTime": [
                1242
            ],
            "dataRestrictionTime": [
                581
            ],
            "balanceSheetStatus": [
                160
            ],
            "customerSelectedAccountingMethod": [
                561
            ],
            "inventorySettings": [
                1164
            ],
            "ordersSettings": [
                1582
            ],
            "generalDetails": [
                1242
            ],
            "configuration": [
                438
            ],
            "isTestCompany": [
                7
            ],
            "isArchived": [
                7
            ],
            "createdAtMs": [
                5
            ],
            "createdAtIso": [
                1
            ],
            "canceledAtIso": [
                1
            ],
            "preloadEmail": [
                1
            ],
            "eventsLock": [
                1242
            ],
            "eventsLock2": [
                684
            ],
            "legalEntityType": [
                1
            ],
            "taxEntityType": [
                1
            ],
            "trialStartTimeIso": [
                1
            ],
            "trialStartTimeMs": [
                5
            ],
            "trialDurationInDays": [
                41
            ],
            "isPaying": [
                7
            ],
            "fullUiAccess": [
                7
            ],
            "paymentStatus": [
                1
            ],
            "tier": [
                1
            ],
            "tierAtConversion": [
                1
            ],
            "taxPlan": [
                1
            ],
            "stripeCustomerId": [
                15
            ],
            "isOnboardingCompleted": [
                7
            ],
            "onboardingCompletedAtIso": [
                1
            ],
            "onboardingState": [
                1472
            ],
            "isParkerReferral": [
                7
            ],
            "estimatedProjectedRevenue": [
                681
            ],
            "calculatedTier": [
                463
            ],
            "hasActiveTrial": [
                7
            ],
            "lockStatus": [
                460
            ],
            "isLiveTestCompany": [
                7
            ],
            "gtmSource": [
                1019
            ],
            "fiscalYearStart": [
                441
            ],
            "lockHistory": [
                459
            ],
            "appsSelectedInPreOnboarding": [
                1
            ],
            "referralCode": [
                1
            ],
            "endOfYearDeadline": [
                1242
            ],
            "booksStatus": [
                1242
            ],
            "accountingServices": [
                9
            ],
            "demo": [
                1
            ],
            "preOnboardingFunnelType": [
                1
            ],
            "isPremiumService": [
                7
            ],
            "isPartner": [
                7
            ],
            "isTaxPlan": [
                7
            ],
            "firstPaymentDate": [
                581
            ],
            "balanceSheetSetup": [
                435
            ],
            "customerSuccessManager": [
                1
            ],
            "healthScore": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CompanyAccountValidation": {
            "account": [
                1
            ],
            "status": [
                474
            ],
            "value": [
                5
            ],
            "isError": [
                7
            ],
            "asOfDate": [
                581
            ],
            "updatedAt": [
                581
            ],
            "lastSuccessfulRunAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CompanyAddress": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "source": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "isDefault": [
                7
            ],
            "name": [
                1
            ],
            "email": [
                1
            ],
            "phone": [
                1
            ],
            "line1": [
                1
            ],
            "line2": [
                1
            ],
            "city": [
                1
            ],
            "country": [
                1
            ],
            "province": [
                1
            ],
            "state": [
                1
            ],
            "zip": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CompanyAddressInput": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CompanyAffiliate": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "type": [
                427
            ],
            "name": [
                1
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "logoUrl": [
                1
            ],
            "holdingsInPercentage": [
                5
            ],
            "isForeignResident": [
                7
            ],
            "balance": [
                5
            ],
            "transactions": [
                426
            ],
            "status": [
                1043
            ],
            "affiliatedEntityId": [
                15
            ],
            "latestAccountingEventIds": [
                1
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CompanyAffiliateInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CompanyAffiliatesByIdsInput": {
            "ids": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CompanyAffiliatesInput": {
            "companyId": [
                15
            ],
            "type": [
                427
            ],
            "searchTerm": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CompanyAffiliateTransaction": {
            "entityId": [
                15
            ],
            "entityType": [
                1
            ],
            "bankAccountId": [
                1
            ],
            "postedAt": [
                581
            ],
            "amount": [
                5
            ],
            "currency": [
                1
            ],
            "amountInUsd": [
                5
            ],
            "type": [
                1
            ],
            "source": [
                1113
            ],
            "__typename": [
                1
            ]
        },
        "CompanyAffiliateType": {},
        "CompanyArCashDiffsActionsResponse": {
            "accountRole": [
                1
            ],
            "amount": [
                5
            ],
            "isAccrual": [
                7
            ],
            "isCash": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "CompanyArCashDiffsFixbooksResponse": {
            "eventTime": [
                581
            ],
            "createdAt": [
                581
            ],
            "creatorEmail": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "memo": [
                1
            ],
            "actions": [
                428
            ],
            "__typename": [
                1
            ]
        },
        "CompanyArCashDiffsInput": {
            "companyId": [
                15
            ],
            "unpaidBalanceAsOf": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CompanyArCashDiffsOrdersResponse": {
            "orderId": [
                15
            ],
            "integrationAccountId": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "displayName": [
                1
            ],
            "ordersVsBooks": [
                5
            ],
            "ordersBalance": [
                5
            ],
            "booksBalance": [
                5
            ],
            "placedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CompanyArCashDiffsResponse": {
            "companyId": [
                15
            ],
            "reportDate": [
                581
            ],
            "orders": [
                431
            ],
            "fixbooks": [
                429
            ],
            "totals": [
                433
            ],
            "lockTime": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CompanyArCashTotalsResponse": {
            "arCashInBooks": [
                5
            ],
            "unpaidOrders": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "CompanyArtificialFulfillmentSettingsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CompanyBalanceSheetSetup": {
            "state": [
                1050
            ],
            "__typename": [
                1
            ]
        },
        "CompanyBilling": {
            "features": [
                725
            ],
            "purchasedOffers": [
                1845
            ],
            "portalUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CompanyByStripeCustomerIdInput": {
            "stripeCustomerId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CompanyConfiguration": {
            "isPnlReportReady": [
                7
            ],
            "isBalanceSheetReportFinal": [
                7
            ],
            "includeCCAccountsInCashFlowBeforePayment": [
                7
            ],
            "includeUDFAccountsInCashFlowBeforeDeposit": [
                7
            ],
            "cashFlowStartTimeISO": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CompanyDomainState": {
            "companyId": [
                15
            ],
            "state": [
                2476
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CompanyEventsLockHistory": {
            "year": [
                41
            ],
            "createdAt": [
                581
            ],
            "userEmail": [
                1
            ],
            "type": [
                1357
            ],
            "__typename": [
                1
            ]
        },
        "CompanyFiscalYearStart": {
            "day": [
                41
            ],
            "month": [
                41
            ],
            "userEmail": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CompanyFundedStatus": {
            "hideBanner": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "CompanyHasBankingMissionInput": {
            "companyId": [
                15
            ],
            "triggerEvaluationIfRequired": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "CompanyHealthStatus": {
            "company": [
                418
            ],
            "domains": [
                469
            ],
            "status": [
                474
            ],
            "__typename": [
                1
            ]
        },
        "CompanyHealthStatusSortDirection": {},
        "CompanyIdAndStripeCustomerId": {
            "companyId": [
                1
            ],
            "stripeCustomerId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CompanyIdInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CompanyIntegration": {
            "companyId": [
                15
            ],
            "integrationType": [
                1113
            ],
            "integrationAccountId": [
                15
            ],
            "integrationTypeAndIntegrationAccountId": [
                1
            ],
            "data": [
                1241
            ],
            "enabled": [
                7
            ],
            "impactOnBooksSince": [
                1
            ],
            "createdAtMs": [
                5
            ],
            "deletedByUserAt": [
                1
            ],
            "deletedByUserId": [
                1
            ],
            "disconnectedAt": [
                1
            ],
            "disconnectedBy": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CompanyIntegrationBulkUpdateInput": {
            "companyId": [
                15
            ],
            "updateExpression": [
                2255
            ],
            "__typename": [
                1
            ]
        },
        "CompanyIntegrationInput": {
            "companyId": [
                15
            ],
            "integrationType": [
                1113
            ],
            "integrationAccountId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CompanyIntegrationsInput": {
            "companyId": [
                15
            ],
            "integrationType": [
                1113
            ],
            "__typename": [
                1
            ]
        },
        "CompanyInvoicePayInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CompanyLoan": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "source": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "type": [
                1339
            ],
            "lender": [
                1446
            ],
            "currency": [
                549
            ],
            "postedAt": [
                581
            ],
            "direction": [
                1307
            ],
            "isShortTerm": [
                7
            ],
            "amount": [
                5
            ],
            "totalAmount": [
                5
            ],
            "outstandingAmount": [
                5
            ],
            "accruedInterest": [
                5
            ],
            "unrecognizedFees": [
                5
            ],
            "prepaymentLiabilityAmount": [
                5
            ],
            "status": [
                1334
            ],
            "userActionStatus": [
                1343
            ],
            "acknowledgedInternallyAt": [
                581
            ],
            "acknowledgedInternallyBy": [
                1
            ],
            "paidOffAt": [
                581
            ],
            "attachments": [
                1293
            ],
            "workingPaperLink": [
                1
            ],
            "updatedBy": [
                1
            ],
            "lockedAt": [
                581
            ],
            "lastSeenByClientAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "interestDays": [
                1314
            ],
            "repaymentType": [
                1327
            ],
            "repaymentFrequency": [
                1326
            ],
            "repaymentRate": [
                5
            ],
            "interestRateType": [
                1315
            ],
            "interestRate": [
                5
            ],
            "gracePeriod": [
                41
            ],
            "catchUpPeriod": [
                41
            ],
            "catchUpPercent": [
                5
            ],
            "originationFees": [
                5
            ],
            "prepaymentFees": [
                5
            ],
            "recurringDataFrequency": [
                1324
            ],
            "instantRepaymentMethod": [
                1313
            ],
            "isIndexLinked": [
                7
            ],
            "interestType": [
                1316
            ],
            "variableInterestUpdatePeriod": [
                1346
            ],
            "variableInterestSpread": [
                5
            ],
            "variableInterestBase": [
                1345
            ],
            "compoundFrequency": [
                1303
            ],
            "indexType": [
                1312
            ],
            "isEarlyRepaymentDiscount": [
                7
            ],
            "earlyRepaymentDiscounts": [
                669
            ],
            "transactions": [
                270
            ],
            "lastTransaction": [
                270
            ],
            "userFollowUp2": [
                2341
            ],
            "askIfRepaid": [
                7
            ],
            "hideOutdatedWarning": [
                7
            ],
            "deleteOptionMode": [
                455
            ],
            "pendingDelete": [
                7
            ],
            "pendingRestoreAcknowledgement": [
                7
            ],
            "lastUserMoveToProcessingAt": [
                581
            ],
            "dataRequestType": [
                1306
            ],
            "isHidden": [
                7
            ],
            "lastEventDate": [
                581
            ],
            "isBillPaymentEventAttached": [
                7
            ],
            "firstPaymentDate": [
                581
            ],
            "lastPaymentDate": [
                581
            ],
            "creationSource": [
                1331
            ],
            "hasRollOverEvent": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "CompanyLoanAttachmentUpdateResult": {
            "success": [
                7
            ],
            "errors": [
                1294
            ],
            "loan": [
                453
            ],
            "processing": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "CompanyLoanDeleteOptionMode": {},
        "CompanyLoanResponse": {
            "loan": [
                453
            ],
            "__typename": [
                1
            ]
        },
        "CompanyLoansResponse": {
            "loans": [
                453
            ],
            "__typename": [
                1
            ]
        },
        "CompanyLockConditions": {
            "accountingMethod": [
                1
            ],
            "moneyIn": [
                1352
            ],
            "moneyOut": [
                1352
            ],
            "reclassificationMoneyIn": [
                1352
            ],
            "reclassificationMoneyOut": [
                1352
            ],
            "assetsEqualToLiabilitiesAndEquities": [
                1352
            ],
            "isPayrollOk": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "CompanyLockHistory": {
            "type": [
                1347
            ],
            "userEmail": [
                1
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "createdAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CompanyLockStatus": {
            "minimumAllowedEventTime": [
                581
            ],
            "lockedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CompanyMainHolderInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CompanySyncBodyInput": {
            "id": [
                15
            ],
            "booksStartTime": [
                581
            ],
            "deletedAt": [
                581
            ],
            "name": [
                1
            ],
            "accountingMethod": [
                1
            ],
            "isTestCompany": [
                7
            ],
            "booksStatus": [
                1241
            ],
            "isArchived": [
                7
            ],
            "archivedAtIso": [
                581
            ],
            "createdAt": [
                581
            ],
            "tier": [
                464
            ],
            "trialStartTime": [
                581
            ],
            "trialDurationInDays": [
                41
            ],
            "isPaying": [
                7
            ],
            "eventsLock": [
                1241
            ],
            "isLiveTestCompany": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "CompanyTier": {},
        "CompanyTierType": {},
        "CompanyUser": {
            "email": [
                1
            ],
            "roles": [
                2355
            ],
            "name": [
                1
            ],
            "auth0Id": [
                1
            ],
            "invitationStatus": [
                1195
            ],
            "__typename": [
                1
            ]
        },
        "CompanyUsersArgs": {
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CompanyUsersResponse": {
            "users": [
                465
            ],
            "__typename": [
                1
            ]
        },
        "CompanyValidation": {
            "type": [
                475
            ],
            "metricName": [
                472
            ],
            "name": [
                1
            ],
            "status": [
                474
            ],
            "accounts": [
                419
            ],
            "asOfDate": [
                581
            ],
            "updatedAt": [
                581
            ],
            "lastSuccessfulRunAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CompanyValidationDomain": {
            "type": [
                470
            ],
            "name": [
                1
            ],
            "status": [
                474
            ],
            "validations": [
                468
            ],
            "__typename": [
                1
            ]
        },
        "CompanyValidationDomainType": {},
        "CompanyValidationMetricMode": {},
        "CompanyValidationMetricName": {},
        "CompanyValidationSortByValidationInput": {
            "validationType": [
                475
            ],
            "metricName": [
                472
            ],
            "__typename": [
                1
            ]
        },
        "CompanyValidationStatus": {},
        "CompanyValidationType": {},
        "CompanyWorksheet": {
            "worksheetRows": [
                477
            ],
            "company": [
                418
            ],
            "__typename": [
                1
            ]
        },
        "CompanyWorksheetRow": {
            "companyId": [
                1
            ],
            "dateForLocking": [
                581
            ],
            "name": [
                1
            ],
            "amount": [
                5
            ],
            "comment": [
                1
            ],
            "signedAt": [
                581
            ],
            "signedBy": [
                1
            ],
            "signedByName": [
                1
            ],
            "attachmentUrl": [
                1
            ],
            "attachmentFileName": [
                1
            ],
            "lockableEntity": [
                478
            ],
            "periodStart": [
                581
            ],
            "periodEnd": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CompanyWorksheetRowLockableEntity": {
            "on_BankAccount": [
                161
            ],
            "__typename": [
                1
            ]
        },
        "CompleteValidationCycleInput": {
            "validationCycleId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ConfirmApBalanceTask": {
            "id": [
                334
            ],
            "status": [
                337
            ],
            "accountBalances": [
                112
            ],
            "stateKey": [
                1
            ],
            "state": [
                481
            ],
            "history": [
                482
            ],
            "__typename": [
                1
            ]
        },
        "ConfirmApBalanceTaskState": {
            "confirmedBalances": [
                112
            ],
            "__typename": [
                1
            ]
        },
        "ConfirmApBalanceTaskStateChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                2507
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                481
            ],
            "newValue": [
                481
            ],
            "__typename": [
                1
            ]
        },
        "ConfirmArBalanceTask": {
            "id": [
                1224
            ],
            "status": [
                1227
            ],
            "stateKey": [
                1
            ],
            "accountBalances": [
                4
            ],
            "state": [
                484
            ],
            "history": [
                485
            ],
            "__typename": [
                1
            ]
        },
        "ConfirmArBalanceTaskState": {
            "confirmedBalances": [
                4
            ],
            "__typename": [
                1
            ]
        },
        "ConfirmArBalanceTaskStateChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                2507
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                484
            ],
            "newValue": [
                484
            ],
            "__typename": [
                1
            ]
        },
        "ConfirmRoleForPaymentGatewayInput": {
            "companyId": [
                15
            ],
            "paymentGatewayType": [
                1649
            ],
            "__typename": [
                1
            ]
        },
        "Contractor": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "source": [
                1
            ],
            "department": [
                640
            ],
            "firstName": [
                1
            ],
            "lastName": [
                1
            ],
            "middleName": [
                1
            ],
            "name": [
                1
            ],
            "businessName": [
                1
            ],
            "isActive": [
                7
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ContractorPayment": {
            "id": [
                1
            ],
            "company": [
                418
            ],
            "source": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "reimbursements": [
                1893
            ],
            "externalSourceId": [
                1
            ],
            "department": [
                640
            ],
            "postedAt": [
                581
            ],
            "currency": [
                1
            ],
            "wage": [
                5
            ],
            "wageInHomeCurrency": [
                5
            ],
            "bonus": [
                5
            ],
            "bonusInHomeCurrency": [
                5
            ],
            "categoryGroup": [
                1700
            ],
            "paymentChecksAmount": [
                5
            ],
            "isPaymentChecksAmountImmaterial": [
                7
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ContractorPaymentIdsByCompanyInput": {
            "companyIds": [
                15
            ],
            "afterBooksStartTimeOnly": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ContractorPaymentIdsByCompanyItem": {
            "companyId": [
                1
            ],
            "contractorPaymentIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ContractorPaymentIdsByCompanyResponse": {
            "items": [
                490
            ],
            "__typename": [
                1
            ]
        },
        "ContractorPaymentsInternalInput": {
            "companyId": [
                15
            ],
            "contractorPaymentIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ContractorPaymentsInternalResponse": {
            "contractorPayments": [
                488
            ],
            "__typename": [
                1
            ]
        },
        "ConvertBankAccountBackFromManualInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ConvertBankAccountToManualInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                15
            ],
            "startDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ConvertBetweenCurrenciesInput": {
            "amount": [
                5
            ],
            "asOfTime": [
                581
            ],
            "fromCurrency": [
                1
            ],
            "toCurrency": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ConvertBetweenCurrenciesResult": {
            "convertedAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "CopyBankAccountInput": {
            "sourceBankAccountId": [
                1
            ],
            "newBankAccountId": [
                1
            ],
            "companyId": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "status": [
                187
            ],
            "__typename": [
                1
            ]
        },
        "CostType": {},
        "CreateAccountRoleInput": {
            "name": [
                1
            ],
            "groupId": [
                15
            ],
            "sign": [
                1444
            ],
            "__typename": [
                1
            ]
        },
        "CreateAdminBankReconciliationRequestInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                15
            ],
            "requestType": [
                147
            ],
            "recurrence": [
                223
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CreateBankAccountInput": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "integrationAccountId": [
                1
            ],
            "source": [
                1113
            ],
            "externalSourceId": [
                1
            ],
            "type": [
                191
            ],
            "subtype": [
                189
            ],
            "connectionStatus": [
                166
            ],
            "lastUpdateTime": [
                581
            ],
            "isHistoricalUpdateCompleted": [
                7
            ],
            "currency": [
                1
            ],
            "externalInstitutionId": [
                1
            ],
            "institutionId": [
                1
            ],
            "institutionName": [
                1
            ],
            "name": [
                1
            ],
            "displayName": [
                1
            ],
            "overrideFullName": [
                1
            ],
            "mask": [
                1
            ],
            "currentBalance": [
                5
            ],
            "connectedAt": [
                581
            ],
            "rawData": [
                1242
            ],
            "shouldUpdateAccountDetailsOnNextUpdate": [
                7
            ],
            "status": [
                187
            ],
            "createdByActor": [
                38
            ],
            "createdBy": [
                1
            ],
            "createdFromSource": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateBankAccountStatementForStopImportInput": {
            "bankAccountId": [
                15
            ],
            "companyId": [
                15
            ],
            "stopImportFromDate": [
                1
            ],
            "displayedBalance": [
                5
            ],
            "closedDate": [
                1
            ],
            "isConfirmed": [
                7
            ],
            "fileNames": [
                1
            ],
            "csvFileNames": [
                1
            ],
            "realBalance": [
                5
            ],
            "newOwner": [
                174
            ],
            "__typename": [
                1
            ]
        },
        "CreateBankStatementFileInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                1
            ],
            "s3Bucket": [
                1
            ],
            "s3Key": [
                1
            ],
            "uploadOriginator": [
                1
            ],
            "skipMachineTrigger": [
                7
            ],
            "originFileId": [
                15
            ],
            "fileStatus": [
                243
            ],
            "uploadedOnBankTransactionId": [
                15
            ],
            "bankStatementRequestId": [
                1
            ],
            "companyAffiliateType": [
                427
            ],
            "companyAffiliateId": [
                1
            ],
            "system": [
                246
            ],
            "subSystem": [
                244
            ],
            "uploadedBy": [
                38
            ],
            "uploadedById": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateBankTransactionsUploadInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                1
            ],
            "bucket": [
                1
            ],
            "key": [
                1
            ],
            "uploadOriginator": [
                1
            ],
            "uploadedBy": [
                38
            ],
            "uploadedById": [
                1
            ],
            "uploadedAt": [
                581
            ],
            "skipMachineTrigger": [
                7
            ],
            "originFileId": [
                15
            ],
            "fileStatus": [
                301
            ],
            "uploadedOnBankTransactionId": [
                15
            ],
            "fileUrl": [
                1
            ],
            "bankStatementRequestId": [
                1
            ],
            "companyAffiliateType": [
                427
            ],
            "companyAffiliateId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateBigValidationAdjustmentInput": {
            "companyId": [
                15
            ],
            "date": [
                581
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "CreateCheckoutSessionInput": {
            "companyId": [
                15
            ],
            "paymentOptionIds": [
                15
            ],
            "successUrl": [
                1
            ],
            "cancelUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateCheckoutSessionResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateCompanyAffiliateInput": {
            "companyId": [
                15
            ],
            "name": [
                1
            ],
            "type": [
                427
            ],
            "isForeignResident": [
                7
            ],
            "holdingsInPercentage": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "CreateCompanyInput": {
            "email": [
                1
            ],
            "stripeCustomerId": [
                1
            ],
            "source": [
                1241
            ],
            "referralCode": [
                1
            ],
            "isParkerReferral": [
                7
            ],
            "withoutNotification": [
                7
            ],
            "gtmSource": [
                1020
            ],
            "appsSelectedInPreOnboarding": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateCompanyLoanFromTransactionClassificationInput": {
            "loanId": [
                15
            ],
            "amount": [
                5
            ],
            "amountInPercentage": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "classificationTagId": [
                15
            ],
            "classificationText": [
                15
            ],
            "businessEvent": [
                1
            ],
            "affiliatedEntityId": [
                15
            ],
            "pairedEntityId": [
                1
            ],
            "pairedEntityType": [
                1637
            ],
            "pairingType": [
                1638
            ],
            "askTheUserResult": [
                1242
            ],
            "extraData": [
                1242
            ],
            "description": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateCompanyLoanInput": {
            "companyId": [
                15
            ],
            "data": [
                1340
            ],
            "__typename": [
                1
            ]
        },
        "CreateCustomerArgs": {
            "name": [
                1
            ],
            "companyName": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "source": [
                562
            ],
            "email": [
                1
            ],
            "phoneNumber": [
                1
            ],
            "billingAddress": [
                59
            ],
            "shippingAddress": [
                59
            ],
            "__typename": [
                1
            ]
        },
        "CreateCustomerCategorizationRuleInput": {
            "companyId": [
                15
            ],
            "applyForAlreadyCategorizedTransactions": [
                7
            ],
            "merchant": [
                1409
            ],
            "moneyDirection": [
                2079
            ],
            "classification": [
                559
            ],
            "classifications": [
                559
            ],
            "__typename": [
                1
            ]
        },
        "CreateCustomerCategorizationRuleResult": {
            "realTimeApplierJobId": [
                1
            ],
            "bankTransactionIdsAffectedByJobId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CreateFileUploadUrlInput": {
            "companyId": [
                1
            ],
            "source": [
                739
            ],
            "fileName": [
                1
            ],
            "featureContext": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateGlobalRuleResult": {
            "id": [
                15
            ],
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "CreateGlobalVendorInput": {
            "id": [
                1
            ],
            "name": [
                1
            ],
            "notificationInfo": [
                2385
            ],
            "subTypes": [
                2388
            ],
            "is1099Contractor": [
                7
            ],
            "websiteUrl": [
                1
            ],
            "source": [
                2386
            ],
            "labels": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateGlobalVendorRuleInput": {
            "vendorIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateImageUploadUrlInput": {
            "companyId": [
                1
            ],
            "fileName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateInstitutionInput": {
            "name": [
                1
            ],
            "preferredProvider": [
                1079
            ],
            "isMajor": [
                1
            ],
            "logoUrl": [
                1
            ],
            "websiteUrl": [
                1
            ],
            "csvInstructionsLink": [
                1
            ],
            "pdfInstructionsLink": [
                1
            ],
            "csvAvailable": [
                7
            ],
            "pdfAvailable": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "CreateInstitutionMappingsInput": {
            "source": [
                1078
            ],
            "externalSourceId": [
                1
            ],
            "externalSourceName": [
                1
            ],
            "institutionId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateIntegrationTransferRuleInput": {
            "companyId": [
                15
            ],
            "integrationType": [
                1113
            ],
            "companyAffiliateId": [
                15
            ],
            "integrationAccountId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CreateInventoryVendorValidationInput": {
            "companyId": [
                15
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "unpaidBillsUntil": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CreateInventoryVendorValidationResponse": {
            "validationId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateLoanEventDefinitionInput": {
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateLoanFromBalanceTransactionInput": {
            "companyId": [
                15
            ],
            "balanceTransactionId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CreateLoanFromBillFinancedInput": {
            "companyId": [
                15
            ],
            "billId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CreateLoanInput": {
            "companyId": [
                15
            ],
            "data": [
                1341
            ],
            "merchantRole": [
                427
            ],
            "__typename": [
                1
            ]
        },
        "CreateLoansEventsEffectConfigurationInput": {
            "eventDefinitionId": [
                15
            ],
            "loanType": [
                1339
            ],
            "isShortTerm": [
                7
            ],
            "direction": [
                1307
            ],
            "minGracePeriod": [
                41
            ],
            "repaymentType": [
                1327
            ],
            "lenderId": [
                15
            ],
            "memoTemplate": [
                1
            ],
            "dateTemplate": [
                1
            ],
            "accrualConfig": [
                1240
            ],
            "cashConfig": [
                1240
            ],
            "loanOutstandingAmountAffect": [
                1321
            ],
            "loanAmountAffect": [
                1292
            ],
            "__typename": [
                1
            ]
        },
        "CreateManualBankAccountInput": {
            "companyId": [
                15
            ],
            "nameOnBooks": [
                1
            ],
            "institutionName": [
                1
            ],
            "institutionId": [
                1
            ],
            "accountName": [
                1
            ],
            "mask": [
                1
            ],
            "type": [
                191
            ],
            "subType": [
                189
            ],
            "currency": [
                1
            ],
            "createdFromSource": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateManualLoanEventInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "events": [
                534
            ],
            "__typename": [
                1
            ]
        },
        "CreateManualLoanEventInput2": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "eventDefinitionId": [
                15
            ],
            "amount": [
                5
            ],
            "memo": [
                1
            ],
            "postedAt": [
                581
            ],
            "spreadInput": [
                535
            ],
            "recurrenceSettings": [
                1887
            ],
            "__typename": [
                1
            ]
        },
        "CreateManualLoanEventInputEvents": {
            "eventDefinitionId": [
                15
            ],
            "amount": [
                5
            ],
            "memo": [
                1
            ],
            "postedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CreateManualLoanEventSpreadInput": {
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CreateOrGetBusinessEventDefinitionInput": {
            "type": [
                1
            ],
            "variant": [
                1
            ],
            "accrualConfig": [
                1240
            ],
            "cashConfig": [
                1240
            ],
            "originalActorId": [
                1
            ],
            "originalActorType": [
                38
            ],
            "integrationType": [
                1
            ],
            "name": [
                1
            ],
            "customerDisplayName": [
                1
            ],
            "groups": [
                1
            ],
            "vendorRequired": [
                7
            ],
            "requiredAffiliatedEntityType": [
                1
            ],
            "irrelevantForVendor": [
                7
            ],
            "hideForManualClassification": [
                7
            ],
            "forceShowInEventsListings": [
                7
            ],
            "isRelevantToAccruals": [
                7
            ],
            "moneyDirection": [
                1436
            ],
            "__typename": [
                1
            ]
        },
        "CreateOrUpdateAccrualInput": {
            "companyId": [
                15
            ],
            "bankTransactionId": [
                15
            ],
            "accrualsData": [
                19
            ],
            "categorizations": [
                16
            ],
            "__typename": [
                1
            ]
        },
        "CreateOrUpdateAccrualResult": {
            "bankTransaction": [
                270
            ],
            "status": [
                27
            ],
            "error": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateProductManuallyError": {
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateProductManuallyInput": {
            "source": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "companyId": [
                1
            ],
            "displayName": [
                1
            ],
            "sku": [
                1
            ],
            "imageUrl": [
                1
            ],
            "isFractional": [
                7
            ],
            "platformId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateProductManuallyResponse": {
            "on_CreateProductManuallyError": [
                539
            ],
            "on_CreateProductManuallySuccess": [
                542
            ],
            "__typename": [
                1
            ]
        },
        "CreateProductManuallySuccess": {
            "product": [
                1769
            ],
            "__typename": [
                1
            ]
        },
        "CreateShopifyProductsFromDiagnosticsInput": {
            "companyId": [
                15
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CreateTeamCategorizationRuleResult": {
            "realTimeApplierJobId": [
                1
            ],
            "bankTransactionIdsAffectedByJobId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CreateUserResponse": {
            "user": [
                2333
            ],
            "__typename": [
                1
            ]
        },
        "CreateVendorArgs": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "name": [
                1
            ],
            "notificationInfo": [
                2385
            ],
            "subTypes": [
                2388
            ],
            "is1099Contractor": [
                7
            ],
            "contactEmail": [
                1
            ],
            "source": [
                2386
            ],
            "externalSourceId": [
                1
            ],
            "isPaymentVendor": [
                7
            ],
            "labels": [
                1
            ],
            "logoUrl": [
                1
            ],
            "websiteUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CreateWarehouseInput": {
            "companyId": [
                1
            ],
            "source": [
                1
            ],
            "name": [
                1
            ],
            "phone": [
                1
            ],
            "city": [
                1
            ],
            "province": [
                1
            ],
            "country": [
                1
            ],
            "zip": [
                1
            ],
            "address": [
                1
            ],
            "isDropshipping": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "CSVUpload": {
            "name": [
                1
            ],
            "uploadId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CurrencyCode": {},
        "CurrentlyRunningInventoryDataSyncInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CurrentlyRunningInventoryDataSyncResponse": {
            "totalItems": [
                41
            ],
            "completedItems": [
                41
            ],
            "updatingProducts": [
                1769
            ],
            "__typename": [
                1
            ]
        },
        "CurrentlyRunningInventoryDataSyncVendorsResponse": {
            "affiliatedEntities": [
                72
            ],
            "__typename": [
                1
            ]
        },
        "CurrentPreviousValue": {
            "current": [
                5
            ],
            "previous": [
                5
            ],
            "unitType": [
                2196
            ],
            "__typename": [
                1
            ]
        },
        "Customer": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "companyId": [
                15
            ],
            "companyName": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "source": [
                562
            ],
            "email": [
                1
            ],
            "phoneNumber": [
                1
            ],
            "billingAddress": [
                557
            ],
            "shippingAddress": [
                557
            ],
            "__typename": [
                1
            ]
        },
        "CustomerAddress": {
            "id": [
                15
            ],
            "country": [
                1
            ],
            "countryCode": [
                1
            ],
            "state": [
                1
            ],
            "stateCode": [
                1
            ],
            "province": [
                1
            ],
            "provinceCode": [
                1
            ],
            "city": [
                1
            ],
            "zip": [
                1
            ],
            "line1": [
                1
            ],
            "line2": [
                1
            ],
            "isShipping": [
                7
            ],
            "isBilling": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "CustomerAddressArgs": {
            "line1": [
                1
            ],
            "line2": [
                1
            ],
            "city": [
                1
            ],
            "country": [
                1
            ],
            "countryCode": [
                1
            ],
            "province": [
                1
            ],
            "provinceCode": [
                1
            ],
            "state": [
                1
            ],
            "stateCode": [
                1
            ],
            "zip": [
                1
            ],
            "source": [
                562
            ],
            "__typename": [
                1
            ]
        },
        "CustomerAddressOld": {
            "country": [
                1
            ],
            "state": [
                1
            ],
            "city": [
                1
            ],
            "postalCode": [
                1
            ],
            "line1": [
                1
            ],
            "line2": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "CustomerAddressV3": {
            "id": [
                15
            ],
            "phoneNumber": [
                1
            ],
            "country": [
                1
            ],
            "countryCode": [
                1
            ],
            "state": [
                1
            ],
            "stateCode": [
                1
            ],
            "province": [
                1
            ],
            "provinceCode": [
                1
            ],
            "city": [
                1
            ],
            "zip": [
                1
            ],
            "line1": [
                1
            ],
            "line2": [
                1
            ],
            "isShipping": [
                7
            ],
            "isBilling": [
                7
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "CustomerCategorizationRuleClassificationInput": {
            "classificationTagId": [
                15
            ],
            "businessEvent": [
                1
            ],
            "pairedEntityType": [
                1637
            ],
            "pairedEntityId": [
                1
            ],
            "pairingType": [
                1638
            ],
            "amountInPercentage": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "CustomerNotExistError": {
            "message": [
                1
            ],
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "CustomerSelectedAccountingMethod": {},
        "CustomerSource": {},
        "CustomerV2": {
            "id": [
                15
            ],
            "affiliatedEntityId": [
                15
            ],
            "companyId": [
                1
            ],
            "source": [
                1
            ],
            "name": [
                1
            ],
            "email": [
                1
            ],
            "billingAddress": [
                555
            ],
            "shippingAddress": [
                555
            ],
            "addresses": [
                555
            ],
            "__typename": [
                1
            ]
        },
        "CustomerV3": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "name": [
                1
            ],
            "email": [
                1
            ],
            "integrationType": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "addresses": [
                558
            ],
            "__typename": [
                1
            ]
        },
        "CustomFixedAssetsData": {
            "usefulLifeStartDate": [
                581
            ],
            "depreciationMethod": [
                642
            ],
            "residualValue": [
                5
            ],
            "section179Deduction": [
                1980
            ],
            "addDepreciationBonus": [
                48
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "amount": [
                5
            ],
            "spreadBasisType": [
                2103
            ],
            "canceledAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "CustomFixedAssetsDataInput": {
            "usefulLifeStartDate": [
                1
            ],
            "depreciationMethod": [
                642
            ],
            "residualValue": [
                5
            ],
            "section179Deduction": [
                1981
            ],
            "addDepreciationBonus": [
                49
            ],
            "startDate": [
                1
            ],
            "endDate": [
                1
            ],
            "amount": [
                5
            ],
            "spreadBasisType": [
                2103
            ],
            "__typename": [
                1
            ]
        },
        "CustomSpread": {
            "specificDate": [
                2097
            ],
            "spreadOverTime": [
                571
            ],
            "__typename": [
                1
            ]
        },
        "CustomSpreadInput": {
            "specificDate": [
                2098
            ],
            "spreadOverTime": [
                572
            ],
            "__typename": [
                1
            ]
        },
        "CustomSpreadOptions": {
            "spreadBasisType": [
                2103
            ],
            "residualAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "CustomSpreadOptionsInput": {
            "spreadBasisType": [
                2103
            ],
            "__typename": [
                1
            ]
        },
        "CustomSpreadOverTime": {
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "CustomSpreadOverTimeInput": {
            "fromDate": [
                1
            ],
            "toDate": [
                1
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "DailyAggregatedOwnersDraw": {
            "employeeId": [
                15
            ],
            "employeeName": [
                1
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "DailyAggregatedPaymentCheck": {
            "id": [
                15
            ],
            "amount": [
                5
            ],
            "postedAt": [
                581
            ],
            "employeeId": [
                15
            ],
            "employmentType": [
                1714
            ],
            "categoryGroup": [
                1700
            ],
            "isImmaterial": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "DailyAggregatedPayrollData": {
            "date": [
                581
            ],
            "salariesAndWages": [
                5
            ],
            "bonus": [
                5
            ],
            "commission": [
                5
            ],
            "correctionPayment": [
                5
            ],
            "tips": [
                5
            ],
            "holidayPay": [
                5
            ],
            "sickLeave": [
                5
            ],
            "severance": [
                5
            ],
            "ownersDraw": [
                5
            ],
            "vacationPay": [
                5
            ],
            "ficaEmployee": [
                5
            ],
            "ficaEmployer": [
                5
            ],
            "federalEmployee": [
                5
            ],
            "federalEmployer": [
                5
            ],
            "stateAndLocalEmployee": [
                5
            ],
            "stateAndLocalEmployer": [
                5
            ],
            "savingsAndRetirement401kEmployee": [
                5
            ],
            "savingsAndRetirement401kEmployer": [
                5
            ],
            "savingsAndRetirementOtherEmployee": [
                5
            ],
            "savingsAndRetirementOtherEmployer": [
                5
            ],
            "healthEmployee": [
                5
            ],
            "healthEmployer": [
                5
            ],
            "transportationEmployee": [
                5
            ],
            "transportationEmployer": [
                5
            ],
            "otherBenefitsEmployee": [
                5
            ],
            "otherBenefitsEmployer": [
                5
            ],
            "childSupport": [
                5
            ],
            "otherGarnishments": [
                5
            ],
            "otherDeductions": [
                5
            ],
            "grossPay": [
                5
            ],
            "netPay": [
                5
            ],
            "employerCost": [
                5
            ],
            "employmentType": [
                1714
            ],
            "categoryGroup": [
                1700
            ],
            "__typename": [
                1
            ]
        },
        "DailyAggregatedReimbursement": {
            "id": [
                15
            ],
            "amount": [
                5
            ],
            "postedAt": [
                581
            ],
            "employeeId": [
                15
            ],
            "isClearedByNetPayPayment": [
                7
            ],
            "paymentMethod": [
                1
            ],
            "employmentType": [
                1714
            ],
            "categoryGroup": [
                1700
            ],
            "__typename": [
                1
            ]
        },
        "DailyPaymentsByContractor": {
            "contractor": [
                487
            ],
            "payments": [
                5
            ],
            "reimbursements": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "DailyPaymentsByEmployee": {
            "employee": [
                673
            ],
            "netPay": [
                5
            ],
            "grossPay": [
                5
            ],
            "employeeTaxes": [
                5
            ],
            "deductionsAndBenefits": [
                5
            ],
            "reimbursements": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "DangerousTouchLoanInput": {
            "loanId": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DataSerie": {
            "label": [
                1
            ],
            "values": [
                5
            ],
            "unitGroup": [
                1
            ],
            "valueType": [
                2374
            ],
            "previous": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "Date": {},
        "DateRange": {
            "startTime": [
                581
            ],
            "endTime": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "DateRangeInput": {
            "from": [
                581
            ],
            "to": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "DatesToFix": {
            "date": [
                581
            ],
            "quantity": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "DatesToFixInput": {
            "date": [
                581
            ],
            "quantity": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "DeadInventoryAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeadInventoryCogs": {
            "amount": [
                5
            ],
            "quantity": [
                5
            ],
            "monthlyBreakdown": [
                589
            ],
            "__typename": [
                1
            ]
        },
        "DeadInventoryDailyBreakdown": {
            "date": [
                581
            ],
            "quantity": [
                5
            ],
            "reason": [
                66
            ],
            "__typename": [
                1
            ]
        },
        "DeadInventoryMonthlyBreakdown": {
            "date": [
                581
            ],
            "quantity": [
                5
            ],
            "dailyData": [
                588
            ],
            "__typename": [
                1
            ]
        },
        "DeadInventoryOriginalValue": {
            "quantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "DecisionClassificationMetadataRecommendationOptionValue": {
            "seenOptions": [
                389
            ],
            "__typename": [
                1
            ]
        },
        "DecisionClassificationMetadataRecommendationPromptValue": {
            "prompt": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DefaultFixedAssetsData": {
            "usefulLifeStartDate": [
                581
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "amount": [
                5
            ],
            "canceledAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "DefaultFixedAssetsDataInput": {
            "usefulLifeStartDate": [
                1
            ],
            "startDate": [
                1
            ],
            "endDate": [
                1
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "DeleteAccrualInput": {
            "bankTransactionId": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteAccrualV2Input": {
            "entityType": [
                21
            ],
            "entityId": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteBankAccountsInput": {
            "companyId": [
                1
            ],
            "bankAccountIds": [
                15
            ],
            "userEmail": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeleteBankConnectionInput": {
            "companyId": [
                15
            ],
            "integrationType": [
                1113
            ],
            "integrationAccountId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeleteBankReconciliationRequestConfigInput": {
            "companyId": [
                15
            ],
            "requestId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteBankTransactionAttachmentInput": {
            "companyId": [
                15
            ],
            "bankTransactionId": [
                15
            ],
            "attachmentUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeleteBankTransactionsByBankAccountIdsInput": {
            "companyId": [
                15
            ],
            "bankAccountIds": [
                15
            ],
            "userEmail": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeleteCompanyAffiliateInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteFifoGroupsInput": {
            "companyId": [
                15
            ],
            "productIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeleteHolderCapitalInvestmentInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteHolderShareInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteInventoryPaymentGroupInput": {
            "companyId": [
                15
            ],
            "paymentGroupId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteInventoryPaymentGroupResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "DeleteInventoryPurchaseInput": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "lastUpdatedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "DeleteInvoicesResponse": {
            "deleted": [
                15
            ],
            "errors": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeleteLoanAttachmentInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "attachmentId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteLoanInput": {
            "loanId": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteLoanManualAccountingEventsInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "accountingEventIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteLoanRelationshipsInput": {
            "relationshipIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteLoansEventsEffectConfigurationInput": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteLoansEventsEffectConfigurationResult": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "DeleteLoansInput": {
            "loans": [
                611
            ],
            "__typename": [
                1
            ]
        },
        "DeleteLoansResults": {
            "loans": [
                1287
            ],
            "__typename": [
                1
            ]
        },
        "DeleteManualAssemblyInput": {
            "companyId": [
                15
            ],
            "id": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeleteManualEquityEventsInput": {
            "ids": [
                15
            ],
            "configurationIds": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteManualLoanEventInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "eventId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteManualLoanEventsInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "eventIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteNoUnitsPhysicalCountInput": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeleteNoUnitsValidationInvalidAckInput": {
            "companyId": [
                15
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "DeleteOrderGroupInput": {
            "companyId": [
                15
            ],
            "orderGroupId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteOrderGroupResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "DeleteOrderGroupUponTransactionChangeInput": {
            "companyId": [
                1
            ],
            "orderGroupId": [
                1
            ],
            "changedBankTransactionId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeleteOrderGroupUponTransactionChangeResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "DeletePaymentGroupInput": {
            "companyId": [
                15
            ],
            "paymentGroupId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeletePaymentGroupResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "DeletePaymentGroupUponTransactionChangeInput": {
            "companyId": [
                1
            ],
            "paymentGroupId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeletePaymentGroupUponTransactionChangeResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "DeletePendingWarehouseOpeningAttachmentInput": {
            "companyId": [
                15
            ],
            "attachmentId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DeleteProductsInput": {
            "companyId": [
                15
            ],
            "productIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeletePurchaseOrderInput": {
            "companyId": [
                1
            ],
            "id": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeleteRecipeInput": {
            "companyId": [
                15
            ],
            "recipeId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeleteUnitsTrackingPhysicalCountInput": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeleteWarehouseInput": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeleteWarehouseOpeningBalancesInput": {
            "companyId": [
                15
            ],
            "date": [
                581
            ],
            "productId": [
                1
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DeleteWarehouseTransferInput": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Department": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "source": [
                1
            ],
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Dependency": {
            "blocked": [
                7
            ],
            "resolvedAt": [
                581
            ],
            "on_BalanceSheetDependency": [
                151
            ],
            "on_YearEndDependency": [
                2473
            ],
            "__typename": [
                1
            ]
        },
        "DepreciationMethod": {},
        "DetectAndNotifyCogsDrasticChangesInput": {
            "companyIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DirectLineItem": {
            "id": [
                15
            ],
            "product": [
                1769
            ],
            "quantity": [
                5
            ],
            "vendor": [
                2375
            ],
            "indirectCostsAllocation": [
                1064
            ],
            "directCostPerUnit": [
                5
            ],
            "indirectCostPerUnit": [
                5
            ],
            "remainderIndirectCostPerUnit": [
                5
            ],
            "discountCostPerUnit": [
                5
            ],
            "remainderDiscountCostPerUnit": [
                5
            ],
            "landedCostPerUnit": [
                5
            ],
            "remainderLandedCostPerUnit": [
                5
            ],
            "directCostTotal": [
                5
            ],
            "indirectCostTotal": [
                5
            ],
            "landedCostTotal": [
                5
            ],
            "discountCostTotal": [
                5
            ],
            "note": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DirectLineItemInput": {
            "id": [
                15
            ],
            "productId": [
                1
            ],
            "quantity": [
                5
            ],
            "vendorId": [
                15
            ],
            "directCostPerUnit": [
                5
            ],
            "indirectCostsAllocation": [
                1065
            ],
            "indirectCostPerUnit": [
                5
            ],
            "remainderIndirectCostPerUnit": [
                5
            ],
            "discountCostPerUnit": [
                5
            ],
            "remainderDiscountCostPerUnit": [
                5
            ],
            "landedCostPerUnit": [
                5
            ],
            "remainderLandedCostPerUnit": [
                5
            ],
            "directCostTotal": [
                5
            ],
            "indirectCostTotal": [
                5
            ],
            "landedCostTotal": [
                5
            ],
            "discountCostTotal": [
                5
            ],
            "note": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DiscardNoUnitsPhysicalCountProductQuantityPendingAdjustmentInput": {
            "physicalCountId": [
                1
            ],
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DiscardPendingAdjustments": {
            "companyId": [
                15
            ],
            "managementMethodId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DiscardPendingWarehouseOpeningBalancesInput": {
            "companyId": [
                15
            ],
            "date": [
                581
            ],
            "warehouseId": [
                1
            ],
            "productId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DiscardUnitsTrackingPhysicalCountProductQuantityPendingAdjustmentInput": {
            "physicalCountId": [
                1
            ],
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DisconnectConnectionInput": {
            "companyId": [
                15
            ],
            "integrationType": [
                1113
            ],
            "integrationAccountId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Discount": {
            "id": [
                15
            ],
            "type": [
                654
            ],
            "amount": [
                5
            ],
            "description": [
                1
            ],
            "totalAmount": [
                5
            ],
            "discountType": [
                1250
            ],
            "__typename": [
                1
            ]
        },
        "DiscountInput": {
            "id": [
                15
            ],
            "amount": [
                5
            ],
            "type": [
                654
            ],
            "description": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DiscountLineItemV3": {
            "id": [
                15
            ],
            "externalLineItemId": [
                1
            ],
            "name": [
                1
            ],
            "description": [
                1
            ],
            "amount": [
                107
            ],
            "parentId": [
                1
            ],
            "parentLineItemType": [
                1639
            ],
            "earliestPostedAt": [
                581
            ],
            "latestPostedAt": [
                581
            ],
            "type": [
                1549
            ],
            "discountType": [
                1542
            ],
            "__typename": [
                1
            ]
        },
        "DiscountType": {},
        "DispatchEshedTestInput": {
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Dispute": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "source": [
                1113
            ],
            "integrationAccountId": [
                15
            ],
            "integrationAccountName": [
                1
            ],
            "disputedAmount": [
                5
            ],
            "disputedCurrency": [
                1
            ],
            "openedAt": [
                581
            ],
            "closedAt": [
                581
            ],
            "reviewStartedAt": [
                581
            ],
            "refundAmount": [
                5
            ],
            "refundCurrency": [
                1
            ],
            "outcome": [
                657
            ],
            "__typename": [
                1
            ]
        },
        "DisputeOutcome": {},
        "DonationCogs": {
            "amount": [
                5
            ],
            "quantity": [
                41
            ],
            "monthlyBreakdown": [
                660
            ],
            "__typename": [
                1
            ]
        },
        "DonationDailyBreakdown": {
            "date": [
                581
            ],
            "quantity": [
                41
            ],
            "reason": [
                66
            ],
            "__typename": [
                1
            ]
        },
        "DonationMonthlyBreakdown": {
            "date": [
                581
            ],
            "quantity": [
                41
            ],
            "dailyData": [
                659
            ],
            "__typename": [
                1
            ]
        },
        "DonationOriginalValue": {
            "quantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "DownloadAttachmentInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "attachmentId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "DownloadAttachmentResult": {
            "fileName": [
                1
            ],
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DropshippingModeType": {},
        "DropshippingSettings": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "isEnabled": [
                7
            ],
            "mode": [
                664
            ],
            "affiliatedEntities": [
                72
            ],
            "__typename": [
                1
            ]
        },
        "DropshippingSettingsInput": {
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "DueDateSummary": {
            "count": [
                41
            ],
            "sum": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "DuplicateCheckResult": {},
        "EarlyRepaymentDiscount": {
            "period": [
                41
            ],
            "fee": [
                5
            ],
            "periodType": [
                670
            ],
            "__typename": [
                1
            ]
        },
        "EarlyRepaymentDiscountPeriodType": {},
        "EarlyRepaymentDiscountUpdate": {
            "period": [
                41
            ],
            "fee": [
                5
            ],
            "periodType": [
                670
            ],
            "__typename": [
                1
            ]
        },
        "EditClassificationTagInput": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "moneyDirection": [
                1436
            ],
            "isHidden": [
                7
            ],
            "isRelevantToBills": [
                7
            ],
            "isRelevantToApplyAlways": [
                7
            ],
            "displayNameForReports": [
                1
            ],
            "keywords": [
                1
            ],
            "moneyInBusinessEvent": [
                15
            ],
            "moneyOutBusinessEvent": [
                15
            ],
            "isApplicableForRefund": [
                7
            ],
            "reportsDisplayNameForTagSelection": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Employee": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "source": [
                1
            ],
            "department": [
                640
            ],
            "firstName": [
                1
            ],
            "lastName": [
                1
            ],
            "middleName": [
                1
            ],
            "name": [
                1
            ],
            "isOfficer": [
                7
            ],
            "isTerminated": [
                7
            ],
            "jobs": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "EnrichmentRuleType": {},
        "EntitiesByType": {
            "entityType": [
                1
            ],
            "entityIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "EntityLockedPeriodBypass": {
            "companyId": [
                15
            ],
            "entityType": [
                1
            ],
            "entityId": [
                15
            ],
            "isBypassed": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "EquityEventsEffectConfiguration": {
            "id": [
                15
            ],
            "legalEntityType": [
                1
            ],
            "taxEntityType": [
                1
            ],
            "shareType": [
                679
            ],
            "memoTemplate": [
                1
            ],
            "dateTemplate": [
                1
            ],
            "businessEventActionsConfiguration": [
                348
            ],
            "latestActorType": [
                38
            ],
            "latestActorId": [
                1
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "EquityEventsEffectConfigurationsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "EquityEventShareType": {},
        "Error": {
            "message": [
                1
            ],
            "on_CustomerNotExistError": [
                560
            ],
            "on_VendorNotExistError": [
                2381
            ],
            "__typename": [
                1
            ]
        },
        "EstimatedProjectedRevenue": {},
        "EvaluateBankReconciliationRequestsInput": {
            "companyId": [
                15
            ],
            "skipFeatureFlags": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "EvaluateBankReconciliationRequestsResponse": {
            "explains": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "EventsLock": {
            "minimumAllowedEventTime": [
                581
            ],
            "lockHistory": [
                440
            ],
            "__typename": [
                1
            ]
        },
        "ExcludedSalesChannelItemReconciliation": {
            "sku": [
                1
            ],
            "isBlacklisted": [
                7
            ],
            "shopifySalesChannel": [
                1
            ],
            "summary": [
                1883
            ],
            "__typename": [
                1
            ]
        },
        "ExistingCompanyIntegrationInput": {
            "integrationType": [
                2312
            ],
            "integrationAccountId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExplainBankAccountMergeDuplicate": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "status": [
                187
            ],
            "createdAt": [
                581
            ],
            "transactionsImportStatus": [
                692
            ],
            "__typename": [
                1
            ]
        },
        "ExplainBankAccountMergeExplain": {
            "primary": [
                15
            ],
            "companyId": [
                15
            ],
            "duplicates": [
                687
            ],
            "notes": [
                690
            ],
            "__typename": [
                1
            ]
        },
        "ExplainBankAccountMergeInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ExplainBankAccountMergeNote": {
            "error": [
                1
            ],
            "resolution": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExplainBankAccountMergeResponse": {
            "explains": [
                688
            ],
            "__typename": [
                1
            ]
        },
        "ExplainBankAccountMergeTransactionsImportStatus": {
            "stopImportFromDate": [
                581
            ],
            "changedBy": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExplainFifoInput": {
            "companyId": [
                15
            ],
            "productId": [
                1
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ExplainFifoResult": {
            "warehouseMovements": [
                2409
            ],
            "__typename": [
                1
            ]
        },
        "ExportAccrualsListCsvInput": {
            "companyId": [
                15
            ],
            "asOfDate": [
                581
            ],
            "accrualType": [
                28
            ],
            "scheduleWithoutAdjustments": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ExportAccrualsListCsvResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExportBalanceSheetApiArgs": {
            "companyId": [
                15
            ],
            "isGoogleExport": [
                7
            ],
            "fromTimeIso": [
                581
            ],
            "toTimeIso": [
                581
            ],
            "noDecimals": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ExportCashFlowApiArgs": {
            "companyId": [
                15
            ],
            "exportArgs": [
                699
            ],
            "__typename": [
                1
            ]
        },
        "ExportCashFlowArgs": {
            "timeRange": [
                2152
            ],
            "fileType": [
                738
            ],
            "groupByTimeWindow": [
                1431
            ],
            "includeUDFAccounts": [
                7
            ],
            "includeCCAccounts": [
                7
            ],
            "breakdowns": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExportCOGSBreakdownRequest": {
            "companyId": [
                15
            ],
            "from": [
                581
            ],
            "to": [
                581
            ],
            "type": [
                415
            ],
            "salesChannel": [
                1946
            ],
            "category": [
                409
            ],
            "sort": [
                814
            ],
            "searchText": [
                1
            ],
            "productIds": [
                1
            ],
            "warehouseIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExportCOGSBreakdownResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExportCOGSOverviewRequest": {
            "companyId": [
                15
            ],
            "from": [
                581
            ],
            "to": [
                581
            ],
            "filters": [
                816
            ],
            "__typename": [
                1
            ]
        },
        "ExportCOGSOverviewResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExportCSVResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExportedReportsLogsSortBy": {},
        "ExportGeneralLedgerInput": {
            "companyId": [
                15
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "email": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExportGeneralLedgerResponse": {
            "jobId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ExportInvoicesResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExportLedgerAccountTransactionsInput": {
            "companyId": [
                15
            ],
            "exportArgs": [
                727
            ],
            "withBalance": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ExportLoansCsvInput": {
            "companyIds": [
                1
            ],
            "lenderIds": [
                1
            ],
            "vendorIds": [
                1
            ],
            "affiliatedEntityIds": [
                1
            ],
            "updateBy": [
                1
            ],
            "statuses": [
                1338
            ],
            "companyTiers": [
                1
            ],
            "owners": [
                1
            ],
            "showOnlyModified": [
                7
            ],
            "userActionStatuses": [
                1343
            ],
            "includeDeleted": [
                7
            ],
            "loanType": [
                1339
            ],
            "limit": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "ExportLoansResult": {
            "url": [
                1
            ],
            "fileName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExportNoUnitsTrackingPhysicalCountProductQuantitiesInput": {
            "companyId": [
                1
            ],
            "filters": [
                896
            ],
            "__typename": [
                1
            ]
        },
        "ExportProductsResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExportPurchaseOrdersInput": {
            "companyId": [
                15
            ],
            "filters": [
                943
            ],
            "__typename": [
                1
            ]
        },
        "ExportPurchaseOrdersResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExportResponse": {
            "signedUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExportSkuAnalysisInput": {
            "companyId": [
                15
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "breakdown": [
                1
            ],
            "timezone": [
                1
            ],
            "comparisonPeriod": [
                1
            ],
            "stores": [
                1
            ],
            "sources": [
                2096
            ],
            "salesChannels": [
                1
            ],
            "searchText": [
                1
            ],
            "sortBy": [
                80
            ],
            "showPrevious": [
                7
            ],
            "showReturn": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ExportSkuAnalysisResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExportStatus": {},
        "ExportUnitsTrackingPhysicalCountProductQuantitiesInput": {
            "companyId": [
                1
            ],
            "filters": [
                969
            ],
            "__typename": [
                1
            ]
        },
        "ExportWarehouseOpeningBalancesCsvInput": {
            "companyId": [
                15
            ],
            "filters": [
                981
            ],
            "__typename": [
                1
            ]
        },
        "ExtensionFiled": {
            "value": [
                7
            ],
            "updatedAt": [
                581
            ],
            "updatedBy": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ExternalBalanceInput": {
            "integrationAccountId": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "FailingValidation": {
            "companyId": [
                1
            ],
            "validationId": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "validationDataLocation": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Feature": {},
        "FeeLineItemV3": {
            "id": [
                15
            ],
            "externalLineItemId": [
                1
            ],
            "name": [
                1
            ],
            "description": [
                1
            ],
            "amount": [
                107
            ],
            "parentId": [
                1
            ],
            "parentLineItemType": [
                1639
            ],
            "earliestPostedAt": [
                581
            ],
            "latestPostedAt": [
                581
            ],
            "type": [
                1549
            ],
            "feeType": [
                1
            ],
            "externalName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "FetchLedgerAccountTransactionsInput": {
            "vendorId": [
                1
            ],
            "categoryId": [
                1
            ],
            "classificationTagId": [
                1
            ],
            "categoryName": [
                1
            ],
            "accountName": [
                1
            ],
            "filterByVendor": [
                7
            ],
            "filterByCategory": [
                7
            ],
            "timeRange": [
                1487
            ],
            "accountingMethod": [
                1
            ],
            "isCashFlow": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "FifoCogsBusinessEventsMetrics": {
            "type": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "integrationType": [
                1
            ],
            "metrics": [
                729
            ],
            "__typename": [
                1
            ]
        },
        "FifoCogsBusinessEventsSingleMetric": {
            "name": [
                1
            ],
            "fifo": [
                5
            ],
            "isValid": [
                7
            ],
            "be": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "FifoValidationCogsSummary": {
            "name": [
                1
            ],
            "fifoCogs": [
                5
            ],
            "isValidCost": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "FifoValidationInput": {
            "date": [
                581
            ],
            "companyId": [
                15
            ],
            "id": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "FifoValidationProductData": {
            "product": [
                1769
            ],
            "warehouse": [
                2396
            ],
            "baseMetrics": [
                735
            ],
            "cogsMetrics": [
                730
            ],
            "__typename": [
                1
            ]
        },
        "FifoValidationProductTotals": {
            "baseMetrics": [
                735
            ],
            "cogsMetrics": [
                730
            ],
            "__typename": [
                1
            ]
        },
        "FifoValidationProductValidationData": {
            "data": [
                732
            ],
            "totals": [
                733
            ],
            "totalBalance": [
                736
            ],
            "fifoCogsBusinessEventsMetrics": [
                728
            ],
            "fifoCogsBusinessEventsMetricsTotal": [
                729
            ],
            "notPropagatedBEIds": [
                1
            ],
            "redundantBEIds": [
                1
            ],
            "secondaryProductRedundantOverviews": [
                1
            ],
            "isUnitsValid": [
                7
            ],
            "isCogsValid": [
                7
            ],
            "isBusinessEventsValid": [
                7
            ],
            "fulfillmentsAfterLock": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "FifoValidationSummary": {
            "name": [
                1
            ],
            "source": [
                5
            ],
            "sourceCost": [
                5
            ],
            "fifo": [
                5
            ],
            "fifoCost": [
                5
            ],
            "fifoCogs": [
                5
            ],
            "isValidQuantity": [
                7
            ],
            "isValidCost": [
                7
            ],
            "isValidCogs": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "FifoValidationTotalsBalance": {
            "totalIncomingFromSource": [
                5
            ],
            "totalOnHandFromFifo": [
                5
            ],
            "totalCogs": [
                5
            ],
            "totalWaste": [
                5
            ],
            "isValid": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "FileLocation": {
            "name": [
                1
            ],
            "key": [
                1
            ],
            "bankTransactionsUploadId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "FileType": {},
        "FileUploadSource": {},
        "FileUploadUrlResult": {
            "uploadUrl": [
                1
            ],
            "url": [
                1
            ],
            "fileName": [
                1
            ],
            "key": [
                1
            ],
            "bucket": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "FilingDeadline": {
            "value": [
                581
            ],
            "extensionFiled": [
                722
            ],
            "__typename": [
                1
            ]
        },
        "FilterableBankStatementRequestTypes": {},
        "FilteringBoundsInput": {
            "companyId": [
                15
            ],
            "placedDate": [
                1573
            ],
            "__typename": [
                1
            ]
        },
        "FilteringBoundsOrderV3Result": {
            "maxNetOrderInHomeCurrency": [
                5
            ],
            "maxItemsCount": [
                41
            ],
            "stores": [
                2114
            ],
            "orderTotalP999": [
                5
            ],
            "integrations": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "FilterOperator": {},
        "FinalizeAskTheUserFlowInput": {
            "companyId": [
                15
            ],
            "bankTransactionId": [
                15
            ],
            "type": [
                125
            ],
            "snapshot": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "FinalizeAskTheUserFlowResult": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "FinaloopProduct": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "FinaloopProductInternalInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "FinaloopTagsInput": {
            "id": [
                1
            ],
            "name": [
                1
            ],
            "isNew": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "FinancedPaymentInstallmentStatus": {},
        "FinancialReportingStatus": {},
        "FinancialReportingStatusSource": {},
        "FindValidationBuggyDateInput": {
            "companyId": [
                15
            ],
            "validationDomain": [
                1
            ],
            "validationType": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "FiscalYearEndStateResponse": {
            "year": [
                41
            ],
            "state": [
                2498
            ],
            "isUnderReview": [
                7
            ],
            "isLegacy": [
                7
            ],
            "updatedAt": [
                581
            ],
            "updatedBy": [
                1
            ],
            "filingDeadline": [
                741
            ],
            "userUnresponsive": [
                2514
            ],
            "__typename": [
                1
            ]
        },
        "FixedAssetsOptions": {
            "startDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "FloatRange": {
            "min": [
                5
            ],
            "max": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "FulfillLineItemInput": {
            "lineItemId": [
                15
            ],
            "fulfillmentDate": [
                581
            ],
            "quantity": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "FulfillmentAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "salesChannel": [
                2398
            ],
            "sku": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "FulfillmentChannel": {},
        "FulfillmentCost": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "source": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "sale": [
                1918
            ],
            "order": [
                1602
            ],
            "type": [
                762
            ],
            "externalId": [
                1
            ],
            "externalName": [
                1
            ],
            "amount": [
                5
            ],
            "currency": [
                549
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "FulfillmentCostType": {},
        "FulfillmentMethod": {
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "type": [
                765
            ],
            "__typename": [
                1
            ]
        },
        "FulfillmentMethodInput": {
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "type": [
                765
            ],
            "__typename": [
                1
            ]
        },
        "FulfillmentMethodType": {},
        "FulfillmentSetting": {
            "companyId": [
                15
            ],
            "integrationAccountId": [
                15
            ],
            "methods": [
                763
            ],
            "__typename": [
                1
            ]
        },
        "FulfillmentSettingInput": {
            "companyId": [
                15
            ],
            "integrationAccountIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "FulfillmentStatus": {},
        "FulfillmentsValidation": {
            "integrationData": [
                1855
            ],
            "adjustments": [
                1855
            ],
            "cogs": [
                1855
            ],
            "source": [
                1855
            ],
            "diff": [
                1855
            ],
            "isValid": [
                7
            ],
            "integrationType": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GenerateBigValidationInput": {
            "companyId": [
                15
            ],
            "to": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "GenerateBigValidationResponse": {
            "validationId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GenerateFifoValidationResponse": {
            "validationId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GenerateNoUnitsValidationError": {
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GenerateNoUnitsValidationInput": {
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GenerateNoUnitsValidationResponse": {
            "validationId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GenerateNoUnitsValidationResult": {
            "id": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GeneratePdfError": {
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GeneratePdfInput": {
            "companyId": [
                1
            ],
            "html": [
                1
            ],
            "id": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GeneratePdfResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GeneratePdfResponseV2": {
            "on_GeneratePdfResponse": [
                779
            ],
            "on_GeneratePdfError": [
                777
            ],
            "__typename": [
                1
            ]
        },
        "GenerateProductMergeRecommendationsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GenericResponse": {
            "success": [
                7
            ],
            "errorMessage": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetAccountRoleInput": {
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetAccrualsByEntityIDsInput": {
            "companyId": [
                15
            ],
            "entityType": [
                21
            ],
            "entityIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetAccrualsByTransactionIDsInput": {
            "companyId": [
                15
            ],
            "bankTransactionIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetAccrualsListInput": {
            "companyId": [
                15
            ],
            "accrualType": [
                28
            ],
            "asOfDate": [
                581
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetAccrualsSpreadInput": {
            "companyId": [
                15
            ],
            "bankTransactionIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetAccrualsSpreadInputV2": {
            "companyId": [
                15
            ],
            "entityType": [
                21
            ],
            "entityIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetAllCompaniesForDomainInput": {
            "domain": [
                2490
            ],
            "state": [
                2476
            ],
            "__typename": [
                1
            ]
        },
        "GetAllCompaniesForDomainResponse": {
            "companyId": [
                15
            ],
            "year": [
                41
            ],
            "state": [
                2498
            ],
            "domainState": [
                2487
            ],
            "domainData": [
                2482
            ],
            "__typename": [
                1
            ]
        },
        "GetAllocatableEventIdsInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "filters": [
                1310
            ],
            "__typename": [
                1
            ]
        },
        "GetAllocatableEventIdsResult": {
            "ids": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetArtificialTransactionsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetAttachmentTargetURLSInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "fileNames": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetBackOfficeBankStatementRequestsInput": {
            "filter": [
                804
            ],
            "sort": [
                802
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetBackOfficeBankStatementRequestsResponse": {
            "statementRequests": [
                216
            ],
            "totalCount": [
                41
            ],
            "offset": [
                41
            ],
            "limit": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetBalanceSheetSetupItemDocumentUrlInput": {
            "balanceSheetSetupItemId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetBalanceSheetSetupItemDocumentUrlReponse": {
            "downloadUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetBankAccountStatementFilesInput": {
            "companyId": [
                1
            ],
            "bankAccountId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetBankStatementParsingRequestInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "bankTransactionsUploadId": [
                1
            ],
            "bankStatementFileId": [
                1
            ],
            "provider": [
                252
            ],
            "queryVersion": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetBankStatementParsingResultsInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "bankTransactionsUploadId": [
                1
            ],
            "bankStatementFileId": [
                1
            ],
            "status": [
                256
            ],
            "__typename": [
                1
            ]
        },
        "GetBankStatementReconciliationRequestsSort": {
            "type": [
                805
            ],
            "direction": [
                803
            ],
            "__typename": [
                1
            ]
        },
        "GetBankStatementRequestsDirection": {},
        "GetBankStatementRequestsFiltersInput": {
            "companyIds": [
                15
            ],
            "bankAccountIds": [
                15
            ],
            "years": [
                1
            ],
            "tiers": [
                463
            ],
            "statuses": [
                263
            ],
            "types": [
                265
            ],
            "withDeleted": [
                7
            ],
            "withTestCompanies": [
                7
            ],
            "withLiveTestCompanies": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "GetBankStatementRequestsSortType": {},
        "GetBillsInput": {
            "companyId": [
                15
            ],
            "dateTo": [
                581
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetBillsResponse": {
            "bills": [
                312
            ],
            "totalCount": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetBusinessEventInput": {
            "id": [
                15
            ],
            "type": [
                1
            ],
            "variant": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetBusinessEventsAccrualsConfigInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetChargebacksByIdsInput": {
            "ids": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetClosingBalancesByIdsInput": {
            "ids": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetCOGSBreakdownRequest": {
            "companyId": [
                15
            ],
            "from": [
                581
            ],
            "to": [
                581
            ],
            "type": [
                415
            ],
            "salesChannel": [
                1946
            ],
            "category": [
                409
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "sort": [
                814
            ],
            "searchText": [
                1
            ],
            "productIds": [
                1
            ],
            "warehouseIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetCOGSBreakdownResponse": {
            "from": [
                581
            ],
            "to": [
                581
            ],
            "type": [
                415
            ],
            "items": [
                408
            ],
            "totalCount": [
                41
            ],
            "hasNext": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "GetCogsBreakdownSort": {
            "field": [
                815
            ],
            "direction": [
                1825
            ],
            "__typename": [
                1
            ]
        },
        "GetCogsBreakdownSortField": {},
        "GetCOGSOverviewFilters": {
            "source": [
                413
            ],
            "type": [
                415
            ],
            "costType": [
                499
            ],
            "category": [
                409
            ],
            "productIds": [
                1
            ],
            "warehouseIds": [
                1
            ],
            "salesChannel": [
                1946
            ],
            "groupNames": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetCOGSOverviewRequest": {
            "companyId": [
                15
            ],
            "from": [
                581
            ],
            "to": [
                581
            ],
            "filters": [
                816
            ],
            "__typename": [
                1
            ]
        },
        "GetCOGSOverviewResponse": {
            "from": [
                581
            ],
            "to": [
                581
            ],
            "summary": [
                414
            ],
            "summaryEvents": [
                410
            ],
            "__typename": [
                1
            ]
        },
        "GetCompaniesByIdsInput": {
            "companyIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetCompaniesInput": {
            "payingCompaniesOnly": [
                7
            ],
            "tiers": [
                463
            ],
            "__typename": [
                1
            ]
        },
        "GetCompanyFundedStatusInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetCompanyInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetCompanyLoanInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetCompanyLoansInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetCompanyLockConditionsArgs": {
            "companyId": [
                1
            ],
            "periodDates": [
                1753
            ],
            "__typename": [
                1
            ]
        },
        "GetCompanyWorksheetsArgs": {
            "companyId": [
                1
            ],
            "periodDates": [
                1753
            ],
            "__typename": [
                1
            ]
        },
        "GetCustomerArgs": {
            "searchTerm": [
                1
            ],
            "limit": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetCustomerByIdInput": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetCustomerByIdsInput": {
            "companyId": [
                15
            ],
            "ids": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetCustomerInternal": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetCustomerResponse": {
            "on_Customer": [
                554
            ],
            "on_CustomerNotExistError": [
                560
            ],
            "on_Error": [
                680
            ],
            "__typename": [
                1
            ]
        },
        "GetDisputesByIdsInput": {
            "ids": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetEntitiesLockedPeriodBypassesInput": {
            "companyId": [
                15
            ],
            "entitiesByType": [
                675
            ],
            "__typename": [
                1
            ]
        },
        "GetExportedReportsInput": {
            "companyId": [
                15
            ],
            "reportType": [
                1907
            ],
            "year": [
                41
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "createdAtFrom": [
                581
            ],
            "createdAtTo": [
                581
            ],
            "email": [
                1
            ],
            "sortBy": [
                705
            ],
            "sortDirection": [
                2094
            ],
            "__typename": [
                1
            ]
        },
        "GetExportedReportsResponse": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "reportType": [
                1
            ],
            "source": [
                1
            ],
            "email": [
                1
            ],
            "period": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetFailingValidationsByValidationCycleInput": {
            "validationCycleId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetFailingValidationsByValidationTemplateInput": {
            "validationType": [
                475
            ],
            "endTime": [
                2373
            ],
            "__typename": [
                1
            ]
        },
        "GetFiscalYerDataInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetFromEmailAddressError": {
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetFromEmailAddressInput": {
            "companyId": [
                1
            ],
            "entityType": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetFromEmailAddressResponse": {
            "fromAddress": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetFromEmailAddressResult": {
            "on_GetFromEmailAddressResponse": [
                841
            ],
            "on_GetFromEmailAddressError": [
                839
            ],
            "__typename": [
                1
            ]
        },
        "GetFulfillmentCostsByIdsInput": {
            "companyId": [
                15
            ],
            "fulfillmentCostIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetFulfillmentSettingInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetFulfillmentSettingsResponse": {
            "settings": [
                1090
            ],
            "__typename": [
                1
            ]
        },
        "GetGlobalVendorsInput": {
            "ids": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetHealthStatusInput": {
            "asOfDate": [
                581
            ],
            "updatedAt": [
                581
            ],
            "companiesIds": [
                1
            ],
            "sort": [
                1032
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "isStrictAsOfDate": [
                7
            ],
            "domains": [
                470
            ],
            "__typename": [
                1
            ]
        },
        "GetIntegrationTagsInput": {
            "companyId": [
                15
            ],
            "searchText": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetIntegrationTransferInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetIntegrationTransfersBackofficeInput": {
            "companyId": [
                15
            ],
            "ids": [
                15
            ],
            "timeRange": [
                1109
            ],
            "sort": [
                1108
            ],
            "type": [
                1110
            ],
            "limit": [
                41
            ],
            "integrationType": [
                1113
            ],
            "amountRange": [
                105
            ],
            "withDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "GetIntegrationTransfersByIdsInput": {
            "ids": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetIntegrationTransfersInput": {
            "companyId": [
                15
            ],
            "ids": [
                15
            ],
            "timeRange": [
                1109
            ],
            "sort": [
                1108
            ],
            "type": [
                1110
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "integrationType": [
                1113
            ],
            "checkAgainstOriginalAmount": [
                7
            ],
            "onlyUnidentified": [
                7
            ],
            "pairedCompanyAffiliateId": [
                15
            ],
            "withDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryAccountBalanceInput": {
            "companyId": [
                15
            ],
            "pointInTime": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryAccountBalanceResponse": {
            "inventoryAccountBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryPurchaseRulesInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryPurchasesByIdsInput": {
            "companyId": [
                15
            ],
            "ids": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryPurchasesCountByVendorInput": {
            "companyId": [
                1
            ],
            "source": [
                1150
            ],
            "affiliatedEntityIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryPurchasesExportInput": {
            "filters": [
                859
            ],
            "sort": [
                1154
            ],
            "managementMethod": [
                1366
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryPurchasesFilters": {
            "companyId": [
                15
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "text": [
                1
            ],
            "status": [
                1158
            ],
            "statusAsOfDate": [
                581
            ],
            "ids": [
                1
            ],
            "affiliatedEntityId": [
                1
            ],
            "source": [
                1151
            ],
            "categoryName": [
                1136
            ],
            "purchaseType": [
                1161
            ],
            "paidStatus": [
                1635
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryPurchasesForCompanyInput": {
            "companyId": [
                15
            ],
            "historicalPurchasesOnly": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryPurchasesInput": {
            "filters": [
                859
            ],
            "offset": [
                41
            ],
            "limit": [
                41
            ],
            "sort": [
                1154
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryPurchaseSummaryInput": {
            "companyId": [
                15
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "text": [
                1
            ],
            "status": [
                1158
            ],
            "purchaseType": [
                1161
            ],
            "statusAsOfDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryPurchaseVendorsInput": {
            "companyId": [
                1
            ],
            "categoryName": [
                1136
            ],
            "source": [
                1150
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryVendorBillsInput": {
            "companyId": [
                15
            ],
            "affiliatedEntityId": [
                15
            ],
            "toDate": [
                581
            ],
            "unpaidBillsUntilDate": [
                581
            ],
            "text": [
                1
            ],
            "fromAmount": [
                5
            ],
            "toAmount": [
                5
            ],
            "itemTypes": [
                1170
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryVendorBillsOverviewInput": {
            "companyId": [
                15
            ],
            "affiliatedEntityId": [
                15
            ],
            "toDate": [
                581
            ],
            "unpaidBillsUntilDate": [
                581
            ],
            "text": [
                1
            ],
            "fromAmount": [
                5
            ],
            "toAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryVendorFilterValuesInput": {
            "companyId": [
                15
            ],
            "untilDate": [
                581
            ],
            "text": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryVendorParamsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryVendorRollingBalanceInput": {
            "companyId": [
                15
            ],
            "affiliatedEntityId": [
                15
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "text": [
                1
            ],
            "fromAmount": [
                5
            ],
            "toAmount": [
                5
            ],
            "skipZeroAmount": [
                7
            ],
            "itemTypes": [
                1180
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryVendorRollingBalanceOverviewInput": {
            "companyId": [
                15
            ],
            "affiliatedEntityId": [
                15
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "text": [
                1
            ],
            "fromAmount": [
                5
            ],
            "toAmount": [
                5
            ],
            "skipZeroAmount": [
                7
            ],
            "itemTypes": [
                1180
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryVendorsInput": {
            "companyId": [
                15
            ],
            "text": [
                1
            ],
            "untilDate": [
                581
            ],
            "unpaidBillsUntilDate": [
                581
            ],
            "skipZeroRollingBalance": [
                7
            ],
            "negativeRollingBalance": [
                7
            ],
            "fromRollingBalance": [
                5
            ],
            "toRollingBalance": [
                5
            ],
            "sort": [
                1185
            ],
            "offset": [
                41
            ],
            "limit": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetInventoryVendorsOverviewInput": {
            "companyId": [
                15
            ],
            "text": [
                1
            ],
            "untilDate": [
                581
            ],
            "unpaidBillsUntilDate": [
                581
            ],
            "skipZeroRollingBalance": [
                7
            ],
            "negativeRollingBalance": [
                7
            ],
            "fromRollingBalance": [
                5
            ],
            "toRollingBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "GetInvoicesAffectingPaymentGroupsInput": {
            "companyId": [
                1
            ],
            "invoiceIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetInvoicesAffectingPaymentGroupsResponse": {
            "invoicesToPaymentGroups": [
                1228
            ],
            "__typename": [
                1
            ]
        },
        "GetInvoiceSettingsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetInvoicesResult": {
            "invoices": [
                1198
            ],
            "__typename": [
                1
            ]
        },
        "GetLatestValidationInput": {
            "companyId": [
                1
            ],
            "type": [
                475
            ],
            "integrationAccountId": [
                1
            ],
            "validationCycleId": [
                1
            ],
            "account": [
                1
            ],
            "startTime": [
                581
            ],
            "endTime": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "GetLatestValidationResult": {
            "validationId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetLoanEventsInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "filters": [
                1310
            ],
            "page": [
                41
            ],
            "size": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetLoanEventsLengthInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "filters": [
                1310
            ],
            "__typename": [
                1
            ]
        },
        "GetLoanEventsLengthResult": {
            "length": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetLoanEventsResult": {
            "events": [
                1308
            ],
            "page": [
                41
            ],
            "size": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetLoanRelationshipsResult": {
            "relationships": [
                1325
            ],
            "page": [
                41
            ],
            "size": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetLoansByIdInput": {
            "loanIds": [
                15
            ],
            "includeDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "GetLoansForAllocateInput": {
            "companyId": [
                15
            ],
            "lenderId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetLoansInput": {
            "page": [
                41
            ],
            "companyIds": [
                1
            ],
            "lenderIds": [
                1
            ],
            "vendorIds": [
                1
            ],
            "affiliatedEntityIds": [
                1
            ],
            "updateBy": [
                1
            ],
            "statuses": [
                1338
            ],
            "companyTiers": [
                1
            ],
            "owners": [
                1
            ],
            "showOnlyModified": [
                7
            ],
            "includeDeleted": [
                7
            ],
            "userActionStatuses": [
                1343
            ],
            "sort": [
                1333
            ],
            "loanType": [
                1339
            ],
            "limit": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetLoansOutstandingAmountOnDateInput": {
            "companyId": [
                15
            ],
            "loansIds": [
                15
            ],
            "date": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "GetLoansOutstandingAmountOnDateResult": {
            "loans": [
                1322
            ],
            "__typename": [
                1
            ]
        },
        "GetMatchingEffectRuleInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "eventDefinitionId": [
                15
            ],
            "loanInput": [
                889
            ],
            "__typename": [
                1
            ]
        },
        "GetMatchingEffectRuleLoanInput": {
            "amount": [
                5
            ],
            "postedAt": [
                581
            ],
            "spreadInput": [
                535
            ],
            "memo": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetMatchingEffectRuleResult": {
            "effect": [
                1329
            ],
            "memo": [
                1
            ],
            "dailyAccrual": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "GetNonMatchingProductsInput": {
            "companyId": [
                15
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "GetNoUnitsPhysicalCountAnyActiveProductsWithoutQuantitiesInput": {
            "companyId": [
                1
            ],
            "physicalCountId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetNoUnitsPhysicalCountClosingBalanceInput": {
            "companyId": [
                1
            ],
            "date": [
                581
            ],
            "excludingDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "GetNoUnitsPhysicalCountInput": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetNoUnitsPhysicalCountOverviewInput": {
            "physicalCountId": [
                1
            ],
            "companyId": [
                1
            ],
            "filters": [
                938
            ],
            "__typename": [
                1
            ]
        },
        "GetNoUnitsPhysicalCountProductQuantitiesInput": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "productQuantityFilter": [
                1816
            ],
            "page": [
                1634
            ],
            "asOfDate": [
                581
            ],
            "filters": [
                938
            ],
            "sort": [
                897
            ],
            "__typename": [
                1
            ]
        },
        "GetNoUnitsPhysicalCountProductQuantitiesSort": {
            "field": [
                898
            ],
            "direction": [
                1825
            ],
            "__typename": [
                1
            ]
        },
        "GetNoUnitsPhysicalCountProductQuantitiesSortField": {},
        "GetOffersInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetOffersResponse": {
            "status": [
                1469
            ],
            "offers": [
                1468
            ],
            "__typename": [
                1
            ]
        },
        "GetOnboardingStatusesInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetOnboardingStatusInput": {
            "companyId": [
                15
            ],
            "scope": [
                1471
            ],
            "step": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetOrderFilteringBoundsResult": {
            "finaloopPaymentGateways": [
                1
            ],
            "salesChannels": [
                1
            ],
            "orderTotalP999": [
                5
            ],
            "maxItemsCount": [
                41
            ],
            "availableStatuses": [
                1502
            ],
            "__typename": [
                1
            ]
        },
        "GetOrdersAggregationsInput": {
            "filter": [
                906
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetOrdersDateRangeInput": {
            "min": [
                581
            ],
            "max": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "GetOrdersFilter": {
            "productIds": [
                15
            ],
            "tagIds": [
                15
            ],
            "customerIds": [
                15
            ],
            "paymentStatuses": [
                1558
            ],
            "finaloopStatus": [
                1502
            ],
            "finaloopPaymentGateways": [
                1
            ],
            "salesChannels": [
                1
            ],
            "integrationAccountIds": [
                1
            ],
            "itemsCount": [
                757
            ],
            "totalAmountInHomeCurrency": [
                757
            ],
            "balanceAsOfAmount": [
                757
            ],
            "placedDate": [
                905
            ],
            "firstPaymentDate": [
                905
            ],
            "firstRefundDate": [
                905
            ],
            "firstFulfillmentDate": [
                905
            ],
            "unpaidAsOfDate": [
                581
            ],
            "hasRestockedItem": [
                7
            ],
            "allTransactionsMatched": [
                7
            ],
            "fulfillmentStatuses": [
                1508
            ],
            "fulfillmentWarehouseIds": [
                15
            ],
            "fulfillmentDate": [
                905
            ],
            "searchText": [
                1
            ],
            "agingPreset": [
                1570
            ],
            "__typename": [
                1
            ]
        },
        "GetOrdersInput": {
            "companyId": [
                15
            ],
            "filter": [
                906
            ],
            "sort": [
                909
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetOrdersResultV2": {
            "orders": [
                1602
            ],
            "__typename": [
                1
            ]
        },
        "GetOrdersSort": {
            "type": [
                911
            ],
            "direction": [
                910
            ],
            "__typename": [
                1
            ]
        },
        "GetOrdersSortDirection": {},
        "GetOrdersSortType": {},
        "GetPaymentFeesByIdsInput": {
            "ids": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetPaymentsByIdsInput": {
            "ids": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetPendingAdjustmentsByIdsInput": {
            "ids": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetPendingAdjustmentsFilter": {
            "attributes": [
                1777
            ],
            "searchText": [
                1
            ],
            "source": [
                1
            ],
            "warehouseId": [
                1
            ],
            "dataType": [
                1742
            ],
            "__typename": [
                1
            ]
        },
        "GetPendingAdjustmentsInput": {
            "companyId": [
                15
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "endDate": [
                581
            ],
            "startDate": [
                581
            ],
            "sort": [
                918
            ],
            "filter": [
                915
            ],
            "__typename": [
                1
            ]
        },
        "GetPendingAdjustmentsOverviewInput": {
            "companyId": [
                15
            ],
            "endDate": [
                581
            ],
            "startDate": [
                581
            ],
            "filter": [
                915
            ],
            "__typename": [
                1
            ]
        },
        "GetPendingAdjustmentsSort": {
            "field": [
                919
            ],
            "direction": [
                1825
            ],
            "__typename": [
                1
            ]
        },
        "GetPendingAdjustmentsSortField": {},
        "GetPendingSalesDataAdjustmentsInputV2": {
            "salesChannel": [
                1946
            ],
            "companyId": [
                15
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "endDate": [
                581
            ],
            "startDate": [
                581
            ],
            "sort": [
                918
            ],
            "filter": [
                915
            ],
            "__typename": [
                1
            ]
        },
        "GetPendingSalesDataAdjustmentsOverviewInputV2": {
            "salesChannel": [
                1946
            ],
            "companyId": [
                15
            ],
            "endDate": [
                581
            ],
            "startDate": [
                581
            ],
            "filter": [
                915
            ],
            "__typename": [
                1
            ]
        },
        "GetPendingSalesDataAdjustmentsSort": {
            "field": [
                923
            ],
            "direction": [
                1825
            ],
            "__typename": [
                1
            ]
        },
        "GetPendingSalesDataAdjustmentsSortField": {},
        "GetPendingWarehouseOpeningBalancesAttachmentsInput": {
            "companyId": [
                15
            ],
            "date": [
                581
            ],
            "displayDeleted": [
                7
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetProductAutomergeSettingsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetProductAutomergeSettingsResponse": {
            "matchGroupSettings": [
                1778
            ],
            "__typename": [
                1
            ]
        },
        "GetProductBulkAdjustmentStatus": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "state": [
                1779
            ],
            "totalAmount": [
                41
            ],
            "processedAmount": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetProductBulkAdjustmentStatusInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetProductInput": {
            "companyId": [
                15
            ],
            "productId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetProductMergeLogsFiltersInput": {
            "searchText": [
                1
            ],
            "trigger": [
                1805
            ],
            "mergedBy": [
                1
            ],
            "productIds": [
                1
            ],
            "from": [
                581
            ],
            "to": [
                581
            ],
            "source": [
                1
            ],
            "showLatestMergeState": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "GetProductMergeLogsInput": {
            "companyId": [
                15
            ],
            "offset": [
                41
            ],
            "limit": [
                41
            ],
            "sort": [
                935
            ],
            "filters": [
                930
            ],
            "__typename": [
                1
            ]
        },
        "GetProductMergeLogsOverviewInput": {
            "companyId": [
                15
            ],
            "filters": [
                930
            ],
            "__typename": [
                1
            ]
        },
        "GetProductMergeLogsOverviewResponse": {
            "total": [
                41
            ],
            "mergedByOptions": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetProductMergeLogsResponse": {
            "items": [
                1800
            ],
            "__typename": [
                1
            ]
        },
        "GetProductMergeLogsSortInput": {
            "field": [
                1803
            ],
            "direction": [
                1802
            ],
            "__typename": [
                1
            ]
        },
        "GetProductMergeRecommendationsMatchGroupInput": {
            "companyId": [
                15
            ],
            "matchGroupId": [
                1
            ],
            "offset": [
                41
            ],
            "limit": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetProductMergeRecommendationsMatchGroupResponse": {
            "productGroups": [
                1810
            ],
            "__typename": [
                1
            ]
        },
        "GetProductsFilter": {
            "searchText": [
                1
            ],
            "sku": [
                1
            ],
            "ids": [
                1
            ],
            "source": [
                1
            ],
            "withoutCostOnly": [
                7
            ],
            "withNegativeOnHandOnly": [
                7
            ],
            "attributes": [
                1777
            ],
            "canEditCurrentAppliedCost": [
                7
            ],
            "onlyPrimaryProducts": [
                7
            ],
            "warehouseId": [
                1
            ],
            "asOfDate": [
                581
            ],
            "startDate": [
                581
            ],
            "notMatchingProducts": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "GetProductsInput": {
            "companyId": [
                15
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "sort": [
                940
            ],
            "filter": [
                938
            ],
            "extendedList": [
                7
            ],
            "extendedWithWarehousesList": [
                7
            ],
            "splitByIsDropshipping": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "GetProductsSort": {
            "field": [
                941
            ],
            "direction": [
                1825
            ],
            "__typename": [
                1
            ]
        },
        "GetProductsSortField": {},
        "GetPurchaseOrderInput": {
            "companyId": [
                15
            ],
            "purchaseOrderId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetPurchaseOrdersInput": {
            "companyId": [
                15
            ],
            "purchaseOrderIds": [
                1
            ],
            "returnDeleted": [
                7
            ],
            "searchField": [
                1
            ],
            "productIds": [
                1
            ],
            "status": [
                1854
            ],
            "fromInProgressDate": [
                581
            ],
            "toInProgressDate": [
                581
            ],
            "fromLandedCostTotal": [
                5
            ],
            "toLandedCostTotal": [
                5
            ],
            "sortField": [
                1853
            ],
            "sortDirection": [
                2094
            ],
            "showHistorical": [
                7
            ],
            "vendorId": [
                1
            ],
            "paidStatus": [
                1635
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetPurchaseOrdersOverviewInput": {
            "companyId": [
                15
            ],
            "purchaseOrderIds": [
                1
            ],
            "returnDeleted": [
                7
            ],
            "searchField": [
                1
            ],
            "vendorId": [
                1
            ],
            "productIds": [
                1
            ],
            "fromInProgressDate": [
                581
            ],
            "toInProgressDate": [
                581
            ],
            "fromLandedCostTotal": [
                5
            ],
            "toLandedCostTotal": [
                5
            ],
            "showHistorical": [
                7
            ],
            "paidStatus": [
                1635
            ],
            "__typename": [
                1
            ]
        },
        "GetReadyValidationInput": {
            "companyId": [
                15
            ],
            "validationId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetReadyValidationResponse": {
            "url": [
                1
            ],
            "from": [
                581
            ],
            "to": [
                581
            ],
            "generatedAt": [
                581
            ],
            "generatedBy": [
                1
            ],
            "isGreen": [
                7
            ],
            "isError": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "GetRefundsByIdsInput": {
            "ids": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetSaleAggregationsInput": {
            "companyId": [
                15
            ],
            "filter": [
                955
            ],
            "__typename": [
                1
            ]
        },
        "GetSaleDateRangeInput": {
            "min": [
                581
            ],
            "max": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "GetSaleFloatRangeInput": {
            "min": [
                5
            ],
            "max": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "GetSaleIntRangeInput": {
            "min": [
                41
            ],
            "max": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetSalesChannelsFilter": {
            "ids": [
                15
            ],
            "source": [
                1
            ],
            "name": [
                1
            ],
            "withDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "GetSalesChannelsInput": {
            "companyId": [
                15
            ],
            "filter": [
                952
            ],
            "sort": [
                958
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetSalesChannelTemplatesInput": {
            "filter": [
                952
            ],
            "sort": [
                958
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetSalesFilter": {
            "ids": [
                15
            ],
            "customerIds": [
                15
            ],
            "excludeCustomerIds": [
                15
            ],
            "withDeleted": [
                7
            ],
            "withForReview": [
                7
            ],
            "withoutVoided": [
                7
            ],
            "withoutDrafts": [
                7
            ],
            "includeAllPreBSD": [
                7
            ],
            "salesChannelName": [
                1
            ],
            "search": [
                1
            ],
            "sources": [
                1961
            ],
            "dueInDays": [
                951
            ],
            "total": [
                950
            ],
            "balance": [
                950
            ],
            "netSales": [
                950
            ],
            "postedAt": [
                949
            ],
            "firstPaymentDate": [
                949
            ],
            "uploadId": [
                1
            ],
            "uploadDate": [
                581
            ],
            "currencies": [
                549
            ],
            "excludeCurrencies": [
                549
            ],
            "paymentMethodIds": [
                15
            ],
            "productIds": [
                15
            ],
            "unpaidAsOfDate": [
                581
            ],
            "statuses": [
                1962
            ],
            "__typename": [
                1
            ]
        },
        "GetSalesInput": {
            "companyId": [
                15
            ],
            "filter": [
                955
            ],
            "sort": [
                958
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "balanceAsOfDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "GetSalesResult": {
            "sales": [
                1918
            ],
            "__typename": [
                1
            ]
        },
        "GetSalesSort": {
            "type": [
                960
            ],
            "direction": [
                959
            ],
            "__typename": [
                1
            ]
        },
        "GetSalesSortDirection": {},
        "GetSalesSortType": {},
        "GetSellingFeesByIdsInput": {
            "companyId": [
                15
            ],
            "sellingFeeIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetShippingCostsByIdsInput": {
            "companyId": [
                15
            ],
            "shippingCostIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetSignedDatesInput": {
            "companyId": [
                1
            ],
            "periodStart": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "GetSignedDatesResponse": {
            "dates": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "GetSignedUrlByExportedLogIdResponse": {
            "downloadUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetTax1099AffiliatedEntityGroupsInput": {
            "companyId": [
                15
            ],
            "calendarYear": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetUnitsTrackingPhysicalCountInput": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "asOfDate": [
                581
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetUnitsTrackingPhysicalCountOverviewInput": {
            "physicalCountId": [
                1
            ],
            "companyId": [
                1
            ],
            "asOfDate": [
                581
            ],
            "filters": [
                938
            ],
            "__typename": [
                1
            ]
        },
        "GetUnitsTrackingPhysicalCountProductQuantitiesInput": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "productQuantityFilter": [
                1816
            ],
            "asOfDate": [
                581
            ],
            "page": [
                1634
            ],
            "filters": [
                938
            ],
            "sort": [
                970
            ],
            "__typename": [
                1
            ]
        },
        "GetUnitsTrackingPhysicalCountProductQuantitiesSort": {
            "field": [
                971
            ],
            "direction": [
                1825
            ],
            "__typename": [
                1
            ]
        },
        "GetUnitsTrackingPhysicalCountProductQuantitiesSortField": {},
        "GetUnpaidOrdersAgingCsvInput": {
            "companyId": [
                15
            ],
            "filter": [
                906
            ],
            "sort": [
                909
            ],
            "__typename": [
                1
            ]
        },
        "GetUnpaidOrdersCsvInput": {
            "companyId": [
                15
            ],
            "filter": [
                906
            ],
            "sort": [
                909
            ],
            "__typename": [
                1
            ]
        },
        "GetUnpaidOrdersCsvResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetValidationCycleInput": {
            "executionId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetValidationTemplatesInput": {
            "validationType": [
                475
            ],
            "endTime": [
                2373
            ],
            "__typename": [
                1
            ]
        },
        "GetVendorInput": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetVendorResponse": {
            "on_Vendor": [
                2375
            ],
            "on_VendorNotExistError": [
                2381
            ],
            "on_Error": [
                680
            ],
            "__typename": [
                1
            ]
        },
        "GetVendorsInput": {
            "companyId": [
                15
            ],
            "ids": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetWarehouseOpeningBalanceOverviewInput": {
            "companyId": [
                15
            ],
            "date": [
                581
            ],
            "text": [
                1
            ],
            "warehouseIds": [
                15
            ],
            "missingData": [
                7
            ],
            "pendingChanges": [
                7
            ],
            "attachmentIds": [
                15
            ],
            "productSource": [
                1
            ],
            "productAttributes": [
                1777
            ],
            "__typename": [
                1
            ]
        },
        "GetWarehouseOpeningBalancesInput": {
            "companyId": [
                15
            ],
            "date": [
                581
            ],
            "productSource": [
                1
            ],
            "productAttributes": [
                1777
            ],
            "text": [
                1
            ],
            "warehouseIds": [
                15
            ],
            "missingData": [
                7
            ],
            "pendingChanges": [
                7
            ],
            "attachmentIds": [
                15
            ],
            "sort": [
                2420
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GetWarehousesDefaultsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GetWarehousesInput": {
            "ids": [
                1
            ],
            "companyId": [
                15
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "searchText": [
                1
            ],
            "includeMerged": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "GetWarehouseTransferInput": {
            "companyId": [
                1
            ],
            "id": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GetWarehouseTransfersInput": {
            "filters": [
                417
            ],
            "status": [
                2462
            ],
            "sort": [
                2461
            ],
            "offset": [
                41
            ],
            "limit": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GiftCard": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "integrationAccountId": [
                1
            ],
            "source": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "status": [
                1003
            ],
            "lastCharacters": [
                1
            ],
            "issueMethod": [
                989
            ],
            "customer": [
                563
            ],
            "issuingOrder": [
                1602
            ],
            "issuedAt": [
                581
            ],
            "expiredAt": [
                581
            ],
            "deactivatedAt": [
                581
            ],
            "disabledAt": [
                581
            ],
            "currency": [
                1
            ],
            "initialBalance": [
                5
            ],
            "initialBalanceInHomeCurrency": [
                5
            ],
            "remainingBalance": [
                5
            ],
            "remainingBalanceInHomeCurrency": [
                5
            ],
            "note": [
                1
            ],
            "transactions": [
                1004
            ],
            "balance": [
                5
            ],
            "balanceInHomeCurrency": [
                5
            ],
            "deactivationDate": [
                581
            ],
            "balanceAsOf": [
                581
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "GiftCardAggregationsInput": {
            "companyId": [
                15
            ],
            "balanceAsOfDate": [
                581
            ],
            "filter": [
                995
            ],
            "__typename": [
                1
            ]
        },
        "GiftCardAggregationsResult": {
            "giftCardsCount": [
                41
            ],
            "totalBalance": [
                5
            ],
            "purchasedGiftCardsBalance": [
                5
            ],
            "maximumGiftCardBalance": [
                5
            ],
            "totalBalanceInHomeCurrency": [
                5
            ],
            "purchasedGiftCardsBalanceInHomeCurrency": [
                5
            ],
            "maximumGiftCardBalanceInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "GiftCardIssueMethod": {},
        "GiftCardsBalanceFilter": {
            "min": [
                5
            ],
            "max": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "GiftCardsByIdsInput": {
            "companyId": [
                15
            ],
            "ids": [
                15
            ],
            "includeDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "GiftCardsByIdsResponse": {
            "giftCards": [
                986
            ],
            "__typename": [
                1
            ]
        },
        "GiftCardsCsvInput": {
            "companyId": [
                15
            ],
            "filter": [
                995
            ],
            "balanceAsOfDate": [
                581
            ],
            "sort": [
                1001
            ],
            "__typename": [
                1
            ]
        },
        "GiftCardsCsvResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GiftCardsFilter": {
            "integrationAccountIds": [
                1
            ],
            "issueMethod": [
                989
            ],
            "status": [
                1003
            ],
            "currentBalance": [
                990
            ],
            "lastCharacters": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GiftCardsInput": {
            "companyId": [
                15
            ],
            "balanceAsOfDate": [
                581
            ],
            "filter": [
                995
            ],
            "sort": [
                1001
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GiftCardsMaximumCompanyBalanceInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GiftCardsMaximumCompanyBalanceResult": {
            "maximumBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "GiftCardSortKeys": {},
        "GiftCardsResult": {
            "giftCards": [
                986
            ],
            "__typename": [
                1
            ]
        },
        "GiftCardsSort": {
            "sortMethod": [
                999
            ],
            "direction": [
                1002
            ],
            "__typename": [
                1
            ]
        },
        "GiftCardsSortDirection": {},
        "GiftCardStatus": {},
        "GiftCardTransaction": {
            "id": [
                15
            ],
            "externalSourceId": [
                15
            ],
            "currency": [
                1
            ],
            "amount": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "postedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "GiveawayCogs": {
            "amount": [
                5
            ],
            "quantity": [
                41
            ],
            "monthlyBreakdown": [
                1008
            ],
            "__typename": [
                1
            ]
        },
        "GiveawayDailyBreakdown": {
            "date": [
                581
            ],
            "quantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GiveawayDropshippingOriginalValue": {
            "quantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GiveawayMonthlyBreakdown": {
            "date": [
                581
            ],
            "quantity": [
                41
            ],
            "dailyData": [
                1006
            ],
            "__typename": [
                1
            ]
        },
        "GiveawayOriginalValue": {
            "quantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GlobalRuleExistByVendorAndMoneyDirectionInput": {
            "vendorId": [
                1
            ],
            "moneyDirection": [
                1436
            ],
            "__typename": [
                1
            ]
        },
        "GlobalRuleInput": {
            "vendorId": [
                1
            ],
            "metadata": [
                1242
            ],
            "outcome": [
                1242
            ],
            "conditions": [
                1242
            ],
            "logicalOperator": [
                1914
            ],
            "updatedAtMS": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "GlobalVendorMappingRule": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "GoogleConnectionLinkInput": {
            "state": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "GoogleConnectLinkResponse": {
            "link": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GoogleConnectStatusResponse": {
            "isConnected": [
                7
            ],
            "email": [
                1
            ],
            "sharedFolderUrl": [
                1
            ],
            "sharedFolderName": [
                1
            ],
            "accessToken": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GoogleTokenCodeArgs": {
            "companyId": [
                15
            ],
            "code": [
                1
            ],
            "scope": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GoogleTokenCodeResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "GrantEntitiesLockedPeriodBypassesInput": {
            "companyId": [
                15
            ],
            "unlockDurationSeconds": [
                41
            ],
            "entitiesByType": [
                675
            ],
            "__typename": [
                1
            ]
        },
        "GTMSource": {
            "utms": [
                1021
            ],
            "identifiers": [
                1241
            ],
            "__typename": [
                1
            ]
        },
        "GTMSourceInput": {
            "utms": [
                1022
            ],
            "identifiers": [
                1241
            ],
            "userAgent": [
                1
            ],
            "xGtmServerPreview": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GTMSourceUtms": {
            "firstUtms": [
                1023
            ],
            "lastUtms": [
                1023
            ],
            "__typename": [
                1
            ]
        },
        "GTMSourceUtmsInput": {
            "firstUtms": [
                1024
            ],
            "lastUtms": [
                1024
            ],
            "__typename": [
                1
            ]
        },
        "GTMUtms": {
            "utmTimestamp": [
                1
            ],
            "uuid": [
                1
            ],
            "utmSource": [
                1
            ],
            "utmMedium": [
                1
            ],
            "utmCampaign": [
                1
            ],
            "firstPageSeen": [
                1
            ],
            "utmTerm": [
                1
            ],
            "utmContent": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "GTMUtmsInput": {
            "utmTimestamp": [
                1
            ],
            "uuid": [
                1
            ],
            "utmSource": [
                1
            ],
            "utmMedium": [
                1
            ],
            "utmCampaign": [
                1
            ],
            "firstPageSeen": [
                1
            ],
            "utmTerm": [
                1
            ],
            "utmContent": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "HandleUserLoginArgs": {
            "source": [
                1241
            ],
            "invitationCode": [
                1
            ],
            "gtmSource": [
                1020
            ],
            "__typename": [
                1
            ]
        },
        "HandleUserLoginResponse": {
            "acceptedInviteCompanyInfo": [
                0
            ],
            "wasCompanyCreated": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "HasOrdersInOrderGroupsInput": {
            "companyId": [
                1
            ],
            "salesChannelId": [
                1
            ],
            "dateRange": [
                583
            ],
            "__typename": [
                1
            ]
        },
        "HasOrdersInOrderGroupsResponse": {
            "hasOrders": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "HasProductMergeRecommendationsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "HasProductMergeRecommendationsResponse": {
            "hasProductMergeRecommendations": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "HasUnacknowledgedChangesInput": {
            "companyId": [
                15
            ],
            "managementMethodId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "HealthStatusSortType": {
            "validation": [
                473
            ],
            "direction": [
                445
            ],
            "__typename": [
                1
            ]
        },
        "HistoricalPayment": {
            "orderId": [
                15
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "Holder": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "HolderCapitalInvestment": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "holder": [
                422
            ],
            "amount": [
                5
            ],
            "bankTransactionId": [
                1
            ],
            "holderTransactionId": [
                1
            ],
            "businessEventId": [
                1
            ],
            "loanManualEventId": [
                1
            ],
            "configuration": [
                677
            ],
            "businessEventData": [
                352
            ],
            "memo": [
                1
            ],
            "postedAt": [
                581
            ],
            "latestActorId": [
                1
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "HolderCapitalInvestmentsByIdsInput": {
            "ids": [
                15
            ],
            "includeDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "HolderCapitalInvestmentsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "HolderSafeInvestment": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "safeHolder": [
                422
            ],
            "amount": [
                5
            ],
            "bankTransactionId": [
                1
            ],
            "holderTransactionId": [
                1
            ],
            "businessEventId": [
                1
            ],
            "loanManualEventId": [
                1
            ],
            "configuration": [
                677
            ],
            "businessEventData": [
                352
            ],
            "memo": [
                1
            ],
            "postedAt": [
                581
            ],
            "latestActorId": [
                1
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "HolderSafeInvestmentsByIdsInput": {
            "ids": [
                15
            ],
            "includeDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "HolderShare": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "holder": [
                422
            ],
            "type": [
                2035
            ],
            "series": [
                1
            ],
            "amount": [
                5
            ],
            "parValue": [
                5
            ],
            "quantity": [
                41
            ],
            "bankTransactionId": [
                1
            ],
            "holderTransactionId": [
                1
            ],
            "businessEventId": [
                1
            ],
            "loanManualEventId": [
                1
            ],
            "configuration": [
                677
            ],
            "businessEventData": [
                352
            ],
            "memo": [
                1
            ],
            "postedAt": [
                581
            ],
            "latestActorId": [
                1
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "HolderSharesByIdsInput": {
            "ids": [
                15
            ],
            "includeDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "HolderSharesInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "HolderStatus": {},
        "HolderTransaction": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "holder": [
                422
            ],
            "bankTransaction": [
                270
            ],
            "type": [
                1047
            ],
            "businessEventId": [
                1
            ],
            "loanManualEventId": [
                1
            ],
            "configuration": [
                677
            ],
            "businessEventData": [
                352
            ],
            "memo": [
                1
            ],
            "amount": [
                5
            ],
            "postedAt": [
                581
            ],
            "latestActorId": [
                1
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "HolderTransactionsByIdsInput": {
            "ids": [
                15
            ],
            "includeDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "HolderTransactionsInput": {
            "companyId": [
                15
            ],
            "onlyManual": [
                7
            ],
            "includeDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "HolderTransactionType": {},
        "HubItemState": {},
        "HubItemStateChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                1052
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                1048
            ],
            "newValue": [
                1048
            ],
            "__typename": [
                1
            ]
        },
        "HubState": {},
        "HubStateChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                1052
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                1050
            ],
            "newValue": [
                1050
            ],
            "__typename": [
                1
            ]
        },
        "HubUpdaterType": {},
        "HubUpdaterTypeInput": {},
        "IdResult": {
            "id": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ImageUploadUrlResult": {
            "uploadUrl": [
                1
            ],
            "url": [
                1
            ],
            "iconUrl": [
                1
            ],
            "fileName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ImpersonateArgs": {
            "companyIdToSwitchTo": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ImpersonateResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "IncludedFinaloopSalesChannelItemReconciliation": {
            "salesChannel": [
                1238
            ],
            "data": [
                1059
            ],
            "summary": [
                1883
            ],
            "productItemSoldData": [
                2073
            ],
            "productStatus": [
                2069
            ],
            "unknownSkuQuantity": [
                41
            ],
            "unknownSkuZeroPriceQuantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "IncludedShopifySalesChannelItemReconciliation": {
            "sku": [
                1
            ],
            "isBlacklisted": [
                7
            ],
            "salesChannel": [
                1238
            ],
            "shopifySalesChannel": [
                1
            ],
            "summary": [
                1883
            ],
            "__typename": [
                1
            ]
        },
        "IncomingBatchAnalytics": {
            "origin": [
                1061
            ],
            "analytics": [
                1062
            ],
            "__typename": [
                1
            ]
        },
        "IncomingBatchOrigin": {
            "on_Shipment": [
                2036
            ],
            "on_WarehouseOpeningBalance": [
                2413
            ],
            "on_RecipeWithBreakdown": [
                1873
            ],
            "on_ManualAssemblyWithBreakdown": [
                1377
            ],
            "on_WarehouseTransferWithBreakdown": [
                2465
            ],
            "on_UnitsTrackingPhysicalCount": [
                2190
            ],
            "on_WarehouseNegativesAdjustmentBreakdown": [
                2412
            ],
            "__typename": [
                1
            ]
        },
        "IncomingInventoryAnalytics": {
            "assembled": [
                5
            ],
            "incoming": [
                5
            ],
            "fulfilled": [
                5
            ],
            "lost": [
                5
            ],
            "found": [
                5
            ],
            "warehouseTransfers": [
                5
            ],
            "adjustments": [
                5
            ],
            "deadInventory": [
                5
            ],
            "otherAdjustments": [
                5
            ],
            "restocked": [
                5
            ],
            "onHand": [
                5
            ],
            "landedCostPerUnit": [
                5
            ],
            "onHandCost": [
                5
            ],
            "unavailable": [
                5
            ],
            "unavailableByAssemblies": [
                5
            ],
            "unavailableByWarehouseTransfersOut": [
                5
            ],
            "unavailableByAdjustmentsDeadInventory": [
                5
            ],
            "unavailableByDeadInventory": [
                5
            ],
            "unavailableByUnitLost": [
                5
            ],
            "unavailableByUnitFound": [
                5
            ],
            "unavailableByOtherAdjustments": [
                5
            ],
            "netDepleted": [
                5
            ],
            "openingBalanceQuantity": [
                5
            ],
            "openingBalanceCost": [
                5
            ],
            "physicalCountAdjustmentOut": [
                5
            ],
            "unavailableBreakdown": [
                1063
            ],
            "__typename": [
                1
            ]
        },
        "IncomingInventoryAnalyticsUnavailableBreakdown": {
            "date": [
                581
            ],
            "total": [
                5
            ],
            "action": [
                2397
            ],
            "__typename": [
                1
            ]
        },
        "IndirectCostAllocation": {
            "id": [
                15
            ],
            "indirectLineItem": [
                1066
            ],
            "allocatedCostPerUnit": [
                5
            ],
            "remainderAllocationCostPerUnit": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "IndirectCostAllocationInput": {
            "indirectLineItemId": [
                15
            ],
            "allocatedCostPerUnit": [
                5
            ],
            "remainderAllocationCostPerUnit": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "IndirectLineItem": {
            "id": [
                15
            ],
            "type": [
                1068
            ],
            "cost": [
                5
            ],
            "vendor": [
                2375
            ],
            "isDefaultVendor": [
                7
            ],
            "hasAutomaticAllocation": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "IndirectLineItemInput": {
            "id": [
                15
            ],
            "type": [
                1068
            ],
            "cost": [
                5
            ],
            "vendorId": [
                15
            ],
            "isDefaultVendor": [
                7
            ],
            "hasAutomaticAllocation": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "IndirectLineItemType": {},
        "IndividualSkusInput": {
            "companyId": [
                15
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "breakdown": [
                1
            ],
            "timezone": [
                1
            ],
            "comparisonPeriod": [
                1
            ],
            "productIds": [
                1
            ],
            "source": [
                2096
            ],
            "salesChannels": [
                1
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "sortBy": [
                1071
            ],
            "__typename": [
                1
            ]
        },
        "IndividualSkusResponse": {
            "title": [
                1
            ],
            "updatedAt": [
                581
            ],
            "data": [
                2091
            ],
            "__typename": [
                1
            ]
        },
        "IndividualSkusSortBy": {
            "field": [
                1072
            ],
            "direction": [
                2094
            ],
            "__typename": [
                1
            ]
        },
        "IndividualSkusSortField": {},
        "InitiateTotalArCashDiffsReportInput": {
            "unpaidBalanceAsOf": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "Institution": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "preferredProvider": [
                1079
            ],
            "logoUrl": [
                1
            ],
            "websiteUrl": [
                1
            ],
            "affiliatedEntityId": [
                15
            ],
            "csvInstructionsLink": [
                1
            ],
            "pdfInstructionsLink": [
                1
            ],
            "csvAvailable": [
                7
            ],
            "pdfAvailable": [
                7
            ],
            "dataConfig": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "InstitutionMapping": {
            "id": [
                15
            ],
            "source": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "externalSourceName": [
                1
            ],
            "institutionId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InstitutionMappingResponse": {
            "mappings": [
                1075
            ],
            "__typename": [
                1
            ]
        },
        "InstitutionMappingsInput": {
            "source": [
                1078
            ],
            "externalSourceId": [
                1
            ],
            "externalSourceName": [
                1
            ],
            "institutionId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InstitutionMappingSourceType": {},
        "InstitutionProviders": {},
        "InstitutionsInput": {
            "name": [
                1
            ],
            "searchTerm": [
                1
            ],
            "ids": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InstitutionsResponse": {
            "institutions": [
                1074
            ],
            "__typename": [
                1
            ]
        },
        "InstitutionVendorID": {
            "vendorId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationCompanyAddressInput": {
            "name": [
                1
            ],
            "email": [
                1
            ],
            "phone": [
                1
            ],
            "line1": [
                1
            ],
            "line2": [
                1
            ],
            "city": [
                1
            ],
            "country": [
                1
            ],
            "province": [
                1
            ],
            "provinceCode": [
                1
            ],
            "state": [
                1
            ],
            "stateCode": [
                1
            ],
            "zip": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationConnectionAccount": {
            "integrationType": [
                1113
            ],
            "connectedAt": [
                581
            ],
            "integrationAccountId": [
                15
            ],
            "integrationAccountName": [
                1
            ],
            "impactOnBooksSince": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationConnectionsFilter": {
            "companyId": [
                15
            ],
            "connectionTypes": [
                1086
            ],
            "integrationTypes": [
                1113
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationConnectionType": {},
        "IntegrationCustomerAddressInput": {
            "line1": [
                1
            ],
            "line2": [
                1
            ],
            "city": [
                1
            ],
            "province": [
                1
            ],
            "provinceCode": [
                1
            ],
            "state": [
                1
            ],
            "stateCode": [
                1
            ],
            "country": [
                1
            ],
            "countryCode": [
                1
            ],
            "zip": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationCustomerInput": {
            "name": [
                1
            ],
            "email": [
                1
            ],
            "externalSourceId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationDiscountInput": {
            "id": [
                15
            ],
            "amount": [
                5
            ],
            "type": [
                654
            ],
            "description": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationFulfillmentSetting": {
            "companyId": [
                15
            ],
            "integrationAccountId": [
                15
            ],
            "source": [
                1113
            ],
            "methods": [
                763
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationFulfillmentSettingsInput": {
            "integrationAccountId": [
                1
            ],
            "methods": [
                764
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationIndicativeTransactionInput": {
            "postedAt": [
                581
            ],
            "amount": [
                5
            ],
            "currency": [
                549
            ],
            "amountInHomeCurrency": [
                5
            ],
            "externalSourceId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationInfo": {
            "accountId": [
                15
            ],
            "accountName": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationSaleLineItemInput": {
            "id": [
                15
            ],
            "quantity": [
                5
            ],
            "unitPrice": [
                5
            ],
            "type": [
                1926
            ],
            "currency": [
                549
            ],
            "salesChannelName": [
                1
            ],
            "productId": [
                15
            ],
            "externalProductId": [
                15
            ],
            "sku": [
                1
            ],
            "description": [
                1
            ],
            "discounts": [
                652
            ],
            "taxRate": [
                5
            ],
            "externalSourceId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationSaleTransaction": {
            "id": [
                15
            ],
            "integrationInfo": [
                1093
            ],
            "integrationAccountId": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "amount": [
                5
            ],
            "postedAt": [
                581
            ],
            "currency": [
                549
            ],
            "amountInHomeCurrency": [
                5
            ],
            "type": [
                2167
            ],
            "finaloopPaymentGateway": [
                1
            ],
            "originalPaymentGateway": [
                1
            ],
            "paymentGatewayVariant": [
                1
            ],
            "isIndication": [
                7
            ],
            "source": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationSource": {},
        "IntegrationTransactionInput": {
            "postedAt": [
                581
            ],
            "amount": [
                5
            ],
            "currency": [
                549
            ],
            "amountInHomeCurrency": [
                5
            ],
            "externalSourceId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationTransfer": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "amount": [
                5
            ],
            "amountInUsd": [
                5
            ],
            "currency": [
                1
            ],
            "eventTime": [
                581
            ],
            "deletedAt": [
                581
            ],
            "markedAsReconciliationDiscrepancyAt": [
                581
            ],
            "integrationType": [
                1113
            ],
            "pairedBankTransaction": [
                270
            ],
            "pairedCompanyAffiliate": [
                422
            ],
            "type": [
                1110
            ],
            "classification": [
                1099
            ],
            "integrationAccountId": [
                15
            ],
            "integrationAccountName": [
                1
            ],
            "link": [
                1
            ],
            "uploadedFileId": [
                1
            ],
            "failedAt": [
                581
            ],
            "failedAmountInUsd": [
                5
            ],
            "markedAsUnidentifiedAt": [
                581
            ],
            "rawEvent": [
                1241
            ],
            "on_Payout": [
                1697
            ],
            "on_Topup": [
                2159
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationTransferClassification": {
            "businessEvent": [
                1
            ],
            "askTheUserResult": [
                1242
            ],
            "description": [
                1
            ],
            "pairedEntity": [
                1102
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationTransferClassificationInput": {
            "integrationTransferId": [
                15
            ],
            "businessEvent": [
                1
            ],
            "askTheUserResult": [
                1242
            ],
            "description": [
                1
            ],
            "pairedEntity": [
                1103
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationTransferGroup": {
            "groupId": [
                15
            ],
            "integrationTransfers": [
                1098
            ],
            "payer": [
                1105
            ],
            "payee": [
                1105
            ],
            "isProcessing": [
                7
            ],
            "action": [
                2180
            ],
            "type": [
                1110
            ],
            "tooltipText": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationTransferPairedEntity": {
            "id": [
                15
            ],
            "type": [
                1104
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationTransferPairedEntityInput": {
            "id": [
                15
            ],
            "type": [
                1104
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationTransferPairedEntityType": {},
        "IntegrationTransferParty": {
            "on_UnknownIntegrationTransferBank": [
                2198
            ],
            "on_UnknownIntegrationTransferAccount": [
                2197
            ],
            "on_Vendor": [
                2375
            ],
            "on_BankAccount": [
                161
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationTransferRule": {
            "id": [
                15
            ],
            "integrationType": [
                1113
            ],
            "companyAffiliate": [
                422
            ],
            "integrationAccountId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationTransfersByCompanyAffiliateInput": {
            "companyId": [
                15
            ],
            "companyAffiliateId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationTransfersSort": {
            "closeToAmount": [
                5
            ],
            "closeToDate": [
                581
            ],
            "byDate": [
                2094
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationTransferTimeRangeInput": {
            "from": [
                581
            ],
            "to": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationTransferType": {},
        "IntegrationTransferTypeV2": {},
        "IntegrationTransferV2": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "source": [
                1113
            ],
            "integrationAccountId": [
                15
            ],
            "integrationAccountName": [
                1
            ],
            "amount": [
                5
            ],
            "currency": [
                1
            ],
            "postedAt": [
                581
            ],
            "requestedAt": [
                581
            ],
            "failedAt": [
                581
            ],
            "type": [
                1111
            ],
            "__typename": [
                1
            ]
        },
        "IntegrationType": {},
        "InternalTransferCandidatesInput": {
            "companyId": [
                15
            ],
            "bankTransactionId": [
                15
            ],
            "allowNotExactMatch": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "internalTransferCandidatesV2Input": {
            "companyId": [
                15
            ],
            "bankTransactionId": [
                15
            ],
            "rangePercentageAmount": [
                5
            ],
            "postedAt": [
                583
            ],
            "allowNotExactDateMatch": [
                7
            ],
            "sort": [
                292
            ],
            "limit": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "InventoryBatch": {
            "action": [
                2397
            ],
            "quantity": [
                41
            ],
            "directCost": [
                5
            ],
            "indirectCosts": [
                1441
            ],
            "__typename": [
                1
            ]
        },
        "InventoryInitStatus": {
            "areProductsLoaded": [
                7
            ],
            "isSalesDataLoaded": [
                7
            ],
            "isDataReconciled": [
                7
            ],
            "hasPurchaseOrders": [
                7
            ],
            "hasWarehouseOpeningBalances": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPaymentGroup": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "postedAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "affiliatedEntity": [
                72
            ],
            "serialNumber": [
                1
            ],
            "purchaseOrders": [
                1665
            ],
            "warehouseTransfers": [
                1666
            ],
            "inventoryPurchases": [
                1660
            ],
            "manualAssemblies": [
                1662
            ],
            "onDemandAssemblyVendorCosts": [
                1663
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPaymentGroupByIdInput": {
            "inventoryPaymentGroupId": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPaymentGroupByIdResponse": {
            "inventoryPaymentGroup": [
                1118
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPaymentGroupLink": {
            "inventoryPaymentGroup": [
                1118
            ],
            "serialNumber": [
                1
            ],
            "amount": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "currency": [
                549
            ],
            "postedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPaymentGroupsByIdsInput": {
            "companyId": [
                15
            ],
            "inventoryPaymentGroupIds": [
                15
            ],
            "withDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPaymentGroupsByIdsResponse": {
            "inventoryPaymentGroups": [
                1118
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPaymentGroupsFilter": {
            "postedAt": [
                583
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPaymentGroupsInput": {
            "companyId": [
                1
            ],
            "filter": [
                1124
            ],
            "affiliatedEntityId": [
                1
            ],
            "sort": [
                1127
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPaymentGroupsResponse": {
            "inventoryPaymentGroups": [
                1118
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPaymentGroupsSort": {
            "type": [
                1129
            ],
            "direction": [
                1128
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPaymentGroupsSortDirection": {},
        "InventoryPaymentGroupsSortType": {},
        "InventoryPaymentGroupUnclearedBalance": {
            "paymentGroup": [
                1118
            ],
            "unclearedBalance": [
                107
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchase": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "source": [
                1150
            ],
            "sourceEntity": [
                1152
            ],
            "bankTransactionId": [
                15
            ],
            "billId": [
                15
            ],
            "amazonShippingInBusinessEventId": [
                15
            ],
            "payrollId": [
                15
            ],
            "sourceDescription": [
                1
            ],
            "direction": [
                1138
            ],
            "dates": [
                582
            ],
            "affiliatedEntity": [
                72
            ],
            "currency": [
                1
            ],
            "amount": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "historicalPurchaseAffectingMethodId": [
                15
            ],
            "categories": [
                1134
            ],
            "items": [
                1140
            ],
            "paymentStatus": [
                1142
            ],
            "canceledAt": [
                581
            ],
            "lastUpdatedAt": [
                581
            ],
            "attachments": [
                1132
            ],
            "paidAt": [
                581
            ],
            "inventoryPaymentGroupLinks": [
                1121
            ],
            "unpaidAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchaseAttachment": {
            "filename": [
                1
            ],
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchaseAttachmentInput": {
            "filename": [
                1
            ],
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchaseCategory": {
            "serialNumber": [
                41
            ],
            "categoryName": [
                1136
            ],
            "purchaseType": [
                1161
            ],
            "amount": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "classificationTag": [
                392
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchaseCategoryInput": {
            "serialNumber": [
                41
            ],
            "categoryName": [
                1136
            ],
            "purchaseType": [
                1161
            ],
            "amount": [
                5
            ],
            "classificationTagId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchaseCategoryName": {},
        "InventoryPurchaseCategorySummary": {
            "categoryName": [
                1136
            ],
            "purchasedAmountInHomeCurrency": [
                5
            ],
            "incidentalsAmountInHomeCurrency": [
                5
            ],
            "receivedAmountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchaseDirection": {},
        "InventoryPurchaseInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "sourceDescription": [
                1
            ],
            "direction": [
                1138
            ],
            "dates": [
                583
            ],
            "vendorId": [
                15
            ],
            "affiliatedEntityId": [
                15
            ],
            "currency": [
                1
            ],
            "amount": [
                5
            ],
            "categories": [
                1135
            ],
            "items": [
                1141
            ],
            "paymentStatus": [
                1142
            ],
            "lastUpdatedAt": [
                581
            ],
            "attachments": [
                1133
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchaseItem": {
            "amount": [
                5
            ],
            "shipmentDate": [
                581
            ],
            "receivedDate": [
                581
            ],
            "purchaseDate": [
                581
            ],
            "note": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchaseItemInput": {
            "amount": [
                5
            ],
            "shipmentDate": [
                581
            ],
            "receivedDate": [
                581
            ],
            "purchaseDate": [
                581
            ],
            "note": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchasePaymentStatus": {},
        "InventoryPurchaseRule": {
            "id": [
                1
            ],
            "affiliatedEntity": [
                72
            ],
            "categoryName": [
                1136
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "condition": [
                1145
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchaseRuleApplyRuleOperation": {},
        "InventoryPurchaseRuleCondition": {},
        "InventoryPurchaseRulesResponse": {
            "items": [
                1143
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchasesCountByVendorItem": {
            "affiliatedEntity": [
                72
            ],
            "count": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchasesCountByVendorResponse": {
            "items": [
                1147
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchasesExportResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchaseSource": {},
        "InventoryPurchaseSourceCategory": {},
        "InventoryPurchaseSourceEntity": {
            "on_BankTransaction": [
                270
            ],
            "on_Bill": [
                312
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchasesResponse": {
            "purchases": [
                1131
            ],
            "hasNext": [
                7
            ],
            "totalCount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchasesSort": {
            "field": [
                1155
            ],
            "direction": [
                1156
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchasesSortByField": {},
        "InventoryPurchasesSortDirection": {},
        "InventoryPurchasesSummaryResponse": {
            "summary": [
                1137
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchaseStatus": {},
        "InventoryPurchasesValidationResult": {
            "checkTime": [
                581
            ],
            "expectedInProcessBalance": [
                5
            ],
            "expectedInTransitBalance": [
                5
            ],
            "actualInProcessBalance": [
                5
            ],
            "actualInTransitBalance": [
                5
            ],
            "clearingAccountBalance": [
                5
            ],
            "missingExpectedPurchaseIds": [
                15
            ],
            "unexpectedPurchaseIds": [
                15
            ],
            "missingExpectedBusinessEventsForPurchaseIds": [
                15
            ],
            "unexpectedBusinessEventIds": [
                15
            ],
            "status": [
                1160
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchasesValidationStatus": {},
        "InventoryPurchaseType": {},
        "InventoryPurchaseUpdateOutOfDateError": {
            "inventoryPurchase": [
                1131
            ],
            "__typename": [
                1
            ]
        },
        "InventoryPurchaseVendorsResponse": {
            "items": [
                72
            ],
            "__typename": [
                1
            ]
        },
        "InventorySettings": {
            "companyId": [
                15
            ],
            "managementMethod": [
                1
            ],
            "onboardingCompletionTime": [
                581
            ],
            "rangedManagementMethod": [
                1857
            ],
            "isEligibleForNoClosingBalancePurchaseBased": [
                7
            ],
            "openingBalance": [
                5
            ],
            "latestOpeningBalanceBusinessEventId": [
                1
            ],
            "closingBalances": [
                1242
            ],
            "latestClosingBalanceBusinessEventIds": [
                1
            ],
            "realtimeCogsStatus": [
                1860
            ],
            "hasUserReviewedProducts": [
                7
            ],
            "haveDropshippingPurchase": [
                7
            ],
            "isUsingPaymentGroupsFeature": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "InventoryUsageType": {},
        "InventoryVendor": {
            "affiliatedEntity": [
                72
            ],
            "rollingBalance": [
                5
            ],
            "unpaidBills": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorAdjustment": {
            "date": [
                581
            ],
            "amount": [
                5
            ],
            "bill": [
                312
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorBillItem": {
            "amount": [
                5
            ],
            "balance": [
                5
            ],
            "paidAmount": [
                5
            ],
            "source": [
                1169
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorBillItemSource": {
            "on_InventoryPurchase": [
                1131
            ],
            "on_InventoryVendorPayment": [
                1177
            ],
            "on_InventoryVendorCredit": [
                1173
            ],
            "on_InventoryVendorAdjustment": [
                1167
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorBillItemType": {},
        "InventoryVendorBillsOverviewResponse": {
            "billsAmount": [
                5
            ],
            "billPayments": [
                5
            ],
            "billCredits": [
                5
            ],
            "billAdjustments": [
                5
            ],
            "billsPurchasesAmount": [
                5
            ],
            "billsIncidentalPurchasesAmount": [
                5
            ],
            "asOfDate": [
                1175
            ],
            "beforeUnitsTracking": [
                1175
            ],
            "count": [
                41
            ],
            "minAmount": [
                5
            ],
            "maxAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorBillsResponse": {
            "hasNext": [
                7
            ],
            "count": [
                41
            ],
            "items": [
                1168
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorCredit": {
            "date": [
                581
            ],
            "amount": [
                5
            ],
            "bill": [
                312
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorFilterValuesResponse": {
            "maxRollingBalance": [
                5
            ],
            "minRollingBalance": [
                5
            ],
            "maxUnpaidBills": [
                5
            ],
            "minUnpaidBills": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorOverviewItem": {
            "amount": [
                5
            ],
            "payments": [
                5
            ],
            "credits": [
                5
            ],
            "adjustments": [
                5
            ],
            "purchasesAmount": [
                5
            ],
            "incidentalPurchasesAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorParamsResponse": {
            "inventoryVendorBillsCount": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorPayment": {
            "date": [
                581
            ],
            "amount": [
                5
            ],
            "bill": [
                312
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorRollingBalanceItem": {
            "amount": [
                5
            ],
            "rollingBalance": [
                5
            ],
            "source": [
                1179
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorRollingBalanceItemSource": {
            "on_PurchaseOrder": [
                1846
            ],
            "on_InventoryPurchase": [
                1131
            ],
            "on_WarehouseTransfer": [
                2435
            ],
            "on_Assembly": [
                131
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorRollingBalanceItemTypes": {},
        "InventoryVendorRollingBalanceOverviewResponse": {
            "affiliatedEntity": [
                72
            ],
            "purchaseOrdersBalance": [
                5
            ],
            "warehouseTransfersBalance": [
                5
            ],
            "paymentsBalance": [
                5
            ],
            "billsBalance": [
                5
            ],
            "assembliesBalance": [
                5
            ],
            "count": [
                41
            ],
            "minAmount": [
                5
            ],
            "maxAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorRollingBalanceResponse": {
            "hasNext": [
                7
            ],
            "items": [
                1178
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorsOverviewResponse": {
            "count": [
                41
            ],
            "negativeRollingBalanceCount": [
                41
            ],
            "rollingBalance": [
                5
            ],
            "unpaidBills": [
                5
            ],
            "unpaidBillsOpeningBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorsResponse": {
            "vendors": [
                1166
            ],
            "hasNext": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorsSort": {
            "field": [
                1186
            ],
            "direction": [
                2094
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorsSortField": {},
        "InventoryVendorValidationResult": {
            "totalsResult": [
                1189
            ],
            "vendorsResults": [
                1188
            ],
            "nonMatchingUnpaidBills": [
                1450
            ],
            "emptyVendorInventoryPurchases": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorValidationResultItem": {
            "affiliatedEntity": [
                72
            ],
            "rollingBalanceTotalAmount": [
                5
            ],
            "rollingBalanceListAmount": [
                5
            ],
            "rollingBalanceOverviewAmount": [
                5
            ],
            "unpaidBillsTotalAmount": [
                5
            ],
            "unpaidBillsListAmount": [
                5
            ],
            "unpaidBillsOverviewAmount": [
                5
            ],
            "rollingBalancePassed": [
                7
            ],
            "unpaidBillsPassed": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "InventoryVendorValidationTotalsResult": {
            "rollingBalanceOverviewAmount": [
                5
            ],
            "rollingBalanceListAmount": [
                5
            ],
            "rollingBalanceBooksAmount": [
                5
            ],
            "rollingBalanceDbAmount": [
                5
            ],
            "unpaidBillsOverviewAmount": [
                5
            ],
            "unpaidBillsIncidentalsAmount": [
                5
            ],
            "unpaidBillsBooksAmount": [
                5
            ],
            "unpaidBillsListAmount": [
                5
            ],
            "unpaidBillsDbAmount": [
                5
            ],
            "rollingBalancePassed": [
                7
            ],
            "unpaidBillsPassed": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "InventoryYearEndHistoryLog": {
            "userEmail": [
                1
            ],
            "updaterType": [
                1
            ],
            "date": [
                581
            ],
            "status": [
                1193
            ],
            "__typename": [
                1
            ]
        },
        "InventoryYearEndMissionsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "InventoryYearEndMissionsResponse": {
            "missions": [
                2497
            ],
            "__typename": [
                1
            ]
        },
        "InventoryYearEndMissionStatus": {},
        "InventoryYearEndMissionsType": {},
        "InvitationStatus": {},
        "InviteUserArgs": {
            "email": [
                1
            ],
            "roles": [
                1
            ],
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InviteUserResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "Invoice": {
            "id": [
                15
            ],
            "dueDate": [
                581
            ],
            "dueInDays": [
                41
            ],
            "companyAddress": [
                420
            ],
            "currentPdf": [
                1213
            ],
            "pdfs": [
                1213
            ],
            "paymentMethod": [
                1689
            ],
            "paymentMethods": [
                1689
            ],
            "openPaymentLinks": [
                1212
            ],
            "paidPaymentLinks": [
                1212
            ],
            "saleType": [
                1
            ],
            "companyId": [
                15
            ],
            "source": [
                1961
            ],
            "externalSourceUrl": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "integrationAccountId": [
                15
            ],
            "integrationAccountName": [
                1
            ],
            "currency": [
                549
            ],
            "displayName": [
                1
            ],
            "statuses": [
                1962
            ],
            "postedAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "publishedAt": [
                581
            ],
            "lineItems": [
                1923
            ],
            "shipping": [
                2047
            ],
            "discounts": [
                651
            ],
            "platformDiscounts": [
                651
            ],
            "taxes": [
                2137
            ],
            "taxFixedAmount": [
                5
            ],
            "taxType": [
                1963
            ],
            "adjustments": [
                1920
            ],
            "payments": [
                1965
            ],
            "credits": [
                1965
            ],
            "refunds": [
                1965
            ],
            "paymentIndications": [
                1965
            ],
            "refundIndications": [
                1965
            ],
            "customer": [
                563
            ],
            "customerId": [
                15
            ],
            "shippingAddress": [
                555
            ],
            "billingAddress": [
                555
            ],
            "integrationTags": [
                1
            ],
            "integrationNote": [
                1
            ],
            "finaloopNote": [
                1
            ],
            "customerNote": [
                1
            ],
            "isSalesAffecting": [
                7
            ],
            "isCogsAffecting": [
                7
            ],
            "accounting": [
                6
            ],
            "voidedAt": [
                581
            ],
            "voidedBy": [
                1919
            ],
            "approvedAt": [
                581
            ],
            "uploadId": [
                1
            ],
            "uploadedAt": [
                581
            ],
            "purchaseOrderNumber": [
                1
            ],
            "summary": [
                1964
            ],
            "__typename": [
                1
            ]
        },
        "InvoiceAdjustmentInput": {
            "invoiceId": [
                15
            ],
            "companyId": [
                15
            ],
            "adjustmentId": [
                15
            ],
            "createPaymentLink": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "InvoiceCreditInput": {
            "invoiceId": [
                15
            ],
            "companyId": [
                15
            ],
            "creditId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "InvoiceEmailInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "note": [
                1
            ],
            "ccList": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InvoiceInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "balanceAsOfDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "InvoicePay": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "source": [
                1
            ],
            "amount": [
                5
            ],
            "currency": [
                549
            ],
            "invoiceTotal": [
                5
            ],
            "invoiceUnpaidBalance": [
                5
            ],
            "invoiceDisplayName": [
                1
            ],
            "pdfUrl": [
                1
            ],
            "companyLogoUrl": [
                1
            ],
            "status": [
                1688
            ],
            "customerName": [
                1
            ],
            "invoicerName": [
                1
            ],
            "invoiceDate": [
                581
            ],
            "dueDate": [
                581
            ],
            "paymentMethods": [
                1689
            ],
            "integrationAccountId": [
                1
            ],
            "publishableApiKey": [
                1
            ],
            "clientSecret": [
                1
            ],
            "previousPaymentErrorMessage": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InvoicePayInput": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "InvoicePayLinkInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "InvoicePaymentGroup": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "postedAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "invoices": [
                1661
            ],
            "bankTransactions": [
                1659
            ],
            "expenses": [
                1653
            ],
            "actorType": [
                38
            ],
            "__typename": [
                1
            ]
        },
        "InvoicePaymentGroupByIdResponse": {
            "paymentGroup": [
                1206
            ],
            "__typename": [
                1
            ]
        },
        "InvoicePaymentGroupsByIdsResponse": {
            "paymentGroups": [
                1206
            ],
            "__typename": [
                1
            ]
        },
        "InvoicePaymentGroupsResponse": {
            "paymentGroups": [
                1206
            ],
            "__typename": [
                1
            ]
        },
        "InvoicePaymentGroupsUnclearedBalanceResponse": {
            "asOfDate": [
                581
            ],
            "unclearedBalances": [
                1211
            ],
            "__typename": [
                1
            ]
        },
        "InvoicePaymentGroupUnclearedBalance": {
            "paymentGroup": [
                1206
            ],
            "unclearedBalance": [
                107
            ],
            "__typename": [
                1
            ]
        },
        "InvoicePaymentLink": {
            "id": [
                1
            ],
            "source": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "amount": [
                5
            ],
            "currency": [
                549
            ],
            "refundedAt": [
                581
            ],
            "amountInHomeCurrency": [
                5
            ],
            "externalSourceId": [
                1
            ],
            "saleTransactionId": [
                1
            ],
            "refundSaleTransactionId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InvoicePdf": {
            "id": [
                15
            ],
            "location": [
                1
            ],
            "createdAt": [
                581
            ],
            "sentAt": [
                581
            ],
            "issuedAt": [
                581
            ],
            "isDraft": [
                7
            ],
            "isVoided": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "InvoicePdfInput": {
            "companyId": [
                15
            ],
            "invoiceId": [
                15
            ],
            "invoicePdfId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "InvoicePdfSentInput": {
            "companyId": [
                15
            ],
            "invoicePdfId": [
                15
            ],
            "invoiceId": [
                15
            ],
            "sentAtStr": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "InvoiceRefundInput": {
            "invoiceId": [
                15
            ],
            "companyId": [
                15
            ],
            "refundId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "InvoiceRefundOrAdjustmentInput": {
            "invoiceId": [
                15
            ],
            "companyId": [
                15
            ],
            "refundId": [
                15
            ],
            "adjustmentId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "InvoicesAggregations": {
            "invoicesCount": [
                41
            ],
            "invoicesAverageValue": [
                5
            ],
            "invoicesNetSales": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "InvoicesBalance": {
            "balance": [
                5
            ],
            "count": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "InvoiceSettings": {
            "logoImageLocation": [
                1
            ],
            "currentAutoInvoiceNumber": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "InvoicesInput": {
            "companyId": [
                15
            ],
            "balanceAsOfDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "InvoicesYearEnd": {
            "fiscalYearStartDate": [
                581
            ],
            "fiscalYearEndDate": [
                581
            ],
            "domainState": [
                2476
            ],
            "hubReportedDomainState": [
                2476
            ],
            "tasks": [
                1223
            ],
            "__typename": [
                1
            ]
        },
        "InvoicesYearEndTask": {
            "id": [
                1224
            ],
            "stateKey": [
                1
            ],
            "status": [
                1227
            ],
            "on_AddMissingInvoicesTask": [
                54
            ],
            "on_CloseOpenInvoicesTask": [
                403
            ],
            "on_ConfirmArBalanceTask": [
                483
            ],
            "on_LinkInvoicePaymentsTask": [
                1261
            ],
            "__typename": [
                1
            ]
        },
        "InvoicesYearEndTaskId": {},
        "InvoicesYearEndTasksInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "InvoicesYearEndTasksResponse": {
            "yearEnd": [
                1222
            ],
            "__typename": [
                1
            ]
        },
        "InvoicesYearEndTaskStatus": {},
        "InvoiceToPaymentGroups": {
            "invoiceId": [
                1
            ],
            "paymentGroups": [
                1206
            ],
            "__typename": [
                1
            ]
        },
        "InvoiceTransactionInput": {
            "invoiceId": [
                15
            ],
            "companyId": [
                15
            ],
            "refundId": [
                15
            ],
            "adjustmentId": [
                15
            ],
            "creditId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "InvoiceUnvoidInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "createPaymentLink": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "IPaymentGroup": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "postedAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "on_InvoicePaymentGroup": [
                1206
            ],
            "on_OrderPaymentGroup": [
                1552
            ],
            "__typename": [
                1
            ]
        },
        "IrrelevantType": {},
        "IsCompanyFulfillmentSettingsAppliedInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "IsGlobalRuleExistResult": {
            "exists": [
                7
            ],
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "IsInvitationCodeForRegisteredUserArgs": {
            "invitationCode": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "IsInvitationCodeForRegisteredUserResponse": {
            "isRegisteredUser": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "IsPaymentGroupLinkExistInput": {
            "companyId": [
                1
            ],
            "affiliatedEntityId": [
                1
            ],
            "categoryName": [
                1136
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "condition": [
                1145
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "ItemReconciliationFinaloopSalesChannel": {
            "displayName": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "JournalEntryActions": {
            "firstAccount": [
                34
            ],
            "secondAccount": [
                34
            ],
            "__typename": [
                1
            ]
        },
        "JournalEntryActionsInput": {
            "firstAccount": [
                35
            ],
            "secondAccount": [
                35
            ],
            "__typename": [
                1
            ]
        },
        "JSON": {},
        "JSONObject": {},
        "LastAccountingReportSyncInput": {
            "companyId": [
                15
            ],
            "reportType": [
                1907
            ],
            "__typename": [
                1
            ]
        },
        "LastAccountingReportSyncResponse": {
            "status": [
                1906
            ],
            "exportedAt": [
                581
            ],
            "fileUrl": [
                1
            ],
            "fileName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "LastTransaction": {
            "id": [
                1
            ],
            "postedAt": [
                581
            ],
            "bankAccountId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "LatestActiveCompanyUserArgs": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "LatestActiveCompanyUserResponse": {
            "user": [
                2333
            ],
            "latestIpAddress": [
                1
            ],
            "latestGtmSourceIdentifiers": [
                1
            ],
            "latestUserAgent": [
                1
            ],
            "latestXGtmServerPreview": [
                1
            ],
            "latestUtms": [
                1241
            ],
            "__typename": [
                1
            ]
        },
        "lenderFromEntityInput": {
            "companyId": [
                15
            ],
            "entityId": [
                15
            ],
            "entityType": [
                1415
            ],
            "__typename": [
                1
            ]
        },
        "LinearIdentifiersInput": {
            "teamName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "LineItemDiscountType": {},
        "LineItemStatuses": {
            "voidStatus": [
                2394
            ],
            "fulfillmentStatus": [
                768
            ],
            "restockStatus": [
                1912
            ],
            "__typename": [
                1
            ]
        },
        "LineItemTimelineAccountStateV3": {
            "quantity": [
                41
            ],
            "amount": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "sellerDiscountAmount": [
                5
            ],
            "sellerDiscountAmountInHomeCurrency": [
                5
            ],
            "platformDiscountAmount": [
                5
            ],
            "platformDiscountAmountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "LineItemTimeLineActionTypeV3": {},
        "LineItemTimelineActionV3": {
            "postedAt": [
                581
            ],
            "action": [
                1253
            ],
            "amount": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "sellerDiscountAmount": [
                5
            ],
            "sellerDiscountAmountInHomeCurrency": [
                5
            ],
            "platformDiscountAmount": [
                5
            ],
            "platformDiscountAmountInHomeCurrency": [
                5
            ],
            "quantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "LinkedBankTransaction": {
            "bankTransaction": [
                270
            ],
            "amount": [
                107
            ],
            "__typename": [
                1
            ]
        },
        "LinkedOrder": {
            "order": [
                1602
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "LinkInventoryPaymentGroupInput": {
            "companyId": [
                15
            ],
            "postedAt": [
                581
            ],
            "affiliatedEntityId": [
                15
            ],
            "purchaseOrders": [
                1674
            ],
            "warehouseTransfers": [
                1687
            ],
            "inventoryPurchases": [
                1656
            ],
            "manualAssemblies": [
                1671
            ],
            "onDemandAssemblyVendorCosts": [
                1672
            ],
            "__typename": [
                1
            ]
        },
        "LinkInventoryPaymentGroupResponse": {
            "inventoryPaymentGroup": [
                1118
            ],
            "__typename": [
                1
            ]
        },
        "LinkInvoicePaymentGroupInput": {
            "companyId": [
                15
            ],
            "postedAt": [
                581
            ],
            "invoices": [
                1657
            ],
            "bankTransactions": [
                1651
            ],
            "expenses": [
                1654
            ],
            "actorType": [
                38
            ],
            "TEMPORARY_ACTOR_EMAIL": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "LinkInvoicePaymentGroupResponse": {
            "paymentGroup": [
                1206
            ],
            "__typename": [
                1
            ]
        },
        "LinkInvoicePaymentsTask": {
            "id": [
                1224
            ],
            "status": [
                1227
            ],
            "stateKey": [
                1
            ],
            "currentInvoicesHash": [
                1
            ],
            "state": [
                1262
            ],
            "history": [
                1263
            ],
            "__typename": [
                1
            ]
        },
        "LinkInvoicePaymentsTaskState": {
            "confirmedInvoicesHash": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "LinkInvoicePaymentsTaskStateChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                2507
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                1262
            ],
            "newValue": [
                1262
            ],
            "__typename": [
                1
            ]
        },
        "LinkOrderGroupInput": {
            "companyId": [
                15
            ],
            "postedAt": [
                581
            ],
            "orders": [
                1595
            ],
            "bankTransactions": [
                302
            ],
            "expenses": [
                1517
            ],
            "__typename": [
                1
            ]
        },
        "LinkOrderGroupResponse": {
            "orderGroup": [
                1512
            ],
            "__typename": [
                1
            ]
        },
        "LinkOrderPaymentGroupInput": {
            "companyId": [
                15
            ],
            "postedAt": [
                581
            ],
            "orders": [
                1673
            ],
            "bankTransactions": [
                1651
            ],
            "expenses": [
                1654
            ],
            "__typename": [
                1
            ]
        },
        "LinkOrderPaymentGroupResponse": {
            "paymentGroup": [
                1552
            ],
            "__typename": [
                1
            ]
        },
        "ListAssembliesAmountRangeFilters": {
            "from": [
                5
            ],
            "to": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "ListAssembliesFilters": {
            "companyId": [
                15
            ],
            "affiliatedEntityId": [
                15
            ],
            "periods": [
                1272
            ],
            "textSearch": [
                1
            ],
            "warehouseIds": [
                15
            ],
            "productIds": [
                15
            ],
            "amountRange": [
                1268
            ],
            "assemblyType": [
                135
            ],
            "__typename": [
                1
            ]
        },
        "ListAssembliesInput": {
            "filters": [
                1269
            ],
            "offset": [
                5
            ],
            "limit": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "ListAssembliesResult": {
            "assemblies": [
                131
            ],
            "hasNext": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ListAssembliesTimePeriod": {
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ListAssemblyCostsInput": {
            "companyId": [
                15
            ],
            "ids": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ListAssemblyItemsFilters": {
            "companyId": [
                15
            ],
            "affiliatedEntityId": [
                15
            ],
            "period": [
                1272
            ],
            "__typename": [
                1
            ]
        },
        "ListAssemblyItemsInput": {
            "filters": [
                1274
            ],
            "sort": [
                1277
            ],
            "__typename": [
                1
            ]
        },
        "ListAssemblyItemsResult": {
            "assemblyItems": [
                134
            ],
            "__typename": [
                1
            ]
        },
        "ListAssemblyItemsSort": {
            "field": [
                1279
            ],
            "direction": [
                1278
            ],
            "__typename": [
                1
            ]
        },
        "ListAssemblyItemsSortDirection": {},
        "ListAssemblyItemsSortField": {},
        "ListCompaniesInput": {
            "withArchivedCompanies": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ListFailingValidationCompaniesResponse": {
            "companies": [
                2366
            ],
            "__typename": [
                1
            ]
        },
        "ListManualAssembliesResult": {
            "manualAssemblies": [
                1373
            ],
            "__typename": [
                1
            ]
        },
        "ListNoUnitsPhysicalCountsInput": {
            "companyId": [
                1
            ],
            "toDate": [
                581
            ],
            "adjustmentAmountMin": [
                5
            ],
            "adjustmentAmountMax": [
                5
            ],
            "productIds": [
                1
            ],
            "page": [
                1634
            ],
            "includeDrafts": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ListReadyValidationsInput": {
            "companyId": [
                15
            ],
            "type": [
                475
            ],
            "from": [
                581
            ],
            "to": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ListUnitsTrackingPhysicalCountsInput": {
            "companyId": [
                1
            ],
            "toDate": [
                581
            ],
            "warehouseId": [
                1
            ],
            "productIds": [
                1
            ],
            "adjustmentAmountMin": [
                5
            ],
            "adjustmentAmountMax": [
                5
            ],
            "page": [
                1634
            ],
            "includeDrafts": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ListValidationRemediationsInput": {
            "validationDomain": [
                1
            ],
            "validationType": [
                1
            ],
            "fiscalYears": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "Loan": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "source": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "latestActorType": [
                38
            ],
            "latestActorId": [
                1
            ],
            "type": [
                1339
            ],
            "lender": [
                1446
            ],
            "currency": [
                549
            ],
            "postedAt": [
                581
            ],
            "direction": [
                1307
            ],
            "internalNote": [
                1
            ],
            "isShortTerm": [
                7
            ],
            "amount": [
                5
            ],
            "totalAmount": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "outstandingAmount": [
                5
            ],
            "accruedInterest": [
                5
            ],
            "unrecognizedFees": [
                5
            ],
            "prepaymentLiabilityAmount": [
                5
            ],
            "status": [
                1334
            ],
            "userActionStatus": [
                1343
            ],
            "treatmentStatus": [
                1338
            ],
            "acknowledgedInternallyAt": [
                581
            ],
            "acknowledgedInternallyBy": [
                1
            ],
            "paidOffAt": [
                581
            ],
            "lastManuallyHandledAt": [
                581
            ],
            "lastManuallyHandledBy": [
                1
            ],
            "attachments": [
                1293
            ],
            "createdBy": [
                1
            ],
            "createdById": [
                1
            ],
            "workingPaperLink": [
                1
            ],
            "internalOwner": [
                1
            ],
            "updatedBy": [
                1
            ],
            "lockedAt": [
                581
            ],
            "lastSeenByClientAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "restoredAt": [
                581
            ],
            "directionSource": [
                1323
            ],
            "merchantSource": [
                1323
            ],
            "postedAtSource": [
                1323
            ],
            "amountSource": [
                1323
            ],
            "interestDays": [
                1314
            ],
            "repaymentType": [
                1327
            ],
            "repaymentFrequency": [
                1326
            ],
            "repaymentRate": [
                5
            ],
            "interestRateType": [
                1315
            ],
            "interestRate": [
                5
            ],
            "gracePeriod": [
                41
            ],
            "catchUpPeriod": [
                41
            ],
            "catchUpPercent": [
                5
            ],
            "catchUpAmount": [
                5
            ],
            "originationFees": [
                5
            ],
            "prepaymentFees": [
                5
            ],
            "feeRate": [
                5
            ],
            "dataRequestType": [
                1306
            ],
            "recurringDataFrequency": [
                1324
            ],
            "instantRepaymentMethod": [
                1313
            ],
            "isIndexLinked": [
                7
            ],
            "interestType": [
                1316
            ],
            "variableInterestUpdatePeriod": [
                1346
            ],
            "variableInterestSpread": [
                5
            ],
            "variableInterestBase": [
                1345
            ],
            "compoundFrequency": [
                1303
            ],
            "indexType": [
                1312
            ],
            "termDurationValue": [
                41
            ],
            "termDurationUnit": [
                1335
            ],
            "modifiedFields": [
                1
            ],
            "manualEventsGroup": [
                1318
            ],
            "billPaymentEvents": [
                1298
            ],
            "isEarlyRepaymentDiscount": [
                7
            ],
            "earlyRepaymentDiscounts": [
                669
            ],
            "userFollowUp2": [
                2341
            ],
            "pendingDelete": [
                7
            ],
            "pendingRestoreAcknowledgement": [
                7
            ],
            "lastUserMoveToProcessingAt": [
                581
            ],
            "isHidden": [
                7
            ],
            "firstEventDate": [
                581
            ],
            "firstPaymentDate": [
                581
            ],
            "lastPaymentDate": [
                581
            ],
            "businessName": [
                1
            ],
            "isBillPaymentEventAttached": [
                7
            ],
            "accountingEvents": [
                1288
            ],
            "bankAccount": [
                161
            ],
            "neededReconciliationAt": [
                581
            ],
            "lastOngoingTreatmentAt": [
                581
            ],
            "hasRollOverEvent": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "LoanAccountingEvent": {
            "id": [
                15
            ],
            "amount": [
                5
            ],
            "postedAt": [
                581
            ],
            "memo": [
                1
            ],
            "businessEventActionsConfiguration": [
                348
            ],
            "customTags": [
                1242
            ],
            "latestActorType": [
                38
            ],
            "latestActorId": [
                1
            ],
            "updatedAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "businessEventData": [
                1300
            ],
            "__typename": [
                1
            ]
        },
        "LoanAccountRoleEffectDirection": {},
        "LoanAffiliatedTransactionEvent": {
            "id": [
                15
            ],
            "bankTransaction": [
                270
            ],
            "companyAffiliate": [
                422
            ],
            "amount": [
                5
            ],
            "postedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "LoanAlreadyExistsResult": {
            "loan": [
                1287
            ],
            "__typename": [
                1
            ]
        },
        "LoanAmountEffect": {},
        "LoanAttachment": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "createdAt": [
                581
            ],
            "type": [
                1296
            ],
            "latestActorId": [
                1
            ],
            "isHidden": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "LoanAttachmentError": {
            "message": [
                1
            ],
            "type": [
                1295
            ],
            "attachment": [
                1
            ],
            "attachmentType": [
                1296
            ],
            "additionalInfo": [
                50
            ],
            "attachmentUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "LoanAttachmentErrorType": {},
        "LoanAttachmentType": {},
        "LoanBillEvent": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "LoanBillPaymentEvent": {
            "id": [
                15
            ],
            "bill": [
                312
            ],
            "paymentId": [
                15
            ],
            "postedAt": [
                581
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "LoanBusinessEvent": {
            "id": [
                15
            ],
            "postedAt": [
                581
            ],
            "eventType": [
                1
            ],
            "memo": [
                1
            ],
            "actions": [
                1242
            ],
            "integrationAccountId": [
                1
            ],
            "amount": [
                5
            ],
            "isMigrationAdjustment": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "LoanBusinessEventData": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "LoanComment": {
            "id": [
                15
            ],
            "text": [
                1
            ],
            "createdAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "LoanCommentInput": {
            "id": [
                15
            ],
            "text": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "LoanCompoundFrequency": {},
        "LoanCreationFailureResult": {
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "LoanCreationResult": {
            "on_LoanUpdatedResult": [
                1342
            ],
            "on_LoanCreationFailureResult": [
                1304
            ],
            "on_LoanAlreadyExistsResult": [
                1291
            ],
            "on_LoanTransactionProcessedOnlineResult": [
                1337
            ],
            "__typename": [
                1
            ]
        },
        "LoanDataRequestType": {},
        "LoanDirection": {},
        "LoanEvent": {
            "on_LoanManualEvent": [
                1318
            ],
            "on_BankTransaction": [
                270
            ],
            "on_LoanBillEvent": [
                1297
            ],
            "on_LoanBusinessEvent": [
                1299
            ],
            "on_LoanBillPaymentEvent": [
                1298
            ],
            "on_Payout": [
                1697
            ],
            "on_Topup": [
                2159
            ],
            "on_LoanAffiliatedTransactionEvent": [
                1290
            ],
            "on_LoanAccountingEvent": [
                1288
            ],
            "on_IntegrationTransfer": [
                1098
            ],
            "__typename": [
                1
            ]
        },
        "LoanEventDefinition": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "isSpreadable": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "LoanEventFilter": {},
        "LoanEventRecurrence": {},
        "LoanIndexType": {},
        "LoanInstantRepaymentMethod": {},
        "LoanInterestDays": {},
        "LoanInterestRateType": {},
        "LoanInterestType": {},
        "LoanLenderType": {},
        "LoanManualEvent": {
            "id": [
                15
            ],
            "eventDefinition": [
                1309
            ],
            "amount": [
                5
            ],
            "postedAt": [
                581
            ],
            "memo": [
                1
            ],
            "recurrenceSettings": [
                1886
            ],
            "spreadData": [
                1319
            ],
            "latestActorType": [
                38
            ],
            "latestActorId": [
                1
            ],
            "updatedAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "effect": [
                1329
            ],
            "accountingEvents": [
                1288
            ],
            "__typename": [
                1
            ]
        },
        "LoanManualEventSpreadData": {
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "LoanMerchantInput": {
            "id": [
                15
            ],
            "type": [
                1415
            ],
            "__typename": [
                1
            ]
        },
        "LoanOutstandingAmountAffect": {},
        "LoanOutstandingAmountOnDate": {
            "loanId": [
                15
            ],
            "outstandingAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "LoanPropertySource": {},
        "LoanRecurringDataFrequency": {},
        "LoanRelationship": {
            "id": [
                15
            ],
            "isManuallyAttached": [
                7
            ],
            "isLocked": [
                7
            ],
            "event": [
                1308
            ],
            "__typename": [
                1
            ]
        },
        "LoanRepaymentFrequency": {},
        "LoanRepaymentType": {},
        "LoansByIdsResponse": {
            "loans": [
                1287
            ],
            "__typename": [
                1
            ]
        },
        "LoansEventsEffectConfiguration": {
            "id": [
                15
            ],
            "event": [
                1309
            ],
            "loanType": [
                1339
            ],
            "isShortTerm": [
                7
            ],
            "direction": [
                1307
            ],
            "minGracePeriod": [
                41
            ],
            "repaymentType": [
                1327
            ],
            "lender": [
                1446
            ],
            "memoTemplate": [
                1
            ],
            "dateTemplate": [
                1
            ],
            "businessEventActionsConfiguration": [
                348
            ],
            "loanOutstandingAmountAffect": [
                1321
            ],
            "loanAmountAffect": [
                1292
            ],
            "latestActorType": [
                38
            ],
            "latestActorId": [
                1
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "LoanSortDirection": {},
        "LoanSource": {},
        "LoansResponse": {
            "loans": [
                1287
            ],
            "page": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "LoansSort": {
            "field": [
                1
            ],
            "direction": [
                1330
            ],
            "__typename": [
                1
            ]
        },
        "LoanStatus": {},
        "LoanTermDuration": {},
        "LoanTransactionLockStatus": {
            "transactionId": [
                15
            ],
            "isLocked": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "LoanTransactionProcessedOnlineResult": {
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "LoanTreatmentStatus": {},
        "LoanType": {},
        "LoanUpdateBasicData": {
            "lenderId": [
                1
            ],
            "userActionStatus": [
                1343
            ],
            "postedAt": [
                581
            ],
            "amount": [
                5
            ],
            "status": [
                1334
            ],
            "hideOutdatedWarning": [
                7
            ],
            "type": [
                1339
            ],
            "pendingDelete": [
                7
            ],
            "userFollowUp2": [
                2342
            ],
            "direction": [
                1307
            ],
            "dataRequestType": [
                1306
            ],
            "recurringDataFrequency": [
                1324
            ],
            "isShortTerm": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "LoanUpdateData": {
            "status": [
                1334
            ],
            "userActionStatus": [
                1343
            ],
            "lastManuallyHandledAt": [
                581
            ],
            "postedAt": [
                581
            ],
            "amount": [
                5
            ],
            "internalOwner": [
                1
            ],
            "postedAtSource": [
                1323
            ],
            "amountSource": [
                1323
            ],
            "isShortTerm": [
                7
            ],
            "type": [
                1339
            ],
            "direction": [
                1307
            ],
            "directionSource": [
                1323
            ],
            "interestRateType": [
                1315
            ],
            "interestRate": [
                5
            ],
            "dataRequestType": [
                1306
            ],
            "interestType": [
                1316
            ],
            "isIndexLinked": [
                7
            ],
            "gracePeriod": [
                41
            ],
            "interestDays": [
                1314
            ],
            "originationFees": [
                5
            ],
            "prepaymentFees": [
                5
            ],
            "repaymentFrequency": [
                1326
            ],
            "repaymentType": [
                1327
            ],
            "lenderId": [
                1
            ],
            "lenderType": [
                1317
            ],
            "merchantSource": [
                1323
            ],
            "variableInterestUpdatePeriod": [
                1346
            ],
            "variableInterestSpread": [
                5
            ],
            "variableInterestBase": [
                1345
            ],
            "compoundFrequency": [
                1303
            ],
            "recurringDataFrequency": [
                1324
            ],
            "comment": [
                1302
            ],
            "unrecognizedFees": [
                5
            ],
            "repaymentRate": [
                5
            ],
            "catchUpPeriod": [
                41
            ],
            "catchUpPercent": [
                5
            ],
            "catchUpAmount": [
                5
            ],
            "instantRepaymentMethod": [
                1313
            ],
            "indexType": [
                1312
            ],
            "currency": [
                549
            ],
            "isEarlyRepaymentDiscount": [
                7
            ],
            "earlyRepaymentDiscounts": [
                671
            ],
            "userFollowUp2": [
                2342
            ],
            "internalNote": [
                1
            ],
            "lastUserMoveToProcessingAt": [
                581
            ],
            "bankAccountId": [
                1
            ],
            "businessName": [
                1
            ],
            "termDurationValue": [
                41
            ],
            "termDurationUnit": [
                1335
            ],
            "lastOngoingTreatmentAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "LoanUpdatedResult": {
            "loans": [
                1287
            ],
            "__typename": [
                1
            ]
        },
        "LoanUserActionStatus": {},
        "LoanUserFollowUpType": {},
        "LoanVariableInterestBase": {},
        "LoanVariableInterestUpdatePeriod": {},
        "LockAction": {},
        "LockBankAccountInput": {
            "companyId": [
                1
            ],
            "name": [
                1
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "LockCompanyBankInput": {
            "companyId": [
                1
            ],
            "bankName": [
                1
            ],
            "year": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "LockCompanyInput": {
            "companyId": [
                1
            ],
            "year": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "LockCompanyV2Input": {
            "companyId": [
                1
            ],
            "date": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "LockConditionStatus": {},
        "LockedStatus": {
            "year": [
                41
            ],
            "lockedAt": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "LockLoanInput": {
            "loanId": [
                15
            ],
            "lockDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "LockLoanResult": {
            "success": [
                7
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "LockStatusV2Input": {
            "from": [
                581
            ],
            "to": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "LockType": {},
        "LostAndFoundCogs": {
            "amount": [
                5
            ],
            "lost": [
                41
            ],
            "found": [
                41
            ],
            "monthlyBreakdown": [
                1360
            ],
            "__typename": [
                1
            ]
        },
        "LostAndFoundDailyBreakdown": {
            "date": [
                581
            ],
            "lost": [
                41
            ],
            "found": [
                41
            ],
            "reason": [
                66
            ],
            "__typename": [
                1
            ]
        },
        "LostAndFoundMonthlyBreakdown": {
            "date": [
                581
            ],
            "lost": [
                41
            ],
            "found": [
                41
            ],
            "dailyData": [
                1359
            ],
            "__typename": [
                1
            ]
        },
        "MachineClassificationInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "MachineClassificationJob": {
            "finishedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ManageBalanceSheetSetupStatus": {},
        "ManageCompanyYearEndStateInput": {
            "companyId": [
                15
            ],
            "year": [
                41
            ],
            "operation": [
                1371
            ],
            "updatedBy": [
                1
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ManageCompanyYearEndStateResponse": {
            "status": [
                1372
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ManagementMethod": {},
        "ManagementMethodYearEndPeriod": {
            "method": [
                1366
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ManagementMethodYearEndPeriodInput": {
            "method": [
                1366
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ManageProductMergeRecommendationsGroupInput": {
            "companyId": [
                15
            ],
            "productGroupId": [
                1
            ],
            "isDelete": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ManageProductMergeRecommendationsProductInput": {
            "companyId": [
                15
            ],
            "productGroupId": [
                1
            ],
            "productId": [
                1
            ],
            "isDelete": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ManageYearEndOperations": {},
        "ManageYearEndOperationStatus": {},
        "ManualAssembly": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "product": [
                1769
            ],
            "date": [
                581
            ],
            "warehouse": [
                2396
            ],
            "recipe": [
                1861
            ],
            "unitsToAssemble": [
                41
            ],
            "displayName": [
                1
            ],
            "serialNumber": [
                41
            ],
            "deletedReason": [
                132
            ],
            "deletedAt": [
                581
            ],
            "unpaidAmounts": [
                2211
            ],
            "inventoryPaymentGroupLinks": [
                1121
            ],
            "__typename": [
                1
            ]
        },
        "ManualAssemblyAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "manualAssembly": [
                1373
            ],
            "__typename": [
                1
            ]
        },
        "ManualAssemblyBreakdown": {
            "origin": [
                1377
            ],
            "analytics": [
                1062
            ],
            "__typename": [
                1
            ]
        },
        "ManualAssemblyDuplicateError": {
            "date": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ManualAssemblyWithBreakdown": {
            "assembly": [
                1373
            ],
            "warehouse": [
                2396
            ],
            "date": [
                581
            ],
            "breakdown": [
                1866
            ],
            "__typename": [
                1
            ]
        },
        "ManualCompanyLoanCreationResult": {
            "loan": [
                453
            ],
            "__typename": [
                1
            ]
        },
        "ManualEquityEntity": {
            "on_HolderTransaction": [
                1044
            ],
            "on_HolderShare": [
                1040
            ],
            "on_HolderCapitalInvestment": [
                1035
            ],
            "on_HolderSafeInvestment": [
                1038
            ],
            "__typename": [
                1
            ]
        },
        "ManualEquityEventsInput": {
            "companyId": [
                15
            ],
            "includeDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ManualLoanCreationResult": {
            "loan": [
                1287
            ],
            "__typename": [
                1
            ]
        },
        "ManualTransactionsAttachToLoanResult": {
            "loan": [
                453
            ],
            "transactions": [
                270
            ],
            "__typename": [
                1
            ]
        },
        "ManualTransactionsAttachToLoansResult": {
            "loans": [
                453
            ],
            "transactions": [
                270
            ],
            "__typename": [
                1
            ]
        },
        "ManualTxInput": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "amount": [
                5
            ],
            "currency": [
                549
            ],
            "amountInHomeCurrency": [
                5
            ],
            "postedAt": [
                581
            ],
            "createPaymentLink": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "MarkAuth0CompanyUsersAsFinishedOnboardingArgs": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "MarkBankAccountReconciliationRelevantInput": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "finaloopMessage": [
                1
            ],
            "internalMessage": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "MarkIntegrationTransfersAsDiscrepancyInput": {
            "ids": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "MarkOrderLineItemsAsVoidedInput": {
            "companyId": [
                15
            ],
            "orderVoidingStates": [
                1608
            ],
            "__typename": [
                1
            ]
        },
        "MarkOrderLineItemsAsVoidedResponse": {
            "success": [
                7
            ],
            "failedOrderIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "MarkOrdersAsCOGSInput": {
            "companyId": [
                15
            ],
            "orderIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "MarkOrdersAsCOGSResponse": {
            "orders": [
                1602
            ],
            "__typename": [
                1
            ]
        },
        "MarkOrdersAsGiveawayInput": {
            "companyId": [
                15
            ],
            "orderIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "MarkOrdersAsGiveawayResponse": {
            "orders": [
                1602
            ],
            "__typename": [
                1
            ]
        },
        "MarkOrdersAsHistoricallyPaidInput": {
            "companyId": [
                15
            ],
            "historicalPayments": [
                1033
            ],
            "__typename": [
                1
            ]
        },
        "MarkOrdersAsHistoricallyPaidResponse": {
            "orders": [
                1602
            ],
            "__typename": [
                1
            ]
        },
        "MarkOrdersAsOvercollectedInput": {
            "companyId": [
                15
            ],
            "orderIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "MarkOrdersAsOvercollectedResponse": {
            "orders": [
                1602
            ],
            "__typename": [
                1
            ]
        },
        "MarkOrdersAsUncollectibleInput": {
            "companyId": [
                15
            ],
            "orderIds": [
                15
            ],
            "postedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "MarkOrdersAsUncollectibleResponse": {
            "orders": [
                1602
            ],
            "__typename": [
                1
            ]
        },
        "MarkOrdersInput": {
            "companyId": [
                15
            ],
            "orderMarks": [
                1404
            ],
            "__typename": [
                1
            ]
        },
        "MarkOrderType": {},
        "MarkOrderWithoutFinancialEventsInput": {
            "companyId": [
                15
            ],
            "orderId": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "MarkReconciliationRequestFileAsNotRelevantInput": {
            "companyId": [
                15
            ],
            "fileId": [
                15
            ],
            "requestId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "MarkSingleOrderInput": {
            "orderId": [
                15
            ],
            "markType": [
                1401
            ],
            "__typename": [
                1
            ]
        },
        "Merchant": {
            "on_Vendor": [
                2375
            ],
            "on_CustomerV2": [
                563
            ],
            "on_CompanyAffiliate": [
                422
            ],
            "on_Institution": [
                1074
            ],
            "__typename": [
                1
            ]
        },
        "MerchantBankTransactionRecommendationsInput": {
            "companyId": [
                15
            ],
            "affiliatedEntityId": [
                15
            ],
            "moneyDirection": [
                2079
            ],
            "__typename": [
                1
            ]
        },
        "MerchantBankTransactionStatsMerchantKeyInput": {
            "id": [
                15
            ],
            "type": [
                1415
            ],
            "__typename": [
                1
            ]
        },
        "MerchantCategorizationInput": {
            "merchant": [
                1409
            ],
            "shouldApplyAlways": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "MerchantInput": {
            "id": [
                15
            ],
            "type": [
                1415
            ],
            "__typename": [
                1
            ]
        },
        "MerchantKey": {
            "id": [
                15
            ],
            "type": [
                1415
            ],
            "__typename": [
                1
            ]
        },
        "MerchantsBankTransactionStats": {
            "merchantsCount": [
                41
            ],
            "transactionsCount": [
                41
            ],
            "transactionsSum": [
                5
            ],
            "uncategorizedTransactionsCount": [
                41
            ],
            "uncategorizedTransactionsSum": [
                5
            ],
            "transactionBusinessEvents": [
                1
            ],
            "uncategorizedTransactionBusinessEvents": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "MerchantsBankTransactionStatsInput": {
            "companyId": [
                15
            ],
            "merchants": [
                1407
            ],
            "moneyDirection": [
                2079
            ],
            "excludeBusinessEventClassifications": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "MerchantsByIdsInput": {
            "companyId": [
                15
            ],
            "merchantIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "MerchantsByKeysInput": {
            "keys": [
                1410
            ],
            "__typename": [
                1
            ]
        },
        "MerchantType": {},
        "MeResponse": {
            "user": [
                2333
            ],
            "__typename": [
                1
            ]
        },
        "MergedProduct": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "finaloopId": [
                1
            ],
            "displayName": [
                1
            ],
            "imageUrl": [
                1
            ],
            "sku": [
                1
            ],
            "price": [
                5
            ],
            "lineOfBusinessId": [
                1
            ],
            "string": [
                1
            ],
            "listedChannels": [
                1940
            ],
            "appliedCosts": [
                1771
            ],
            "dailySalesData": [
                1942,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "totalSold": [
                41
            ],
            "avgCostPerUnit": [
                5
            ],
            "representativeFinaloopProductId": [
                1
            ],
            "mergedWithProducts": [
                1769
            ],
            "canEditLatestAppliedCost": [
                7
            ],
            "isFractional": [
                7
            ],
            "isHidden": [
                7
            ],
            "salesData": [
                1959,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "rawRecipes": [
                1861,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "componentOfProducts": [
                1769
            ],
            "analyticsOverview": [
                1770,
                {
                    "input": [
                        110
                    ]
                }
            ],
            "warehousesAnalyticsOverview": [
                1837,
                {
                    "input": [
                        110
                    ]
                }
            ],
            "tags": [
                1
            ],
            "isDataSyncing": [
                7
            ],
            "mergeHistory": [
                1799
            ],
            "isDropshipping": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "MergeProductMergeRecommendationsMatchGroupInput": {
            "companyId": [
                15
            ],
            "matchGroupId": [
                1
            ],
            "from": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "MergeProductsInput": {
            "companyId": [
                1
            ],
            "representativeFinaloopProductId": [
                1
            ],
            "mergedFinaloopProductIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "MergeProductsV3": {
            "representativeId": [
                1
            ],
            "productIds": [
                1
            ],
            "from": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "MergeProductsV3Input": {
            "companyId": [
                1
            ],
            "mergeInput": [
                1420
            ],
            "splitInput": [
                2100
            ],
            "__typename": [
                1
            ]
        },
        "MergeProductsV3Response": {
            "on_MergeProductsV3Result": [
                1423
            ],
            "on_MergeProductsValidationError": [
                1424
            ],
            "__typename": [
                1
            ]
        },
        "MergeProductsV3Result": {
            "splitResult": [
                1769
            ],
            "mergeResult": [
                1769
            ],
            "__typename": [
                1
            ]
        },
        "MergeProductsValidationError": {
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "MergeResult": {},
        "MergeTax1099AffiliatedEntitiesInput": {
            "companyId": [
                15
            ],
            "affiliatedEntityIds": [
                15
            ],
            "type": [
                2144
            ],
            "calendarYear": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "MergeWarehousesError": {
            "error": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "MergeWarehousesInput": {
            "companyId": [
                15
            ],
            "representativeId": [
                1
            ],
            "warehouseIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "MergeWarehousesResult": {
            "on_MergeWarehousesSuccess": [
                1430
            ],
            "on_MergeWarehousesError": [
                1427
            ],
            "__typename": [
                1
            ]
        },
        "MergeWarehousesSuccess": {
            "isMerged": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "MetricRangeGroupBy": {},
        "MissingCostsInPeriodInput": {
            "companyId": [
                15
            ],
            "from": [
                581
            ],
            "to": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "MissingCostsInPeriodResponse": {
            "hasMissingCosts": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "MissionSpecificInfoInput": {
            "purchaseBasedOpeningBalance": [
                1842
            ],
            "purchaseBasedClosingBalanceInput": [
                1840
            ],
            "purchaseBasedPurchases": [
                1844
            ],
            "salesBasedOpeningBalance": [
                1935
            ],
            "salesBasedMissingCostPerUnit": [
                1933
            ],
            "salesBasedClosingBalance": [
                1931
            ],
            "salesBasedPurchases": [
                1937
            ],
            "unitBasedVendorsNegativeBalance": [
                2187
            ],
            "unitBasedNegativeOnHands": [
                2184
            ],
            "unitBasedClosingBalance": [
                2182
            ],
            "__typename": [
                1
            ]
        },
        "MissionStateInput": {
            "missionType": [
                1194
            ],
            "status": [
                1193
            ],
            "missionSpecificData": [
                1434
            ],
            "managementMethodPeriod": [
                1368
            ],
            "__typename": [
                1
            ]
        },
        "MoneyDirection": {},
        "MoveBankAccountUploadsToAnotherBankAccountInput": {
            "companyId": [
                15
            ],
            "sourceBankAccountId": [
                15
            ],
            "targetBankAccountId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "MoveBankStatementFilesToAnotherBankAccount": {
            "companyId": [
                15
            ],
            "sourceBankAccountId": [
                15
            ],
            "targetBankAccountId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "Movement": {
            "stockSituation": [
                1116
            ],
            "direction": [
                1440
            ],
            "batches": [
                1116
            ],
            "unavailableQuantity": [
                41
            ],
            "action": [
                2397
            ],
            "__typename": [
                1
            ]
        },
        "MovementDirection": {},
        "MovementIndirectCost": {
            "type": [
                1442
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "MovementIndirectCostType": {},
        "Mutation": {
            "createOrUpdateAccrual": [
                538,
                {
                    "input": [
                        537,
                        "CreateOrUpdateAccrualInput!"
                    ]
                }
            ],
            "deleteAccrual": [
                14,
                {
                    "input": [
                        595,
                        "DeleteAccrualInput!"
                    ]
                }
            ],
            "upsertAccrual": [
                29,
                {
                    "input": [
                        2319,
                        "UpsertAccrualInput!"
                    ]
                }
            ],
            "deleteAccrualV2": [
                29,
                {
                    "input": [
                        596,
                        "DeleteAccrualV2Input!"
                    ]
                }
            ],
            "cancelAccrual": [
                14,
                {
                    "input": [
                        364,
                        "CancelAccrualInput!"
                    ]
                }
            ],
            "cancelAccrualV2": [
                29,
                {
                    "input": [
                        365,
                        "CancelAccrualV2Input!"
                    ]
                }
            ],
            "sendAnalyticsEvent": [
                1985,
                {
                    "input": [
                        1984,
                        "SendAnalyticsEventInput!"
                    ]
                }
            ],
            "dispatchEshedTest": [
                1985,
                {
                    "input": [
                        655,
                        "DispatchEshedTestInput!"
                    ]
                }
            ],
            "updateBalanceSheetSetup": [
                2224,
                {
                    "args": [
                        2221,
                        "UpdateBalanceSheetSetupInput!"
                    ]
                }
            ],
            "updateBalanceSheetSetupItem": [
                2223,
                {
                    "args": [
                        2222,
                        "UpdateBalanceSheetSetupItemInput!"
                    ]
                }
            ],
            "resetBalanceSheetSetup": [
                1910,
                {
                    "input": [
                        1909,
                        "ResetBalanceSheetSetupInput!"
                    ]
                }
            ],
            "openBalanceSheetSetup": [
                1485,
                {
                    "input": [
                        1484,
                        "OpenBalanceSheetSetupInput!"
                    ]
                }
            ],
            "updateBankAccountClosingBalance": [
                161,
                {
                    "input": [
                        2226,
                        "UpdateBankAccountClosingBalanceInput!"
                    ]
                }
            ],
            "createBankAccountBalanceAdjustment": [
                161,
                {
                    "input": [
                        2225,
                        "UpdateBankAccountBalanceAdjustmentInput!"
                    ]
                }
            ],
            "deleteBankAccountBalanceAdjustment": [
                161,
                {
                    "input": [
                        2225,
                        "UpdateBankAccountBalanceAdjustmentInput!"
                    ]
                }
            ],
            "setBankAccountsLatestEventIds": [
                161,
                {
                    "input": [
                        1991,
                        "SetBankAccountsLatestEventIdsInput!"
                    ]
                }
            ],
            "createBankAccount": [
                161,
                {
                    "input": [
                        502,
                        "CreateBankAccountInput!"
                    ]
                }
            ],
            "copyBankAccount": [
                161,
                {
                    "input": [
                        498,
                        "CopyBankAccountInput!"
                    ]
                }
            ],
            "updateBankAccount": [
                161,
                {
                    "input": [
                        2227,
                        "UpdateBankAccountInput!"
                    ]
                }
            ],
            "replaceBankAccountLocks": [
                161,
                {
                    "input": [
                        1901,
                        "ReplaceBankAccountLocksInput!"
                    ]
                }
            ],
            "replaceBankAccountLocksByType": [
                161,
                {
                    "input": [
                        1900,
                        "ReplaceBankAccountLocksByTypeInput!"
                    ]
                }
            ],
            "updateBankAccountsMergeStatus": [
                2125,
                {
                    "input": [
                        2228,
                        "UpdateBankAccountsMergeStatusInput!"
                    ]
                }
            ],
            "lockBankAccount": [
                161,
                {
                    "input": [
                        1348,
                        "LockBankAccountInput!"
                    ]
                }
            ],
            "createInstitution": [
                1074,
                {
                    "input": [
                        521,
                        "CreateInstitutionInput!"
                    ]
                }
            ],
            "updateInstitution": [
                1074,
                {
                    "input": [
                        2259,
                        "UpdateInstitutionInput!"
                    ]
                }
            ],
            "updateInstitutionDataConfig": [
                1074,
                {
                    "input": [
                        2258,
                        "UpdateInstitutionDataConfigInput!"
                    ]
                }
            ],
            "createInstitutionMapping": [
                1075,
                {
                    "input": [
                        522,
                        "CreateInstitutionMappingsInput!"
                    ]
                }
            ],
            "updateInstitutionMapping": [
                1075,
                {
                    "input": [
                        2260,
                        "UpdateInstitutionMappingInput!"
                    ]
                }
            ],
            "uploadBankStatement": [
                2314,
                {
                    "input": [
                        2313,
                        "UploadBankStatementInput!"
                    ]
                }
            ],
            "updateBankReconciliationRequestMessage": [
                216,
                {
                    "input": [
                        2229,
                        "UpdateBankReconciliationRequestMessageInput!"
                    ]
                }
            ],
            "updateBankReconciliationRequestStatus": [
                216,
                {
                    "input": [
                        2230,
                        "UpdateBankReconciliationRequestStatusInput!"
                    ]
                }
            ],
            "upsertBankStatementParsingRequest": [
                250,
                {
                    "input": [
                        251,
                        "BankStatementParsingRequestInput!"
                    ]
                }
            ],
            "upsertBankStatementParsingResults": [
                254,
                {
                    "input": [
                        255,
                        "BankStatementParsingResultsInput!"
                    ]
                }
            ],
            "updateBankStatementParsingResultStatus": [
                254,
                {
                    "input": [
                        2232,
                        "UpdateBankStatementParsingResultStatus!"
                    ]
                }
            ],
            "writeBankingMetric": [
                41,
                {
                    "input": [
                        209,
                        "[BankingMetricInput!]!"
                    ]
                }
            ],
            "deleteBankReconciliationRequestConfiguration": [
                782,
                {
                    "input": [
                        599,
                        "DeleteBankReconciliationRequestConfigInput!"
                    ]
                }
            ],
            "createAdminBankReconciliationRequest": [
                15,
                {
                    "input": [
                        501,
                        "CreateAdminBankReconciliationRequestInput!"
                    ]
                }
            ],
            "convertBankAccountToManual": [
                161,
                {
                    "input": [
                        495,
                        "ConvertBankAccountToManualInput!"
                    ]
                }
            ],
            "convertBankAccountBackFromManual": [
                782,
                {
                    "input": [
                        494,
                        "ConvertBankAccountBackFromManualInput!"
                    ]
                }
            ],
            "markReconciliationRequestFileAsNotRelevant": [
                782,
                {
                    "input": [
                        1403,
                        "MarkReconciliationRequestFileAsNotRelevantInput!"
                    ]
                }
            ],
            "uploadFileToBankReconciliationRequest": [
                782,
                {
                    "input": [
                        2316,
                        "UploadFileToBankReconciliationRequestInput!"
                    ]
                }
            ],
            "moveBankStatementFilesToAnotherBankAccount": [
                235,
                {
                    "input": [
                        1438,
                        "MoveBankStatementFilesToAnotherBankAccount!"
                    ]
                }
            ],
            "updateBankStatementFileProcessingLogs": [
                235,
                {
                    "input": [
                        2231,
                        "UpdateBankStatementFileProcessingLogsInput!"
                    ]
                }
            ],
            "stopImportingDataForBankAccount": [
                161,
                {
                    "input": [
                        2108,
                        "StopImportingDataForBankAccountInput!"
                    ]
                }
            ],
            "stopImportingDataForBankAccountNew": [
                161,
                {
                    "input": [
                        2109,
                        "StopImportingDataForBankAccountNewInput!"
                    ]
                }
            ],
            "createBankAccountStatementForStopImport": [
                183,
                {
                    "input": [
                        503,
                        "CreateBankAccountStatementForStopImportInput!"
                    ]
                }
            ],
            "createManualBankAccount": [
                161,
                {
                    "input": [
                        531,
                        "CreateManualBankAccountInput!"
                    ]
                }
            ],
            "deleteBankAccounts": [
                7,
                {
                    "input": [
                        597,
                        "DeleteBankAccountsInput!"
                    ]
                }
            ],
            "submitBankReconciliationRequestResolution": [
                262,
                {
                    "input": [
                        261,
                        "BankStatementRequestResolutionInput!"
                    ]
                }
            ],
            "markBankReconciliationRequestAsRelevant": [
                216,
                {
                    "input": [
                        1386,
                        "MarkBankAccountReconciliationRelevantInput!"
                    ]
                }
            ],
            "triggerBankReconciliationRequests": [
                216,
                {
                    "input": [
                        177,
                        "BankAccountReconciliationsInput!"
                    ]
                }
            ],
            "updateBankReconciliationStatementAutoProcessingResults": [
                7,
                {
                    "input": [
                        229,
                        "BankReconciliationStatementAutoProcessingResultsInput!"
                    ]
                }
            ],
            "uploadReportedTransactions": [
                782,
                {
                    "input": [
                        2318,
                        "UploadReportedTransactionsInput!"
                    ]
                }
            ],
            "createBankStatementFileUpload": [
                235,
                {
                    "input": [
                        504,
                        "CreateBankStatementFileInput!"
                    ]
                }
            ],
            "categorizeBankTransactions": [
                277,
                {
                    "input": [
                        370,
                        "CategorizeBankTransactionsInput!"
                    ]
                }
            ],
            "createCustomerCategorizationRule": [
                515,
                {
                    "input": [
                        514,
                        "CreateCustomerCategorizationRuleInput!"
                    ]
                }
            ],
            "updateBankTransactionMemo": [
                270,
                {
                    "input": [
                        2233,
                        "UpdateBankTransactionMemoInput!"
                    ]
                }
            ],
            "addBankTransactionAttachment": [
                270,
                {
                    "input": [
                        45,
                        "AddBankTransactionAttachmentInput!"
                    ]
                }
            ],
            "deleteBankTransactionAttachment": [
                270,
                {
                    "input": [
                        600,
                        "DeleteBankTransactionAttachmentInput!"
                    ]
                }
            ],
            "finalizeAskTheUserFlow": [
                747,
                {
                    "input": [
                        746,
                        "FinalizeAskTheUserFlowInput!"
                    ]
                }
            ],
            "askTheUserNotificationService": [
                127,
                {
                    "input": [
                        126,
                        "AskTheUserNotificationInput!"
                    ]
                }
            ],
            "scheduleAtuTransactionsResultProcessing": [
                1973,
                {
                    "input": [
                        1972,
                        "ScheduleAtuTransactionsResultProcessingInput!"
                    ]
                }
            ],
            "createGlobalVendorMappingRule": [
                1012,
                {
                    "input": [
                        519,
                        "CreateGlobalVendorRuleInput!"
                    ]
                }
            ],
            "createBankTransactionsUpload": [
                294,
                {
                    "input": [
                        505,
                        "CreateBankTransactionsUploadInput!"
                    ]
                }
            ],
            "toggleBankTransactionAccrual": [
                2155,
                {
                    "input": [
                        2154,
                        "ToggleBankTransactionAccrualInput!"
                    ]
                }
            ],
            "upsertBankTransactionLocalRule": [
                544,
                {
                    "input": [
                        2320,
                        "UpsertBankTransactionLocalRuleInput!"
                    ]
                }
            ],
            "createGlobalRule": [
                517,
                {
                    "input": [
                        1011,
                        "GlobalRuleInput!"
                    ]
                }
            ],
            "attemptToClassifyTransactions": [
                391,
                {
                    "input": [
                        142,
                        "AttemptToClassifyTransactionsInput!"
                    ]
                }
            ],
            "attemptToClassifyTransactionsWithPairedEntities": [
                391,
                {
                    "input": [
                        142,
                        "AttemptToClassifyTransactionsInput!"
                    ]
                }
            ],
            "deleteBankTransactionsByBankAccountIds": [
                7,
                {
                    "input": [
                        601,
                        "DeleteBankTransactionsByBankAccountIdsInput!"
                    ]
                }
            ],
            "deleteBankTransactionsInternal": [
                83,
                {
                    "input": [
                        82,
                        "AlterBankTransactionsLifecycleStateInput!"
                    ]
                }
            ],
            "restoreBankTransactionsInternal": [
                83,
                {
                    "input": [
                        82,
                        "AlterBankTransactionsLifecycleStateInput!"
                    ]
                }
            ],
            "moveBankAccountUploadsToAnotherBankAccount": [
                294,
                {
                    "input": [
                        1437,
                        "MoveBankAccountUploadsToAnotherBankAccountInput!"
                    ]
                }
            ],
            "appendProcessingLogToBankTransactionsUpload": [
                294,
                {
                    "input": [
                        113,
                        "AppendProcessingLogToBankTransactionsUploadInput!"
                    ]
                }
            ],
            "submitTransactionsFileToBankTransactionsUpload": [
                2121,
                {
                    "input": [
                        2120,
                        "SubmitTransactionsFileToBankTransactionsUploadInput!"
                    ]
                }
            ],
            "clearExpiredDoItLaterResults": [
                71
            ],
            "addClassificationTag": [
                392,
                {
                    "input": [
                        46,
                        "AddClassificationTagInput!"
                    ]
                }
            ],
            "editClassificationTag": [
                392,
                {
                    "input": [
                        672,
                        "EditClassificationTagInput!"
                    ]
                }
            ],
            "updateAssociatedBankTransactionsFile": [
                2218,
                {
                    "input": [
                        2217,
                        "UpdateAssociatedBankTransactionsFileInput!"
                    ]
                }
            ],
            "processCheckoutWebhookEvents": [
                7,
                {
                    "args": [
                        1767,
                        "ProcessCheckoutWebhookEventsInput!"
                    ]
                }
            ],
            "syncStripeOffers": [
                7,
                {
                    "args": [
                        2135,
                        "SyncStripeOffersInput!"
                    ]
                }
            ],
            "syncStripeTier1Offer": [
                7,
                {
                    "args": [
                        2136,
                        "SyncStripeTier1Offer!"
                    ]
                }
            ],
            "createCheckoutSession": [
                508,
                {
                    "args": [
                        507,
                        "CreateCheckoutSessionInput!"
                    ]
                }
            ],
            "pollCheckoutSessionStatus": [
                418,
                {
                    "args": [
                        1763,
                        "PollCheckoutSessionStatusInput!"
                    ]
                }
            ],
            "toggleBillHasAccrual": [
                7,
                {
                    "input": [
                        2156,
                        "ToggleBillHasAccrualInput!"
                    ]
                }
            ],
            "createOrGetBusinessEventDefinition": [
                348,
                {
                    "input": [
                        536,
                        "CreateOrGetBusinessEventDefinitionInput!"
                    ]
                }
            ],
            "createAccountRole": [
                10,
                {
                    "input": [
                        500,
                        "CreateAccountRoleInput!"
                    ]
                }
            ],
            "updateBooksStartTime": [
                2123,
                {
                    "args": [
                        2234,
                        "UpdateBooksStartTimeArgs!"
                    ]
                }
            ],
            "createFileUploadUrl": [
                740,
                {
                    "input": [
                        516,
                        "CreateFileUploadUrlInput!"
                    ]
                }
            ],
            "updateCompanyAccountingMethod": [
                418,
                {
                    "args": [
                        2239,
                        "UpdateCompanyAccountingMethodArgs!"
                    ]
                }
            ],
            "updateEstimatedProjectedRevenue": [
                418,
                {
                    "args": [
                        2254,
                        "UpdateEstimatedProjectedRevenueInput!"
                    ]
                }
            ],
            "toggleOrdersZeroNetBalance": [
                2123,
                {
                    "args": [
                        2157,
                        "ToggleOrdersZeroNetBalanceInput!"
                    ]
                }
            ],
            "toggleRecognizeZeroNetOrdersAsGiveaways": [
                7,
                {
                    "args": [
                        2158,
                        "ToggleRecognizeZeroNetOrdersAsGiveawaysInput!"
                    ]
                }
            ],
            "createImageUploadUrl": [
                1055,
                {
                    "input": [
                        520,
                        "CreateImageUploadUrlInput!"
                    ]
                }
            ],
            "setSettings": [
                2123,
                {
                    "args": [
                        2029,
                        "SetSettingsArgs!"
                    ]
                }
            ],
            "upsertCompanyAddress": [
                420,
                {
                    "input": [
                        2321
                    ]
                }
            ],
            "deleteCompanyAddress": [
                7,
                {
                    "input": [
                        421,
                        "CompanyAddressInput!"
                    ]
                }
            ],
            "updateOnboardingStatus": [
                1474,
                {
                    "input": [
                        2284,
                        "UpdateOnboardingStatusInput!"
                    ]
                }
            ],
            "setFiscalYearData": [
                7,
                {
                    "input": [
                        1992,
                        "SetFiscalYearDataInput!"
                    ]
                }
            ],
            "updateCompanyNamesAndNotifyHandler": [
                418,
                {
                    "input": [
                        2246,
                        "UpdateCompanyNamesAndNotifyHandlerInput!"
                    ]
                }
            ],
            "updateCompany": [
                418,
                {
                    "input": [
                        2243,
                        "UpdateCompanyInput!"
                    ]
                }
            ],
            "setFiscalYearStart": [
                7,
                {
                    "input": [
                        1993,
                        "SetFiscalYearStartInput!"
                    ]
                }
            ],
            "createCompany": [
                418,
                {
                    "args": [
                        510,
                        "CreateCompanyInput!"
                    ]
                }
            ],
            "updateCompanyPayingStatus": [
                418,
                {
                    "args": [
                        2247,
                        "UpdateCompanyPayingStatusInput!"
                    ]
                }
            ],
            "syncCompany": [
                7,
                {
                    "args": [
                        2129,
                        "SyncCompanyInput!"
                    ]
                }
            ],
            "lockCompany": [
                460,
                {
                    "args": [
                        1350,
                        "LockCompanyInput!"
                    ]
                }
            ],
            "unlockCompany": [
                460,
                {
                    "args": [
                        1350,
                        "LockCompanyInput!"
                    ]
                }
            ],
            "lockCompanyV2": [
                418,
                {
                    "args": [
                        1351,
                        "LockCompanyV2Input!"
                    ]
                }
            ],
            "unlockCompanyV2": [
                418,
                {
                    "args": [
                        2201,
                        "UnlockCompanyV2Input!"
                    ]
                }
            ],
            "removeDataRestriction": [
                418,
                {
                    "args": [
                        1896,
                        "RemoveDataRestrictionInput!"
                    ]
                }
            ],
            "validationCycle": [
                2364,
                {
                    "input": [
                        975,
                        "GetValidationCycleInput!"
                    ]
                }
            ],
            "completeValidationCycle": [
                7,
                {
                    "input": [
                        479,
                        "CompleteValidationCycleInput!"
                    ]
                }
            ],
            "sendValidationNotification": [
                7,
                {
                    "input": [
                        1990,
                        "SendValidationNotificationInput!"
                    ]
                }
            ],
            "storeValidation": [
                7,
                {
                    "input": [
                        2115,
                        "StoreValidationInput!"
                    ]
                }
            ],
            "grantEntitiesLockedPeriodBypasses": [
                7,
                {
                    "args": [
                        1018,
                        "GrantEntitiesLockedPeriodBypassesInput!"
                    ]
                }
            ],
            "createCompanyAffiliate": [
                422,
                {
                    "input": [
                        509,
                        "CreateCompanyAffiliateInput!"
                    ]
                }
            ],
            "updateCompanyAffiliate": [
                422,
                {
                    "input": [
                        2240,
                        "UpdateCompanyAffiliateInput!"
                    ]
                }
            ],
            "deleteCompanyAffiliate": [
                422,
                {
                    "input": [
                        602,
                        "DeleteCompanyAffiliateInput!"
                    ]
                }
            ],
            "upsertHolderShare": [
                1040,
                {
                    "input": [
                        2326,
                        "UpsertHolderShareInput!"
                    ]
                }
            ],
            "deleteHolderShare": [
                1040,
                {
                    "input": [
                        605,
                        "DeleteHolderShareInput!"
                    ]
                }
            ],
            "upsertHolderCapitalInvestment": [
                1035,
                {
                    "input": [
                        2325,
                        "UpsertHolderCapitalInvestmentInput!"
                    ]
                }
            ],
            "deleteHolderCapitalInvestment": [
                1035,
                {
                    "input": [
                        604,
                        "DeleteHolderCapitalInvestmentInput!"
                    ]
                }
            ],
            "addRoleToAffiliatedEntity": [
                62,
                {
                    "input": [
                        60,
                        "AddRoleToAffiliatedEntityInput!"
                    ]
                }
            ],
            "upsertManualEquityEvent": [
                1379,
                {
                    "input": [
                        2331,
                        "UpsertManualEquityEventInput!"
                    ]
                }
            ],
            "deleteManualEquityEvents": [
                1379,
                {
                    "input": [
                        619,
                        "DeleteManualEquityEventsInput!"
                    ]
                }
            ],
            "companyIntegrationBulkUpdate": [
                448,
                {
                    "input": [
                        449,
                        "CompanyIntegrationBulkUpdateInput!"
                    ]
                }
            ],
            "syncDataPlatformIntegration": [
                2131,
                {
                    "input": [
                        2130,
                        "SyncDataPlatformIntegrationInput!"
                    ]
                }
            ],
            "deleteBankConnection": [
                7,
                {
                    "input": [
                        598,
                        "DeleteBankConnectionInput!"
                    ]
                }
            ],
            "disconnectPayrollConnection": [
                7,
                {
                    "input": [
                        650,
                        "DisconnectConnectionInput!"
                    ]
                }
            ],
            "disconnectConnection": [
                7,
                {
                    "input": [
                        650,
                        "DisconnectConnectionInput!"
                    ]
                }
            ],
            "confirmRoleForPaymentGateway": [
                7,
                {
                    "input": [
                        486,
                        "ConfirmRoleForPaymentGatewayInput!"
                    ]
                }
            ],
            "unclassifyIntegrationTransfers": [
                1098,
                {
                    "input": [
                        2174,
                        "UnclassifyIntegrationTransferInput!"
                    ]
                }
            ],
            "markIntegrationTransfersAsDiscrepancy": [
                1098,
                {
                    "input": [
                        1387,
                        "MarkIntegrationTransfersAsDiscrepancyInput!"
                    ]
                }
            ],
            "classifyIntegrationTransfer": [
                1098,
                {
                    "input": [
                        399,
                        "ClassifyIntegrationTransferInput!"
                    ]
                }
            ],
            "createIntegrationTransferRule": [
                1106,
                {
                    "input": [
                        523,
                        "CreateIntegrationTransferRuleInput!"
                    ]
                }
            ],
            "scheduleAtuIntegrationTransfersResultProcessing": [
                1971,
                {
                    "input": [
                        1970,
                        "ScheduleAtuIntegrationTransfersResultProcessingInput!"
                    ]
                }
            ],
            "refreshSkuAmbiguity": [
                7,
                {
                    "input": [
                        1891,
                        "RefreshSkuAmbiguityInput!"
                    ]
                }
            ],
            "triggerCOGSFromScratch": [
                7,
                {
                    "input": [
                        2171,
                        "TriggerCOGSFromScratchInput!"
                    ]
                }
            ],
            "deleteFifoGroups": [
                7,
                {
                    "input": [
                        603,
                        "DeleteFifoGroupsInput!"
                    ]
                }
            ],
            "bulkRecoveryUnitsTracking": [
                346,
                {
                    "input": [
                        345
                    ]
                }
            ],
            "syncInventoryIntegrationFulfillmentSetting": [
                7,
                {
                    "input": [
                        2133,
                        "SyncInventoryIntegrationFulfillmentSettingInput!"
                    ]
                }
            ],
            "triggerBigValidationReconciliation": [
                7,
                {
                    "input": [
                        2173,
                        "TriggerReconciliationInput!"
                    ]
                }
            ],
            "triggerInventoryPurchasesReconciliation": [
                7,
                {
                    "input": [
                        2173,
                        "TriggerReconciliationInput!"
                    ]
                }
            ],
            "triggerFifoReconciliation": [
                7,
                {
                    "input": [
                        2172,
                        "TriggerFifoReconciliationInput!"
                    ]
                }
            ],
            "updateOnDemandAssemblyCosts": [
                7,
                {
                    "input": [
                        2285,
                        "UpdateOnDemandAssemblyCostsInput!"
                    ]
                }
            ],
            "updateOnDemandAssemblyVendorCosts": [
                7,
                {
                    "input": [
                        2285,
                        "UpdateOnDemandAssemblyCostsInput!"
                    ]
                }
            ],
            "validateInventoryPaymentGroupOnEntityChange": [
                7,
                {
                    "input": [
                        2362,
                        "ValidateInventoryPaymentGroupOnEntityChangeInput!"
                    ]
                }
            ],
            "setWarehouseDropshippingSettings": [
                2396,
                {
                    "input": [
                        2033,
                        "SetWarehouseDropshippingSettingsInput!"
                    ]
                }
            ],
            "reconcileInventoryPurchasesFromTransactions": [
                7,
                {
                    "input": [
                        1880,
                        "ReconcileInventoryPurchasesFromTransactionsInput!"
                    ]
                }
            ],
            "reconcileInventoryPurchasesFromBills": [
                7,
                {
                    "input": [
                        1877,
                        "ReconcileInventoryPurchasesFromBillsInput!"
                    ]
                }
            ],
            "reconcileInventoryPurchasesFromBusinessEvents": [
                7,
                {
                    "input": [
                        1878,
                        "ReconcileInventoryPurchasesFromBusinessEventsInput!"
                    ]
                }
            ],
            "reconcileAllPayrollInventoryPurchases": [
                7,
                {
                    "input": [
                        1876,
                        "ReconcileAllInventoryPurchasesInput!"
                    ]
                }
            ],
            "reconcileAllContractorPaymentInventoryPurchases": [
                7,
                {
                    "input": [
                        1876,
                        "ReconcileAllInventoryPurchasesInput!"
                    ]
                }
            ],
            "reconcileAllBillInventoryPurchases": [
                7,
                {
                    "input": [
                        1876,
                        "ReconcileAllInventoryPurchasesInput!"
                    ]
                }
            ],
            "reconcileAllTransactionInventoryPurchases": [
                7,
                {
                    "input": [
                        1876,
                        "ReconcileAllInventoryPurchasesInput!"
                    ]
                }
            ],
            "reReconcileInventoryPurchases": [
                7,
                {
                    "input": [
                        1908,
                        "ReReconcileInventoryPurchasesInput!"
                    ]
                }
            ],
            "shopifyItemsValidationBlacklistSku": [
                7,
                {
                    "input": [
                        2058,
                        "ShopifyItemsValidationBlacklistSkuInput!"
                    ]
                }
            ],
            "shopifyItemsValidationBlacklistSalesChannel": [
                7,
                {
                    "input": [
                        2057,
                        "ShopifyItemsValidationBlacklistSalesChannelInput!"
                    ]
                }
            ],
            "markOrderWithoutFinancialEvents": [
                7,
                {
                    "input": [
                        1402,
                        "MarkOrderWithoutFinancialEventsInput!"
                    ]
                }
            ],
            "markOrdersWithoutFinancialEvents": [
                41,
                {
                    "input": [
                        104,
                        "AmazonValidationInput!"
                    ]
                }
            ],
            "generateFifoValidation": [
                772,
                {
                    "input": [
                        731,
                        "FifoValidationInput!"
                    ]
                }
            ],
            "generateNoUnitsValidation": [
                775,
                {
                    "input": [
                        774,
                        "GenerateNoUnitsValidationInput!"
                    ]
                }
            ],
            "ackInvalidNoUnitsValidation": [
                7,
                {
                    "input": [
                        30,
                        "AckInvalidNoUnitsValidationInput!"
                    ]
                }
            ],
            "deleteNoUnitsValidationInvalidAck": [
                7,
                {
                    "input": [
                        623,
                        "DeleteNoUnitsValidationInvalidAckInput!"
                    ]
                }
            ],
            "generateBigValidation": [
                771,
                {
                    "input": [
                        770,
                        "GenerateBigValidationInput!"
                    ]
                }
            ],
            "runNoUnitsChangesDetector": [
                7
            ],
            "amazonValidationAdjustSkuQuantities": [
                7,
                {
                    "input": [
                        103,
                        "AmazonValidationAdjustSkuQuantitiesInput!"
                    ]
                }
            ],
            "createInventoryVendorValidation": [
                525,
                {
                    "input": [
                        524,
                        "CreateInventoryVendorValidationInput!"
                    ]
                }
            ],
            "remediateValidation": [
                7,
                {
                    "input": [
                        1895,
                        "RemediateValidationInput!"
                    ]
                }
            ],
            "deleteValidationRemediations": [
                7,
                {
                    "input": [
                        1895,
                        "RemediateValidationInput!"
                    ]
                }
            ],
            "findValidationBuggyDate": [
                7,
                {
                    "input": [
                        754,
                        "FindValidationBuggyDateInput!"
                    ]
                }
            ],
            "createShopifyProductsFromDiagnostics": [
                41,
                {
                    "input": [
                        543,
                        "CreateShopifyProductsFromDiagnosticsInput!"
                    ]
                }
            ],
            "createBigValidationAdjustment": [
                7,
                {
                    "input": [
                        506,
                        "CreateBigValidationAdjustmentInput!"
                    ]
                }
            ],
            "generatePhysicalCountValidation": [
                1761,
                {
                    "input": [
                        1759,
                        "PhysicalCountValidationInput!"
                    ]
                }
            ],
            "changeProductsHiddenStatus": [
                7,
                {
                    "input": [
                        375,
                        "ChangeProductsHiddenStatusInput!"
                    ]
                }
            ],
            "createProductManually": [
                541,
                {
                    "input": [
                        540,
                        "CreateProductManuallyInput!"
                    ]
                }
            ],
            "deleteManualAssembly": [
                7,
                {
                    "input": [
                        618,
                        "DeleteManualAssemblyInput!"
                    ]
                }
            ],
            "deleteRecipe": [
                7,
                {
                    "input": [
                        635,
                        "DeleteRecipeInput!"
                    ]
                }
            ],
            "mergeProductsV3": [
                1422,
                {
                    "input": [
                        1421,
                        "MergeProductsV3Input!"
                    ]
                }
            ],
            "setProductAdjustments": [
                1769,
                {
                    "input": [
                        2019,
                        "SetProductAdjustmentsInput!"
                    ]
                }
            ],
            "setWarehouseOpeningBalance": [
                2413,
                {
                    "input": [
                        2034,
                        "SetWarehouseOpeningBalanceInput!"
                    ]
                }
            ],
            "updateManualAssembly": [
                2275,
                {
                    "input": [
                        2274,
                        "UpdateManualAssemblyInput!"
                    ]
                }
            ],
            "updateProduct": [
                1769,
                {
                    "input": [
                        2293,
                        "UpdateProductInput!"
                    ]
                }
            ],
            "updateProductFractional": [
                1769,
                {
                    "input": [
                        2292,
                        "UpdateProductFractionalInput!"
                    ]
                }
            ],
            "updateRecipe": [
                2295,
                {
                    "input": [
                        2294,
                        "UpdateRecipeInput!"
                    ]
                }
            ],
            "generatePdf": [
                779,
                {
                    "input": [
                        778,
                        "GeneratePdfInput!"
                    ]
                }
            ],
            "generatePdfV2": [
                780,
                {
                    "input": [
                        778,
                        "GeneratePdfInput!"
                    ]
                }
            ],
            "sendPoEmail": [
                1989,
                {
                    "input": [
                        1987,
                        "SendPoEmailInput!"
                    ]
                }
            ],
            "setInventoryUsages": [
                7,
                {
                    "input": [
                        1996,
                        "SetInventoryUsagesInput!"
                    ]
                }
            ],
            "detectAndNotifyCogsDrasticChanges": [
                7,
                {
                    "input": [
                        643,
                        "DetectAndNotifyCogsDrasticChangesInput!"
                    ]
                }
            ],
            "saveDropshippingSettings": [
                665,
                {
                    "input": [
                        1967,
                        "SaveDropshippingSettingsInput!"
                    ]
                }
            ],
            "removeDropshippingSettings": [
                7,
                {
                    "input": [
                        1897,
                        "RemoveDropshippingSettingsInput!"
                    ]
                }
            ],
            "deletePurchaseOrder": [
                7,
                {
                    "input": [
                        634,
                        "DeletePurchaseOrderInput!"
                    ]
                }
            ],
            "updatePurchaseOrder": [
                1846,
                {
                    "input": [
                        1849,
                        "PurchaseOrderInput!"
                    ]
                }
            ],
            "updateInventoryPurchase": [
                2264,
                {
                    "input": [
                        1139,
                        "InventoryPurchaseInput!"
                    ]
                }
            ],
            "deleteInventoryPurchase": [
                1162,
                {
                    "input": [
                        608,
                        "DeleteInventoryPurchaseInput!"
                    ]
                }
            ],
            "schedulePurchasesValidation": [
                1975,
                {
                    "input": [
                        1974,
                        "SchedulePurchasesValidationInput!"
                    ]
                }
            ],
            "applyInventoryPurchaseRules": [
                1146,
                {
                    "input": [
                        114,
                        "ApplyInventoryPurchaseRulesInput!"
                    ]
                }
            ],
            "setPendingWarehouseOpeningBalance": [
                1751,
                {
                    "input": [
                        2014,
                        "SetPendingWarehouseOpeningBalancesInput!"
                    ]
                }
            ],
            "deleteWarehouseOpeningBalance": [
                7,
                {
                    "input": [
                        638,
                        "DeleteWarehouseOpeningBalancesInput!"
                    ]
                }
            ],
            "discardPendingWarehouseOpeningBalance": [
                7,
                {
                    "input": [
                        648,
                        "DiscardPendingWarehouseOpeningBalancesInput!"
                    ]
                }
            ],
            "applyPendingWarehouseOpeningBalance": [
                7,
                {
                    "input": [
                        119,
                        "ApplyPendingWarehouseOpeningBalanceInput!"
                    ]
                }
            ],
            "setPendingWarehouseOpeningBalanceWithCsv": [
                1752,
                {
                    "input": [
                        2016,
                        "SetPendingWarehouseOpeningBalancesWithCsvInput!"
                    ]
                }
            ],
            "deletePendingWarehouseOpeningBalanceAttachment": [
                7,
                {
                    "input": [
                        632,
                        "DeletePendingWarehouseOpeningAttachmentInput!"
                    ]
                }
            ],
            "updateWarehouseTransfer": [
                2435,
                {
                    "input": [
                        2311,
                        "UpdateWarehouseTransferInput!"
                    ]
                }
            ],
            "deleteWarehouseTransfer": [
                7,
                {
                    "input": [
                        639,
                        "DeleteWarehouseTransferInput!"
                    ]
                }
            ],
            "setPendingSalesDataAdjustmentsV2": [
                2012,
                {
                    "input": [
                        2010,
                        "SetPendingSalesDataAdjustmentsInput!"
                    ]
                }
            ],
            "setPendingDeadInventoryAdjustments": [
                2002,
                {
                    "input": [
                        2000,
                        "SetPendingDeadInventoryAdjustmentsInput!"
                    ]
                }
            ],
            "setPendingGiveawayAdjustments": [
                2008,
                {
                    "input": [
                        2006,
                        "SetPendingGiveawayAdjustmentsInput!"
                    ]
                }
            ],
            "setPendingGiveawayDropshippingAdjustments": [
                2009,
                {
                    "input": [
                        2006,
                        "SetPendingGiveawayAdjustmentsInput!"
                    ]
                }
            ],
            "setPendingDonationAdjustments": [
                2005,
                {
                    "input": [
                        2003,
                        "SetPendingDonationAdjustmentsInput!"
                    ]
                }
            ],
            "setPendingSalesDataAdjustmentsWithCsv": [
                1788,
                {
                    "input": [
                        2013,
                        "SetPendingSalesDataAdjustmentsWithCsvInput!"
                    ]
                }
            ],
            "setPendingDeadInventoryAdjustmentsWithCsv": [
                1788,
                {
                    "input": [
                        1999,
                        "SetPendingAdjustmentsWithCsvInput!"
                    ]
                }
            ],
            "setPendingGiveawayAdjustmentsWithCsv": [
                1788,
                {
                    "input": [
                        1999,
                        "SetPendingAdjustmentsWithCsvInput!"
                    ]
                }
            ],
            "setPendingGiveawayDropshippingAdjustmentsWithCsv": [
                1788,
                {
                    "input": [
                        1999,
                        "SetPendingAdjustmentsWithCsvInput!"
                    ]
                }
            ],
            "setPendingDonationAdjustmentsWithCsv": [
                1788,
                {
                    "input": [
                        1999,
                        "SetPendingAdjustmentsWithCsvInput!"
                    ]
                }
            ],
            "discardPendingAdjustments": [
                7,
                {
                    "input": [
                        647,
                        "DiscardPendingAdjustments!"
                    ]
                }
            ],
            "applyPendingSalesDataAdjustments": [
                927,
                {
                    "input": [
                        117,
                        "ApplyPendingSalesDataAdjustmentsInput!"
                    ]
                }
            ],
            "updateNoUnitsPhysicalCount": [
                1054,
                {
                    "input": [
                        2281,
                        "UpdateNoUnitsPhysicalCountInput!"
                    ]
                }
            ],
            "deleteNoUnitsPhysicalCount": [
                7,
                {
                    "input": [
                        622,
                        "DeleteNoUnitsPhysicalCountInput!"
                    ]
                }
            ],
            "updateNoUnitsPhysicalCountProductQuantityPendingAdjustments": [
                7,
                {
                    "input": [
                        2283,
                        "UpdateNoUnitsPhysicalCountProductQuantityPendingAdjustmentsInput!"
                    ]
                }
            ],
            "applyNoUnitsPhysicalCountProductQuantitiesPendingAdjustments": [
                7,
                {
                    "input": [
                        116,
                        "ApplyNoUnitsPhysicalCountProductQuantitiesPendingAdjustmentsInput!"
                    ]
                }
            ],
            "discardNoUnitsPhysicalCountProductQuantityPendingAdjustments": [
                7,
                {
                    "input": [
                        646,
                        "DiscardNoUnitsPhysicalCountProductQuantityPendingAdjustmentInput!"
                    ]
                }
            ],
            "setNoUnitsPhysicalCountPendingAdjustmentsWithCsv": [
                1788,
                {
                    "input": [
                        2017,
                        "SetPhysicalCountPendingAdjustmentsWithCsvInput!"
                    ]
                }
            ],
            "updateUnitsTrackingPhysicalCount": [
                2190,
                {
                    "input": [
                        2299,
                        "UpdateUnitsTrackingPhysicalCountInput!"
                    ]
                }
            ],
            "deleteUnitsTrackingPhysicalCount": [
                7,
                {
                    "input": [
                        636,
                        "DeleteUnitsTrackingPhysicalCountInput!"
                    ]
                }
            ],
            "updateUnitsTrackingPhysicalCountProductQuantityPendingAdjustments": [
                7,
                {
                    "input": [
                        2301,
                        "UpdateUnitsTrackingPhysicalCountProductQuantityPendingAdjustmentsInput!"
                    ]
                }
            ],
            "acknowledgeUnitsTrackingPhysicalCountProductQuantitiesAmounts": [
                7,
                {
                    "input": [
                        33,
                        "AcknowledgeUnitsTrackingPhysicalCountProductQuantitiesAmountsInput!"
                    ]
                }
            ],
            "discardUnitsTrackingPhysicalCountProductQuantityPendingAdjustments": [
                7,
                {
                    "input": [
                        649,
                        "DiscardUnitsTrackingPhysicalCountProductQuantityPendingAdjustmentInput!"
                    ]
                }
            ],
            "setUnitsTrackingPhysicalCountPendingAdjustmentsWithCsv": [
                1788,
                {
                    "input": [
                        2017,
                        "SetPhysicalCountPendingAdjustmentsWithCsvInput!"
                    ]
                }
            ],
            "createWarehouse": [
                2401,
                {
                    "input": [
                        547,
                        "CreateWarehouseInput!"
                    ]
                }
            ],
            "deleteWarehouse": [
                7,
                {
                    "input": [
                        637,
                        "DeleteWarehouseInput!"
                    ]
                }
            ],
            "updateWarehouse": [
                2396,
                {
                    "input": [
                        2308,
                        "UpdateWarehouseInput!"
                    ]
                }
            ],
            "updateWarehousesDefaults": [
                2429,
                {
                    "input": [
                        2310,
                        "UpdateWarehousesDefaultsInput!"
                    ]
                }
            ],
            "updateWarehousesDefaultsV2": [
                2428,
                {
                    "input": [
                        2310,
                        "UpdateWarehousesDefaultsInput!"
                    ]
                }
            ],
            "mergeWarehouses": [
                1429,
                {
                    "input": [
                        1428,
                        "MergeWarehousesInput!"
                    ]
                }
            ],
            "splitWarehouses": [
                7,
                {
                    "input": [
                        2102,
                        "SplitWarehouseInput!"
                    ]
                }
            ],
            "setUserGivenWarehouseName": [
                2396,
                {
                    "input": [
                        2030,
                        "SetUserGivenWarehouseNameInput!"
                    ]
                }
            ],
            "linkInventoryPaymentGroup": [
                1258,
                {
                    "input": [
                        1257,
                        "LinkInventoryPaymentGroupInput!"
                    ]
                }
            ],
            "updateInventoryPaymentGroup": [
                2263,
                {
                    "input": [
                        2262,
                        "UpdateInventoryPaymentGroupInput!"
                    ]
                }
            ],
            "deleteInventoryPaymentGroup": [
                607,
                {
                    "input": [
                        606,
                        "DeleteInventoryPaymentGroupInput!"
                    ]
                }
            ],
            "cancelInvalidInventoryPaymentGroups": [
                369,
                {
                    "input": [
                        368,
                        "CancelInvalidInventoryPaymentGroupsInput!"
                    ]
                }
            ],
            "updateInventoryYearEndMission": [
                1192,
                {
                    "input": [
                        2265,
                        "UpdateInventoryYearEndMissionInput!"
                    ]
                }
            ],
            "updateWarehouseNegativesAdjustment": [
                7,
                {
                    "input": [
                        2309,
                        "UpdateWarehouseNegativesAdjustmentInput!"
                    ]
                }
            ],
            "manageProductMergeRecommendationsGroup": [
                7,
                {
                    "input": [
                        1369,
                        "ManageProductMergeRecommendationsGroupInput!"
                    ]
                }
            ],
            "manageProductMergeRecommendationsProduct": [
                7,
                {
                    "input": [
                        1370,
                        "ManageProductMergeRecommendationsProductInput!"
                    ]
                }
            ],
            "setProductMergeRecommendationsPrimaryProduct": [
                7,
                {
                    "input": [
                        2024,
                        "SetProductMergeRecommendationsPrimaryProductInput!"
                    ]
                }
            ],
            "mergeProductMergeRecommendationsMatchGroup": [
                7,
                {
                    "input": [
                        1418,
                        "MergeProductMergeRecommendationsMatchGroupInput!"
                    ]
                }
            ],
            "updateProductAutomergeSettings": [
                7,
                {
                    "input": [
                        2220,
                        "UpdateAutomergeSettingsInput!"
                    ]
                }
            ],
            "revertVanillaChipMerges": [
                7
            ],
            "lockLoan": [
                1355,
                {
                    "input": [
                        1354,
                        "LockLoanInput!"
                    ]
                }
            ],
            "unlockLoan": [
                2202,
                {
                    "id": [
                        15,
                        "ID!"
                    ]
                }
            ],
            "updateLoan": [
                1381,
                {
                    "input": [
                        2261,
                        "UpdateInternalLoanInput!"
                    ]
                }
            ],
            "updateLoanAttachments": [
                1381,
                {
                    "input": [
                        2269,
                        "UpdateLoanAttachmentsInput!"
                    ]
                }
            ],
            "createLoan": [
                1381,
                {
                    "input": [
                        529,
                        "CreateLoanInput!"
                    ]
                }
            ],
            "createLoanFromTransaction": [
                1305,
                {
                    "input": [
                        2168,
                        "TransactionUpdatedInput!"
                    ]
                }
            ],
            "createLoanFromBalanceTransaction": [
                1305,
                {
                    "input": [
                        527,
                        "CreateLoanFromBalanceTransactionInput!"
                    ]
                }
            ],
            "createLoanFromBillFinanced": [
                7,
                {
                    "input": [
                        528,
                        "CreateLoanFromBillFinancedInput!"
                    ]
                }
            ],
            "acknowledgeLoansChanges": [
                31,
                {
                    "input": [
                        32,
                        "AcknowledgeLoansChangesInput!"
                    ]
                }
            ],
            "simulateLoanFromTransaction2": [
                2082,
                {
                    "input": [
                        2088,
                        "SimulateTransactionUpdatedInput2!"
                    ]
                }
            ],
            "deleteLoans": [
                617,
                {
                    "input": [
                        616,
                        "DeleteLoansInput!"
                    ]
                }
            ],
            "dangerousForceDeleteLoans": [
                617,
                {
                    "input": [
                        616,
                        "DeleteLoansInput!"
                    ]
                }
            ],
            "dangerousTouchLoan": [
                7,
                {
                    "input": [
                        579,
                        "DangerousTouchLoanInput!"
                    ]
                }
            ],
            "deleteLoanRelationships": [
                7,
                {
                    "input": [
                        613,
                        "DeleteLoanRelationshipsInput!"
                    ]
                }
            ],
            "deleteManualLoanEvent": [
                2278,
                {
                    "input": [
                        620,
                        "DeleteManualLoanEventInput!"
                    ]
                }
            ],
            "deleteManualLoanEvents": [
                2279,
                {
                    "input": [
                        621,
                        "DeleteManualLoanEventsInput!"
                    ]
                }
            ],
            "createManualLoanEvent2": [
                2278,
                {
                    "input": [
                        533,
                        "CreateManualLoanEventInput2!"
                    ]
                }
            ],
            "updateManualLoanEvent2": [
                2278,
                {
                    "input": [
                        2277,
                        "UpdateManualLoanEventInput2!"
                    ]
                }
            ],
            "deleteLoanManualAccountingEvents": [
                2279,
                {
                    "input": [
                        612,
                        "DeleteLoanManualAccountingEventsInput!"
                    ]
                }
            ],
            "updateLoanManualAccountingEvent": [
                2278,
                {
                    "input": [
                        2271,
                        "UpdateLoanManualAccountingEventInput!"
                    ]
                }
            ],
            "deleteLoansEventsEffectConfiguration": [
                615,
                {
                    "input": [
                        614,
                        "DeleteLoansEventsEffectConfigurationInput!"
                    ]
                }
            ],
            "createLoansEventsEffectConfiguration": [
                1329,
                {
                    "input": [
                        530,
                        "CreateLoansEventsEffectConfigurationInput!"
                    ]
                }
            ],
            "createLoanEventDefinition": [
                1309,
                {
                    "input": [
                        526,
                        "CreateLoanEventDefinitionInput!"
                    ]
                }
            ],
            "attachRelationsToLoan": [
                7,
                {
                    "input": [
                        140,
                        "AttachRelationsToLoanInput!"
                    ]
                }
            ],
            "deleteCompanyLoanAttachment": [
                1378,
                {
                    "input": [
                        610,
                        "DeleteLoanAttachmentInput!"
                    ]
                }
            ],
            "updateCompanyLoanAttachments": [
                454,
                {
                    "input": [
                        2269,
                        "UpdateLoanAttachmentsInput!"
                    ]
                }
            ],
            "createCompanyLoan": [
                1378,
                {
                    "input": [
                        512,
                        "CreateCompanyLoanInput!"
                    ]
                }
            ],
            "updateCompanyLoan": [
                1378,
                {
                    "input": [
                        2270,
                        "UpdateLoanInput!"
                    ]
                }
            ],
            "updateCompanyLoans": [
                2245,
                {
                    "input": [
                        2244,
                        "UpdateCompanyLoansInput!"
                    ]
                }
            ],
            "deleteLoan": [
                617,
                {
                    "input": [
                        611,
                        "DeleteLoanInput!"
                    ]
                }
            ],
            "userAttachTransactionsToExistingLoan": [
                1382,
                {
                    "input": [
                        2334,
                        "UserAttachTransactionsToExistingLoanInput!"
                    ]
                }
            ],
            "userAttachTransactionsToNewLoan": [
                1382,
                {
                    "input": [
                        2337,
                        "UserAttachTransactionsToNewLoanInput!"
                    ]
                }
            ],
            "userAttachTransactionsToLoans": [
                1383,
                {
                    "input": [
                        2335,
                        "UserAttachTransactionsToLoansInput!"
                    ]
                }
            ],
            "lenderFromEntity": [
                1446,
                {
                    "input": [
                        1248,
                        "lenderFromEntityInput!"
                    ]
                }
            ],
            "updateCompanyFundedStatus": [
                442,
                {
                    "input": [
                        2242,
                        "UpdateCompanyFundedStatusInput!"
                    ]
                }
            ],
            "updateOrderEntities": [
                2122,
                {
                    "input": [
                        2286,
                        "UpdateOrderEntitiesInput!"
                    ]
                }
            ],
            "deleteOrderGroupUponTransactionChange": [
                627,
                {
                    "input": [
                        626,
                        "DeleteOrderGroupUponTransactionChangeInput!"
                    ]
                }
            ],
            "initiateTotalArCashDiffsReport": [
                2122,
                {
                    "input": [
                        1073,
                        "InitiateTotalArCashDiffsReportInput!"
                    ]
                }
            ],
            "updateCompanyArCashDiffsInBucket": [
                2122,
                {
                    "input": [
                        430,
                        "CompanyArCashDiffsInput!"
                    ]
                }
            ],
            "overrideOrderFulfillmentsToLineItemPostDate": [
                1629,
                {
                    "input": [
                        1630,
                        "OverrideOrderFulfillmentsToLineItemPostDateInput!"
                    ]
                }
            ],
            "setOrderFinaloopNote": [
                1604,
                {
                    "input": [
                        1997,
                        "SetOrderFinaloopNoteInput!"
                    ]
                }
            ],
            "setOrderFinaloopTags": [
                1604,
                {
                    "input": [
                        1998,
                        "SetOrderFinaloopTagsInput!"
                    ]
                }
            ],
            "setFulfillmentSettings": [
                1995,
                {
                    "input": [
                        1994,
                        "SetFulfillmentSettingsInput!"
                    ]
                }
            ],
            "markOrders": [
                7,
                {
                    "input": [
                        1400
                    ]
                }
            ],
            "linkOrderGroup": [
                1265,
                {
                    "input": [
                        1264,
                        "LinkOrderGroupInput!"
                    ]
                }
            ],
            "updateOrderGroup": [
                2288,
                {
                    "input": [
                        2287,
                        "UpdateOrderGroupInput!"
                    ]
                }
            ],
            "deleteOrderGroup": [
                625,
                {
                    "input": [
                        624,
                        "DeleteOrderGroupInput!"
                    ]
                }
            ],
            "voidOrders": [
                2393,
                {
                    "input": [
                        2392,
                        "VoidOrdersInput!"
                    ]
                }
            ],
            "unvoidOrders": [
                2216,
                {
                    "input": [
                        2215,
                        "UnvoidOrdersInput!"
                    ]
                }
            ],
            "markOrdersAsUncollectible": [
                1399,
                {
                    "input": [
                        1398,
                        "MarkOrdersAsUncollectibleInput!"
                    ]
                }
            ],
            "markOrdersAsOvercollected": [
                1397,
                {
                    "input": [
                        1396,
                        "MarkOrdersAsOvercollectedInput!"
                    ]
                }
            ],
            "markOrdersAsHistoricallyPaid": [
                1395,
                {
                    "input": [
                        1394,
                        "MarkOrdersAsHistoricallyPaidInput!"
                    ]
                }
            ],
            "unMarkOrdersAsUncollectible": [
                2210,
                {
                    "input": [
                        2209,
                        "UnMarkOrdersAsUncollectibleInput!"
                    ]
                }
            ],
            "unMarkOrdersAsOvercollected": [
                2208,
                {
                    "input": [
                        2207,
                        "UnMarkOrdersAsOvercollectedInput!"
                    ]
                }
            ],
            "markOrdersAsGiveaway": [
                1393,
                {
                    "input": [
                        1392,
                        "MarkOrdersAsGiveawayInput!"
                    ]
                }
            ],
            "unMarkOrdersAsGiveaway": [
                2206,
                {
                    "input": [
                        2205,
                        "UnMarkOrdersAsGiveawayInput!"
                    ]
                }
            ],
            "markOrdersAsCOGS": [
                1391,
                {
                    "input": [
                        1390,
                        "MarkOrdersAsCOGSInput!"
                    ]
                }
            ],
            "unMarkOrdersAsCOGS": [
                2204,
                {
                    "input": [
                        2203,
                        "UnMarkOrdersAsCOGSInput!"
                    ]
                }
            ],
            "markOrderLineItemsAsVoided": [
                1389,
                {
                    "input": [
                        1388,
                        "MarkOrderLineItemsAsVoidedInput!"
                    ]
                }
            ],
            "overrideOrderFulfillments": [
                1629,
                {
                    "input": [
                        1625,
                        "OverrideOrderFulfillmentsInput!"
                    ]
                }
            ],
            "deletePaymentGroupUponTransactionChange": [
                631,
                {
                    "input": [
                        630,
                        "DeletePaymentGroupUponTransactionChangeInput!"
                    ]
                }
            ],
            "linkOrderPaymentGroup": [
                1267,
                {
                    "input": [
                        1266,
                        "LinkOrderPaymentGroupInput!"
                    ]
                }
            ],
            "updateOrderPaymentGroup": [
                2290,
                {
                    "input": [
                        2289,
                        "UpdateOrderPaymentGroupInput!"
                    ]
                }
            ],
            "deleteOrderPaymentGroup": [
                629,
                {
                    "input": [
                        628,
                        "DeletePaymentGroupInput!"
                    ]
                }
            ],
            "linkInvoicePaymentGroup": [
                1260,
                {
                    "input": [
                        1259,
                        "LinkInvoicePaymentGroupInput!"
                    ]
                }
            ],
            "updateInvoicePaymentGroup": [
                2267,
                {
                    "input": [
                        2266,
                        "UpdateInvoicePaymentGroupInput!"
                    ]
                }
            ],
            "deleteInvoicePaymentGroup": [
                629,
                {
                    "input": [
                        628,
                        "DeletePaymentGroupInput!"
                    ]
                }
            ],
            "updateEmployeesOfficerStatus": [
                7,
                {
                    "input": [
                        2253,
                        "UpdateEmployeesOfficerStatusInput!"
                    ]
                }
            ],
            "updatePayrollSettings": [
                7,
                {
                    "input": [
                        2291,
                        "UpdatePayrollSettingsInput!"
                    ]
                }
            ],
            "createPeriodicPartnerReport": [
                1754,
                {
                    "input": [
                        1755,
                        "PeriodicPartnerReportInput!"
                    ]
                }
            ],
            "scheduleAccountingReportExport": [
                1969,
                {
                    "args": [
                        1968,
                        "ScheduleAccountingReportExportInput!"
                    ]
                }
            ],
            "exportGeneralLedger": [
                707,
                {
                    "input": [
                        706,
                        "ExportGeneralLedgerInput!"
                    ]
                }
            ],
            "upsertIntegrationCustomer": [
                563,
                {
                    "input": [
                        2327,
                        "UpsertIntegrationCustomerArgs!"
                    ]
                }
            ],
            "upsertIntegrationInvoice": [
                1198,
                {
                    "input": [
                        2328,
                        "UpsertIntegrationInvoiceInput!"
                    ]
                }
            ],
            "sendSalesToReconcilerByTypeAndDate": [
                7,
                {
                    "input": [
                        1939,
                        "SalesByTypeAndDateInput!"
                    ]
                }
            ],
            "forceDeleteInvoices": [
                609,
                {
                    "input": [
                        1960,
                        "SalesInternalInput!"
                    ]
                }
            ],
            "refreshInvoiceCalculatedFields": [
                1198,
                {
                    "input": [
                        1922,
                        "SaleInternalInput!"
                    ]
                }
            ],
            "refreshManyInvoicesCalculatedFields": [
                1198,
                {
                    "input": [
                        1960,
                        "SalesInternalInput!"
                    ]
                }
            ],
            "createCustomer": [
                554,
                {
                    "createCustomerArgs": [
                        513,
                        "CreateCustomerArgs!"
                    ]
                }
            ],
            "updateCustomer": [
                554,
                {
                    "updateCustomerArgs": [
                        2250,
                        "UpdateCustomerArgs!"
                    ]
                }
            ],
            "upsertCustomerAddress": [
                555,
                {
                    "input": [
                        2322,
                        "UpsertCustomerAddressArgs!"
                    ]
                }
            ],
            "upsertCustomerV2": [
                563,
                {
                    "input": [
                        2323,
                        "UpsertCustomerV2Args!"
                    ]
                }
            ],
            "upsertInvoice": [
                1198,
                {
                    "input": [
                        2329,
                        "UpsertInvoiceInput!"
                    ]
                }
            ],
            "voidInvoice": [
                1198,
                {
                    "input": [
                        1202,
                        "InvoiceInput!"
                    ]
                }
            ],
            "unvoidInvoice": [
                1198,
                {
                    "input": [
                        1230,
                        "InvoiceUnvoidInput!"
                    ]
                }
            ],
            "deleteInvoiceAdjustment": [
                1198,
                {
                    "input": [
                        1199,
                        "InvoiceAdjustmentInput!"
                    ]
                }
            ],
            "markAsUncollectible": [
                1198,
                {
                    "input": [
                        1384,
                        "ManualTxInput!"
                    ]
                }
            ],
            "addRefundToInvoice": [
                1198,
                {
                    "input": [
                        1384,
                        "ManualTxInput!"
                    ]
                }
            ],
            "deleteInvoiceRefund": [
                1198,
                {
                    "input": [
                        1216,
                        "InvoiceRefundInput!"
                    ]
                }
            ],
            "addCreditToInvoice": [
                1198,
                {
                    "input": [
                        1384,
                        "ManualTxInput!"
                    ]
                }
            ],
            "deleteInvoiceCredit": [
                1198,
                {
                    "input": [
                        1200,
                        "InvoiceCreditInput!"
                    ]
                }
            ],
            "upsertPaymentMethod": [
                1689,
                {
                    "input": [
                        2332
                    ]
                }
            ],
            "deletePaymentMethod": [
                7,
                {
                    "input": [
                        1690,
                        "PaymentMethodInput!"
                    ]
                }
            ],
            "generateInvoicePDF": [
                15,
                {
                    "input": [
                        1202,
                        "InvoiceInput!"
                    ]
                }
            ],
            "markInvoicePdfAsSent": [
                1,
                {
                    "input": [
                        1215,
                        "InvoicePdfSentInput!"
                    ]
                }
            ],
            "sendInvoiceEmail": [
                1198,
                {
                    "input": [
                        1201,
                        "InvoiceEmailInput!"
                    ]
                }
            ],
            "issueInvoice": [
                1198,
                {
                    "input": [
                        1202,
                        "InvoiceInput!"
                    ]
                }
            ],
            "deleteInvoice": [
                7,
                {
                    "input": [
                        1202,
                        "InvoiceInput!"
                    ]
                }
            ],
            "updateSalesChannel": [
                1945,
                {
                    "input": [
                        2296,
                        "UpdateSalesChannelInput!"
                    ]
                }
            ],
            "applySalesChannelChanges": [
                121,
                {
                    "input": [
                        120,
                        "ApplySalesChannelChangesInput!"
                    ]
                }
            ],
            "upsertInvoiceSettings": [
                1220,
                {
                    "input": [
                        2330,
                        "UpsertInvoiceSettingsInput!"
                    ]
                }
            ],
            "startPaymentLinkCheckout": [
                1203,
                {
                    "input": [
                        1204
                    ]
                }
            ],
            "markPaymentLinkAsProcessing": [
                581,
                {
                    "input": [
                        1204
                    ]
                }
            ],
            "createPaymentLinkForInvoice": [
                1,
                {
                    "input": [
                        1205
                    ]
                }
            ],
            "deletePaymentLinkForInvoice": [
                7,
                {
                    "input": [
                        452
                    ]
                }
            ],
            "refundPaymentLinkPayment": [
                1,
                {
                    "input": [
                        452
                    ]
                }
            ],
            "createPaymentFromPaymentLink": [
                1,
                {
                    "input": [
                        452
                    ]
                }
            ],
            "createRefundFromPaymentLink": [
                1,
                {
                    "input": [
                        452
                    ]
                }
            ],
            "uploadInvoicesFromCSV": [
                2315,
                {
                    "input": [
                        2317,
                        "UploadInvoicesFromCSVInput!"
                    ]
                }
            ],
            "dispatchInvoicesCSVBulkUploadTask": [
                145,
                {
                    "input": [
                        2317,
                        "UploadInvoicesFromCSVInput!"
                    ]
                }
            ],
            "updateUserRolesForCompany": [
                2305,
                {
                    "args": [
                        2304,
                        "UpdateUserRolesForCompanyArgs!"
                    ]
                }
            ],
            "inviteUser": [
                1197,
                {
                    "args": [
                        1196,
                        "InviteUserArgs!"
                    ]
                }
            ],
            "referUser": [
                1890,
                {
                    "args": [
                        1889,
                        "ReferUserArgs!"
                    ]
                }
            ],
            "removeUser": [
                1899,
                {
                    "args": [
                        1898,
                        "RemoveUserArgs!"
                    ]
                }
            ],
            "acceptInvitation": [
                3,
                {
                    "args": [
                        2,
                        "AcceptInvitationArgs!"
                    ]
                }
            ],
            "handleUserLogin": [
                1026,
                {
                    "args": [
                        1025,
                        "HandleUserLoginArgs!"
                    ]
                }
            ],
            "updateUserDetails": [
                2303,
                {
                    "args": [
                        2302,
                        "UpdateUserDetailsArgs!"
                    ]
                }
            ],
            "setGoogleToken": [
                1017,
                {
                    "args": [
                        1016,
                        "GoogleTokenCodeArgs!"
                    ]
                }
            ],
            "disconnectGoogleAccount": [
                1017
            ],
            "switchCompany": [
                2127,
                {
                    "args": [
                        2126,
                        "SwitchCompanyArgs!"
                    ]
                }
            ],
            "updateSharedGoogleDriveFolder": [
                2123,
                {
                    "args": [
                        2297,
                        "UpdateSharedGoogleDriveFolder!"
                    ]
                }
            ],
            "assignCompanyToUser": [
                137,
                {
                    "args": [
                        136,
                        "AssignCompanyToUser!"
                    ]
                }
            ],
            "impersonate": [
                1057,
                {
                    "args": [
                        1056,
                        "ImpersonateArgs!"
                    ]
                }
            ],
            "setUserName": [
                2032,
                {
                    "args": [
                        2031,
                        "SetUserName!"
                    ]
                }
            ],
            "updateAuth0UserDetails": [
                7,
                {
                    "args": [
                        2219,
                        "UpdateAuth0UserDetailsArgs!"
                    ]
                }
            ],
            "addCompanyToParkerUser": [
                7,
                {
                    "args": [
                        47,
                        "AddCompanyToParkerUserArgs!"
                    ]
                }
            ],
            "markAuth0CompanyUsersAsFinishedOnboarding": [
                7,
                {
                    "args": [
                        1385,
                        "MarkAuth0CompanyUsersAsFinishedOnboardingArgs!"
                    ]
                }
            ],
            "publishValidationStatusUpdate": [
                7,
                {
                    "input": [
                        1838,
                        "PublishValidationStatusUpdateInput!"
                    ]
                }
            ],
            "createVendor": [
                2375,
                {
                    "createVendorArgs": [
                        546,
                        "CreateVendorArgs!"
                    ]
                }
            ],
            "recordTax1099AffiliatedEntityGroupInput": [
                7,
                {
                    "input": [
                        1885,
                        "RecordTax1099AffiliatedEntityGroupInput!"
                    ]
                }
            ],
            "mergeTax1099AffiliatedEntities": [
                7,
                {
                    "input": [
                        1426,
                        "MergeTax1099AffiliatedEntitiesInput!"
                    ]
                }
            ],
            "splitTax1099AffiliatedEntityGroups": [
                7,
                {
                    "input": [
                        2101,
                        "SplitTax1099AffiliatedEntityGroupsInput!"
                    ]
                }
            ],
            "createGlobalVendor": [
                2375,
                {
                    "input": [
                        518,
                        "CreateGlobalVendorInput!"
                    ]
                }
            ],
            "updateCompanyVendorExternalSourceId": [
                2375,
                {
                    "args": [
                        2249,
                        "UpdateCompanyVendorExternalSourceIdVendorInput!"
                    ]
                }
            ],
            "upsertCompanyVendor": [
                2375,
                {
                    "args": [
                        2306,
                        "UpdateVendorInput!"
                    ]
                }
            ],
            "updateGlobalVendorLogo": [
                2375,
                {
                    "input": [
                        2257,
                        "UpdateGlobalVendorLogoInput!"
                    ]
                }
            ],
            "upsertGlobalVendor": [
                2375,
                {
                    "args": [
                        2324,
                        "UpsertGlobalVendorInput!"
                    ]
                }
            ],
            "unsignWorksheetRow": [
                477,
                {
                    "args": [
                        2214,
                        "UnsignWorksheetRowInput!"
                    ]
                }
            ],
            "signWorksheetRow": [
                477,
                {
                    "args": [
                        2078,
                        "SignWorksheetRowInput!"
                    ]
                }
            ],
            "storeDateForLocking": [
                477,
                {
                    "args": [
                        2111,
                        "StoreDateForLockingInput!"
                    ]
                }
            ],
            "updateComments": [
                477,
                {
                    "args": [
                        2237,
                        "UpdateCommentsInput!"
                    ]
                }
            ],
            "signAndLockBankAccount": [
                477,
                {
                    "args": [
                        2076,
                        "SignAndLockBankAccountInput!"
                    ]
                }
            ],
            "updateCompaniesDomainState": [
                2241,
                {
                    "args": [
                        2238,
                        "UpdateCompaniesDomainStateInput!"
                    ]
                }
            ],
            "manageCompanyYearEndState": [
                1365,
                {
                    "args": [
                        1364,
                        "ManageCompanyYearEndStateInput!"
                    ]
                }
            ],
            "updateYearEndState": [
                2506,
                {
                    "args": [
                        2505,
                        "YearEndStateUpdateInput!"
                    ]
                }
            ],
            "updateYearEndDomainState": [
                2489,
                {
                    "args": [
                        2488,
                        "YearEndDomainStateUpdateInput!"
                    ]
                }
            ],
            "updateYearEndDomainStateData": [
                2484,
                {
                    "args": [
                        2483,
                        "YearEndDomainStateDataUpdateInput!"
                    ]
                }
            ],
            "deleteYearEndDomainStateData": [
                2480,
                {
                    "args": [
                        2479,
                        "YearEndDomainStateDataDeleteInput!"
                    ]
                }
            ],
            "updateYearEndUserUnresponsive": [
                2513,
                {
                    "args": [
                        2512,
                        "YearEndUpdateUserUnresponsiveInput!"
                    ]
                }
            ],
            "updateYearEndAdditionalFields": [
                2509,
                {
                    "args": [
                        2508,
                        "YearEndUpdateAdditionalFieldsInput!"
                    ]
                }
            ],
            "__typename": [
                1
            ]
        },
        "NaturalSign": {},
        "NewCompanyIntegrationInput": {
            "integrationType": [
                2312
            ],
            "accountName": [
                1
            ],
            "businessCreationType": [
                347
            ],
            "businessPurchaseDate": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "NewLender": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "affiliatedEntity": [
                72
            ],
            "name": [
                1
            ],
            "supportedLoanTypes": [
                1339
            ],
            "defaultLoanType": [
                1339
            ],
            "isShortTerm": [
                7
            ],
            "supportedFollowUpTypes": [
                1344
            ],
            "logoUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "NewSourceInput": {
            "sourceName": [
                1
            ],
            "accountName": [
                1
            ],
            "businessCreationType": [
                347
            ],
            "businessPurchaseDate": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "NonMatchedSku": {
            "sku": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "quantity": [
                41
            ],
            "zeroPriceQuantity": [
                41
            ],
            "restocks": [
                41
            ],
            "giveaway": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "NonMatchingProductsResponse": {
            "ambiguousSkuCount": [
                41
            ],
            "notFoundProductSkuCount": [
                41
            ],
            "notFoundProductSkus": [
                1451
            ],
            "__typename": [
                1
            ]
        },
        "NonMatchingUnpaidBill": {
            "billId": [
                1
            ],
            "booksAmount": [
                5
            ],
            "inventoryPurchaseAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "NotFoundProductSkus": {
            "shopName": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "source": [
                1
            ],
            "skus": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "NothingTypes": {
            "id": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsBusinessEventsValidationResult": {
            "isValid": [
                7
            ],
            "isYoung": [
                7
            ],
            "costDiff": [
                5
            ],
            "ackedCostDiff": [
                5
            ],
            "integrationValidations": [
                1455
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsDailyProductValidationResult": {
            "productValidations": [
                1464
            ],
            "diff": [
                1855
            ],
            "isValid": [
                7
            ],
            "ackedDiff": [
                1855
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsIntegrationValidation": {
            "isValid": [
                7
            ],
            "integrationType": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "totalCogsAmount": [
                5
            ],
            "totalBusinessEventsAmount": [
                5
            ],
            "dailyCogsType": [
                1
            ],
            "businessEventType": [
                1
            ],
            "isYoung": [
                7
            ],
            "businessEventId": [
                1
            ],
            "dailyCogsId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsPhysicalCount": {
            "id": [
                15
            ],
            "amount": [
                5
            ],
            "date": [
                581
            ],
            "companyId": [
                1
            ],
            "attachments": [
                1457
            ],
            "diff": [
                5
            ],
            "lastAckDiff": [
                5
            ],
            "closingBalance": [
                5
            ],
            "lastAckClosingBalance": [
                5
            ],
            "note": [
                1
            ],
            "isDraft": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsPhysicalCountAttachment": {
            "name": [
                1
            ],
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsPhysicalCountClosingBalanceResult": {
            "closingBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsPhysicalCountOverview": {
            "amount": [
                5
            ],
            "amountWithoutPendingAdjustments": [
                5
            ],
            "missingData": [
                5
            ],
            "count": [
                5
            ],
            "pendingChanges": [
                5
            ],
            "productQuantities": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsPhysicalCountProductQuantities": {
            "products": [
                1461
            ],
            "offset": [
                5
            ],
            "count": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsPhysicalCountProductQuantity": {
            "product": [
                1769
            ],
            "quantity": [
                5
            ],
            "appliedCost": [
                5
            ],
            "isPendingChange": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsPhysicalCountProductQuantityPendingAdjustment": {
            "quantity": [
                5
            ],
            "companyId": [
                1
            ],
            "physicalCountId": [
                1
            ],
            "productId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsPhysicalCountsList": {
            "physicalCounts": [
                1456
            ],
            "offset": [
                41
            ],
            "count": [
                41
            ],
            "totalCount": [
                41
            ],
            "minAmount": [
                5
            ],
            "maxAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsProductValidation": {
            "product": [
                1769
            ],
            "sales": [
                769
            ],
            "restocks": [
                769
            ],
            "deadInventory": [
                67
            ],
            "donations": [
                67
            ],
            "giveaways": [
                67
            ],
            "isValid": [
                7
            ],
            "diff": [
                1855
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsValidationError": {
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsValidationResponse": {
            "on_NoUnitsValidationResult": [
                1467
            ],
            "on_NoUnitsValidationError": [
                1465
            ],
            "__typename": [
                1
            ]
        },
        "NoUnitsValidationResult": {
            "isValid": [
                7
            ],
            "dailyProductValidationResult": [
                1454
            ],
            "businessEventsValidationResult": [
                1453
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "error": [
                1
            ],
            "diff": [
                1855
            ],
            "fulfillmentsAfterLock": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "Offer": {
            "tier": [
                1470
            ],
            "payment": [
                319
            ],
            "features": [
                725
            ],
            "title": [
                1
            ],
            "description": [
                1
            ],
            "couponDiscount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "OffersStatus": {},
        "OfferTier": {},
        "OnboardingScope": {},
        "OnBoardingState": {
            "signupCompleted": [
                7
            ],
            "currentPage": [
                1
            ],
            "funnelVersion": [
                1
            ],
            "isLastPageCompleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "OnboardingStateInput": {
            "signupCompleted": [
                7
            ],
            "currentPage": [
                1
            ],
            "funnelVersion": [
                1
            ],
            "isLastPageCompleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "OnboardingStatus": {
            "companyId": [
                15
            ],
            "scope": [
                1471
            ],
            "step": [
                1
            ],
            "status": [
                1476
            ],
            "__typename": [
                1
            ]
        },
        "OnboardingStatuses": {
            "hasReportedCOGSEvents": [
                7
            ],
            "hasClassifiedPurchases": [
                7
            ],
            "hasConfirmedOpeningBalance": [
                7
            ],
            "dropshippingSettings": [
                665
            ],
            "inventoryInitStatus": [
                1117
            ],
            "__typename": [
                1
            ]
        },
        "OnboardingStepStatus": {},
        "OnDemandAssemblyAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OnDemandAssemblyBreakdown": {
            "origin": [
                1873
            ],
            "analytics": [
                1062
            ],
            "__typename": [
                1
            ]
        },
        "OnDemandAssemblyCosts": {
            "id": [
                15
            ],
            "amount": [
                5
            ],
            "date": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "OnDemandAssemblyCostsResult": {
            "assemblyCosts": [
                1479
            ],
            "__typename": [
                1
            ]
        },
        "OnDemandAssemblyVendorCosts": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "amount": [
                5
            ],
            "recipe": [
                1861
            ],
            "date": [
                581
            ],
            "unpaidAmounts": [
                2211
            ],
            "inventoryPaymentGroupLinks": [
                1121
            ],
            "affiliatedEntity": [
                72
            ],
            "__typename": [
                1
            ]
        },
        "OnDemandAssemblyVendorCostsResult": {
            "assemblyVendorCosts": [
                1481
            ],
            "__typename": [
                1
            ]
        },
        "OneTimePayment": {
            "id": [
                15
            ],
            "price": [
                5
            ],
            "quantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "OpenBalanceSheetSetupInput": {
            "companyId": [
                1
            ],
            "updatedBy": [
                1
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OpenBalanceSheetSetupResponse": {
            "message": [
                1
            ],
            "status": [
                1363
            ],
            "__typename": [
                1
            ]
        },
        "OpeningBalanceAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "averageCost": [
                5
            ],
            "isFromUserInput": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "OptionalTimeRangeInput": {
            "fromUTC": [
                581
            ],
            "toUTC": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "OrderAccountingReconciliationAccount": {
            "entity": [
                1489
            ],
            "account": [
                1489
            ],
            "__typename": [
                1
            ]
        },
        "OrderAccountingReconciliationAmount": {
            "amount": [
                5
            ],
            "accountRole": [
                1
            ],
            "accountName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OrderAccountingReconciliationRow": {
            "accountName": [
                1
            ],
            "accounts": [
                1488
            ],
            "__typename": [
                1
            ]
        },
        "OrderAccountingReconciliationsResponse": {
            "rows": [
                1490
            ],
            "otherBalances": [
                1551
            ],
            "__typename": [
                1
            ]
        },
        "OrderActionType": {},
        "OrderAdjustment": {
            "id": [
                15
            ],
            "amountInHomeCurrency": [
                5
            ],
            "type": [
                1494
            ],
            "postedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "OrderAdjustmentType": {},
        "OrderAdjustmentTypeV3": {},
        "OrderAdjustmentV3": {
            "id": [
                1
            ],
            "externalId": [
                1
            ],
            "postedAt": [
                581
            ],
            "amount": [
                5
            ],
            "amountCurrency": [
                549
            ],
            "amountHomeCurrency": [
                549
            ],
            "amountInHomeCurrency": [
                5
            ],
            "type": [
                1495
            ],
            "__typename": [
                1
            ]
        },
        "OrderAggregationEntry": {
            "on_OrdersAggregation": [
                1568
            ],
            "on_OrdersAgingAggregation": [
                1569
            ],
            "__typename": [
                1
            ]
        },
        "OrderAggregationType": {},
        "OrderBalance": {
            "date": [
                581
            ],
            "balance": [
                5
            ],
            "balanceInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "OrderEntity": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "OrderEntityType": {},
        "OrderFinaloopStatus": {},
        "OrderFinancialReportingStatus": {
            "status": [
                752
            ],
            "source": [
                753
            ],
            "__typename": [
                1
            ]
        },
        "OrderFulfillment": {
            "id": [
                15
            ],
            "fulfilledAt": [
                581
            ],
            "fulfillmentLineItems": [
                1505
            ],
            "source": [
                1
            ],
            "warehouse": [
                2396
            ],
            "isOverriddenByFinaloop": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "OrderFulfillmentLineItem": {
            "id": [
                15
            ],
            "lineItemId": [
                15
            ],
            "quantity": [
                41
            ],
            "sku": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OrderFulfillmentLineItemV3": {
            "id": [
                15
            ],
            "externalId": [
                1
            ],
            "lineItemId": [
                1
            ],
            "quantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "OrderFulfillmentSource": {},
        "OrderFulfillmentStatus": {},
        "OrderFulfillmentStatusInput": {},
        "OrderFulfillmentStatusV3": {},
        "OrderFulfillmentV3": {
            "id": [
                15
            ],
            "externalId": [
                1
            ],
            "status": [
                1510
            ],
            "channel": [
                760
            ],
            "warehouse": [
                2396
            ],
            "shippedAt": [
                581
            ],
            "deliveredAt": [
                581
            ],
            "fulfilledAt": [
                581
            ],
            "lineItems": [
                1506
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroup": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "amountInHomeCurrency": [
                5
            ],
            "orders": [
                1256
            ],
            "bankTransactions": [
                1255
            ],
            "expenses": [
                1516
            ],
            "orderDistributions": [
                1520
            ],
            "postedAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupByIdInput": {
            "orderGroupId": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupByIdResponse": {
            "orderGroup": [
                1512
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupDistributionBasic": {
            "orderGroupId": [
                15
            ],
            "postedAt": [
                581
            ],
            "amountInHomeCurrency": [
                5
            ],
            "orderGroupHasCashPayments": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupExpense": {
            "id": [
                15
            ],
            "expenseType": [
                1518
            ],
            "amount": [
                107
            ],
            "vendor": [
                2375
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupExpenseInput": {
            "expenseType": [
                1518
            ],
            "amount": [
                5
            ],
            "vendorId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupExpenseType": {},
        "OrderGroupLink": {
            "orderGroupId": [
                15
            ],
            "amountInHomeCurrency": [
                5
            ],
            "postedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupOrderDistribution": {
            "order": [
                1602
            ],
            "bankTransaction": [
                270
            ],
            "expense": [
                1516
            ],
            "postedAt": [
                581
            ],
            "amountInHomeCurrency": [
                5
            ],
            "orderGroupHasCashPayments": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupsByIdsInput": {
            "companyId": [
                15
            ],
            "orderGroupIds": [
                15
            ],
            "withDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupsByIdsResponse": {
            "orderGroups": [
                1512
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupsFilter": {
            "postedAt": [
                583
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupsInput": {
            "companyId": [
                1
            ],
            "filter": [
                1523
            ],
            "sort": [
                1526
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupsResponse": {
            "orderGroups": [
                1512
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupsSort": {
            "type": [
                1528
            ],
            "direction": [
                1527
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupsSortDirection": {},
        "OrderGroupsSortType": {},
        "OrderGroupsTotalUnclearedBalanceInput": {
            "companyId": [
                15
            ],
            "asOfDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupsTotalUnclearedBalanceResponse": {
            "asOfDate": [
                581
            ],
            "totalUnclearedBalance": [
                107
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupsUnclearedBalanceInput": {
            "companyId": [
                15
            ],
            "orderGroupIds": [
                15
            ],
            "asOfDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupsUnclearedBalanceResponse": {
            "asOfDate": [
                581
            ],
            "unclearedBalances": [
                1533
            ],
            "__typename": [
                1
            ]
        },
        "OrderGroupUnclearedBalance": {
            "orderGroup": [
                1512
            ],
            "unclearedBalance": [
                107
            ],
            "__typename": [
                1
            ]
        },
        "OrderIdInput": {
            "companyId": [
                15
            ],
            "orderId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "OrderInternalInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "OrderItemsFulfillmentV2": {
            "id": [
                15
            ],
            "trackingInfoRecords": [
                1241
            ],
            "externalWarehouseId": [
                1
            ],
            "voidedAt": [
                581
            ],
            "fulfilledAt": [
                581
            ],
            "fulfilledQuantity": [
                41
            ],
            "voidedBy": [
                38
            ],
            "source": [
                1507
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "OrderItemStatus": {},
        "OrderItemStatusWithOverride": {
            "status": [
                1537
            ],
            "isOverridden": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "OrderItemType": {},
        "OrderItemV2": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "actionType": [
                1492
            ],
            "type": [
                1539
            ],
            "amount": [
                107
            ],
            "taxAmount": [
                5
            ],
            "taxAmountInHomeCurrency": [
                5
            ],
            "discountAmount": [
                5
            ],
            "discountAmountInHomeCurrency": [
                5
            ],
            "exchangeRateOverride": [
                5
            ],
            "taxExchangeRateOverride": [
                5
            ],
            "discountExchangeRateOverride": [
                5
            ],
            "taxes": [
                1241
            ],
            "externalSourceId": [
                1
            ],
            "postedAt": [
                581
            ],
            "externalProductId": [
                1
            ],
            "product": [
                1769
            ],
            "sku": [
                1
            ],
            "quantity": [
                41
            ],
            "unitPrice": [
                5
            ],
            "isRestocked": [
                7
            ],
            "fulfillments": [
                1536
            ],
            "originalFulfillmentId": [
                1
            ],
            "voided": [
                1241
            ],
            "voidedAt": [
                581
            ],
            "isFulfillmentOverridden": [
                7
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "status": [
                1538
            ],
            "lineItemId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "OrderLineItem": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "type": [
                1548
            ],
            "amount": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "taxAmount": [
                5
            ],
            "taxAmountInHomeCurrency": [
                5
            ],
            "discountAmount": [
                5
            ],
            "discountAmountInHomeCurrency": [
                5
            ],
            "currency": [
                549
            ],
            "quantity": [
                41
            ],
            "firstPostedAt": [
                581
            ],
            "lastPostedAt": [
                581
            ],
            "externalProductId": [
                1
            ],
            "product": [
                1769
            ],
            "sku": [
                1
            ],
            "unitPrice": [
                5
            ],
            "voidedAt": [
                581
            ],
            "status": [
                1538
            ],
            "fulfillments": [
                1543
            ],
            "fulfillmentStats": [
                1544
            ],
            "__typename": [
                1
            ]
        },
        "OrderLineItemDiscountType": {},
        "OrderLineItemFulfillment": {
            "warehouseId": [
                15
            ],
            "fulfilledAt": [
                581
            ],
            "quantity": [
                41
            ],
            "quantityOverride": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "OrderLineItemFulfillmentStats": {
            "unfulfilledQuantity": [
                41
            ],
            "unfulfilledQuantityOverride": [
                41
            ],
            "fulfilledQuantity": [
                41
            ],
            "fulfilledQuantityOverride": [
                41
            ],
            "orderedQuantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "OrderLineItemFulfillmentV3": {
            "warehouse": [
                2396
            ],
            "fulfilledAt": [
                581
            ],
            "quantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "OrderLineItemTaxType": {},
        "OrderLineItemTimelineV3": {
            "lastEffectBy": [
                1
            ],
            "postedAt": [
                581
            ],
            "totalQuantity": [
                41
            ],
            "fullyFulfilledAt": [
                581
            ],
            "firstFulfillmentAt": [
                581
            ],
            "totalPlaced": [
                1252
            ],
            "unfulfilled": [
                1252
            ],
            "fulfilled": [
                1252
            ],
            "unfulfilledRefunded": [
                1252
            ],
            "fulfilledRefunded": [
                1252
            ],
            "actions": [
                1254
            ],
            "__typename": [
                1
            ]
        },
        "OrderLineItemType": {},
        "OrderLineItemTypeV3": {},
        "OrderLineItemV3": {
            "id": [
                15
            ],
            "externalLineItemId": [
                1
            ],
            "name": [
                1
            ],
            "description": [
                1
            ],
            "amount": [
                107
            ],
            "parentId": [
                1
            ],
            "parentLineItemType": [
                1639
            ],
            "earliestPostedAt": [
                581
            ],
            "latestPostedAt": [
                581
            ],
            "type": [
                1549
            ],
            "on_DiscountLineItemV3": [
                653
            ],
            "on_FeeLineItemV3": [
                726
            ],
            "on_ProductLineItemV3": [
                1796
            ],
            "on_ShippingLineItemV3": [
                2048
            ],
            "on_TaxLineItemV3": [
                2146
            ],
            "on_TipLineItemV3": [
                2153
            ],
            "__typename": [
                1
            ]
        },
        "OrderOtherAccountingReconciliationRow": {
            "accountName": [
                1
            ],
            "accounts": [
                1489
            ],
            "__typename": [
                1
            ]
        },
        "OrderPaymentGroup": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "postedAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "orders": [
                1664
            ],
            "bankTransactions": [
                1659
            ],
            "expenses": [
                1653
            ],
            "__typename": [
                1
            ]
        },
        "OrderPaymentGroupByIdResponse": {
            "paymentGroup": [
                1552
            ],
            "__typename": [
                1
            ]
        },
        "OrderPaymentGroupsByIdsResponse": {
            "paymentGroups": [
                1552
            ],
            "__typename": [
                1
            ]
        },
        "OrderPaymentGroupsResponse": {
            "paymentGroups": [
                1552
            ],
            "__typename": [
                1
            ]
        },
        "OrderPaymentGroupsUnclearedBalanceResponse": {
            "asOfDate": [
                581
            ],
            "unclearedBalances": [
                1557
            ],
            "__typename": [
                1
            ]
        },
        "OrderPaymentGroupUnclearedBalance": {
            "paymentGroup": [
                1552
            ],
            "unclearedBalance": [
                107
            ],
            "__typename": [
                1
            ]
        },
        "OrderPaymentStatus": {},
        "OrderReconciliationRow": {
            "title": [
                1
            ],
            "saleAmount": [
                5
            ],
            "taxAmount": [
                5
            ],
            "discountAmount": [
                5
            ],
            "shippingAmount": [
                5
            ],
            "refundAmount": [
                5
            ],
            "additionalTaxesAmount": [
                5
            ],
            "totalAmount": [
                5
            ],
            "netAmount": [
                5
            ],
            "subRows": [
                1559
            ],
            "__typename": [
                1
            ]
        },
        "OrderReconciliationRowType": {},
        "OrderReconciliationsInput": {
            "startTime": [
                581
            ],
            "endTime": [
                581
            ],
            "integrationAccountId": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "OrderReconciliationsResponse": {
            "booksRows": [
                1559
            ],
            "excludedRows": [
                1559
            ],
            "adjustedRows": [
                1559
            ],
            "shopifyRow": [
                1559
            ],
            "dateRange": [
                582
            ],
            "currency": [
                1
            ],
            "failureReason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OrderRestock": {
            "id": [
                15
            ],
            "postedAt": [
                581
            ],
            "restockLineItems": [
                1564
            ],
            "__typename": [
                1
            ]
        },
        "OrderRestockLineItem": {
            "id": [
                15
            ],
            "quantity": [
                41
            ],
            "lineItemId": [
                15
            ],
            "sku": [
                1
            ],
            "warehouse": [
                2396
            ],
            "__typename": [
                1
            ]
        },
        "OrderReturnLineItemTypeV3": {},
        "OrderReturnLineItemV3": {
            "id": [
                15
            ],
            "externalId": [
                1
            ],
            "warehouse": [
                2396
            ],
            "lineItemId": [
                1
            ],
            "externalLineItemId": [
                1
            ],
            "type": [
                1565
            ],
            "isRestocked": [
                7
            ],
            "quantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "OrderReturnV3": {
            "id": [
                15
            ],
            "externalId": [
                1
            ],
            "postedAt": [
                581
            ],
            "lineItems": [
                1566
            ],
            "totalRefundedAmount": [
                5
            ],
            "totalRefundedAmountCurrency": [
                1
            ],
            "totalRefundedAmountInHomeCurrency": [
                5
            ],
            "totalRefundedAmountHomeCurrency": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OrdersAggregation": {
            "type": [
                1498
            ],
            "value": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "OrdersAgingAggregation": {
            "type": [
                1498
            ],
            "values": [
                76
            ],
            "__typename": [
                1
            ]
        },
        "OrdersAgingPreset": {},
        "OrdersByIdsInput": {
            "companyId": [
                15
            ],
            "orderIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "OrdersByIdsResponse": {
            "orders": [
                1602
            ],
            "__typename": [
                1
            ]
        },
        "OrdersDateRangeInput": {
            "min": [
                581
            ],
            "max": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "OrderSettings": {
            "void": [
                2391
            ],
            "__typename": [
                1
            ]
        },
        "OrderSettingsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "OrderSettingsResponse": {
            "settings": [
                1574
            ],
            "__typename": [
                1
            ]
        },
        "OrderSettlementStatusInput": {},
        "OrdersFilter": {
            "searchText": [
                1
            ],
            "orderIds": [
                1
            ],
            "unpaidAsOfDate": [
                581
            ],
            "placedDate": [
                1573
            ],
            "productIds": [
                15
            ],
            "itemsCount": [
                757
            ],
            "totalAmountInHomeCurrency": [
                757
            ],
            "integrationAccountIds": [
                1
            ],
            "storeIds": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "paymentStatuses": [
                1558
            ],
            "fulfillmentStatuses": [
                1509
            ],
            "settlementStatuses": [
                1577
            ],
            "orderStatuses": [
                1586
            ],
            "tagIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "OrdersInput": {
            "companyId": [
                15
            ],
            "filter": [
                1578
            ],
            "sort": [
                1583
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "OrderSourceTypeV3": {},
        "OrdersResult": {
            "orders": [
                1605
            ],
            "__typename": [
                1
            ]
        },
        "OrdersSettings": {
            "isZeroNetOrdersSupported": [
                7
            ],
            "shouldRecognizeZeroNetCogsAsGiveaways": [
                7
            ],
            "shopifyStoreV2StartDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "OrdersSort": {
            "type": [
                1584
            ],
            "direction": [
                2094
            ],
            "__typename": [
                1
            ]
        },
        "OrdersSortType": {},
        "OrderStatus": {},
        "OrderStatusInput": {},
        "OrderStatusV3": {},
        "OrderStatusWithOverride": {
            "status": [
                1585
            ],
            "isOverridden": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "OrderStatusWithOverrideV3": {
            "status": [
                1587
            ],
            "isOverridden": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "OrdersYearEndBalances": {
            "unpaidAmount": [
                5
            ],
            "cashDepositAmount": [
                5
            ],
            "netUnpaidBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "OrdersYearEndInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "OrdersYearEndResponse": {
            "balances": [
                1590
            ],
            "waitingPermissionsIntegrations": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OrderTag": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OrderTimestamps": {
            "fullyPaidAt": [
                581
            ],
            "firstPaymentAt": [
                581
            ],
            "firstRefundAt": [
                581
            ],
            "fullyFulfilledAt": [
                581
            ],
            "firstFulfilledAt": [
                581
            ],
            "latestFinancialTimestamp": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "OrderToLinkInput": {
            "orderId": [
                15
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "OrderTotals": {
            "netSales": [
                5
            ],
            "netSalesInHomeCurrency": [
                5
            ],
            "subTotal": [
                5
            ],
            "subTotalInHomeCurrency": [
                5
            ],
            "tipsSubtotal": [
                5
            ],
            "tipsSubtotalInHomeCurrency": [
                5
            ],
            "shippingSubtotal": [
                5
            ],
            "shippingSubtotalInHomeCurrency": [
                5
            ],
            "orderValue": [
                5
            ],
            "orderValueInHomeCurrency": [
                5
            ],
            "netOrder": [
                5
            ],
            "netOrderInHomeCurrency": [
                5
            ],
            "itemSellerDiscounts": [
                5
            ],
            "itemSellerDiscountsInHomeCurrency": [
                5
            ],
            "itemPlatformDiscounts": [
                5
            ],
            "itemPlatformDiscountsInHomeCurrency": [
                5
            ],
            "itemCofundedDiscounts": [
                5
            ],
            "itemCofundedDiscountsInHomeCurrency": [
                5
            ],
            "itemOtherDiscounts": [
                5
            ],
            "itemOtherDiscountsInHomeCurrency": [
                5
            ],
            "shippingSellerDiscounts": [
                5
            ],
            "shippingSellerDiscountsInHomeCurrency": [
                5
            ],
            "shippingPlatformDiscounts": [
                5
            ],
            "shippingPlatformDiscountsInHomeCurrency": [
                5
            ],
            "shippingCofundedDiscounts": [
                5
            ],
            "shippingCofundedDiscountsInHomeCurrency": [
                5
            ],
            "shippingOtherDiscounts": [
                5
            ],
            "shippingOtherDiscountsInHomeCurrency": [
                5
            ],
            "feesSellerDiscounts": [
                5
            ],
            "feesSellerDiscountsInHomeCurrency": [
                5
            ],
            "feesPlatformDiscounts": [
                5
            ],
            "feesPlatformDiscountsInHomeCurrency": [
                5
            ],
            "feesCofundedDiscounts": [
                5
            ],
            "feesCofundedDiscountsInHomeCurrency": [
                5
            ],
            "feesOtherDiscounts": [
                5
            ],
            "feesOtherDiscountsInHomeCurrency": [
                5
            ],
            "globalSellerDiscounts": [
                5
            ],
            "globalSellerDiscountsInHomeCurrency": [
                5
            ],
            "globalPlatformDiscounts": [
                5
            ],
            "globalPlatformDiscountsInHomeCurrency": [
                5
            ],
            "globalCofundedDiscounts": [
                5
            ],
            "globalCofundedDiscountsInHomeCurrency": [
                5
            ],
            "globalOtherDiscounts": [
                5
            ],
            "globalOtherDiscountsInHomeCurrency": [
                5
            ],
            "totalDiscounts": [
                5
            ],
            "totalDiscountsInHomeCurrency": [
                5
            ],
            "payments": [
                5
            ],
            "paymentsInHomeCurrency": [
                5
            ],
            "paymentRefunds": [
                5
            ],
            "paymentRefundsInHomeCurrency": [
                5
            ],
            "saleRefunds": [
                5
            ],
            "saleRefundsInHomeCurrency": [
                5
            ],
            "adjustments": [
                5
            ],
            "adjustmentsInHomeCurrency": [
                5
            ],
            "totalTaxes": [
                5
            ],
            "totalTaxesInHomeCurrency": [
                5
            ],
            "taxesSubtotal": [
                5
            ],
            "taxesSubtotalInHomeCurrency": [
                5
            ],
            "taxRefunds": [
                5
            ],
            "taxRefundsInHomeCurrency": [
                5
            ],
            "salesTax": [
                5
            ],
            "salesTaxInHomeCurrency": [
                5
            ],
            "vat": [
                5
            ],
            "vatInHomeCurrency": [
                5
            ],
            "gst": [
                5
            ],
            "gstInHomeCurrency": [
                5
            ],
            "dutiesAndOtherTaxes": [
                5
            ],
            "dutiesAndOtherTaxesInHomeCurrency": [
                5
            ],
            "numberOfItems": [
                5
            ],
            "netPaid": [
                5
            ],
            "netPaidInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "OrderTotalSummary": {
            "subtotal": [
                107
            ],
            "shippingIncome": [
                107
            ],
            "discounts": [
                107
            ],
            "netSale": [
                107
            ],
            "taxes": [
                107
            ],
            "additionalTaxes": [
                107
            ],
            "refunds": [
                107
            ],
            "fxAdjustment": [
                107
            ],
            "netOrder": [
                107
            ],
            "voided": [
                107
            ],
            "paid": [
                5
            ],
            "refunded": [
                5
            ],
            "netPaid": [
                5
            ],
            "uncollectible": [
                5
            ],
            "overCollected": [
                5
            ],
            "orderBalance": [
                5
            ],
            "balanceAsOf": [
                581
            ],
            "balanceAsOfAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "OrderTransactionMatchV2": {
            "id": [
                15
            ],
            "amount": [
                107
            ],
            "payment": [
                2113
            ],
            "__typename": [
                1
            ]
        },
        "OrderTransactionType": {},
        "OrderTransactionV2": {
            "id": [
                15
            ],
            "amount": [
                107
            ],
            "exchangeRateOverride": [
                5
            ],
            "type": [
                1599
            ],
            "postedAt": [
                581
            ],
            "matches": [
                1598
            ],
            "finaloopPaymentGateway": [
                1
            ],
            "originalPaymentGateway": [
                1
            ],
            "paymentGatewayVariant": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "isManual": [
                7
            ],
            "voided": [
                1241
            ],
            "authorizationCode": [
                1
            ],
            "isArtificiallyMatched": [
                7
            ],
            "matchedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "OrderTransactionV3": {
            "id": [
                15
            ],
            "amount": [
                107
            ],
            "externalId": [
                1
            ],
            "type": [
                1599
            ],
            "paymentGateway": [
                2164
            ],
            "postedAt": [
                581
            ],
            "releasedAt": [
                581
            ],
            "externalPaymentGateway": [
                1
            ],
            "authorizationCode": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OrderV2": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "items": [
                1540
            ],
            "lineItems": [
                1541
            ],
            "transactions": [
                1600
            ],
            "orderGroupLinks": [
                1519
            ],
            "orderGroupDistributions": [
                1515
            ],
            "orderAdjustments": [
                1493
            ],
            "totalSummary": [
                1597
            ],
            "displayName": [
                1
            ],
            "currency": [
                1
            ],
            "source": [
                1
            ],
            "placedAt": [
                581
            ],
            "firstPaymentDate": [
                581
            ],
            "fullyPaidDate": [
                581
            ],
            "firstRefundDate": [
                581
            ],
            "firstFulfillmentDate": [
                581
            ],
            "latestFinancialDate": [
                581
            ],
            "salesChannel": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "integrationAccountId": [
                15
            ],
            "customer": [
                563
            ],
            "isZeroNetOrder": [
                7
            ],
            "integrationTags": [
                1
            ],
            "finaloopTags": [
                1593
            ],
            "finaloopNote": [
                1
            ],
            "integrationNote": [
                1
            ],
            "isChannelProductSalesAffecting": [
                7
            ],
            "isChannelAccountsAffecting": [
                7
            ],
            "isProductSalesAffecting": [
                7
            ],
            "isAccountsAffecting": [
                7
            ],
            "paymentStatus": [
                1558
            ],
            "fulfillmentStatus": [
                1508
            ],
            "balanceInHomeCurrency": [
                5
            ],
            "voidedAt": [
                581
            ],
            "shippingAddress": [
                555
            ],
            "billingAddress": [
                555
            ],
            "store": [
                2110
            ],
            "status": [
                1588
            ],
            "financialReportingStatus": [
                1503
            ],
            "integrationExternalUrl": [
                1
            ],
            "fulfillments": [
                1504
            ],
            "restocks": [
                1563
            ],
            "paymentGroupLinks": [
                1658
            ],
            "__typename": [
                1
            ]
        },
        "OrderV2NotFound": {
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OrderV2Result": {
            "on_OrderV2": [
                1602
            ],
            "on_OrderV2NotFound": [
                1603
            ],
            "__typename": [
                1
            ]
        },
        "OrderV3": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "integrationType": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "totals": [
                1596
            ],
            "returns": [
                1567
            ],
            "store": [
                2114
            ],
            "balances": [
                1499
            ],
            "unfulfilledBalances": [
                1499
            ],
            "balanceAsOfAmount": [
                5
            ],
            "currency": [
                549
            ],
            "postedAt": [
                581
            ],
            "statuses": [
                1589
            ],
            "voidedAt": [
                581
            ],
            "voidedBy": [
                1607
            ],
            "integrationVoidedAt": [
                581
            ],
            "buyerNote": [
                1
            ],
            "isZeroNet": [
                7
            ],
            "lineItems": [
                1550
            ],
            "customer": [
                564
            ],
            "externalUrl": [
                1
            ],
            "externalId": [
                1
            ],
            "externalUpdatedAt": [
                581
            ],
            "sellerNote": [
                1
            ],
            "timestamps": [
                1594
            ],
            "adjustments": [
                1496
            ],
            "displayName": [
                1
            ],
            "fulfillments": [
                1511
            ],
            "transactions": [
                1601
            ],
            "source": [
                1580
            ],
            "currentBalance": [
                5
            ],
            "currentBalanceInHomeCurrency": [
                5
            ],
            "currentUnfulfilledBalance": [
                5
            ],
            "currentUnfulfilledBalanceInHomeCurrency": [
                5
            ],
            "salesChannelId": [
                1
            ],
            "billingAddressId": [
                1
            ],
            "shippingAddressId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OrderV3NotFound": {
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OrderVoidedByType": {},
        "OrderVoidingStateInput": {
            "orderId": [
                15
            ],
            "voidedLineItemIds": [
                15
            ],
            "nonVoidedLineItemIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "OtherFbaAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OtherFbaCogs": {
            "amount": [
                5
            ],
            "otherFbaIncoming": [
                41
            ],
            "otherFba": [
                41
            ],
            "monthlyBreakdown": [
                1612
            ],
            "__typename": [
                1
            ]
        },
        "OtherFbaDailyBreakdown": {
            "date": [
                581
            ],
            "otherFbaIncoming": [
                41
            ],
            "otherFba": [
                41
            ],
            "reason": [
                66
            ],
            "__typename": [
                1
            ]
        },
        "OtherFbaMonthlyBreakdown": {
            "date": [
                581
            ],
            "otherFbaIncoming": [
                41
            ],
            "otherFba": [
                41
            ],
            "dailyData": [
                1611
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentLineItemInput": {
            "lineItemId": [
                15
            ],
            "overrides": [
                1626
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsError": {
            "on_OverrideOrderFulfillmentsErrorInvalidLineItem": [
                1617
            ],
            "on_OverrideOrderFulfillmentsErrorInvalidOrder": [
                1618
            ],
            "on_OverrideOrderFulfillmentsErrorInvalidWarehouse": [
                1620
            ],
            "on_OverrideOrderFulfillmentsErrorInvalidQuantity": [
                1619
            ],
            "on_OverrideOrderFulfillmentsErrorQuantityDiscrepancy": [
                1624
            ],
            "on_OverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouse": [
                1616
            ],
            "on_OverrideOrderFulfillmentsErrorInvalidFulfillmentDate": [
                1615
            ],
            "on_OverrideOrderFulfillmentsErrorLockedFulfillmentDate": [
                1621
            ],
            "on_OverrideOrderFulfillmentsErrorMissingOverride": [
                1623
            ],
            "on_OverrideOrderFulfillmentsErrorMisc": [
                1622
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsErrorInvalidFulfillmentDate": {
            "lineItemId": [
                15
            ],
            "fulfilledAt": [
                581
            ],
            "warehouseId": [
                1
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsErrorInvalidFulfillmentWarehouse": {
            "fulfillmentId": [
                15
            ],
            "warehouseId": [
                1
            ],
            "fulfilledAt": [
                581
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsErrorInvalidLineItem": {
            "lineItemId": [
                15
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsErrorInvalidOrder": {
            "orderId": [
                15
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsErrorInvalidQuantity": {
            "lineItemId": [
                15
            ],
            "warehouseId": [
                1
            ],
            "fulfilledAt": [
                581
            ],
            "quantity": [
                41
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsErrorInvalidWarehouse": {
            "lineItemId": [
                15
            ],
            "warehouseId": [
                1
            ],
            "fulfilledAt": [
                581
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsErrorLockedFulfillmentDate": {
            "lineItemId": [
                15
            ],
            "fulfilledAt": [
                581
            ],
            "warehouseId": [
                1
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsErrorMisc": {
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsErrorMissingOverride": {
            "lineItemId": [
                15
            ],
            "fulfilledAt": [
                581
            ],
            "warehouseId": [
                1
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsErrorQuantityDiscrepancy": {
            "quantity": [
                41
            ],
            "lineItemQuantity": [
                41
            ],
            "lineItemId": [
                15
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsInput": {
            "companyId": [
                15
            ],
            "fulfillmentOverrides": [
                1627
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsItemInput": {
            "warehouseId": [
                1
            ],
            "fulfilledAt": [
                581
            ],
            "quantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsOrderInput": {
            "orderId": [
                15
            ],
            "lineItemOverrides": [
                1613
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsOrderResponse": {
            "orderId": [
                15
            ],
            "success": [
                7
            ],
            "errors": [
                1614
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsResponse": {
            "orders": [
                1628
            ],
            "__typename": [
                1
            ]
        },
        "OverrideOrderFulfillmentsToLineItemPostDateInput": {
            "companyId": [
                15
            ],
            "orderIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "OverviewConnectionStatus": {},
        "OverviewCycle": {
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "openingBalance": [
                5
            ],
            "purchasesSum": [
                5
            ],
            "assemblyCostsSum": [
                5
            ],
            "cogsSum": [
                5
            ],
            "cogsAdjustmentsSum": [
                5
            ],
            "closingBalance": [
                5
            ],
            "warehouseTransfersSum": [
                5
            ],
            "physicalCountAdjustment": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "OverviewCyclesInput": {
            "companyId": [
                15
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "PageInput": {
            "offset": [
                41
            ],
            "limit": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "PaidStatus": {},
        "PairedEntity": {
            "on_Bill": [
                312
            ],
            "on_Payout": [
                1697
            ],
            "on_Topup": [
                2159
            ],
            "on_BankTransaction": [
                270
            ],
            "on_CompanyAffiliate": [
                422
            ],
            "on_IntegrationTransfer": [
                1098
            ],
            "__typename": [
                1
            ]
        },
        "PairedEntityType": {},
        "PairingType": {},
        "ParentLineItemType": {},
        "Payment": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "source": [
                1113
            ],
            "integrationAccountId": [
                15
            ],
            "integrationAccountName": [
                1
            ],
            "amount": [
                5
            ],
            "currency": [
                1
            ],
            "postedAt": [
                581
            ],
            "externalAuthorizationCode": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PaymentCheck": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "source": [
                1
            ],
            "postedAt": [
                581
            ],
            "amount": [
                5
            ],
            "currency": [
                1
            ],
            "amountInHomeCurrency": [
                5
            ],
            "contractor": [
                487
            ],
            "employee": [
                673
            ],
            "matchedBankTransaction": [
                270
            ],
            "isImmaterial": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "PaymentChecksInput": {
            "companyId": [
                15
            ],
            "amount": [
                5
            ],
            "currency": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PaymentDetails": {
            "id": [
                15
            ],
            "price": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PaymentFee": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "source": [
                1113
            ],
            "integrationAccountId": [
                15
            ],
            "integrationAccountName": [
                1
            ],
            "amount": [
                5
            ],
            "currency": [
                1
            ],
            "type": [
                1646
            ],
            "basis": [
                1645
            ],
            "postedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "PaymentFeeBasis": {},
        "PaymentFeeType": {},
        "PaymentGateway": {},
        "PaymentGatewaysByCompanyIntegrationAndSalesChannelInput": {
            "companyId": [
                15
            ],
            "integrationAccountId": [
                15
            ],
            "salesChannel": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGatewayType": {},
        "PaymentGroup": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupBankTransactionToLinkInput": {
            "transactionId": [
                15
            ],
            "amount": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "currency": [
                549
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupByIdInput": {
            "paymentGroupId": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupExpense": {
            "id": [
                15
            ],
            "expenseType": [
                1655
            ],
            "amount": [
                107
            ],
            "vendor": [
                2375
            ],
            "merchant": [
                2382
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupExpenseInput": {
            "expenseType": [
                1655
            ],
            "amount": [
                5
            ],
            "vendorId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupExpenseType": {},
        "PaymentGroupInventoryPurchasesToLinkInput": {
            "id": [
                15
            ],
            "inventoryPurchaseId": [
                15
            ],
            "amount": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "currency": [
                549
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupInvoiceToLinkInput": {
            "invoiceId": [
                15
            ],
            "amount": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "currency": [
                549
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupLink": {
            "paymentGroupId": [
                15
            ],
            "amount": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "currency": [
                549
            ],
            "postedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupLinkedBankTransaction": {
            "bankTransaction": [
                270
            ],
            "bankTransactionPostedAt": [
                581
            ],
            "amount": [
                107
            ],
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupLinkedInventoryPurchases": {
            "inventoryPurchase": [
                1131
            ],
            "inventoryPurchasePostedAt": [
                581
            ],
            "amount": [
                107
            ],
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupLinkedInvoice": {
            "invoice": [
                1198
            ],
            "amountInHomeCurrency": [
                5
            ],
            "currency": [
                549
            ],
            "amount": [
                5
            ],
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupLinkedManualAssembly": {
            "id": [
                15
            ],
            "manualAssembly": [
                1373
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupLinkedOnDemandAssemblyVendorCost": {
            "id": [
                15
            ],
            "onDemandAssemblyVendorCost": [
                1481
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupLinkedOrder": {
            "order": [
                1602
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupLinkedPurchaseOrder": {
            "id": [
                15
            ],
            "purchaseOrder": [
                1846
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupLinkedWarehouseTransfer": {
            "id": [
                15
            ],
            "warehouseTransfer": [
                2435
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupLinksForInvoiceInput": {
            "companyId": [
                1
            ],
            "invoiceId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupLinksForInvoiceResponse": {
            "paymentGroupLinks": [
                1658
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupLinksInput": {
            "companyId": [
                1
            ],
            "saleId": [
                1
            ],
            "paymentGroupType": [
                1686
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupLinksResponse": {
            "paymentGroupLinks": [
                1658
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupManualAssemblyCostsToLinkInput": {
            "id": [
                15
            ],
            "manualAssemblyId": [
                15
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupOnDemandAssemblyVendorCostsToLinkInput": {
            "id": [
                15
            ],
            "onDemandAssemblyVendorCostId": [
                15
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupOrderToLinkInput": {
            "orderId": [
                15
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupPurchaseOrderToLinkInput": {
            "id": [
                15
            ],
            "purchaseOrderId": [
                15
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupsByIdsInput": {
            "companyId": [
                15
            ],
            "paymentGroupIds": [
                15
            ],
            "withDeleted": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupsByIdsResponse": {
            "paymentGroups": [
                1231
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupsFilter": {
            "postedAt": [
                583
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupsInput": {
            "companyId": [
                1
            ],
            "filter": [
                1677
            ],
            "sort": [
                1679
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupsSort": {
            "type": [
                1681
            ],
            "direction": [
                1680
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupsSortDirection": {},
        "PaymentGroupsSortType": {},
        "PaymentGroupsTotalUnclearedBalanceInput": {
            "companyId": [
                15
            ],
            "asOfDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupsTotalUnclearedBalanceResponse": {
            "asOfDate": [
                581
            ],
            "totalUnclearedBalance": [
                107
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupsUnclearedBalanceInput": {
            "companyId": [
                15
            ],
            "paymentGroupIds": [
                15
            ],
            "asOfDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupTransaction": {
            "id": [
                15
            ],
            "integrationInfo": [
                1093
            ],
            "integrationAccountId": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "amount": [
                5
            ],
            "postedAt": [
                581
            ],
            "currency": [
                549
            ],
            "amountInHomeCurrency": [
                5
            ],
            "type": [
                2167
            ],
            "finaloopPaymentGateway": [
                1
            ],
            "originalPaymentGateway": [
                1
            ],
            "paymentGatewayVariant": [
                1
            ],
            "isIndication": [
                7
            ],
            "paymentGroup": [
                1650
            ],
            "__typename": [
                1
            ]
        },
        "PaymentGroupType": {},
        "PaymentGroupWarehouseTransferToLinkInput": {
            "id": [
                15
            ],
            "warehouseTransferId": [
                15
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PaymentLinkStatus": {},
        "PaymentMethod": {
            "id": [
                15
            ],
            "source": [
                1
            ],
            "type": [
                1691
            ],
            "isDefault": [
                7
            ],
            "integrationAccountId": [
                1
            ],
            "instructions": [
                1
            ],
            "bankName": [
                1
            ],
            "accountNumber": [
                1
            ],
            "routingNumber": [
                1
            ],
            "swift": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PaymentMethodInput": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PaymentMethodType": {},
        "PaymentOptionInput": {
            "stripeId": [
                1
            ],
            "price": [
                5
            ],
            "recurrence": [
                1695
            ],
            "__typename": [
                1
            ]
        },
        "PaymentProcessorByCompanyAndVendorInput": {
            "companyId": [
                15
            ],
            "vendorId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PaymentProcessorByCompanyAndVendorResponse": {
            "processor": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PaymentRecurrence": {},
        "PaymentsByEntityInput": {
            "companyId": [
                15
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "Payout": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "amount": [
                5
            ],
            "amountInUsd": [
                5
            ],
            "currency": [
                1
            ],
            "eventTime": [
                581
            ],
            "deletedAt": [
                581
            ],
            "markedAsReconciliationDiscrepancyAt": [
                581
            ],
            "integrationType": [
                1113
            ],
            "pairedBankTransaction": [
                270
            ],
            "type": [
                1110
            ],
            "classification": [
                1099
            ],
            "integrationAccountId": [
                15
            ],
            "integrationAccountName": [
                1
            ],
            "pairedCompanyAffiliate": [
                422
            ],
            "link": [
                1
            ],
            "uploadedFileId": [
                1
            ],
            "failedAmountInUsd": [
                5
            ],
            "failedAt": [
                581
            ],
            "markedAsUnidentifiedAt": [
                581
            ],
            "rawEvent": [
                1241
            ],
            "__typename": [
                1
            ]
        },
        "PaypalTransactionCurrenciesInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                15
            ],
            "integrationAccountId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Payroll": {
            "id": [
                15
            ],
            "company": [
                418
            ],
            "source": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "currency": [
                1
            ],
            "postedAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "PayrollCategory": {},
        "PayrollCategoryMapping": {
            "on_PayrollDepartmentCategoryMapping": [
                1712
            ],
            "on_PayrollEmployeeCategoryMapping": [
                1713
            ],
            "on_PayrollContractorCategoryMapping": [
                1708
            ],
            "__typename": [
                1
            ]
        },
        "PayrollCategoryMappingInput": {
            "id": [
                15
            ],
            "type": [
                1721
            ],
            "category": [
                1700
            ],
            "__typename": [
                1
            ]
        },
        "PayrollCategoryMappingMode": {},
        "PayrollConnection": {
            "integrationAccountId": [
                15
            ],
            "integrationType": [
                1113
            ],
            "integrationAccountName": [
                1
            ],
            "importStatus": [
                1705
            ],
            "disconnectedAt": [
                581
            ],
            "disconnectedBy": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PayrollConnectionImportStatus": {
            "contractorPayments": [
                1706
            ],
            "contractors": [
                1706
            ],
            "departments": [
                1706
            ],
            "employees": [
                1706
            ],
            "payrolls": [
                1706
            ],
            "__typename": [
                1
            ]
        },
        "PayrollConnectionImportStatusData": {
            "lastUpdateTime": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "PayrollConnectionsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PayrollContractorCategoryMapping": {
            "contractor": [
                487
            ],
            "category": [
                1700
            ],
            "__typename": [
                1
            ]
        },
        "PayrollDailyAggregate": {
            "id": [
                15
            ],
            "currency": [
                1
            ],
            "postedAt": [
                581
            ],
            "source": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "unallocatedHealthBenefitsContribution": [
                5
            ],
            "unallocatedCompanyTaxes": [
                5
            ],
            "unallocatedDonationDeductions": [
                5
            ],
            "pension401k": [
                5
            ],
            "deletedAt": [
                581
            ],
            "matchedBankTransaction": [
                270
            ],
            "paymentChecks": [
                574
            ],
            "reimbursements": [
                576
            ],
            "ownersDraw": [
                573
            ],
            "integrationTransfers": [
                1718
            ],
            "taxDebitAmount": [
                5
            ],
            "netPayDebitAmount": [
                5
            ],
            "dailyAggregates": [
                575
            ],
            "unpaidAmountsViaProvider": [
                2212
            ],
            "__typename": [
                1
            ]
        },
        "PayrollDailyDataInput": {
            "companyId": [
                15
            ],
            "payrollIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PayrollData": {
            "knownVendors": [
                1
            ],
            "unknownVendors": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PayrollDepartmentCategoryMapping": {
            "department": [
                640
            ],
            "category": [
                1700
            ],
            "__typename": [
                1
            ]
        },
        "PayrollEmployeeCategoryMapping": {
            "employee": [
                673
            ],
            "category": [
                1700
            ],
            "__typename": [
                1
            ]
        },
        "PayrollEmploymentType": {},
        "PayrollIdsByCompanyInput": {
            "companyIds": [
                15
            ],
            "afterBooksStartTimeOnly": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "PayrollIdsByCompanyItem": {
            "companyId": [
                1
            ],
            "payrollIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PayrollIdsByCompanyResponse": {
            "items": [
                1716
            ],
            "__typename": [
                1
            ]
        },
        "PayrollIntegrationTransfer": {
            "integrationTransferId": [
                1
            ],
            "type": [
                1719
            ],
            "amount": [
                5
            ],
            "amountInHomeCurrency": [
                5
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "PayrollIntegrationTransferType": {},
        "PayrollItemToReconcile": {
            "companyId": [
                15
            ],
            "payrollId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PayrollMappableType": {},
        "PayrollSettings": {
            "withCategoryMapping": [
                7
            ],
            "categoryMappingMode": [
                1703
            ],
            "categoryMappings": [
                1701
            ],
            "__typename": [
                1
            ]
        },
        "PayrollSettingsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PendingAdjustmentsExcludeListItem": {
            "productId": [
                1
            ],
            "date": [
                581
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PendingAdjustmentsOverviewResponse": {
            "count": [
                41
            ],
            "pendingCount": [
                41
            ],
            "missingDataCount": [
                41
            ],
            "lastPendingChange": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "PendingDeadInventoryAdjustments": {
            "id": [
                1
            ],
            "date": [
                581
            ],
            "quantity": [
                41
            ],
            "warehouseId": [
                1
            ],
            "warehouse": [
                2396
            ],
            "productId": [
                1
            ],
            "companyId": [
                1
            ],
            "currentState": [
                590
            ],
            "__typename": [
                1
            ]
        },
        "PendingDeadInventoryAdjustmentsByIdsResponse": {
            "items": [
                1726
            ],
            "__typename": [
                1
            ]
        },
        "PendingDeadInventoryAdjustmentsItem": {
            "productId": [
                1
            ],
            "product": [
                1769
            ],
            "pendingDeadInventoryAdjustments": [
                1726
            ],
            "__typename": [
                1
            ]
        },
        "PendingDeadInventoryAdjustmentsResponse": {
            "items": [
                1728
            ],
            "excludeList": [
                1724
            ],
            "__typename": [
                1
            ]
        },
        "PendingDonationAdjustments": {
            "id": [
                1
            ],
            "date": [
                581
            ],
            "quantity": [
                41
            ],
            "warehouseId": [
                1
            ],
            "warehouse": [
                2396
            ],
            "productId": [
                1
            ],
            "companyId": [
                1
            ],
            "currentState": [
                661
            ],
            "__typename": [
                1
            ]
        },
        "PendingDonationAdjustmentsByIdsResponse": {
            "items": [
                1730
            ],
            "__typename": [
                1
            ]
        },
        "PendingDonationAdjustmentsItem": {
            "productId": [
                1
            ],
            "product": [
                1769
            ],
            "pendingDonationAdjustments": [
                1730
            ],
            "__typename": [
                1
            ]
        },
        "PendingDonationAdjustmentsResponse": {
            "items": [
                1732
            ],
            "excludeList": [
                1724
            ],
            "__typename": [
                1
            ]
        },
        "PendingGiveawayAdjustments": {
            "id": [
                1
            ],
            "date": [
                581
            ],
            "quantity": [
                41
            ],
            "warehouseId": [
                1
            ],
            "warehouse": [
                2396
            ],
            "productId": [
                1
            ],
            "companyId": [
                1
            ],
            "currentState": [
                1009
            ],
            "__typename": [
                1
            ]
        },
        "PendingGiveawayAdjustmentsByIdsResponse": {
            "items": [
                1734
            ],
            "__typename": [
                1
            ]
        },
        "PendingGiveawayAdjustmentsItem": {
            "productId": [
                1
            ],
            "product": [
                1769
            ],
            "pendingGiveawayAdjustments": [
                1734
            ],
            "__typename": [
                1
            ]
        },
        "PendingGiveawayAdjustmentsResponse": {
            "items": [
                1736
            ],
            "excludeList": [
                1724
            ],
            "__typename": [
                1
            ]
        },
        "PendingGiveawayDropshippingAdjustments": {
            "id": [
                1
            ],
            "date": [
                581
            ],
            "quantity": [
                41
            ],
            "warehouseId": [
                1
            ],
            "warehouse": [
                2396
            ],
            "productId": [
                1
            ],
            "companyId": [
                1
            ],
            "currentState": [
                1007
            ],
            "__typename": [
                1
            ]
        },
        "PendingGiveawayDropshippingAdjustmentsByIdsResponse": {
            "items": [
                1738
            ],
            "__typename": [
                1
            ]
        },
        "PendingGiveawayDropshippingAdjustmentsItem": {
            "productId": [
                1
            ],
            "product": [
                1769
            ],
            "pendingGiveawayDropshippingAdjustments": [
                1738
            ],
            "__typename": [
                1
            ]
        },
        "PendingGiveawayDropshippingAdjustmentsResponse": {
            "items": [
                1740
            ],
            "excludeList": [
                1724
            ],
            "__typename": [
                1
            ]
        },
        "PendingProductAdjustmentsDataType": {},
        "PendingSalesDataAdjustments": {
            "id": [
                1
            ],
            "salesChannel": [
                1940
            ],
            "date": [
                581
            ],
            "unitsSold": [
                41
            ],
            "unitsRestocked": [
                41
            ],
            "warehouseId": [
                1
            ],
            "warehouse": [
                2396
            ],
            "productId": [
                1
            ],
            "companyId": [
                1
            ],
            "currentState": [
                1928
            ],
            "__typename": [
                1
            ]
        },
        "PendingSalesDataAdjustmentsByIdsResponse": {
            "items": [
                1743
            ],
            "__typename": [
                1
            ]
        },
        "PendingSalesDataAdjustmentsItem": {
            "productId": [
                1
            ],
            "product": [
                1769
            ],
            "pendingSalesDataAdjustments": [
                1743
            ],
            "__typename": [
                1
            ]
        },
        "PendingSalesDataAdjustmentsOverviewResponse": {
            "count": [
                41
            ],
            "pendingCount": [
                41
            ],
            "missingDataCount": [
                41
            ],
            "lastPendingChange": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "PendingSalesDataAdjustmentsResponse": {
            "items": [
                1745
            ],
            "excludeList": [
                1724
            ],
            "__typename": [
                1
            ]
        },
        "PendingWarehouseOpeningBalance": {
            "id": [
                15
            ],
            "warehouse": [
                2396
            ],
            "quantity": [
                5
            ],
            "costPerUnit": [
                5
            ],
            "date": [
                581
            ],
            "attachmentId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PendingWarehouseOpeningBalanceAttachment": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "date": [
                581
            ],
            "filename": [
                1
            ],
            "url": [
                1
            ],
            "createdAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "pendingChangesCount": [
                41
            ],
            "summaryData": [
                1750
            ],
            "__typename": [
                1
            ]
        },
        "PendingWarehouseOpeningBalancesAttachmentSummary": {
            "totalCount": [
                41
            ],
            "validCount": [
                41
            ],
            "invalidCount": [
                41
            ],
            "errorCount": [
                41
            ],
            "errorItems": [
                2414
            ],
            "__typename": [
                1
            ]
        },
        "PendingWarehouseOpeningBalancesResponse": {
            "items": [
                2416
            ],
            "__typename": [
                1
            ]
        },
        "PendingWarehouseOpeningBalancesWithCsvResponse": {
            "attachmentId": [
                15
            ],
            "summaryData": [
                1750
            ],
            "__typename": [
                1
            ]
        },
        "PeriodDatesInput": {
            "periodStart": [
                581
            ],
            "periodEnd": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "PeriodicPartnerReport": {
            "company": [
                418
            ],
            "partner": [
                1905
            ],
            "createdAt": [
                581
            ],
            "latestActorId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PeriodicPartnerReportInput": {
            "companyId": [
                15
            ],
            "partnerId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "Permission": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PerVendorBreakdownInput": {
            "affiliatedEntityId": [
                1
            ],
            "newTotal": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PhysicalCountValidationData": {
            "items": [
                1760
            ],
            "__typename": [
                1
            ]
        },
        "PhysicalCountValidationInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PhysicalCountValidationItem": {
            "date": [
                581
            ],
            "booksAmount": [
                5
            ],
            "entityAmount": [
                5
            ],
            "diff": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PhysicalCountValidationResponse": {
            "validationId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Platform": {},
        "PollCheckoutSessionStatusInput": {
            "checkoutSessionId": [
                1
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "PrevalidateCompanyLoanInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "data": [
                1340
            ],
            "attachments": [
                2268
            ],
            "__typename": [
                1
            ]
        },
        "ProcessBillContentInput": {
            "companyId": [
                15
            ],
            "filePathInBucket": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ProcessBillContentResult": {
            "isSuccessful": [
                7
            ],
            "id": [
                15
            ],
            "vendor": [
                2375
            ],
            "categories": [
                372
            ],
            "date": [
                581
            ],
            "dueDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ProcessCheckoutWebhookEventsInput": {
            "webhookEvent": [
                1241
            ],
            "__typename": [
                1
            ]
        },
        "ProcessLoanAttachmentResult": {
            "success": [
                7
            ],
            "errors": [
                1294
            ],
            "processing": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "Product": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "finaloopId": [
                1
            ],
            "displayName": [
                1
            ],
            "imageUrl": [
                1
            ],
            "sku": [
                1
            ],
            "lineOfBusinessId": [
                1
            ],
            "listedChannels": [
                1940
            ],
            "appliedCosts": [
                1771
            ],
            "dailySalesData": [
                1942,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "totalSold": [
                41
            ],
            "avgCostPerUnit": [
                5
            ],
            "price": [
                5
            ],
            "canEditLatestAppliedCost": [
                7
            ],
            "isFractional": [
                7
            ],
            "isHidden": [
                7
            ],
            "salesData": [
                1959,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "rawRecipes": [
                1861,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "componentOfProducts": [
                1769
            ],
            "analyticsOverview": [
                1770,
                {
                    "input": [
                        110
                    ]
                }
            ],
            "warehousesAnalyticsOverview": [
                1837,
                {
                    "input": [
                        110
                    ]
                }
            ],
            "tags": [
                1
            ],
            "isDataSyncing": [
                7
            ],
            "mergeHistory": [
                1799
            ],
            "isDropshipping": [
                7
            ],
            "on_AmazonProduct": [
                90
            ],
            "on_MergedProduct": [
                1417
            ],
            "on_ShopifyProduct": [
                2063
            ],
            "on_TikTokProduct": [
                2149
            ],
            "on_UserManualProduct": [
                2350
            ],
            "on_WalmartProduct": [
                2395
            ],
            "__typename": [
                1
            ]
        },
        "ProductAnalyticsOverview": {
            "inTransit": [
                5
            ],
            "incoming": [
                5
            ],
            "netDepleted": [
                5
            ],
            "onHand": [
                5
            ],
            "costPerUnit": [
                5
            ],
            "onHandCost": [
                5
            ],
            "unavailable": [
                5
            ],
            "openingBalanceCost": [
                5
            ],
            "openingBalanceQuantity": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "ProductAppliedCost": {
            "asOfDate": [
                581
            ],
            "appliedCost": [
                5
            ],
            "source": [
                1772
            ],
            "type": [
                1773
            ],
            "isLocked": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ProductAppliedCostSource": {},
        "ProductAppliedCostType": {},
        "ProductAppliedCostWithDepletedCount": {
            "asOfDate": [
                581
            ],
            "appliedCost": [
                5
            ],
            "source": [
                1772
            ],
            "depletedCount": [
                41
            ],
            "type": [
                1773
            ],
            "isLocked": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ProductAssembliesBreakdownInput": {
            "companyId": [
                15
            ],
            "productId": [
                1
            ],
            "date": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ProductAssembliesBreakdownResult": {
            "manualAssemblies": [
                1375
            ],
            "onDemandAssemblies": [
                1478
            ],
            "__typename": [
                1
            ]
        },
        "ProductAttributesTypes": {},
        "ProductAutomergeMatchGroupSetting": {
            "matchGroupType": [
                1807
            ],
            "isEnabled": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ProductBulkAdjustmentStatusState": {},
        "ProductBulkAdjustmentStatusType": {},
        "ProductBulkEditCsvAttachment": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "filename": [
                1
            ],
            "url": [
                1
            ],
            "createdAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "summaryData": [
                1787
            ],
            "__typename": [
                1
            ]
        },
        "ProductBulkEditCsvAttachmentsInput": {
            "companyId": [
                15
            ],
            "type": [
                1784
            ],
            "displayDeleted": [
                7
            ],
            "managementMethodId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ProductBulkEditCsvAttachmentsResponse": {
            "attachments": [
                1781
            ],
            "__typename": [
                1
            ]
        },
        "ProductBulkEditCsvAttachmentType": {},
        "ProductBulkEditCsvErrorItem": {
            "rowNumber": [
                41
            ],
            "cellNumber": [
                41
            ],
            "errorType": [
                1786
            ],
            "__typename": [
                1
            ]
        },
        "ProductBulkEditCsvErrorItemType": {},
        "ProductBulkEditCsvSummary": {
            "totalCount": [
                41
            ],
            "validCount": [
                41
            ],
            "invalidCount": [
                41
            ],
            "errorCount": [
                41
            ],
            "errorItems": [
                1785
            ],
            "__typename": [
                1
            ]
        },
        "ProductBulkEditCsvUploadResponse": {
            "attachmentId": [
                15
            ],
            "summaryData": [
                1787
            ],
            "__typename": [
                1
            ]
        },
        "ProductDataTimeRangeInput": {
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ProductDeadInventoryAdjustment": {
            "id": [
                1
            ],
            "finaloopProductId": [
                1
            ],
            "date": [
                581
            ],
            "unitsDeadInventory": [
                5
            ],
            "warehouse": [
                2396
            ],
            "__typename": [
                1
            ]
        },
        "ProductDeadInventoryAdjustments": {
            "adjustments": [
                1790
            ],
            "__typename": [
                1
            ]
        },
        "ProductDonationAdjustment": {
            "finaloopProductId": [
                1
            ],
            "date": [
                581
            ],
            "unitsDonated": [
                41
            ],
            "warehouse": [
                2396
            ],
            "__typename": [
                1
            ]
        },
        "ProductDonationAdjustments": {
            "adjustments": [
                1792
            ],
            "__typename": [
                1
            ]
        },
        "ProductGiveawayAdjustment": {
            "finaloopProductId": [
                1
            ],
            "date": [
                581
            ],
            "unitsGiveaway": [
                41
            ],
            "warehouse": [
                2396
            ],
            "__typename": [
                1
            ]
        },
        "ProductGiveawayAdjustments": {
            "adjustments": [
                1794
            ],
            "__typename": [
                1
            ]
        },
        "ProductLineItemV3": {
            "id": [
                15
            ],
            "externalLineItemId": [
                1
            ],
            "name": [
                1
            ],
            "description": [
                1
            ],
            "amount": [
                107
            ],
            "parentId": [
                1
            ],
            "parentLineItemType": [
                1639
            ],
            "earliestPostedAt": [
                581
            ],
            "latestPostedAt": [
                581
            ],
            "statuses": [
                1251
            ],
            "fulfillments": [
                1545
            ],
            "timeline": [
                1547
            ],
            "product": [
                1769
            ],
            "sku": [
                1
            ],
            "externalProductId": [
                1
            ],
            "quantity": [
                41
            ],
            "originalQuantity": [
                41
            ],
            "unitPrice": [
                5
            ],
            "totalAmount": [
                5
            ],
            "type": [
                1549
            ],
            "__typename": [
                1
            ]
        },
        "ProductLostAndFoundAdjustment": {
            "finaloopProductId": [
                1
            ],
            "date": [
                581
            ],
            "unitsLost": [
                41
            ],
            "unitsFound": [
                41
            ],
            "warehouse": [
                2396
            ],
            "__typename": [
                1
            ]
        },
        "ProductLostAndFoundAdjustments": {
            "adjustments": [
                1797
            ],
            "__typename": [
                1
            ]
        },
        "ProductMergeHistoryItem": {
            "from": [
                581
            ],
            "to": [
                581
            ],
            "product": [
                1769
            ],
            "isPrimary": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ProductMergeLogItem": {
            "id": [
                1
            ],
            "products": [
                1801
            ],
            "date": [
                581
            ],
            "trigger": [
                1804
            ],
            "actor": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ProductMergeLogItemProduct": {
            "product": [
                1769
            ],
            "isPrimary": [
                7
            ],
            "date": [
                581
            ],
            "trigger": [
                1804
            ],
            "actor": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ProductMergeLogSortDirection": {},
        "ProductMergeLogSortField": {},
        "ProductMergeLogTrigger": {},
        "ProductMergeLogTriggerType": {},
        "ProductMergeRecommendations": {
            "matchGroups": [
                1808
            ],
            "__typename": [
                1
            ]
        },
        "ProductMergeRecommendationsGroupType": {},
        "ProductMergeRecommendationsMatchGroup": {
            "id": [
                1
            ],
            "type": [
                1807
            ],
            "mergeStartedAt": [
                581
            ],
            "mergeFinishedAt": [
                581
            ],
            "mergedCount": [
                41
            ],
            "errorCount": [
                41
            ],
            "totalCount": [
                41
            ],
            "deletedCount": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "ProductMergeRecommendationsProduct": {
            "product": [
                1769
            ],
            "isPrimary": [
                7
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ProductMergeRecommendationsProductGroup": {
            "id": [
                1
            ],
            "deletedAt": [
                581
            ],
            "products": [
                1809
            ],
            "__typename": [
                1
            ]
        },
        "ProductOtherFbaAdjustment": {
            "finaloopProductId": [
                1
            ],
            "date": [
                581
            ],
            "otherFbaIncoming": [
                41
            ],
            "otherFba": [
                41
            ],
            "warehouse": [
                2396
            ],
            "__typename": [
                1
            ]
        },
        "ProductOtherFbaAdjustments": {
            "adjustments": [
                1811
            ],
            "__typename": [
                1
            ]
        },
        "ProductPendingAdjustmentsCountBreakdownInput": {
            "companyId": [
                15
            ],
            "managementMethodId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ProductPendingAdjustmentsCountBreakdownResponse": {
            "salesAdjustmentsCount": [
                41
            ],
            "deadInventoryAdjustmentsCount": [
                41
            ],
            "giveawayAdjustmentsCount": [
                41
            ],
            "giveawayDropshippingAdjustmentsCount": [
                41
            ],
            "donationAdjustmentsCount": [
                41
            ],
            "totalCount": [
                41
            ],
            "salesAdjustmentsBreakdown": [
                1929
            ],
            "__typename": [
                1
            ]
        },
        "ProductPurchases": {
            "purchaseOrder": [
                1846
            ],
            "__typename": [
                1
            ]
        },
        "ProductQuantityFilter": {},
        "Products2Result": {
            "products": [
                1769
            ],
            "hasNext": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ProductSalesDataAdjustment": {
            "salesChannel": [
                1940
            ],
            "date": [
                581
            ],
            "unitsSold": [
                41
            ],
            "unitsRestocked": [
                41
            ],
            "warehouse": [
                2396
            ],
            "__typename": [
                1
            ]
        },
        "ProductSalesDataAdjustments": {
            "adjustments": [
                1818
            ],
            "__typename": [
                1
            ]
        },
        "ProductSource": {},
        "ProductSourceV3": {},
        "ProductsOverviewInput": {
            "companyId": [
                15
            ],
            "splitByIsDropshipping": [
                7
            ],
            "filter": [
                938
            ],
            "__typename": [
                1
            ]
        },
        "ProductsOverviewResponse": {
            "totalOnHandInventory": [
                5
            ],
            "totalNegativeOnHand": [
                5
            ],
            "productsWithoutCostCount": [
                41
            ],
            "totalProducts": [
                41
            ],
            "totalHidden": [
                41
            ],
            "totalGeneral": [
                41
            ],
            "totalDropshipping": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "ProductsResult": {
            "totalProducts": [
                41
            ],
            "productsWithoutCostCount": [
                41
            ],
            "totalOnHandInventory": [
                5
            ],
            "totalNegativeOnHand": [
                41
            ],
            "totalHidden": [
                41
            ],
            "products": [
                1769
            ],
            "hasNext": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ProductsSortDirection": {},
        "ProductStatusChangeInput": {
            "productId": [
                1
            ],
            "isHidden": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ProductsValidationData": {
            "skuData": [
                2092
            ],
            "ambiguousSkus": [
                1448
            ],
            "unknownSkus": [
                1448
            ],
            "__typename": [
                1
            ]
        },
        "ProductsValidationDataInput": {
            "companyId": [
                15
            ],
            "integrationType": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "isUIOperation": [
                7
            ],
            "timeRange": [
                1789
            ],
            "__typename": [
                1
            ]
        },
        "ProductTopPerformersFilter": {
            "companyId": [
                15
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "breakdown": [
                1
            ],
            "timezone": [
                1
            ],
            "comparisonPeriod": [
                1
            ],
            "stores": [
                1
            ],
            "source": [
                2096
            ],
            "salesChannels": [
                1
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "ProductTopPerformersResponse": {
            "title": [
                1
            ],
            "updatedAt": [
                581
            ],
            "data": [
                580
            ],
            "labels": [
                1
            ],
            "labelsIds": [
                1
            ],
            "skus": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ProductUnitCogs": {
            "amount": [
                5
            ],
            "quantity": [
                41
            ],
            "monthlyBreakdown": [
                1833
            ],
            "__typename": [
                1
            ]
        },
        "ProductUnitCogsDailyBreakdown": {
            "date": [
                581
            ],
            "quantity": [
                41
            ],
            "reason": [
                66
            ],
            "__typename": [
                1
            ]
        },
        "ProductUnitCogsMonthlyBreakdown": {
            "date": [
                581
            ],
            "quantity": [
                41
            ],
            "dailyData": [
                1832
            ],
            "__typename": [
                1
            ]
        },
        "ProductUnitsAdjustment": {
            "date": [
                581
            ],
            "unitsIn": [
                41
            ],
            "unitsOut": [
                41
            ],
            "warehouse": [
                2396
            ],
            "__typename": [
                1
            ]
        },
        "ProductUnitsAdjustments": {
            "adjustments": [
                1834
            ],
            "__typename": [
                1
            ]
        },
        "ProductV3": {
            "id": [
                1
            ],
            "integrationType": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "company": [
                418
            ],
            "sku": [
                1
            ],
            "price": [
                5
            ],
            "title": [
                1
            ],
            "source": [
                1821
            ],
            "imageUrl": [
                1
            ],
            "displayName": [
                1
            ],
            "platformId": [
                1
            ],
            "parentPlatformId": [
                1
            ],
            "amazonAsin": [
                1
            ],
            "shopifyProductId": [
                1
            ],
            "walmartItemId": [
                1
            ],
            "isFractional": [
                7
            ],
            "isBlacklisted": [
                7
            ],
            "isMerged": [
                7
            ],
            "isCreatedManually": [
                7
            ],
            "isTrackingIntegrationCost": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ProductWarehousesAnalyticsOverview": {
            "warehouse": [
                2396
            ],
            "analytics": [
                1770
            ],
            "__typename": [
                1
            ]
        },
        "PublishValidationStatusUpdateInput": {
            "status": [
                1
            ],
            "timestamp": [
                1
            ],
            "companyId": [
                1
            ],
            "companyName": [
                1
            ],
            "validationType": [
                1
            ],
            "yearEndValidationOf": [
                5
            ],
            "integrationAccountId": [
                1
            ],
            "content": [
                1
            ],
            "linearIdentifiers": [
                1249
            ],
            "__typename": [
                1
            ]
        },
        "PurchaseBasedClosingBalance": {
            "missionType": [
                1194
            ],
            "status": [
                1193
            ],
            "historyLog": [
                1190
            ],
            "managementMethodPeriod": [
                1367
            ],
            "openingBalance": [
                5
            ],
            "purchases": [
                5
            ],
            "cogs": [
                5
            ],
            "closingBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PurchaseBasedClosingBalanceInput": {
            "openingBalance": [
                5
            ],
            "purchases": [
                5
            ],
            "cogs": [
                5
            ],
            "closingBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PurchaseBasedOpeningBalance": {
            "missionType": [
                1194
            ],
            "status": [
                1193
            ],
            "historyLog": [
                1190
            ],
            "managementMethodPeriod": [
                1367
            ],
            "openingBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PurchaseBasedOpeningBalanceInput": {
            "openingBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PurchaseBasedPurchases": {
            "missionType": [
                1194
            ],
            "status": [
                1193
            ],
            "historyLog": [
                1190
            ],
            "managementMethodPeriod": [
                1367
            ],
            "purchases": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PurchaseBasedPurchasesInput": {
            "purchases": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PurchasedOffer": {
            "purchasedAt": [
                581
            ],
            "tier": [
                1470
            ],
            "features": [
                725
            ],
            "price": [
                5
            ],
            "title": [
                1
            ],
            "description": [
                1
            ],
            "recurrence": [
                1695
            ],
            "__typename": [
                1
            ]
        },
        "PurchaseOrder": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "displayName": [
                1
            ],
            "placementDate": [
                581
            ],
            "inProgressDate": [
                581
            ],
            "vendor": [
                2375
            ],
            "directLineItems": [
                644
            ],
            "indirectLineItems": [
                1066
            ],
            "shipments": [
                2036
            ],
            "directCostTotal": [
                5
            ],
            "indirectCostTotal": [
                5
            ],
            "landedCostTotal": [
                5
            ],
            "landedCostBreakdown": [
                1850
            ],
            "discountCostTotal": [
                5
            ],
            "status": [
                1854
            ],
            "publishedEventIds": [
                1
            ],
            "deletedAt": [
                581
            ],
            "isDeleted": [
                7
            ],
            "serialNumber": [
                41
            ],
            "notes": [
                1
            ],
            "attachments": [
                1847
            ],
            "inventoryPaymentGroupLinks": [
                1121
            ],
            "unpaidAmounts": [
                2211
            ],
            "__typename": [
                1
            ]
        },
        "PurchaseOrderAttachment": {
            "id": [
                15
            ],
            "filename": [
                1
            ],
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PurchaseOrderAttachmentInput": {
            "id": [
                1
            ],
            "filename": [
                1
            ],
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "PurchaseOrderInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "displayName": [
                1
            ],
            "placementDate": [
                581
            ],
            "vendorId": [
                15
            ],
            "directLineItems": [
                645
            ],
            "indirectLineItems": [
                1067
            ],
            "shipments": [
                2044
            ],
            "directCostTotal": [
                5
            ],
            "indirectCostTotal": [
                5
            ],
            "landedCostTotal": [
                5
            ],
            "discountCostTotal": [
                5
            ],
            "inProgressDate": [
                581
            ],
            "notes": [
                1
            ],
            "attachments": [
                1848
            ],
            "__typename": [
                1
            ]
        },
        "PurchaseOrderLandedCostBreakdown": {
            "inTransit": [
                5
            ],
            "inProcess": [
                5
            ],
            "received": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "PurchaseOrderOverview": {
            "status": [
                1854
            ],
            "landedCostTotal": [
                5
            ],
            "totalPurchaseOrders": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "PurchaseOrderOverviewV2": {
            "maxLandedCostTotal": [
                5
            ],
            "purchaseOrderOverview": [
                1851
            ],
            "__typename": [
                1
            ]
        },
        "PurchaseOrdersSortField": {},
        "PurchaseOrderStatus": {},
        "QuantityAndCost": {
            "quantity": [
                41
            ],
            "cost": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "Query": {
            "accrualsSpreadByTransactionIDs": [
                26,
                {
                    "input": [
                        787,
                        "GetAccrualsSpreadInput!"
                    ]
                }
            ],
            "getAccrualsByTransactionIDs": [
                14,
                {
                    "input": [
                        785,
                        "GetAccrualsByTransactionIDsInput!"
                    ]
                }
            ],
            "getAccrualsByEntityIDs": [
                29,
                {
                    "input": [
                        784,
                        "GetAccrualsByEntityIDsInput!"
                    ]
                }
            ],
            "getAccrualsList": [
                22,
                {
                    "input": [
                        786,
                        "GetAccrualsListInput!"
                    ]
                }
            ],
            "exportAccrualsListCsv": [
                696,
                {
                    "input": [
                        695,
                        "ExportAccrualsListCsvInput!"
                    ]
                }
            ],
            "adAccounts": [
                40,
                {
                    "input": [
                        42,
                        "AdAccountInput!"
                    ]
                }
            ],
            "adCampaigns": [
                43,
                {
                    "input": [
                        44,
                        "AdCampaignInput!"
                    ]
                }
            ],
            "adSets": [
                69,
                {
                    "input": [
                        70,
                        "AdSetInput!"
                    ]
                }
            ],
            "balanceSheetSetup": [
                154,
                {
                    "input": [
                        155,
                        "BalanceSheetSetupInput!"
                    ]
                }
            ],
            "getBalanceSheetSetupItemDocumentUrl": [
                798,
                {
                    "input": [
                        797,
                        "GetBalanceSheetSetupItemDocumentUrlInput!"
                    ]
                }
            ],
            "reportedBusinessBankTransactionsAccount": [
                161,
                {
                    "input": [
                        1903,
                        "ReportedBusinessBankTransactionsAccountInput!"
                    ]
                }
            ],
            "bankAccountInternal": [
                161,
                {
                    "input": [
                        169,
                        "BankAccountInternalInput!"
                    ]
                }
            ],
            "bankAccountsInternal": [
                161,
                {
                    "input": [
                        181,
                        "BankAccountsInternalInput!"
                    ]
                }
            ],
            "institutionVendorsIds": [
                1082,
                {
                    "vendorId": [
                        15
                    ]
                }
            ],
            "institutionMappings": [
                1076,
                {
                    "input": [
                        1077
                    ]
                }
            ],
            "institutionById": [
                1074,
                {
                    "id": [
                        15,
                        "ID!"
                    ]
                }
            ],
            "bankStatementParsingRequest": [
                250,
                {
                    "input": [
                        800,
                        "GetBankStatementParsingRequestInput!"
                    ]
                }
            ],
            "bankStatementParsingResults": [
                254,
                {
                    "input": [
                        801,
                        "GetBankStatementParsingResultsInput!"
                    ]
                }
            ],
            "backOfficeBankStatementRequests": [
                796,
                {
                    "input": [
                        795,
                        "GetBackOfficeBankStatementRequestsInput!"
                    ]
                }
            ],
            "backOfficeBankStatementRequestsFilters": [
                146
            ],
            "bankReconciliationStatementFiles": [
                1881,
                {
                    "input": [
                        799,
                        "GetBankAccountStatementFilesInput!"
                    ]
                }
            ],
            "bankReconciliationRequestsSettings": [
                225,
                {
                    "input": [
                        224,
                        "BankReconciliationRequestSettingsInput!"
                    ]
                }
            ],
            "companyHasBankingMission": [
                210,
                {
                    "input": [
                        443,
                        "CompanyHasBankingMissionInput!"
                    ]
                }
            ],
            "isDomainBanksEnabledForBalanceSheetSetup": [
                7,
                {
                    "input": [
                        155,
                        "BalanceSheetSetupInput!"
                    ]
                }
            ],
            "evaluateBankReconciliationRequestsDryRun": [
                683,
                {
                    "input": [
                        682,
                        "EvaluateBankReconciliationRequestsInput!"
                    ]
                }
            ],
            "explainBankAccountMerge": [
                691,
                {
                    "input": [
                        689,
                        "ExplainBankAccountMergeInput!"
                    ]
                }
            ],
            "bankingAudits": [
                204,
                {
                    "input": [
                        206,
                        "BankingAuditsInput!"
                    ]
                }
            ],
            "bankStatementFileById": [
                235,
                {
                    "input": [
                        237,
                        "BankStatementFileByIdInput!"
                    ]
                }
            ],
            "bankStatementFilesByCompanyId": [
                235,
                {
                    "input": [
                        236,
                        "BankStatementFileByCompanyIdInput!"
                    ]
                }
            ],
            "bankStatementFiles": [
                235,
                {
                    "input": [
                        242,
                        "BankStatementFilesInput!"
                    ]
                }
            ],
            "bankAccount": [
                161,
                {
                    "input": [
                        168,
                        "BankAccountInput!"
                    ]
                }
            ],
            "bankAccounts": [
                161,
                {
                    "input": [
                        180,
                        "BankAccountsInput!"
                    ]
                }
            ],
            "bankAccountsByIds": [
                161,
                {
                    "input": [
                        179,
                        "BankAccountsByIdsInput!"
                    ]
                }
            ],
            "bankAccountReconciliations": [
                176,
                {
                    "input": [
                        177,
                        "BankAccountReconciliationsInput!"
                    ]
                }
            ],
            "bankAccountBalance": [
                5,
                {
                    "input": [
                        163,
                        "BankAccountBalanceInput!"
                    ]
                }
            ],
            "institutions": [
                1081,
                {
                    "input": [
                        1080
                    ]
                }
            ],
            "bankReconciliationRequest": [
                216,
                {
                    "input": [
                        221,
                        "BankReconciliationRequestInput!"
                    ]
                }
            ],
            "bankReconciliationRequests": [
                216,
                {
                    "input": [
                        226,
                        "BankReconciliationRequestsInput!"
                    ]
                }
            ],
            "bankConnections": [
                192,
                {
                    "input": [
                        199,
                        "BankConnectionsInput!"
                    ]
                }
            ],
            "bankOverviewPageAccounts": [
                211,
                {
                    "input": [
                        212,
                        "BankOverviewPageInput!"
                    ]
                }
            ],
            "bankConnectionMetrics": [
                207,
                {
                    "input": [
                        198,
                        "BankConnectionMetricsInput!"
                    ]
                }
            ],
            "bankReconciliationGraphPoints": [
                214,
                {
                    "input": [
                        215,
                        "BankReconciliationGraphPointsInput!"
                    ]
                }
            ],
            "bankTransaction": [
                270,
                {
                    "getBankTransactionInput": [
                        282,
                        "BankTransactionInput!"
                    ]
                }
            ],
            "bankTransactions": [
                287,
                {
                    "input": [
                        290,
                        "BankTransactionsInput!"
                    ]
                }
            ],
            "bankTransactionsByMerchant": [
                275,
                {
                    "bankTransactionsByMerchantInput": [
                        288,
                        "BankTransactionsByMerchantInput!"
                    ]
                }
            ],
            "searchMerchants": [
                1405,
                {
                    "input": [
                        1977,
                        "SearchMerchantsInput!"
                    ]
                }
            ],
            "merchantBankTransactionRecommendations": [
                286,
                {
                    "input": [
                        1406,
                        "MerchantBankTransactionRecommendationsInput!"
                    ]
                }
            ],
            "searchVendorsTransactionsPriority": [
                1979,
                {
                    "input": [
                        1978,
                        "SearchVendorsTransactionPriorityInput!"
                    ]
                }
            ],
            "classificationTags": [
                392,
                {
                    "input": [
                        396
                    ]
                }
            ],
            "classificationTagsByIds": [
                392,
                {
                    "input": [
                        395,
                        "ClassificationTagsByIdsInput!"
                    ]
                }
            ],
            "internalTransferCandidates": [
                287,
                {
                    "input": [
                        1114,
                        "InternalTransferCandidatesInput!"
                    ]
                }
            ],
            "internalTransferCandidatesV2": [
                291,
                {
                    "input": [
                        1115,
                        "internalTransferCandidatesV2Input!"
                    ]
                }
            ],
            "unidentifiedBankTransactionsGroups": [
                2177,
                {
                    "input": [
                        2178,
                        "UnidentifiedBankTransactionsGroupsInput!"
                    ]
                }
            ],
            "merchantsBankTransactionStats": [
                1411,
                {
                    "input": [
                        1412,
                        "MerchantsBankTransactionStatsInput!"
                    ]
                }
            ],
            "bankTransactionsSummary": [
                293,
                {
                    "input": [
                        290,
                        "BankTransactionsInput!"
                    ]
                }
            ],
            "merchantsByIds": [
                1405,
                {
                    "input": [
                        1413,
                        "MerchantsByIdsInput!"
                    ]
                }
            ],
            "suggestBankTransactionClassification": [
                397,
                {
                    "input": [
                        2124,
                        "SuggestBankTransactionClassificationInput!"
                    ]
                }
            ],
            "lastMachineClassificationJob": [
                1362,
                {
                    "input": [
                        1361,
                        "MachineClassificationInput!"
                    ]
                }
            ],
            "convertBetweenCurrencies": [
                497,
                {
                    "input": [
                        496,
                        "ConvertBetweenCurrenciesInput!"
                    ]
                }
            ],
            "merchantsByKeys": [
                1405,
                {
                    "input": [
                        1414,
                        "MerchantsByKeysInput!"
                    ]
                }
            ],
            "bankTransactionsByPairings": [
                285,
                {
                    "input": [
                        289,
                        "BankTransactionsByPairingsInput!"
                    ]
                }
            ],
            "isGlobalRuleExistByVendorAndMoneyDirection": [
                1234,
                {
                    "input": [
                        1010,
                        "GlobalRuleExistByVendorAndMoneyDirectionInput!"
                    ]
                }
            ],
            "paypalTransactionCurrencies": [
                549,
                {
                    "input": [
                        1698,
                        "PaypalTransactionCurrenciesInput!"
                    ]
                }
            ],
            "bankTransactionUploadFileById": [
                294,
                {
                    "input": [
                        295,
                        "BankTransactionsUploadFileInput!"
                    ]
                }
            ],
            "companyByStripeCustomerId": [
                418,
                {
                    "args": [
                        437,
                        "CompanyByStripeCustomerIdInput!"
                    ]
                }
            ],
            "stripeCustomerIdsByCompanyIds": [
                2119,
                {
                    "args": [
                        2118,
                        "StripeCustomerIdsByCompanyIdsInput!"
                    ]
                }
            ],
            "offers": [
                900,
                {
                    "args": [
                        899,
                        "GetOffersInput!"
                    ]
                }
            ],
            "billsByIds": [
                312,
                {
                    "input": [
                        15,
                        "[ID!]!"
                    ]
                }
            ],
            "bill": [
                312,
                {
                    "input": [
                        320,
                        "BillInput!"
                    ]
                }
            ],
            "billsDueDateSummary": [
                330,
                {
                    "input": [
                        331,
                        "BillsDueDateSummaryInput!"
                    ]
                }
            ],
            "processBillContent": [
                1766,
                {
                    "input": [
                        1765,
                        "ProcessBillContentInput!"
                    ]
                }
            ],
            "bills": [
                807,
                {
                    "input": [
                        806,
                        "GetBillsInput!"
                    ]
                }
            ],
            "billsAgingReportCSV": [
                145,
                {
                    "args": [
                        329,
                        "BillsAgingReportInput!"
                    ]
                }
            ],
            "billsYearEndTasks": [
                336,
                {
                    "input": [
                        335,
                        "BillsYearEndTasksInput!"
                    ]
                }
            ],
            "businessEventDefinitions": [
                353
            ],
            "businessEventDefinitionsByIds": [
                353,
                {
                    "input": [
                        355,
                        "BusinessEventDefinitionsByIds!"
                    ]
                }
            ],
            "businessEventDefinitionsByGroups": [
                353,
                {
                    "input": [
                        354,
                        "BusinessEventDefinitionsByGroups!"
                    ]
                }
            ],
            "businessEventActionsConfigurations": [
                348
            ],
            "businessEventActionsConfigurationByType": [
                348,
                {
                    "input": [
                        349,
                        "BusinessEventActionsConfigurationByType!"
                    ]
                }
            ],
            "accountRoles": [
                10
            ],
            "classificationBusinessEventDefinitions": [
                353
            ],
            "businessEventsAccrualsConfig": [
                359
            ],
            "getBusinessEventsAccrualsConfig": [
                360,
                {
                    "input": [
                        809,
                        "GetBusinessEventsAccrualsConfigInput!"
                    ]
                }
            ],
            "accountRole": [
                10,
                {
                    "input": [
                        783,
                        "GetAccountRoleInput!"
                    ]
                }
            ],
            "businessEvents": [
                348,
                {
                    "input": [
                        808,
                        "[GetBusinessEventInput!]!"
                    ]
                }
            ],
            "company": [
                418,
                {
                    "args": [
                        822,
                        "GetCompanyInput!"
                    ]
                }
            ],
            "getCompanyAddresses": [
                420,
                {
                    "input": [
                        447,
                        "CompanyIdInput!"
                    ]
                }
            ],
            "getCompanyDefaultAddress": [
                420,
                {
                    "input": [
                        447,
                        "CompanyIdInput!"
                    ]
                }
            ],
            "signedDownloadUrl": [
                1,
                {
                    "args": [
                        2077,
                        "SignedDownloadUrlInput!"
                    ]
                }
            ],
            "onboardingStatus": [
                1474,
                {
                    "input": [
                        902,
                        "GetOnboardingStatusInput!"
                    ]
                }
            ],
            "listCompanies": [
                418,
                {
                    "args": [
                        1280
                    ]
                }
            ],
            "getCompanies": [
                418,
                {
                    "args": [
                        820
                    ]
                }
            ],
            "getCompaniesByIds": [
                418,
                {
                    "args": [
                        819,
                        "GetCompaniesByIdsInput!"
                    ]
                }
            ],
            "healthStatus": [
                444,
                {
                    "input": [
                        847,
                        "GetHealthStatusInput!"
                    ]
                }
            ],
            "getLatestValidation": [
                877,
                {
                    "input": [
                        876,
                        "GetLatestValidationInput!"
                    ]
                }
            ],
            "validationTemplates": [
                2372,
                {
                    "input": [
                        976,
                        "GetValidationTemplatesInput!"
                    ]
                }
            ],
            "failingValidationsByValidationCycle": [
                724,
                {
                    "input": [
                        836,
                        "GetFailingValidationsByValidationCycleInput!"
                    ]
                }
            ],
            "failingValidationsByValidationTemplate": [
                724,
                {
                    "input": [
                        837,
                        "GetFailingValidationsByValidationTemplateInput!"
                    ]
                }
            ],
            "getEntitiesLockedPeriodBypasses": [
                676,
                {
                    "args": [
                        833,
                        "GetEntitiesLockedPeriodBypassesInput!"
                    ]
                }
            ],
            "listReadyValidations": [
                1859,
                {
                    "input": [
                        1284,
                        "ListReadyValidationsInput!"
                    ]
                }
            ],
            "getReadyValidation": [
                946,
                {
                    "input": [
                        945,
                        "GetReadyValidationInput!"
                    ]
                }
            ],
            "companyMainHolder": [
                422,
                {
                    "input": [
                        461,
                        "CompanyMainHolderInput!"
                    ]
                }
            ],
            "companyAffiliatesByIds": [
                422,
                {
                    "input": [
                        424,
                        "CompanyAffiliatesByIdsInput!"
                    ]
                }
            ],
            "holderTransactionsByIds": [
                1044,
                {
                    "input": [
                        1045,
                        "HolderTransactionsByIdsInput!"
                    ]
                }
            ],
            "holderSharesByIds": [
                1040,
                {
                    "input": [
                        1041,
                        "HolderSharesByIdsInput!"
                    ]
                }
            ],
            "holderCapitalInvestmentsByIds": [
                1035,
                {
                    "input": [
                        1036,
                        "HolderCapitalInvestmentsByIdsInput!"
                    ]
                }
            ],
            "holderSafeInvestmentsByIds": [
                1038,
                {
                    "input": [
                        1039,
                        "HolderSafeInvestmentsByIdsInput!"
                    ]
                }
            ],
            "equityEventsEffectConfigurations": [
                677,
                {
                    "input": [
                        678,
                        "EquityEventsEffectConfigurationsInput!"
                    ]
                }
            ],
            "manualEquityEvents": [
                1379,
                {
                    "input": [
                        1380,
                        "ManualEquityEventsInput!"
                    ]
                }
            ],
            "affiliatedEntityByIds": [
                72,
                {
                    "input": [
                        74,
                        "AffiliatedEntityByIdsInput!"
                    ]
                }
            ],
            "companyAffiliates": [
                422,
                {
                    "input": [
                        425,
                        "CompanyAffiliatesInput!"
                    ]
                }
            ],
            "companyAffiliate": [
                422,
                {
                    "input": [
                        423,
                        "CompanyAffiliateInput!"
                    ]
                }
            ],
            "holderShares": [
                1040,
                {
                    "input": [
                        1042,
                        "HolderSharesInput!"
                    ]
                }
            ],
            "holderCapitalInvestments": [
                1035,
                {
                    "input": [
                        1037,
                        "HolderCapitalInvestmentsInput!"
                    ]
                }
            ],
            "holderTransactions": [
                1044,
                {
                    "input": [
                        1046,
                        "HolderTransactionsInput!"
                    ]
                }
            ],
            "affiliatedEntityById": [
                72,
                {
                    "input": [
                        73,
                        "AffiliatedEntityByIdInput!"
                    ]
                }
            ],
            "companyIntegration": [
                448,
                {
                    "input": [
                        450,
                        "CompanyIntegrationInput!"
                    ]
                }
            ],
            "companyIntegrations": [
                448,
                {
                    "input": [
                        451,
                        "CompanyIntegrationsInput!"
                    ]
                }
            ],
            "closingBalancesByIds": [
                406,
                {
                    "input": [
                        811,
                        "GetClosingBalancesByIdsInput!"
                    ]
                }
            ],
            "payrollConnections": [
                1704,
                {
                    "input": [
                        1707,
                        "PayrollConnectionsInput!"
                    ]
                }
            ],
            "integrationConnectionAccounts": [
                1084,
                {
                    "input": [
                        1085,
                        "IntegrationConnectionsFilter!"
                    ]
                }
            ],
            "integrationTransfersByCompanyAffiliate": [
                1098,
                {
                    "input": [
                        1107,
                        "IntegrationTransfersByCompanyAffiliateInput!"
                    ]
                }
            ],
            "integrationTransfersBackoffice": [
                1098,
                {
                    "input": [
                        850,
                        "GetIntegrationTransfersBackofficeInput!"
                    ]
                }
            ],
            "integrationTransfer": [
                1098,
                {
                    "input": [
                        849,
                        "GetIntegrationTransferInput!"
                    ]
                }
            ],
            "integrationTransfers": [
                1098,
                {
                    "input": [
                        852,
                        "GetIntegrationTransfersInput!"
                    ]
                }
            ],
            "groupedIntegrationTransfers": [
                1101,
                {
                    "input": [
                        852,
                        "GetIntegrationTransfersInput!"
                    ]
                }
            ],
            "finaloopProductInternal": [
                748,
                {
                    "input": [
                        749,
                        "FinaloopProductInternalInput!"
                    ]
                }
            ],
            "inventoryPurchasesForCompany": [
                1131,
                {
                    "input": [
                        860,
                        "GetInventoryPurchasesForCompanyInput!"
                    ]
                }
            ],
            "inventoryPurchasesByIds": [
                1131,
                {
                    "input": [
                        856,
                        "GetInventoryPurchasesByIdsInput!"
                    ]
                }
            ],
            "runAmazonProductsValidationDiagnostics": [
                1916,
                {
                    "input": [
                        1915,
                        "RunProductsValidationDiagnosticsInput!"
                    ]
                }
            ],
            "runShopifyProductsValidationDiagnostics": [
                1916,
                {
                    "input": [
                        1915,
                        "RunProductsValidationDiagnosticsInput!"
                    ]
                }
            ],
            "getCOGSBreakdown2": [
                813,
                {
                    "input": [
                        812,
                        "GetCOGSBreakdownRequest!"
                    ]
                }
            ],
            "exportCOGSBreakdown": [
                701,
                {
                    "input": [
                        700,
                        "ExportCOGSBreakdownRequest!"
                    ]
                }
            ],
            "getCOGSOverview2": [
                818,
                {
                    "input": [
                        817,
                        "GetCOGSOverviewRequest!"
                    ]
                }
            ],
            "exportCOGSOverview": [
                703,
                {
                    "input": [
                        702,
                        "ExportCOGSOverviewRequest!"
                    ]
                }
            ],
            "product": [
                1769,
                {
                    "input": [
                        929,
                        "GetProductInput!"
                    ]
                }
            ],
            "productAssembliesInventoryBreakdown": [
                1776,
                {
                    "input": [
                        1775,
                        "ProductAssembliesBreakdownInput!"
                    ]
                }
            ],
            "productsCsv": [
                713,
                {
                    "input": [
                        939,
                        "GetProductsInput!"
                    ]
                }
            ],
            "products2": [
                1817,
                {
                    "input": [
                        939,
                        "GetProductsInput!"
                    ]
                }
            ],
            "productsOverview": [
                1823,
                {
                    "input": [
                        1822,
                        "ProductsOverviewInput!"
                    ]
                }
            ],
            "salesChannels": [
                1940,
                {
                    "input": [
                        1954,
                        "SalesChannelsInput!"
                    ]
                }
            ],
            "currentlyRunningInventoryDataSync": [
                551,
                {
                    "input": [
                        550,
                        "CurrentlyRunningInventoryDataSyncInput!"
                    ]
                }
            ],
            "currentlyRunningInventoryDataSyncVendors": [
                552,
                {
                    "input": [
                        550,
                        "CurrentlyRunningInventoryDataSyncInput!"
                    ]
                }
            ],
            "inventoryAccountBalance": [
                854,
                {
                    "input": [
                        853,
                        "GetInventoryAccountBalanceInput!"
                    ]
                }
            ],
            "getOnboardingStatuses": [
                1475,
                {
                    "input": [
                        901,
                        "GetOnboardingStatusesInput!"
                    ]
                }
            ],
            "nonMatchedProducts": [
                1449,
                {
                    "input": [
                        891,
                        "GetNonMatchingProductsInput!"
                    ]
                }
            ],
            "getFromEmailAddress": [
                842,
                {
                    "input": [
                        840,
                        "GetFromEmailAddressInput!"
                    ]
                }
            ],
            "productBulkEditCsvAttachments": [
                1783,
                {
                    "input": [
                        1782,
                        "ProductBulkEditCsvAttachmentsInput!"
                    ]
                }
            ],
            "listOnDemandAssemblyCosts": [
                1480,
                {
                    "input": [
                        1273,
                        "ListAssemblyCostsInput!"
                    ]
                }
            ],
            "listOnDemandAssemblyVendorCosts": [
                1482,
                {
                    "input": [
                        1273,
                        "ListAssemblyCostsInput!"
                    ]
                }
            ],
            "listManualAssemblies": [
                1282,
                {
                    "input": [
                        1273,
                        "ListAssemblyCostsInput!"
                    ]
                }
            ],
            "listAssemblies": [
                1271,
                {
                    "input": [
                        1270,
                        "ListAssembliesInput!"
                    ]
                }
            ],
            "listAssemblyItems": [
                1276,
                {
                    "input": [
                        1275,
                        "ListAssemblyItemsInput!"
                    ]
                }
            ],
            "missingCostsInPeriod": [
                1433,
                {
                    "input": [
                        1432,
                        "MissingCostsInPeriodInput!"
                    ]
                }
            ],
            "dropshippingSettings": [
                665,
                {
                    "input": [
                        666,
                        "DropshippingSettingsInput!"
                    ]
                }
            ],
            "purchaseOrder": [
                1846,
                {
                    "input": [
                        942,
                        "GetPurchaseOrderInput!"
                    ]
                }
            ],
            "purchaseOrdersV2": [
                1846,
                {
                    "input": [
                        943,
                        "GetPurchaseOrdersInput!"
                    ]
                }
            ],
            "purchaseOrdersV2Total": [
                41,
                {
                    "input": [
                        943,
                        "GetPurchaseOrdersInput!"
                    ]
                }
            ],
            "purchaseOrdersOverviewV2": [
                1852,
                {
                    "input": [
                        944,
                        "GetPurchaseOrdersOverviewInput!"
                    ]
                }
            ],
            "exportPurchaseOrders": [
                715,
                {
                    "input": [
                        714,
                        "ExportPurchaseOrdersInput!"
                    ]
                }
            ],
            "inventoryPurchases": [
                1153,
                {
                    "input": [
                        861,
                        "GetInventoryPurchasesInput!"
                    ]
                }
            ],
            "inventoryPurchasesExport": [
                1149,
                {
                    "input": [
                        858,
                        "GetInventoryPurchasesExportInput!"
                    ]
                }
            ],
            "inventoryPurchasesSummary": [
                1157,
                {
                    "input": [
                        862,
                        "GetInventoryPurchaseSummaryInput!"
                    ]
                }
            ],
            "inventoryPurchaseRules": [
                1146,
                {
                    "input": [
                        855,
                        "GetInventoryPurchaseRulesInput!"
                    ]
                }
            ],
            "isPaymentGroupLinkExist": [
                7,
                {
                    "input": [
                        1237,
                        "IsPaymentGroupLinkExistInput!"
                    ]
                }
            ],
            "inventoryPurchaseVendors": [
                1163,
                {
                    "input": [
                        863,
                        "GetInventoryPurchaseVendorsInput!"
                    ]
                }
            ],
            "inventoryPurchasesCountByVendor": [
                1148,
                {
                    "input": [
                        857,
                        "GetInventoryPurchasesCountByVendorInput!"
                    ]
                }
            ],
            "inventoryOverviewCycles": [
                1632,
                {
                    "input": [
                        1633,
                        "OverviewCyclesInput!"
                    ]
                }
            ],
            "shopifyProductsValidationConnections": [
                2066,
                {
                    "input": [
                        2065,
                        "ShopifyProductsValidationConnectionsInput!"
                    ]
                }
            ],
            "shopifyItemsReconciliation": [
                2068,
                {
                    "input": [
                        2050,
                        "ShopifyItemsReconciliationInput!"
                    ]
                }
            ],
            "shopifyItemsReconciliationOrders": [
                2056,
                {
                    "input": [
                        2055,
                        "ShopifyItemsReconciliationOrdersInput!"
                    ]
                }
            ],
            "shopifyItemsReconciliationOrdersDiff": [
                2053,
                {
                    "input": [
                        2052,
                        "ShopifyItemsReconciliationOrdersDiffInput!"
                    ]
                }
            ],
            "amazonProductsReconciliation": [
                91,
                {
                    "input": [
                        104,
                        "AmazonValidationInput!"
                    ]
                }
            ],
            "amazonAvailableValidationData": [
                87,
                {
                    "input": [
                        86,
                        "AmazonAvailableValidationDataInput!"
                    ]
                }
            ],
            "amazonOrdersDiff": [
                89,
                {
                    "input": [
                        104,
                        "AmazonValidationInput!"
                    ]
                }
            ],
            "amazonCustomerShipmentReportLink": [
                1902,
                {
                    "input": [
                        104,
                        "AmazonValidationInput!"
                    ]
                }
            ],
            "amazonLedgerReportLink": [
                1902,
                {
                    "input": [
                        104,
                        "AmazonValidationInput!"
                    ]
                }
            ],
            "amazonCustomerReturnsReportLink": [
                1902,
                {
                    "input": [
                        104,
                        "AmazonValidationInput!"
                    ]
                }
            ],
            "listValidationRemediations": [
                2368,
                {
                    "input": [
                        1286,
                        "ListValidationRemediationsInput!"
                    ]
                }
            ],
            "inventoryVendorsOverview": [
                1183,
                {
                    "input": [
                        871,
                        "GetInventoryVendorsOverviewInput!"
                    ]
                }
            ],
            "inventoryVendors": [
                1184,
                {
                    "input": [
                        870,
                        "GetInventoryVendorsInput!"
                    ]
                }
            ],
            "inventoryVendorRollingBalance": [
                1182,
                {
                    "input": [
                        868,
                        "GetInventoryVendorRollingBalanceInput!"
                    ]
                }
            ],
            "inventoryVendorRollingBalanceOverview": [
                1181,
                {
                    "input": [
                        869,
                        "GetInventoryVendorRollingBalanceOverviewInput!"
                    ]
                }
            ],
            "inventoryVendorBills": [
                1172,
                {
                    "input": [
                        864,
                        "GetInventoryVendorBillsInput!"
                    ]
                }
            ],
            "inventoryVendorBillsOverview": [
                1171,
                {
                    "input": [
                        865,
                        "GetInventoryVendorBillsOverviewInput!"
                    ]
                }
            ],
            "inventoryVendorFilterValues": [
                1174,
                {
                    "input": [
                        866,
                        "GetInventoryVendorFilterValuesInput!"
                    ]
                }
            ],
            "inventoryVendorParams": [
                1176,
                {
                    "input": [
                        867,
                        "GetInventoryVendorParamsInput!"
                    ]
                }
            ],
            "warehouseOpeningBalanceOverview": [
                2417,
                {
                    "input": [
                        980,
                        "GetWarehouseOpeningBalanceOverviewInput!"
                    ]
                }
            ],
            "warehouseOpeningBalances": [
                2422,
                {
                    "input": [
                        981,
                        "GetWarehouseOpeningBalancesInput!"
                    ]
                }
            ],
            "pendingWarehouseOpeningBalancesAttachments": [
                1749,
                {
                    "input": [
                        924,
                        "GetPendingWarehouseOpeningBalancesAttachmentsInput!"
                    ]
                }
            ],
            "getWarehouseOpeningBalancesCsvTemplate": [
                2419,
                {
                    "input": [
                        980,
                        "GetWarehouseOpeningBalanceOverviewInput!"
                    ]
                }
            ],
            "exportWarehouseOpeningBalancesCsv": [
                2418,
                {
                    "input": [
                        721,
                        "ExportWarehouseOpeningBalancesCsvInput!"
                    ]
                }
            ],
            "warehouseTransfersOverview": [
                2457,
                {
                    "input": [
                        417,
                        "CommonWarehouseTransfersFilterInput!"
                    ]
                }
            ],
            "warehouseTransfers": [
                2458,
                {
                    "input": [
                        985,
                        "GetWarehouseTransfersInput!"
                    ]
                }
            ],
            "warehouseTransfer": [
                2435,
                {
                    "input": [
                        984,
                        "GetWarehouseTransferInput!"
                    ]
                }
            ],
            "pendingSalesDataAdjustmentsV2": [
                1747,
                {
                    "input": [
                        920,
                        "GetPendingSalesDataAdjustmentsInputV2!"
                    ]
                }
            ],
            "pendingSalesDataAdjustmentsByIds": [
                1744,
                {
                    "input": [
                        914,
                        "GetPendingAdjustmentsByIdsInput!"
                    ]
                }
            ],
            "pendingDeadInventoryAdjustments": [
                1729,
                {
                    "input": [
                        916,
                        "GetPendingAdjustmentsInput!"
                    ]
                }
            ],
            "pendingDeadInventoryAdjustmentsByIds": [
                1727,
                {
                    "input": [
                        914,
                        "GetPendingAdjustmentsByIdsInput!"
                    ]
                }
            ],
            "pendingGiveawayAdjustments": [
                1737,
                {
                    "input": [
                        916,
                        "GetPendingAdjustmentsInput!"
                    ]
                }
            ],
            "pendingGiveawayAdjustmentsByIds": [
                1735,
                {
                    "input": [
                        914,
                        "GetPendingAdjustmentsByIdsInput!"
                    ]
                }
            ],
            "pendingGiveawayDropshippingAdjustments": [
                1741,
                {
                    "input": [
                        916,
                        "GetPendingAdjustmentsInput!"
                    ]
                }
            ],
            "pendingGiveawayDropshippingAdjustmentsByIds": [
                1735,
                {
                    "input": [
                        914,
                        "GetPendingAdjustmentsByIdsInput!"
                    ]
                }
            ],
            "pendingDonationAdjustments": [
                1733,
                {
                    "input": [
                        916,
                        "GetPendingAdjustmentsInput!"
                    ]
                }
            ],
            "pendingDonationAdjustmentsByIds": [
                1731,
                {
                    "input": [
                        914,
                        "GetPendingAdjustmentsByIdsInput!"
                    ]
                }
            ],
            "pendingSalesDataAdjustmentsOverviewV2": [
                1725,
                {
                    "input": [
                        921,
                        "GetPendingSalesDataAdjustmentsOverviewInputV2!"
                    ]
                }
            ],
            "pendingDeadInventoryAdjustmentsOverview": [
                1725,
                {
                    "input": [
                        917,
                        "GetPendingAdjustmentsOverviewInput!"
                    ]
                }
            ],
            "pendingGiveawayAdjustmentsOverview": [
                1725,
                {
                    "input": [
                        917,
                        "GetPendingAdjustmentsOverviewInput!"
                    ]
                }
            ],
            "pendingGiveawayDropshippingAdjustmentsOverview": [
                1725,
                {
                    "input": [
                        917,
                        "GetPendingAdjustmentsOverviewInput!"
                    ]
                }
            ],
            "pendingDonationAdjustmentsOverview": [
                1725,
                {
                    "input": [
                        917,
                        "GetPendingAdjustmentsOverviewInput!"
                    ]
                }
            ],
            "productBulkAdjustmentStatus": [
                927,
                {
                    "input": [
                        928,
                        "GetProductBulkAdjustmentStatusInput!"
                    ]
                }
            ],
            "salesAdjustmentsCsvTemplate": [
                342,
                {
                    "input": [
                        341,
                        "BulkEditCsvTemplateInput!"
                    ]
                }
            ],
            "deadInventoryAdjustmentsCsvTemplate": [
                342,
                {
                    "input": [
                        341,
                        "BulkEditCsvTemplateInput!"
                    ]
                }
            ],
            "giveawayAdjustmentsCsvTemplate": [
                342,
                {
                    "input": [
                        341,
                        "BulkEditCsvTemplateInput!"
                    ]
                }
            ],
            "donationAdjustmentsCsvTemplate": [
                342,
                {
                    "input": [
                        341,
                        "BulkEditCsvTemplateInput!"
                    ]
                }
            ],
            "productPendingAdjustmentsCountBreakdown": [
                1814,
                {
                    "input": [
                        1813,
                        "ProductPendingAdjustmentsCountBreakdownInput!"
                    ]
                }
            ],
            "listNoUnitsPhysicalCounts": [
                1463,
                {
                    "input": [
                        1283,
                        "ListNoUnitsPhysicalCountsInput!"
                    ]
                }
            ],
            "noUnitsPhysicalCount": [
                1456,
                {
                    "input": [
                        894,
                        "GetNoUnitsPhysicalCountInput!"
                    ]
                }
            ],
            "noUnitsPhysicalCountProductQuantities": [
                1460,
                {
                    "input": [
                        896,
                        "GetNoUnitsPhysicalCountProductQuantitiesInput!"
                    ]
                }
            ],
            "exportNoUnitsTrackingPhysicalCountProductQuantities": [
                704,
                {
                    "input": [
                        712,
                        "ExportNoUnitsTrackingPhysicalCountProductQuantitiesInput!"
                    ]
                }
            ],
            "noUnitsPhysicalCountOverview": [
                1459,
                {
                    "input": [
                        895,
                        "GetNoUnitsPhysicalCountOverviewInput!"
                    ]
                }
            ],
            "getNoUnitsPhysicalCountClosingBalance": [
                1458,
                {
                    "input": [
                        893,
                        "GetNoUnitsPhysicalCountClosingBalanceInput!"
                    ]
                }
            ],
            "getNoUnitsPhysicalCountAnyActiveProductsWithoutQuantities": [
                111,
                {
                    "input": [
                        892,
                        "GetNoUnitsPhysicalCountAnyActiveProductsWithoutQuantitiesInput!"
                    ]
                }
            ],
            "listUnitsTrackingPhysicalCounts": [
                2195,
                {
                    "input": [
                        1285,
                        "ListUnitsTrackingPhysicalCountsInput!"
                    ]
                }
            ],
            "unitsTrackingPhysicalCount": [
                2190,
                {
                    "input": [
                        967,
                        "GetUnitsTrackingPhysicalCountInput!"
                    ]
                }
            ],
            "unitsTrackingPhysicalCountProductQuantities": [
                2193,
                {
                    "input": [
                        969,
                        "GetUnitsTrackingPhysicalCountProductQuantitiesInput!"
                    ]
                }
            ],
            "exportUnitsTrackingPhysicalCountProductQuantities": [
                704,
                {
                    "input": [
                        720,
                        "ExportUnitsTrackingPhysicalCountProductQuantitiesInput!"
                    ]
                }
            ],
            "unitsTrackingPhysicalCountOverview": [
                2192,
                {
                    "input": [
                        968,
                        "GetUnitsTrackingPhysicalCountOverviewInput!"
                    ]
                }
            ],
            "physicalCountCsvTemplate": [
                342,
                {
                    "input": [
                        341,
                        "BulkEditCsvTemplateInput!"
                    ]
                }
            ],
            "hasUnacknowledgedChanges": [
                7,
                {
                    "input": [
                        1031,
                        "HasUnacknowledgedChangesInput!"
                    ]
                }
            ],
            "warehouses": [
                2423,
                {
                    "input": [
                        983,
                        "GetWarehousesInput!"
                    ]
                }
            ],
            "warehouseDefaults": [
                2429,
                {
                    "input": [
                        982,
                        "GetWarehousesDefaultsInput!"
                    ]
                }
            ],
            "inventoryPaymentGroupById": [
                1120,
                {
                    "input": [
                        1119,
                        "InventoryPaymentGroupByIdInput!"
                    ]
                }
            ],
            "inventoryPaymentGroupsByIds": [
                1123,
                {
                    "input": [
                        1122,
                        "InventoryPaymentGroupsByIdsInput!"
                    ]
                }
            ],
            "validateInventoryPaymentGroupByEntity": [
                2361,
                {
                    "input": [
                        2360,
                        "ValidateInventoryPaymentGroupByEntityInput!"
                    ]
                }
            ],
            "inventoryYearEndMissions": [
                1192,
                {
                    "input": [
                        1191,
                        "InventoryYearEndMissionsInput!"
                    ]
                }
            ],
            "explainFifo": [
                694,
                {
                    "input": [
                        693,
                        "ExplainFifoInput!"
                    ]
                }
            ],
            "warehouseIncomingInventoryOverview": [
                2408,
                {
                    "input": [
                        2407,
                        "WarehouseIncomingInventoryOverviewInput!"
                    ]
                }
            ],
            "warehouseIncomingInventoryBreakdown": [
                2406,
                {
                    "input": [
                        2405,
                        "WarehouseIncomingInventoryBreakdownInput!"
                    ]
                }
            ],
            "productMergeRecommendationsMatchGroup": [
                937,
                {
                    "input": [
                        936,
                        "GetProductMergeRecommendationsMatchGroupInput!"
                    ]
                }
            ],
            "productMergeLogs": [
                934,
                {
                    "input": [
                        931,
                        "GetProductMergeLogsInput!"
                    ]
                }
            ],
            "productMergeLogsOverview": [
                933,
                {
                    "input": [
                        932,
                        "GetProductMergeLogsOverviewInput!"
                    ]
                }
            ],
            "productAutomergeSettings": [
                926,
                {
                    "input": [
                        925,
                        "GetProductAutomergeSettingsInput!"
                    ]
                }
            ],
            "hasProductMergeRecommendations": [
                1030,
                {
                    "input": [
                        1029,
                        "HasProductMergeRecommendationsInput!"
                    ]
                }
            ],
            "productMergeRecommendations": [
                1806,
                {
                    "input": [
                        781,
                        "GenerateProductMergeRecommendationsInput!"
                    ]
                }
            ],
            "loans": [
                1332,
                {
                    "input": [
                        885,
                        "GetLoansInput!"
                    ]
                }
            ],
            "getMatchingEffectRule": [
                890,
                {
                    "input": [
                        888,
                        "GetMatchingEffectRuleInput!"
                    ]
                }
            ],
            "loansEventsEffectConfiguration": [
                1329
            ],
            "getLoansById": [
                1328,
                {
                    "input": [
                        883,
                        "GetLoansByIdInput!"
                    ]
                }
            ],
            "exportLoans": [
                711,
                {
                    "input": [
                        710,
                        "ExportLoansCsvInput!"
                    ]
                }
            ],
            "getLoanEvents": [
                881,
                {
                    "input": [
                        878,
                        "GetLoanEventsInput!"
                    ]
                }
            ],
            "getLoanRelationships": [
                882,
                {
                    "input": [
                        878,
                        "GetLoanEventsInput!"
                    ]
                }
            ],
            "getAllocatableEventIds": [
                792,
                {
                    "input": [
                        791,
                        "GetAllocatableEventIdsInput!"
                    ]
                }
            ],
            "getLoanEventsLength": [
                880,
                {
                    "input": [
                        879,
                        "GetLoanEventsLengthInput!"
                    ]
                }
            ],
            "loanEventDefinitions": [
                1309
            ],
            "getLoansUpdatedBy": [
                1
            ],
            "knownLenders": [
                1446
            ],
            "companyLoans": [
                457,
                {
                    "input": [
                        824,
                        "GetCompanyLoansInput!"
                    ]
                }
            ],
            "companyLoan": [
                456,
                {
                    "input": [
                        823,
                        "GetCompanyLoanInput!"
                    ]
                }
            ],
            "getAttachmentTargetURLS": [
                139,
                {
                    "input": [
                        794,
                        "GetAttachmentTargetURLSInput!"
                    ]
                }
            ],
            "downloadAttachment": [
                663,
                {
                    "input": [
                        662,
                        "DownloadAttachmentInput!"
                    ]
                }
            ],
            "getLoansOutstandingAmountOnDate": [
                887,
                {
                    "input": [
                        886,
                        "GetLoansOutstandingAmountOnDateInput!"
                    ]
                }
            ],
            "getLoanTransactionStatuses": [
                1336,
                {
                    "transactionIds": [
                        15,
                        "[ID!]!"
                    ]
                }
            ],
            "prevalidateCompanyLoan": [
                1768,
                {
                    "input": [
                        1764,
                        "PrevalidateCompanyLoanInput!"
                    ]
                }
            ],
            "getCompanyFundedStatus": [
                442,
                {
                    "input": [
                        821,
                        "GetCompanyFundedStatusInput!"
                    ]
                }
            ],
            "companyArCashDiffs": [
                432,
                {
                    "input": [
                        430,
                        "CompanyArCashDiffsInput!"
                    ]
                }
            ],
            "giftCardsByIds": [
                992,
                {
                    "input": [
                        991,
                        "GiftCardsByIdsInput!"
                    ]
                }
            ],
            "shopifyReportDateLimits": [
                2071,
                {
                    "input": [
                        2070,
                        "ShopifyReportDateLimitsInput!"
                    ]
                }
            ],
            "shopifyReconciliationData": [
                1562,
                {
                    "input": [
                        1561,
                        "OrderReconciliationsInput!"
                    ]
                }
            ],
            "paymentProcessorByCompanyAndVendor": [
                1694,
                {
                    "input": [
                        1693,
                        "PaymentProcessorByCompanyAndVendorInput!"
                    ]
                }
            ],
            "vendorByPaymentGateway": [
                2380,
                {
                    "input": [
                        2379,
                        "VendorByPaymentGatewayInput!"
                    ]
                }
            ],
            "salesChannelsByCompanyAndIntegration": [
                1953,
                {
                    "input": [
                        1952,
                        "SalesChannelsByCompanyAndIntegrationInput!"
                    ]
                }
            ],
            "paymentGatewaysByCompanyIntegrationAndSalesChannel": [
                1,
                {
                    "input": [
                        1648,
                        "PaymentGatewaysByCompanyIntegrationAndSalesChannelInput!"
                    ]
                }
            ],
            "getOrdersV2": [
                908,
                {
                    "input": [
                        907,
                        "GetOrdersInput!"
                    ]
                }
            ],
            "getUnpaidOrdersCsv": [
                974,
                {
                    "input": [
                        973,
                        "GetUnpaidOrdersCsvInput!"
                    ]
                }
            ],
            "getUnpaidOrdersAgingCsv": [
                974,
                {
                    "input": [
                        972,
                        "GetUnpaidOrdersAgingCsvInput!"
                    ]
                }
            ],
            "giftCardsCsv": [
                994,
                {
                    "input": [
                        993,
                        "GiftCardsCsvInput!"
                    ]
                }
            ],
            "getOrdersAggregations": [
                1497,
                {
                    "input": [
                        904,
                        "GetOrdersAggregationsInput!"
                    ]
                }
            ],
            "getOrderById": [
                1604,
                {
                    "input": [
                        1534,
                        "OrderIdInput!"
                    ]
                }
            ],
            "getFinaloopTags": [
                1593,
                {
                    "input": [
                        447,
                        "CompanyIdInput!"
                    ]
                }
            ],
            "getIntegrationTags": [
                1593,
                {
                    "input": [
                        848,
                        "GetIntegrationTagsInput!"
                    ]
                }
            ],
            "getFinaloopPaymentGateways": [
                1,
                {
                    "input": [
                        447,
                        "CompanyIdInput!"
                    ]
                }
            ],
            "getOrderSalesChannels": [
                1,
                {
                    "input": [
                        447,
                        "CompanyIdInput!"
                    ]
                }
            ],
            "getOrderFilteringBounds": [
                903,
                {
                    "input": [
                        447,
                        "CompanyIdInput!"
                    ]
                }
            ],
            "getFulfillmentSettings": [
                845,
                {
                    "input": [
                        844,
                        "GetFulfillmentSettingInput!"
                    ]
                }
            ],
            "isCompanyFulfillmentSettingsApplied": [
                7,
                {
                    "input": [
                        1233,
                        "IsCompanyFulfillmentSettingsAppliedInput!"
                    ]
                }
            ],
            "ordersByIds": [
                1572,
                {
                    "input": [
                        1571,
                        "OrdersByIdsInput!"
                    ]
                }
            ],
            "orderGroupById": [
                1514,
                {
                    "input": [
                        1513,
                        "OrderGroupByIdInput!"
                    ]
                }
            ],
            "orderGroupsByIds": [
                1522,
                {
                    "input": [
                        1521,
                        "OrderGroupsByIdsInput!"
                    ]
                }
            ],
            "orderGroups": [
                1525,
                {
                    "input": [
                        1524,
                        "OrderGroupsInput!"
                    ]
                }
            ],
            "orderGroupsUnclearedBalance": [
                1532,
                {
                    "input": [
                        1531,
                        "OrderGroupsUnclearedBalanceInput!"
                    ]
                }
            ],
            "orderGroupsTotalUnclearedBalance": [
                1530,
                {
                    "input": [
                        1529,
                        "OrderGroupsTotalUnclearedBalanceInput!"
                    ]
                }
            ],
            "ordersYearEnd": [
                1592,
                {
                    "input": [
                        1591,
                        "OrdersYearEndInput!"
                    ]
                }
            ],
            "giftCards": [
                1000,
                {
                    "input": [
                        996,
                        "GiftCardsInput!"
                    ]
                }
            ],
            "giftCardAggregations": [
                988,
                {
                    "input": [
                        987,
                        "GiftCardAggregationsInput!"
                    ]
                }
            ],
            "giftCardsMaximumCompanyBalance": [
                998,
                {
                    "input": [
                        997,
                        "GiftCardsMaximumCompanyBalanceInput!"
                    ]
                }
            ],
            "hasOrdersInOrderGroups": [
                1028,
                {
                    "input": [
                        1027,
                        "HasOrdersInOrderGroupsInput!"
                    ]
                }
            ],
            "orders": [
                1581,
                {
                    "input": [
                        1579,
                        "OrdersInput!"
                    ]
                }
            ],
            "orderById": [
                2089,
                {
                    "input": [
                        1534,
                        "OrderIdInput!"
                    ]
                }
            ],
            "filteringBoundsOrderV3": [
                744,
                {
                    "input": [
                        743,
                        "FilteringBoundsInput!"
                    ]
                }
            ],
            "paymentGroupLinks": [
                1670,
                {
                    "input": [
                        1669,
                        "PaymentGroupLinksInput!"
                    ]
                }
            ],
            "getInvoicesAffectingPaymentGroups": [
                873,
                {
                    "input": [
                        872,
                        "GetInvoicesAffectingPaymentGroupsInput!"
                    ]
                }
            ],
            "getPaymentGroupsByIds": [
                1676,
                {
                    "input": [
                        1675,
                        "PaymentGroupsByIdsInput!"
                    ]
                }
            ],
            "orderPaymentGroupById": [
                1553,
                {
                    "input": [
                        1652,
                        "PaymentGroupByIdInput!"
                    ]
                }
            ],
            "orderPaymentGroupsByIds": [
                1554,
                {
                    "input": [
                        1675,
                        "PaymentGroupsByIdsInput!"
                    ]
                }
            ],
            "orderPaymentGroups": [
                1555,
                {
                    "input": [
                        1678,
                        "PaymentGroupsInput!"
                    ]
                }
            ],
            "orderPaymentGroupsUnclearedBalance": [
                1556,
                {
                    "input": [
                        1684,
                        "PaymentGroupsUnclearedBalanceInput!"
                    ]
                }
            ],
            "orderPaymentGroupsTotalUnclearedBalance": [
                1683,
                {
                    "input": [
                        1682,
                        "PaymentGroupsTotalUnclearedBalanceInput!"
                    ]
                }
            ],
            "invoicePaymentGroupById": [
                1207,
                {
                    "input": [
                        1652,
                        "PaymentGroupByIdInput!"
                    ]
                }
            ],
            "invoicePaymentGroupsByIds": [
                1208,
                {
                    "input": [
                        1675,
                        "PaymentGroupsByIdsInput!"
                    ]
                }
            ],
            "invoicePaymentGroups": [
                1209,
                {
                    "input": [
                        1678,
                        "PaymentGroupsInput!"
                    ]
                }
            ],
            "invoicePaymentGroupsUnclearedBalance": [
                1210,
                {
                    "input": [
                        1684,
                        "PaymentGroupsUnclearedBalanceInput!"
                    ]
                }
            ],
            "invoicePaymentGroupsTotalUnclearedBalance": [
                1683,
                {
                    "input": [
                        1682,
                        "PaymentGroupsTotalUnclearedBalanceInput!"
                    ]
                }
            ],
            "artificialTransactionsByMonth": [
                123,
                {
                    "input": [
                        793,
                        "GetArtificialTransactionsInput!"
                    ]
                }
            ],
            "paymentsByIds": [
                1640,
                {
                    "input": [
                        913,
                        "GetPaymentsByIdsInput!"
                    ]
                }
            ],
            "refundsByIds": [
                1892,
                {
                    "input": [
                        947,
                        "GetRefundsByIdsInput!"
                    ]
                }
            ],
            "integrationTransfersByIds": [
                1112,
                {
                    "input": [
                        851,
                        "GetIntegrationTransfersByIdsInput!"
                    ]
                }
            ],
            "disputesByIds": [
                656,
                {
                    "input": [
                        832,
                        "GetDisputesByIdsInput!"
                    ]
                }
            ],
            "paymentFeesByIds": [
                1644,
                {
                    "input": [
                        913,
                        "GetPaymentsByIdsInput!"
                    ]
                }
            ],
            "chargebacksByIds": [
                376,
                {
                    "input": [
                        810,
                        "GetChargebacksByIdsInput!"
                    ]
                }
            ],
            "paymentChecks": [
                1641,
                {
                    "input": [
                        1642,
                        "PaymentChecksInput!"
                    ]
                }
            ],
            "payrollDailyAggregatesByEmploymentTypeAndCategory": [
                1709,
                {
                    "input": [
                        1710,
                        "PayrollDailyDataInput!"
                    ]
                }
            ],
            "payrollIdsByCompany": [
                1717,
                {
                    "input": [
                        1715,
                        "PayrollIdsByCompanyInput!"
                    ]
                }
            ],
            "contractorPaymentsInternal": [
                493,
                {
                    "input": [
                        492,
                        "ContractorPaymentsInternalInput!"
                    ]
                }
            ],
            "contractorPaymentIdsByCompany": [
                491,
                {
                    "input": [
                        489,
                        "ContractorPaymentIdsByCompanyInput!"
                    ]
                }
            ],
            "paymentsByEmployee": [
                578,
                {
                    "input": [
                        1696,
                        "PaymentsByEntityInput!"
                    ]
                }
            ],
            "paymentsByContractor": [
                577,
                {
                    "input": [
                        1696,
                        "PaymentsByEntityInput!"
                    ]
                }
            ],
            "payrollSettings": [
                1722,
                {
                    "input": [
                        1723,
                        "PayrollSettingsInput!"
                    ]
                }
            ],
            "validations": [
                2369,
                {
                    "args": [
                        2371,
                        "ValidationsArgs!"
                    ]
                }
            ],
            "periodicPartnerReports": [
                1754
            ],
            "periodicReportsPartners": [
                1905
            ],
            "exportCashFlow": [
                716,
                {
                    "args": [
                        698,
                        "ExportCashFlowApiArgs!"
                    ]
                }
            ],
            "exportBalanceSheet": [
                145,
                {
                    "args": [
                        697,
                        "ExportBalanceSheetApiArgs!"
                    ]
                }
            ],
            "ledgerAccountTransactionsCSV": [
                145,
                {
                    "args": [
                        709,
                        "ExportLedgerAccountTransactionsInput!"
                    ]
                }
            ],
            "checkExportStatus": [
                145,
                {
                    "args": [
                        379,
                        "CheckAwaitedExportStatusInput!"
                    ]
                }
            ],
            "syncReportDefinition": [
                1969,
                {
                    "args": [
                        2134,
                        "SyncReportInput!"
                    ]
                }
            ],
            "lastAccountingReportSync": [
                1244,
                {
                    "args": [
                        1243,
                        "LastAccountingReportSyncInput!"
                    ]
                }
            ],
            "chartData": [
                378,
                {
                    "args": [
                        377,
                        "ChartDataInput!"
                    ]
                }
            ],
            "getExportedReportsLogs": [
                835,
                {
                    "args": [
                        834,
                        "GetExportedReportsInput!"
                    ]
                }
            ],
            "getSignedUrlByExportedReportsLogId": [
                965,
                {
                    "id": [
                        1,
                        "String!"
                    ]
                }
            ],
            "skuAnalysis": [
                79,
                {
                    "args": [
                        78,
                        "AllSkusInput!"
                    ]
                }
            ],
            "exportSkuAnalysis": [
                718,
                {
                    "args": [
                        717,
                        "ExportSkuAnalysisInput!"
                    ]
                }
            ],
            "skuAnalysisByDate": [
                1070,
                {
                    "args": [
                        1069,
                        "IndividualSkusInput!"
                    ]
                }
            ],
            "bestSellers": [
                1830,
                {
                    "args": [
                        1829,
                        "ProductTopPerformersFilter!"
                    ]
                }
            ],
            "unitsSold": [
                1830,
                {
                    "args": [
                        1829,
                        "ProductTopPerformersFilter!"
                    ]
                }
            ],
            "highestProfit": [
                1830,
                {
                    "args": [
                        1829,
                        "ProductTopPerformersFilter!"
                    ]
                }
            ],
            "bestMargin": [
                1830,
                {
                    "args": [
                        1829,
                        "ProductTopPerformersFilter!"
                    ]
                }
            ],
            "customerInternal": [
                554,
                {
                    "args": [
                        830,
                        "GetCustomerInternal!"
                    ]
                }
            ],
            "sellingFeesByIds": [
                1982,
                {
                    "input": [
                        961,
                        "GetSellingFeesByIdsInput!"
                    ]
                }
            ],
            "fulfillmentCostsByIds": [
                761,
                {
                    "input": [
                        843,
                        "GetFulfillmentCostsByIdsInput!"
                    ]
                }
            ],
            "shippingCostsByIds": [
                2045,
                {
                    "input": [
                        962,
                        "GetShippingCostsByIdsInput!"
                    ]
                }
            ],
            "getCustomers": [
                554,
                {
                    "getCustomerArgs": [
                        827,
                        "GetCustomerArgs!"
                    ]
                }
            ],
            "getCustomerById": [
                831,
                {
                    "id": [
                        15,
                        "ID!"
                    ]
                }
            ],
            "searchCustomers": [
                563,
                {
                    "input": [
                        1976,
                        "SearchCustomersInput!"
                    ]
                }
            ],
            "getCustomerV2ById": [
                563,
                {
                    "input": [
                        828,
                        "GetCustomerByIdInput!"
                    ]
                }
            ],
            "getCustomerV2ByIds": [
                563,
                {
                    "input": [
                        829,
                        "GetCustomerByIdsInput!"
                    ]
                }
            ],
            "sale": [
                1918,
                {
                    "input": [
                        1921,
                        "SaleInput!"
                    ]
                }
            ],
            "getSales": [
                957,
                {
                    "input": [
                        956,
                        "GetSalesInput!"
                    ]
                }
            ],
            "invoice": [
                1198,
                {
                    "input": [
                        1202,
                        "InvoiceInput!"
                    ]
                }
            ],
            "getInvoices": [
                875,
                {
                    "input": [
                        956,
                        "GetSalesInput!"
                    ]
                }
            ],
            "getInvoicePdfUrl": [
                1,
                {
                    "input": [
                        1214,
                        "InvoicePdfInput!"
                    ]
                }
            ],
            "getPaymentMethods": [
                1689,
                {
                    "input": [
                        447,
                        "CompanyIdInput!"
                    ]
                }
            ],
            "calculateInvoice": [
                1198,
                {
                    "input": [
                        361,
                        "CalculateInvoiceInput!"
                    ]
                }
            ],
            "getInvoicesCsv": [
                708,
                {
                    "input": [
                        956,
                        "GetSalesInput!"
                    ]
                }
            ],
            "getInvoiceAggregations": [
                1218,
                {
                    "input": [
                        948,
                        "GetSaleAggregationsInput!"
                    ]
                }
            ],
            "getInvoicesBalance": [
                1219,
                {
                    "input": [
                        948,
                        "GetSaleAggregationsInput!"
                    ]
                }
            ],
            "invoicesAgingReportCSV": [
                145,
                {
                    "args": [
                        956,
                        "GetSalesInput!"
                    ]
                }
            ],
            "salesChannel": [
                1945,
                {
                    "input": [
                        1921,
                        "SaleInput!"
                    ]
                }
            ],
            "getSalesChannels": [
                1945,
                {
                    "input": [
                        953,
                        "GetSalesChannelsInput!"
                    ]
                }
            ],
            "getSalesChannelTemplates": [
                1957,
                {
                    "input": [
                        954,
                        "GetSalesChannelTemplatesInput!"
                    ]
                }
            ],
            "invoiceSettings": [
                1220,
                {
                    "input": [
                        874,
                        "GetInvoiceSettingsInput!"
                    ]
                }
            ],
            "getInvoiceExamplePdfUrl": [
                1,
                {
                    "input": [
                        1221,
                        "InvoicesInput!"
                    ]
                }
            ],
            "invoicesYearEndTasks": [
                1226,
                {
                    "input": [
                        1225,
                        "InvoicesYearEndTasksInput!"
                    ]
                }
            ],
            "testSPSCommerceOrgConnection": [
                2148,
                {
                    "input": [
                        2147,
                        "TestSPSCommerceOrgConnectionInput!"
                    ]
                }
            ],
            "me": [
                1416
            ],
            "isInvitationCodeForRegisteredUser": [
                1236,
                {
                    "args": [
                        1235,
                        "IsInvitationCodeForRegisteredUserArgs!"
                    ]
                }
            ],
            "companyUsers": [
                467,
                {
                    "args": [
                        466
                    ]
                }
            ],
            "userInvitationByCode": [
                2346,
                {
                    "args": [
                        2345,
                        "UserInvitationArgs!"
                    ]
                }
            ],
            "userReferralLink": [
                2354,
                {
                    "args": [
                        2353
                    ]
                }
            ],
            "userInvitationsByEmail": [
                2348,
                {
                    "args": [
                        2347,
                        "UserInvitationsByEmailArgs!"
                    ]
                }
            ],
            "userRoles": [
                2356
            ],
            "auth0UserLookup": [
                144,
                {
                    "args": [
                        143,
                        "Auth0UserLookupInput!"
                    ]
                }
            ],
            "googleConnectStatus": [
                1015
            ],
            "googleConnectionLink": [
                1014,
                {
                    "input": [
                        1013
                    ]
                }
            ],
            "calendlyEventDetails": [
                363,
                {
                    "args": [
                        362,
                        "CalendlyEventInput!"
                    ]
                }
            ],
            "userNameFromReferralCode": [
                2352,
                {
                    "args": [
                        2351,
                        "UserNameFromReferralCodeInput!"
                    ]
                }
            ],
            "userByEmail": [
                2339,
                {
                    "args": [
                        2338,
                        "UserByEmailArgs!"
                    ]
                }
            ],
            "usersByEmails": [
                2358,
                {
                    "args": [
                        2357,
                        "UsersByEmailsArgs!"
                    ]
                }
            ],
            "latestActiveCompanyUser": [
                1247,
                {
                    "args": [
                        1246,
                        "LatestActiveCompanyUserArgs!"
                    ]
                }
            ],
            "vendors": [
                2375,
                {
                    "input": [
                        2384,
                        "VendorsInput!"
                    ]
                }
            ],
            "vendor": [
                978,
                {
                    "input": [
                        977,
                        "GetVendorInput!"
                    ]
                }
            ],
            "vendorsByIds": [
                2375,
                {
                    "input": [
                        979,
                        "GetVendorsInput!"
                    ]
                }
            ],
            "vendorsBySubtype": [
                2375,
                {
                    "companyId": [
                        15,
                        "ID!"
                    ],
                    "subTypes": [
                        2388,
                        "[VendorSubType!]!"
                    ]
                }
            ],
            "tax1099AffiliatedEntityGroups": [
                2143,
                {
                    "input": [
                        966,
                        "GetTax1099AffiliatedEntityGroupsInput!"
                    ]
                }
            ],
            "institutionVendors": [
                2375
            ],
            "vendorById": [
                2375,
                {
                    "input": [
                        2377,
                        "VendorByIdInput!"
                    ]
                }
            ],
            "vendorByAffiliatedEntityId": [
                2375,
                {
                    "input": [
                        2376,
                        "VendorByAffiliatedEntityIdInput!"
                    ]
                }
            ],
            "vendorByName": [
                2375,
                {
                    "input": [
                        2378,
                        "VendorByNameInput!"
                    ]
                }
            ],
            "globalVendorsByIds": [
                2375,
                {
                    "input": [
                        846,
                        "GetGlobalVendorsInput!"
                    ]
                }
            ],
            "vendorsByIntegrationType": [
                2375,
                {
                    "input": [
                        2383,
                        "VendorsByIntegrationTypeInput!"
                    ]
                }
            ],
            "getCompanyWorksheets": [
                476,
                {
                    "args": [
                        826,
                        "GetCompanyWorksheetsArgs!"
                    ]
                }
            ],
            "getCompanyLockConditions": [
                458,
                {
                    "args": [
                        825,
                        "GetCompanyLockConditionsArgs!"
                    ]
                }
            ],
            "getSignedDates": [
                964,
                {
                    "args": [
                        963,
                        "GetSignedDatesInput!"
                    ]
                }
            ],
            "getWorksheets": [
                2470,
                {
                    "input": [
                        826,
                        "GetCompanyWorksheetsArgs!"
                    ]
                }
            ],
            "getAllCompaniesForDomain": [
                790,
                {
                    "args": [
                        789,
                        "GetAllCompaniesForDomainInput!"
                    ]
                }
            ],
            "yearEnd": [
                2503,
                {
                    "args": [
                        2502,
                        "YearEndStateInput!"
                    ]
                }
            ],
            "yearEndDomainStateDatum": [
                2482,
                {
                    "args": [
                        2485,
                        "YearEndDomainStateDatumInput!"
                    ]
                }
            ],
            "yearEndDomainStateData": [
                2482,
                {
                    "args": [
                        2481,
                        "YearEndDomainStateDataInput!"
                    ]
                }
            ],
            "yearEndStates": [
                755,
                {
                    "args": [
                        2504,
                        "YearEndStatesInput!"
                    ]
                }
            ],
            "__typename": [
                1
            ]
        },
        "RangedManagementMethod": {
            "managementMethod": [
                1366
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "RangedManagementMethodInput": {
            "managementMethod": [
                1366
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ReadyValidation": {
            "id": [
                15
            ],
            "from": [
                581
            ],
            "to": [
                581
            ],
            "generatedAt": [
                581
            ],
            "generatedBy": [
                1
            ],
            "isGreen": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "RealtimeCogsStatus": {
            "isAmazonEnabled": [
                7
            ],
            "isShopifyEnabled": [
                7
            ],
            "isWalmartEnabled": [
                7
            ],
            "isTikTokEnabled": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "Recipe": {
            "id": [
                1
            ],
            "from": [
                581
            ],
            "to": [
                581
            ],
            "isAssembledOnDemand": [
                7
            ],
            "product": [
                1769
            ],
            "warehouse": [
                2396
            ],
            "components": [
                1869
            ],
            "managementMethod": [
                1871
            ],
            "displayName": [
                1
            ],
            "deletedReason": [
                132
            ],
            "manualAssemblyId": [
                1
            ],
            "totalAssembled": [
                5
            ],
            "allocatedCosts": [
                1862
            ],
            "additionalAllocatedCostsPerUnit": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "RecipeAllocatedCost": {
            "affiliatedEntity": [
                72
            ],
            "type": [
                1865
            ],
            "costPerUnit": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "RecipeAllocatedCostInput": {
            "costPerUnit": [
                5
            ],
            "type": [
                1865
            ],
            "affiliatedEntityId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "RecipeAllocatedCostsError": {
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "RecipeAllocatedCostType": {},
        "RecipeBreakdown": {
            "quantity": [
                5
            ],
            "wasteQuantity": [
                5
            ],
            "costPerUnit": [
                5
            ],
            "product": [
                1769
            ],
            "warehouse": [
                2396
            ],
            "__typename": [
                1
            ]
        },
        "RecipeCirclesFoundError": {
            "data": [
                1868
            ],
            "__typename": [
                1
            ]
        },
        "RecipeCirclesFoundErrorData": {
            "recipe": [
                1861
            ],
            "product": [
                1769
            ],
            "__typename": [
                1
            ]
        },
        "RecipeComponent": {
            "product": [
                1769
            ],
            "warehouse": [
                2396
            ],
            "quantity": [
                5
            ],
            "wasteQuantity": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "RecipeComponentInput": {
            "productId": [
                1
            ],
            "warehouseId": [
                1
            ],
            "quantity": [
                5
            ],
            "wasteQuantity": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "RecipeManagementMethod": {},
        "RecipeOverlappingError": {
            "recipes": [
                1861
            ],
            "__typename": [
                1
            ]
        },
        "RecipeWithBreakdown": {
            "recipe": [
                1861
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "warehouse": [
                2396
            ],
            "breakdown": [
                1866
            ],
            "affiliatedEntities": [
                72
            ],
            "__typename": [
                1
            ]
        },
        "RecommendationSource": {},
        "RecommendedBy": {},
        "ReconcileAllInventoryPurchasesInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ReconcileInventoryPurchasesFromBillsInput": {
            "billItemsToReconcile": [
                321
            ],
            "__typename": [
                1
            ]
        },
        "ReconcileInventoryPurchasesFromBusinessEventsInput": {
            "businessEventItemsToReconcile": [
                357
            ],
            "__typename": [
                1
            ]
        },
        "ReconcileInventoryPurchasesFromPayrollsInput": {
            "payrollItemsToReconcile": [
                1720
            ],
            "__typename": [
                1
            ]
        },
        "ReconcileInventoryPurchasesFromTransactionsInput": {
            "transactionItemsToReconcile": [
                2161
            ],
            "__typename": [
                1
            ]
        },
        "ReconciliationRequestStatementFile": {
            "id": [
                1
            ],
            "requestId": [
                1
            ],
            "s3Bucket": [
                1
            ],
            "s3Key": [
                1
            ],
            "fileName": [
                1
            ],
            "fileType": [
                182
            ],
            "status": [
                219
            ],
            "machineStatus": [
                222
            ],
            "providerValidationResults": [
                267
            ],
            "createdAt": [
                581
            ],
            "uploadOriginator": [
                266
            ],
            "companyAffiliate": [
                422
            ],
            "__typename": [
                1
            ]
        },
        "ReconciliationStatus": {},
        "ReconciliationSummary": {
            "totalInReport": [
                41
            ],
            "isGreen": [
                7
            ],
            "inBooks": [
                41
            ],
            "unfulfilledInBooks": [
                41
            ],
            "voided": [
                41
            ],
            "restocked": [
                41
            ],
            "excluded": [
                41
            ],
            "totalInDb": [
                41
            ],
            "fulfilled": [
                41
            ],
            "fulfilledNotSold": [
                41
            ],
            "soldNotFulfilled": [
                41
            ],
            "zeroNet": [
                41
            ],
            "zeroNetFulfilled": [
                41
            ],
            "zeroNetNotSold": [
                41
            ],
            "zeroNetNotFulfilled": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "RecordTax1099AffiliatedEntityGroupIdentifierInput": {
            "id": [
                15
            ],
            "type": [
                2144
            ],
            "isGroup": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "RecordTax1099AffiliatedEntityGroupInput": {
            "companyId": [
                15
            ],
            "identifiers": [
                1884
            ],
            "calendarYear": [
                41
            ],
            "isDone": [
                7
            ],
            "disqualifyReason": [
                2139
            ],
            "resetDisqualifyReason": [
                7
            ],
            "file": [
                2142
            ],
            "resetFile": [
                7
            ],
            "finaloopComment": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "RecurrenceSettings": {
            "recurrence": [
                1311
            ],
            "totalRecurrences": [
                41
            ],
            "cutOffDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "RecurrenceSettingsInput": {
            "recurrence": [
                1311
            ],
            "totalRecurrences": [
                41
            ],
            "cutOffDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "RecurringPayment": {
            "yearly": [
                1643
            ],
            "monthly": [
                1643
            ],
            "yearlyDiscount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "ReferUserArgs": {
            "email": [
                1
            ],
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "referUserResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "RefreshSkuAmbiguityInput": {
            "companyId": [
                15
            ],
            "productId": [
                1
            ],
            "skus": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Refund": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "source": [
                1113
            ],
            "integrationAccountId": [
                15
            ],
            "integrationAccountName": [
                1
            ],
            "amount": [
                5
            ],
            "currency": [
                1
            ],
            "postedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "Reimbursement": {
            "id": [
                1
            ],
            "source": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "postedAt": [
                581
            ],
            "amount": [
                5
            ],
            "isClearedByNetPayPayment": [
                7
            ],
            "employee": [
                673
            ],
            "contractor": [
                487
            ],
            "contractorPayment": [
                488
            ],
            "payroll": [
                1699
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "RelatedParty": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "RemediateValidationInput": {
            "companyIds": [
                15
            ],
            "validationDomain": [
                1
            ],
            "validationType": [
                1
            ],
            "fiscalYears": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "RemoveDataRestrictionInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "RemoveDropshippingSettingsInput": {
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "RemoveUserArgs": {
            "email": [
                1
            ],
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "RemoveUserResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ReplaceBankAccountLocksByTypeInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                15
            ],
            "locks": [
                171
            ],
            "lockType": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ReplaceBankAccountLocksInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                15
            ],
            "locks": [
                172
            ],
            "__typename": [
                1
            ]
        },
        "Report": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ReportedBusinessBankTransactionsAccountInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ReportHierarchyNode": {
            "name": [
                1
            ],
            "reportType": [
                1907
            ],
            "breakdownType": [
                340
            ],
            "accountRole": [
                10
            ],
            "__typename": [
                1
            ]
        },
        "ReportsPartner": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ReportSyncStatus": {},
        "ReportType": {},
        "ReReconcileInventoryPurchasesInput": {
            "purchasesIds": [
                1
            ],
            "businessEventIds": [
                1
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ResetBalanceSheetSetupInput": {
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ResetBalanceSheetSetupResponse": {
            "message": [
                1
            ],
            "status": [
                1363
            ],
            "__typename": [
                1
            ]
        },
        "RestockingAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "salesChannel": [
                2398
            ],
            "fulfillmentDate": [
                581
            ],
            "sku": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "RestockStatus": {},
        "Role": {},
        "RootConditionOperator": {},
        "RunProductsValidationDiagnosticsInput": {
            "companyId": [
                15
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "RunProductsValidationDiagnosticsResponse": {
            "issues": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SafeHolder": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "Sale": {
            "id": [
                15
            ],
            "saleType": [
                1
            ],
            "companyId": [
                15
            ],
            "source": [
                1961
            ],
            "externalSourceUrl": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "integrationAccountId": [
                15
            ],
            "integrationAccountName": [
                1
            ],
            "currency": [
                549
            ],
            "displayName": [
                1
            ],
            "statuses": [
                1962
            ],
            "postedAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "publishedAt": [
                581
            ],
            "lineItems": [
                1923
            ],
            "shipping": [
                2047
            ],
            "discounts": [
                651
            ],
            "platformDiscounts": [
                651
            ],
            "taxes": [
                2137
            ],
            "taxFixedAmount": [
                5
            ],
            "taxType": [
                1963
            ],
            "adjustments": [
                1920
            ],
            "payments": [
                1965
            ],
            "credits": [
                1965
            ],
            "refunds": [
                1965
            ],
            "paymentIndications": [
                1965
            ],
            "refundIndications": [
                1965
            ],
            "customer": [
                563
            ],
            "customerId": [
                15
            ],
            "shippingAddress": [
                555
            ],
            "billingAddress": [
                555
            ],
            "integrationTags": [
                1
            ],
            "integrationNote": [
                1
            ],
            "finaloopNote": [
                1
            ],
            "customerNote": [
                1
            ],
            "isSalesAffecting": [
                7
            ],
            "isCogsAffecting": [
                7
            ],
            "voidedAt": [
                581
            ],
            "voidedBy": [
                1919
            ],
            "approvedAt": [
                581
            ],
            "uploadId": [
                1
            ],
            "uploadedAt": [
                581
            ],
            "summary": [
                1964
            ],
            "__typename": [
                1
            ]
        },
        "SaleActor": {},
        "SaleAdjustment": {
            "id": [
                15
            ],
            "amount": [
                5
            ],
            "currency": [
                549
            ],
            "amountInHomeCurrency": [
                5
            ],
            "type": [
                68
            ],
            "postedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "SaleInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "balanceAsOfDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "SaleInternalInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "SaleLineItem": {
            "id": [
                15
            ],
            "quantity": [
                5
            ],
            "unitPrice": [
                5
            ],
            "currency": [
                549
            ],
            "type": [
                1926
            ],
            "integrationInfo": [
                1093
            ],
            "product": [
                1769
            ],
            "sku": [
                1
            ],
            "description": [
                1
            ],
            "discounts": [
                651
            ],
            "shipping": [
                2047
            ],
            "taxes": [
                2137
            ],
            "subtotal": [
                5
            ],
            "totalAmount": [
                5
            ],
            "salesChannel": [
                1945
            ],
            "salesChannelId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "SaleLineItemInput": {
            "id": [
                15
            ],
            "quantity": [
                5
            ],
            "unitPrice": [
                5
            ],
            "type": [
                1926
            ],
            "currency": [
                549
            ],
            "salesChannelName": [
                1
            ],
            "productId": [
                15
            ],
            "sku": [
                1
            ],
            "description": [
                1
            ],
            "discounts": [
                652
            ],
            "taxRate": [
                5
            ],
            "externalSourceId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SaleLineItemTaxInfo": {
            "taxableAmount": [
                5
            ],
            "taxRate": [
                5
            ],
            "totalTaxAmount": [
                5
            ],
            "isTaxInclusive": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "SaleLineItemType": {},
        "SaleOrder": {
            "id": [
                15
            ],
            "saleType": [
                1
            ],
            "companyId": [
                15
            ],
            "source": [
                1961
            ],
            "externalSourceUrl": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "integrationAccountId": [
                15
            ],
            "integrationAccountName": [
                1
            ],
            "currency": [
                549
            ],
            "displayName": [
                1
            ],
            "statuses": [
                1962
            ],
            "postedAt": [
                581
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "publishedAt": [
                581
            ],
            "lineItems": [
                1923
            ],
            "shipping": [
                2047
            ],
            "discounts": [
                651
            ],
            "platformDiscounts": [
                651
            ],
            "taxes": [
                2137
            ],
            "taxFixedAmount": [
                5
            ],
            "taxType": [
                1963
            ],
            "adjustments": [
                1920
            ],
            "payments": [
                1965
            ],
            "credits": [
                1965
            ],
            "refunds": [
                1965
            ],
            "paymentIndications": [
                1965
            ],
            "refundIndications": [
                1965
            ],
            "customer": [
                563
            ],
            "customerId": [
                15
            ],
            "shippingAddress": [
                555
            ],
            "billingAddress": [
                555
            ],
            "integrationTags": [
                1
            ],
            "integrationNote": [
                1
            ],
            "finaloopNote": [
                1
            ],
            "customerNote": [
                1
            ],
            "accounting": [
                6
            ],
            "isSalesAffecting": [
                7
            ],
            "isCogsAffecting": [
                7
            ],
            "voidedAt": [
                581
            ],
            "voidedBy": [
                1919
            ],
            "approvedAt": [
                581
            ],
            "uploadId": [
                1
            ],
            "uploadedAt": [
                581
            ],
            "summary": [
                1964
            ],
            "__typename": [
                1
            ]
        },
        "SalesAdjustmentOriginalValue": {
            "unitsSold": [
                41
            ],
            "unitsRestocked": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "SalesAdjustmentsBreakdownItem": {
            "salesChannel": [
                1940
            ],
            "count": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "SalesBasedClosingBalance": {
            "missionType": [
                1194
            ],
            "status": [
                1193
            ],
            "historyLog": [
                1190
            ],
            "managementMethodPeriod": [
                1367
            ],
            "closingBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "SalesBasedClosingBalanceInput": {
            "closingBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "SalesBasedMissingCostPerUnit": {
            "missionType": [
                1194
            ],
            "status": [
                1193
            ],
            "historyLog": [
                1190
            ],
            "managementMethodPeriod": [
                1367
            ],
            "missingCostPerUnitProducts": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "SalesBasedMissingCostPerUnitInput": {
            "missingCostPerUnitProducts": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "SalesBasedOpeningBalance": {
            "missionType": [
                1194
            ],
            "status": [
                1193
            ],
            "historyLog": [
                1190
            ],
            "managementMethodPeriod": [
                1367
            ],
            "openingBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "SalesBasedOpeningBalanceInput": {
            "openingBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "SalesBasedPurchases": {
            "missionType": [
                1194
            ],
            "status": [
                1193
            ],
            "historyLog": [
                1190
            ],
            "managementMethodPeriod": [
                1367
            ],
            "purchases": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "SalesBasedPurchasesInput": {
            "purchases": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "SalesBasedReportCogs": {
            "missionType": [
                1194
            ],
            "status": [
                1193
            ],
            "historyLog": [
                1190
            ],
            "managementMethodPeriod": [
                1367
            ],
            "__typename": [
                1
            ]
        },
        "SalesByTypeAndDateInput": {
            "saleType": [
                1966
            ],
            "companyId": [
                15
            ],
            "from": [
                581
            ],
            "to": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannel": {
            "accountRole": [
                1
            ],
            "integrationType": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "currency": [
                1
            ],
            "displayName": [
                1
            ],
            "isDropshipping": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelAddChangeInput": {
            "salesChannelName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelDailySalesData": {
            "salesChannel": [
                1940
            ],
            "salesData": [
                1951
            ],
            "soldSkusSummary": [
                1955
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelDailySummary": {
            "date": [
                581
            ],
            "summary": [
                1956
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelDeleteChangeInput": {
            "salesChannelName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelInfo": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "source": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "isCogsAffecting": [
                7
            ],
            "isSalesAffecting": [
                7
            ],
            "financialReportingStatus": [
                752
            ],
            "periods": [
                1948
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelInput": {
            "accountRole": [
                1
            ],
            "integrationType": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "currency": [
                1
            ],
            "isDropshipping": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelMonthlyBreakdown": {
            "date": [
                581
            ],
            "summary": [
                1956
            ],
            "dailyData": [
                1943
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelPeriod": {
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "financialReportingStatus": [
                752
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelPeriodInput": {
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "financialReportingStatus": [
                752
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelSalesCogs": {
            "hasAdjustments": [
                7
            ],
            "salesChannel": [
                1940
            ],
            "summary": [
                1956
            ],
            "monthlyBreakdown": [
                1947
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelSalesData": {
            "date": [
                581
            ],
            "unitsSold": [
                41
            ],
            "unitsRestocked": [
                41
            ],
            "unitsGiveaway": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelsByCompanyAndIntegrationInput": {
            "companyId": [
                15
            ],
            "integrationAccountId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelsByCompanyAndIntegrationResponse": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "isSalesAffecting": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelSkuSalesSummary": {
            "sku": [
                1
            ],
            "unitsSold": [
                41
            ],
            "unitsRestocked": [
                41
            ],
            "unitsGiveaway": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelSkuSummary": {
            "sku": [
                1
            ],
            "fulfilled": [
                41
            ],
            "restocked": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelTemplate": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "source": [
                1
            ],
            "isCogsAffecting": [
                7
            ],
            "isSalesAffecting": [
                7
            ],
            "financialReportingStatus": [
                752
            ],
            "__typename": [
                1
            ]
        },
        "SalesChannelUpdateChangeInput": {
            "newSalesChannelName": [
                1
            ],
            "oldSalesChannelName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SalesData": {
            "recipes": [
                1861
            ],
            "assembledByRecipeMap": [
                130
            ],
            "salesChannels": [
                1950
            ],
            "deadInventory": [
                587
            ],
            "giveaway": [
                1005
            ],
            "giveawayDropshipping": [
                1005
            ],
            "donation": [
                658
            ],
            "lostAndFound": [
                1358
            ],
            "otherFba": [
                1610
            ],
            "waste": [
                2467
            ],
            "supplierReturn": [
                1831
            ],
            "warehouseSalesData": [
                2424
            ],
            "salesAdjustments": [
                1819
            ],
            "deadInventoryAdjustments": [
                1791
            ],
            "giveawayAdjustments": [
                1795
            ],
            "giveawayDropshippingAdjustments": [
                1795
            ],
            "donationAdjustments": [
                1793
            ],
            "lostAndFoundAdjustments": [
                1798
            ],
            "otherFbaAdjustments": [
                1812
            ],
            "supplierReturnAdjustments": [
                1835
            ],
            "appliedCosts": [
                1774
            ],
            "__typename": [
                1
            ]
        },
        "SalesInternalInput": {
            "ids": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "SaleSource": {},
        "SaleStatus": {},
        "SaleTaxType": {},
        "SaleTotals": {
            "subtotal": [
                107
            ],
            "subtotalAfterItemDiscounts": [
                107
            ],
            "subtotalAfterDiscounts": [
                107
            ],
            "totalBeforeTaxes": [
                107
            ],
            "total": [
                107
            ],
            "tipsSubtotal": [
                107
            ],
            "shippingSubtotal": [
                107
            ],
            "shippingDiscounts": [
                107
            ],
            "shipping": [
                107
            ],
            "payments": [
                107
            ],
            "refunds": [
                107
            ],
            "credits": [
                107
            ],
            "adjustments": [
                107
            ],
            "taxes": [
                107
            ],
            "globalDiscounts": [
                107
            ],
            "globalPlatformDiscounts": [
                107
            ],
            "itemDiscounts": [
                107
            ],
            "totalDiscounts": [
                107
            ],
            "unpaidBalance": [
                107
            ],
            "balanceAsOf": [
                581
            ],
            "balanceAsOfAmount": [
                107
            ],
            "latestFinancialTimestamp": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "SaleTransaction": {
            "id": [
                15
            ],
            "integrationInfo": [
                1093
            ],
            "integrationAccountId": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "amount": [
                5
            ],
            "postedAt": [
                581
            ],
            "currency": [
                549
            ],
            "amountInHomeCurrency": [
                5
            ],
            "type": [
                2167
            ],
            "finaloopPaymentGateway": [
                1
            ],
            "originalPaymentGateway": [
                1
            ],
            "paymentGatewayVariant": [
                1
            ],
            "isIndication": [
                7
            ],
            "on_BankTxSaleTransaction": [
                303
            ],
            "on_IntegrationSaleTransaction": [
                1095
            ],
            "on_PaymentGroupTransaction": [
                1685
            ],
            "__typename": [
                1
            ]
        },
        "SaleType": {},
        "SaveDropshippingSettingsInput": {
            "companyId": [
                1
            ],
            "isEnabled": [
                7
            ],
            "mode": [
                664
            ],
            "warehouseIds": [
                1
            ],
            "affiliatedEntityIds": [
                1
            ],
            "applyVendorsSettingsForExistingTransactions": [
                7
            ],
            "isIncludePaymentTerms": [
                7
            ],
            "paymentsPerMonth": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "ScheduleAccountingReportExportInput": {
            "companyId": [
                15
            ],
            "reportType": [
                1907
            ],
            "isEnabled": [
                7
            ],
            "byMonth": [
                7
            ],
            "fractions": [
                7
            ],
            "withMerchantsBreakdown": [
                7
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "includeCCAccounts": [
                7
            ],
            "includeUDFAccounts": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ScheduleAccountingReportExportResponse": {
            "reportType": [
                1907
            ],
            "isEnabled": [
                7
            ],
            "byMonth": [
                7
            ],
            "fractions": [
                7
            ],
            "withMerchantsBreakdown": [
                7
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "syncMostUpdatedReport": [
                7
            ],
            "includeCCAccounts": [
                7
            ],
            "includeUDFAccounts": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ScheduleAtuIntegrationTransfersResultProcessingInput": {
            "companyId": [
                15
            ],
            "integrationTransferIds": [
                15
            ],
            "askTheUserResult": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "ScheduleAtuIntegrationTransfersResultProcessingResult": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ScheduleAtuTransactionsResultProcessingInput": {
            "companyId": [
                15
            ],
            "transactionIds": [
                15
            ],
            "askTheUserResult": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "ScheduleAtuTransactionsResultProcessingResult": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "SchedulePurchasesValidationInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "SchedulePurchasesValidationResponse": {
            "validationId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SearchCustomersInput": {
            "companyId": [
                15
            ],
            "searchTerm": [
                1
            ],
            "source": [
                562
            ],
            "limit": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "SearchMerchantsInput": {
            "companyId": [
                15
            ],
            "searchTerm": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SearchVendorsTransactionPriorityInput": {
            "companyId": [
                15
            ],
            "searchTerm": [
                1
            ],
            "merchantType": [
                1415
            ],
            "subType": [
                2388
            ],
            "__typename": [
                1
            ]
        },
        "SearchVendorsTransactionsPriorityResult": {
            "vendors": [
                2375
            ],
            "counts": [
                2387
            ],
            "__typename": [
                1
            ]
        },
        "Section179Deduction": {
            "date": [
                581
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "Section179DeductionInput": {
            "date": [
                1
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "SellingFee": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "source": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "sale": [
                1918
            ],
            "order": [
                1602
            ],
            "type": [
                1983
            ],
            "externalId": [
                1
            ],
            "externalName": [
                1
            ],
            "amount": [
                5
            ],
            "currency": [
                549
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "SellingFeeType": {},
        "SendAnalyticsEventInput": {
            "companyId": [
                15
            ],
            "events": [
                109
            ],
            "__typename": [
                1
            ]
        },
        "SendAnalyticsEventResult": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "SendPoEmailError": {
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SendPoEmailInput": {
            "companyId": [
                1
            ],
            "id": [
                1
            ],
            "to": [
                1
            ],
            "from": [
                1
            ],
            "cc": [
                1
            ],
            "bcc": [
                1
            ],
            "subject": [
                1
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SendPoEmailResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "SendPoEmailResult": {
            "on_SendPoEmailResponse": [
                1988
            ],
            "on_SendPoEmailError": [
                1986
            ],
            "__typename": [
                1
            ]
        },
        "SendValidationNotificationInput": {
            "caption": [
                1
            ],
            "validationCycleId": [
                1
            ],
            "validationTemplateId": [
                1
            ],
            "slackChannel": [
                1
            ],
            "type": [
                470
            ],
            "__typename": [
                1
            ]
        },
        "SetBankAccountsLatestEventIdsInput": {
            "bankAccountEventIds": [
                167
            ],
            "__typename": [
                1
            ]
        },
        "SetFiscalYearDataInput": {
            "companyId": [
                15
            ],
            "month": [
                41
            ],
            "day": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "SetFiscalYearStartInput": {
            "companyId": [
                15
            ],
            "month": [
                41
            ],
            "day": [
                41
            ],
            "userEmail": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetFulfillmentSettingsInput": {
            "companyId": [
                15
            ],
            "settings": [
                1091
            ],
            "__typename": [
                1
            ]
        },
        "SetFulfillmentSettingsResponse": {
            "settings": [
                1090
            ],
            "__typename": [
                1
            ]
        },
        "SetInventoryUsagesInput": {
            "companyId": [
                15
            ],
            "usageTypes": [
                1165
            ],
            "__typename": [
                1
            ]
        },
        "SetOrderFinaloopNoteInput": {
            "companyId": [
                15
            ],
            "orderId": [
                15
            ],
            "finaloopNote": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetOrderFinaloopTagsInput": {
            "companyId": [
                15
            ],
            "orderId": [
                15
            ],
            "finaloopTags": [
                750
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingAdjustmentsWithCsvInput": {
            "companyId": [
                15
            ],
            "url": [
                1
            ],
            "filename": [
                1
            ],
            "managementMethodId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingDeadInventoryAdjustmentsInput": {
            "companyId": [
                15
            ],
            "managementMethodId": [
                15
            ],
            "items": [
                2001
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingDeadInventoryAdjustmentsItemInput": {
            "productId": [
                1
            ],
            "pendingId": [
                1
            ],
            "date": [
                581
            ],
            "quantity": [
                41
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingDedInventoryAdjustmentsResponse": {
            "items": [
                1726
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingDonationAdjustmentsInput": {
            "companyId": [
                15
            ],
            "managementMethodId": [
                15
            ],
            "items": [
                2004
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingDonationAdjustmentsItemInput": {
            "productId": [
                1
            ],
            "pendingId": [
                1
            ],
            "date": [
                581
            ],
            "quantity": [
                41
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingDonationAdjustmentsResponse": {
            "items": [
                1730
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingGiveawayAdjustmentsInput": {
            "companyId": [
                15
            ],
            "managementMethodId": [
                15
            ],
            "items": [
                2007
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingGiveawayAdjustmentsItemInput": {
            "productId": [
                1
            ],
            "pendingId": [
                1
            ],
            "date": [
                581
            ],
            "quantity": [
                41
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingGiveawayAdjustmentsResponse": {
            "items": [
                1734
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingGiveawayDropshippingAdjustmentsResponse": {
            "items": [
                1738
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingSalesDataAdjustmentsInput": {
            "companyId": [
                15
            ],
            "salesChannel": [
                1946
            ],
            "managementMethodId": [
                15
            ],
            "items": [
                2011
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingSalesDataAdjustmentsItemInput": {
            "productId": [
                1
            ],
            "pendingId": [
                1
            ],
            "date": [
                581
            ],
            "unitsSold": [
                41
            ],
            "unitsRestocked": [
                41
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingSalesDataAdjustmentsResponseV2": {
            "items": [
                1743
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingSalesDataAdjustmentsWithCsvInput": {
            "companyId": [
                15
            ],
            "url": [
                1
            ],
            "filename": [
                1
            ],
            "managementMethodId": [
                15
            ],
            "salesChannel": [
                1946
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingWarehouseOpeningBalancesInput": {
            "companyId": [
                15
            ],
            "date": [
                581
            ],
            "items": [
                2015
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingWarehouseOpeningBalancesItemInput": {
            "productId": [
                1
            ],
            "warehouseId": [
                1
            ],
            "sourceId": [
                1
            ],
            "pendingId": [
                1
            ],
            "quantity": [
                5
            ],
            "costPerUnit": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "SetPendingWarehouseOpeningBalancesWithCsvInput": {
            "companyId": [
                15
            ],
            "date": [
                581
            ],
            "url": [
                1
            ],
            "filename": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetPhysicalCountPendingAdjustmentsWithCsvInput": {
            "companyId": [
                15
            ],
            "physicalCountId": [
                15
            ],
            "url": [
                1
            ],
            "filename": [
                1
            ],
            "managementMethodId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "SetProductAdjustmentOperation": {},
        "SetProductAdjustmentsInput": {
            "companyId": [
                15
            ],
            "finaloopProductId": [
                1
            ],
            "salesDataAdjustments": [
                2026
            ],
            "deadInventoryAdjustments": [
                2021
            ],
            "giveawayAdjustments": [
                2023
            ],
            "donationAdjustments": [
                2022
            ],
            "unitLostAdjustments": [
                2028
            ],
            "otherFbaAdjustments": [
                2025
            ],
            "supplierReturnAdjustments": [
                2027
            ],
            "appliedCosts": [
                2020
            ],
            "__typename": [
                1
            ]
        },
        "SetProductAppliedCostInput": {
            "operation": [
                2018
            ],
            "asOfDate": [
                581
            ],
            "appliedCost": [
                5
            ],
            "type": [
                1773
            ],
            "__typename": [
                1
            ]
        },
        "SetProductDeadInventoryAdjustmentInput": {
            "id": [
                1
            ],
            "operation": [
                2018
            ],
            "finaloopProductId": [
                1
            ],
            "date": [
                581
            ],
            "unitsDeadInventory": [
                5
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetProductDonationAdjustmentInput": {
            "operation": [
                2018
            ],
            "finaloopProductId": [
                1
            ],
            "date": [
                581
            ],
            "unitsDonated": [
                41
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetProductGiveawayAdjustmentInput": {
            "operation": [
                2018
            ],
            "finaloopProductId": [
                1
            ],
            "date": [
                581
            ],
            "unitsGiveaway": [
                41
            ],
            "warehouseId": [
                1
            ],
            "isDropshipping": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "SetProductMergeRecommendationsPrimaryProductInput": {
            "companyId": [
                15
            ],
            "productGroupId": [
                1
            ],
            "productId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetProductOtherFbaAdjustmentInput": {
            "operation": [
                2018
            ],
            "date": [
                581
            ],
            "otherFbaIncoming": [
                41
            ],
            "otherFba": [
                41
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetProductSalesDataAdjustmentInput": {
            "operation": [
                2018
            ],
            "salesChannel": [
                1946
            ],
            "date": [
                581
            ],
            "unitsSold": [
                41
            ],
            "unitsRestocked": [
                41
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetProductSupplierReturnAdjustmentInput": {
            "operation": [
                2018
            ],
            "date": [
                581
            ],
            "units": [
                41
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetProductUnitLostAdjustmentInput": {
            "operation": [
                2018
            ],
            "date": [
                581
            ],
            "unitsLost": [
                41
            ],
            "unitsFound": [
                41
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetSettingsArgs": {
            "companyId": [
                1
            ],
            "rangedManagementMethod": [
                1858
            ],
            "__typename": [
                1
            ]
        },
        "SetUserGivenWarehouseNameInput": {
            "companyId": [
                15
            ],
            "warehouseId": [
                15
            ],
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetUserName": {
            "email": [
                1
            ],
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SetUserNameResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "SetWarehouseDropshippingSettingsInput": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "isDropshipping": [
                7
            ],
            "isDropshippingFrom": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "SetWarehouseOpeningBalanceInput": {
            "warehouseId": [
                1
            ],
            "companyId": [
                15
            ],
            "productId": [
                1
            ],
            "quantity": [
                5
            ],
            "costPerUnit": [
                5
            ],
            "date": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ShareType": {},
        "Shipment": {
            "id": [
                15
            ],
            "shipmentDate": [
                581
            ],
            "arrival": [
                2038
            ],
            "contents": [
                2042
            ],
            "displayName": [
                1
            ],
            "vendor": [
                2375
            ],
            "notes": [
                1
            ],
            "attachments": [
                2040
            ],
            "purchaseOrder": [
                1846
            ],
            "cost": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "ShipmentAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "purchaseOrder": [
                1846
            ],
            "directCost": [
                5
            ],
            "indirectCosts": [
                1441
            ],
            "__typename": [
                1
            ]
        },
        "ShipmentArrival": {
            "arrivalDate": [
                581
            ],
            "warehouse": [
                2396
            ],
            "__typename": [
                1
            ]
        },
        "ShipmentArrivalInput": {
            "arrivalDate": [
                581
            ],
            "warehouseId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ShipmentAttachment": {
            "id": [
                15
            ],
            "filename": [
                1
            ],
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ShipmentAttachmentInput": {
            "filename": [
                1
            ],
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ShipmentContents": {
            "id": [
                15
            ],
            "lineItem": [
                644
            ],
            "quantity": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "ShipmentContentsInput": {
            "lineItemId": [
                15
            ],
            "quantity": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "ShipmentInput": {
            "id": [
                15
            ],
            "shipmentDate": [
                581
            ],
            "arrival": [
                2039
            ],
            "contents": [
                2043
            ],
            "displayName": [
                1
            ],
            "vendorId": [
                15
            ],
            "notes": [
                1
            ],
            "attachments": [
                2041
            ],
            "__typename": [
                1
            ]
        },
        "ShippingCost": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "source": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "sale": [
                1918
            ],
            "order": [
                1602
            ],
            "type": [
                2046
            ],
            "externalId": [
                1
            ],
            "externalName": [
                1
            ],
            "amount": [
                5
            ],
            "currency": [
                549
            ],
            "amountInHomeCurrency": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "ShippingCostType": {},
        "ShippingLineItem": {
            "id": [
                15
            ],
            "quantity": [
                5
            ],
            "unitPrice": [
                5
            ],
            "currency": [
                549
            ],
            "type": [
                1926
            ],
            "description": [
                1
            ],
            "discounts": [
                651
            ],
            "taxes": [
                2137
            ],
            "subtotal": [
                5
            ],
            "totalAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "ShippingLineItemV3": {
            "id": [
                15
            ],
            "externalLineItemId": [
                1
            ],
            "name": [
                1
            ],
            "description": [
                1
            ],
            "amount": [
                107
            ],
            "parentId": [
                1
            ],
            "parentLineItemType": [
                1639
            ],
            "earliestPostedAt": [
                581
            ],
            "latestPostedAt": [
                581
            ],
            "timeline": [
                1547
            ],
            "type": [
                1549
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyCsvBalance": {
            "companyId": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "balances": [
                2074
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyItemsReconciliationInput": {
            "startTime": [
                581
            ],
            "endTime": [
                581
            ],
            "integrationAccountId": [
                1
            ],
            "companyId": [
                15
            ],
            "isRegenerateFromScratch": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyItemsReconciliationOrderData": {
            "orderId": [
                1
            ],
            "url": [
                1
            ],
            "shopifySalesChannel": [
                1
            ],
            "salesChannel": [
                1
            ],
            "quantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyItemsReconciliationOrdersDiffInput": {
            "companyId": [
                15
            ],
            "startTime": [
                581
            ],
            "endTime": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyItemsReconciliationOrdersDiffResult": {
            "ordersData": [
                2054
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyItemsReconciliationOrdersDiffResultData": {
            "orderId": [
                15
            ],
            "reportQuantity": [
                41
            ],
            "entitiesQuantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyItemsReconciliationOrdersInput": {
            "startTime": [
                581
            ],
            "endTime": [
                581
            ],
            "integrationAccountId": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "companyId": [
                15
            ],
            "sku": [
                1
            ],
            "itemType": [
                2075
            ],
            "salesChannel": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyItemsReconciliationOrdersResponse": {
            "ordersData": [
                2051
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyItemsValidationBlacklistSalesChannelInput": {
            "companyId": [
                15
            ],
            "integrationAccountId": [
                1
            ],
            "salesChannel": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyItemsValidationBlacklistSkuInput": {
            "companyId": [
                15
            ],
            "integrationAccountId": [
                1
            ],
            "sku": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyOrderSourceData": {
            "financialStatus": [
                1
            ],
            "fulfillmentStatus": [
                1
            ],
            "gqlId": [
                1
            ],
            "orderValidationData": [
                2060
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyOrderValidationData": {
            "sales": [
                2062
            ],
            "refunds": [
                2061
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyOrderValidationRefund": {
            "id": [
                1
            ],
            "refundAmount": [
                5
            ],
            "giftCardAmount": [
                5
            ],
            "giftCardDiscountAmount": [
                5
            ],
            "shippingAmount": [
                5
            ],
            "taxAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyOrderValidationSale": {
            "id": [
                1
            ],
            "saleAmount": [
                5
            ],
            "giftCardAmount": [
                5
            ],
            "giftCardDiscountAmount": [
                5
            ],
            "taxAmount": [
                5
            ],
            "dutyAmount": [
                5
            ],
            "discountAmount": [
                5
            ],
            "shippingAmount": [
                5
            ],
            "tipAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyProduct": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "finaloopId": [
                1
            ],
            "lineOfBusinessId": [
                1
            ],
            "sku": [
                1
            ],
            "price": [
                5
            ],
            "displayName": [
                1
            ],
            "imageUrl": [
                1
            ],
            "listedChannels": [
                1940
            ],
            "appliedCosts": [
                1771
            ],
            "dailySalesData": [
                1942,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "totalSold": [
                41
            ],
            "avgCostPerUnit": [
                5
            ],
            "productUrl": [
                1
            ],
            "productVariantId": [
                1
            ],
            "canEditLatestAppliedCost": [
                7
            ],
            "isFractional": [
                7
            ],
            "isHidden": [
                7
            ],
            "salesData": [
                1959,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "rawRecipes": [
                1861,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "componentOfProducts": [
                1769
            ],
            "isAmbiguousSku": [
                7
            ],
            "analyticsOverview": [
                1770,
                {
                    "input": [
                        110
                    ]
                }
            ],
            "warehousesAnalyticsOverview": [
                1837,
                {
                    "input": [
                        110
                    ]
                }
            ],
            "tags": [
                1
            ],
            "isCreatedManually": [
                7
            ],
            "isDataSyncing": [
                7
            ],
            "mergeHistory": [
                1799
            ],
            "isDropshipping": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyProductsValidationConnection": {
            "integrationAccountId": [
                1
            ],
            "isAvailable": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyProductsValidationConnectionsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyProductsValidationConnectionsResponse": {
            "connections": [
                2064
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyProductsValidationData": {
            "integrationAccountId": [
                1
            ],
            "data": [
                2072
            ],
            "reportEndTime": [
                581
            ],
            "reportPath": [
                1
            ],
            "summary": [
                1883
            ],
            "productItemSoldData": [
                2073
            ],
            "productStatus": [
                2069
            ],
            "unknownSkuQuantity": [
                41
            ],
            "unknownSkuZeroPriceQuantity": [
                41
            ],
            "isNotArtificiallyFulfilled": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyProductsValidationResponse": {
            "validationId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyReconciliationProductsStatus": {
            "unitsSoldDiff": [
                41
            ],
            "unitsRestockedDiff": [
                41
            ],
            "unitsGiveawayDiff": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyReportDateLimitsInput": {
            "integrationAccountId": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyReportDateLimitsResponse": {
            "dateRange": [
                582
            ],
            "failureType": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "ShopifySkuReconciliationData": {
            "sku": [
                1
            ],
            "isBlacklisted": [
                7
            ],
            "excludedSalesChannelsData": [
                685
            ],
            "includedSalesChannelsData": [
                1058
            ],
            "summary": [
                1883
            ],
            "productItemSoldData": [
                2073
            ],
            "productStatus": [
                2069
            ],
            "unknownSkuQuantity": [
                41
            ],
            "unknownSkuZeroPriceQuantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "ShopifySkuReconciliationProductItemSoldData": {
            "unitsSold": [
                41
            ],
            "unitsSoldWithZeroPrice": [
                41
            ],
            "unitsRestocked": [
                41
            ],
            "unitsGiveaway": [
                41
            ],
            "ambiguousSkuQuantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyTimezoneBalance": {
            "timezone": [
                1
            ],
            "grossAmount": [
                5
            ],
            "netAmount": [
                5
            ],
            "taxAmount": [
                5
            ],
            "discountAmount": [
                5
            ],
            "shippingAmount": [
                5
            ],
            "refundAmount": [
                5
            ],
            "totalAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "ShopifyValidationItemType": {},
        "SignAndLockBankAccountInput": {
            "companyId": [
                1
            ],
            "bankAccountId": [
                1
            ],
            "signedBy": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SignedDownloadUrlInput": {
            "companyId": [
                1
            ],
            "s3Url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SignWorksheetRowInput": {
            "companyId": [
                1
            ],
            "name": [
                1
            ],
            "amount": [
                5
            ],
            "comment": [
                1
            ],
            "periodDates": [
                1753
            ],
            "__typename": [
                1
            ]
        },
        "SimpleMoneyDirection": {},
        "SimulatedLoanFailure": {
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SimulatedLoanIrrelevantEvent": {
            "event": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SimulatedLoanSummary": {
            "on_SimulatedLoanIrrelevantEvent": [
                2081
            ],
            "on_SimulatedLoanUpdate": [
                2083
            ],
            "on_SimulatedLoanFailure": [
                2080
            ],
            "__typename": [
                1
            ]
        },
        "SimulatedLoanUpdate": {
            "createdLoan": [
                2084
            ],
            "deletedLoan": [
                2085
            ],
            "__typename": [
                1
            ]
        },
        "SimulatedLoanUpdateCreate": {
            "type": [
                1339
            ],
            "isShortTerm": [
                7
            ],
            "date": [
                581
            ],
            "amount": [
                5
            ],
            "lender": [
                1446
            ],
            "__typename": [
                1
            ]
        },
        "SimulatedLoanUpdateDelete": {
            "loanId": [
                1
            ],
            "type": [
                1339
            ],
            "isShortTerm": [
                7
            ],
            "date": [
                581
            ],
            "amount": [
                5
            ],
            "lender": [
                1446
            ],
            "__typename": [
                1
            ]
        },
        "SimulateTransactionUpdatedClassification": {
            "businessEvent": [
                1
            ],
            "amount": [
                5
            ],
            "pairedEntityId": [
                1
            ],
            "pairedEntityType": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SimulateTransactionUpdatedInput": {
            "companyId": [
                15
            ],
            "transactionId": [
                1
            ],
            "businessEvent": [
                1
            ],
            "merchantId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SimulateTransactionUpdatedInput2": {
            "companyId": [
                15
            ],
            "transactionId": [
                1
            ],
            "classifications": [
                2086
            ],
            "merchantId": [
                1
            ],
            "merchantType": [
                1317
            ],
            "__typename": [
                1
            ]
        },
        "SingleOrderResult": {
            "on_OrderV3": [
                1605
            ],
            "on_OrderV3NotFound": [
                1606
            ],
            "__typename": [
                1
            ]
        },
        "SkuData": {
            "product": [
                1769
            ],
            "productId": [
                1
            ],
            "productName": [
                1
            ],
            "sku": [
                1
            ],
            "sourcesAndStores": [
                2095
            ],
            "sales": [
                553
            ],
            "salesTrend": [
                5
            ],
            "discounts": [
                553
            ],
            "cogs": [
                553
            ],
            "profit": [
                553
            ],
            "margin": [
                553
            ],
            "refunds": [
                553
            ],
            "restocks": [
                553
            ],
            "effectiveProfit": [
                553
            ],
            "effectiveProfitMargin": [
                553
            ],
            "unitsSold": [
                553
            ],
            "unitsRefunded": [
                553
            ],
            "averageUnitsSold": [
                553
            ],
            "averageSalePrice": [
                553
            ],
            "averageNetSales": [
                553
            ],
            "averageCostPerUnit": [
                553
            ],
            "averageProfitPerUnit": [
                553
            ],
            "__typename": [
                1
            ]
        },
        "SkuDataByDate": {
            "date": [
                581
            ],
            "sales": [
                553
            ],
            "discounts": [
                553
            ],
            "cogs": [
                553
            ],
            "profit": [
                553
            ],
            "margin": [
                553
            ],
            "refunds": [
                553
            ],
            "unitsSold": [
                553
            ],
            "unitsRefunded": [
                553
            ],
            "__typename": [
                1
            ]
        },
        "SkuValidationData": {
            "sku": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "unitsSold": [
                41
            ],
            "unitsRestocked": [
                41
            ],
            "unitsGiveaway": [
                41
            ],
            "unitsSoldWithZeroPrice": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "SortByMerchants": {},
        "SortDirection": {},
        "SourceAndStores": {
            "source": [
                2096
            ],
            "stores": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SourceTypes": {},
        "SpecificDate": {
            "date": [
                581
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "SpecificDateInput": {
            "date": [
                1
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "SplitProductsInput": {
            "companyId": [
                1
            ],
            "finaloopProductIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SplitProductsV3": {
            "productIds": [
                1
            ],
            "from": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "SplitTax1099AffiliatedEntityGroupsInput": {
            "companyId": [
                15
            ],
            "groupIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "SplitWarehouseInput": {
            "companyId": [
                15
            ],
            "representativeId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SpreadBasisType": {},
        "SpreadOverTime": {
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "amount": [
                5
            ],
            "spreadBasisType": [
                2103
            ],
            "__typename": [
                1
            ]
        },
        "SpreadOverTimeInput": {
            "fromDate": [
                1
            ],
            "toDate": [
                1
            ],
            "amount": [
                5
            ],
            "spreadBasisType": [
                2103
            ],
            "__typename": [
                1
            ]
        },
        "SpreadType": {},
        "StatementFile": {
            "s3Bucket": [
                1
            ],
            "s3Key": [
                1
            ],
            "fileName": [
                1
            ],
            "fileType": [
                182
            ],
            "__typename": [
                1
            ]
        },
        "StopImportingDataForBankAccountInput": {
            "bankAccountId": [
                15
            ],
            "companyId": [
                15
            ],
            "stopImportFromDate": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "StopImportingDataForBankAccountNewInput": {
            "bankAccountId": [
                15
            ],
            "companyId": [
                15
            ],
            "stopImportFromDate": [
                1
            ],
            "newOwner": [
                174
            ],
            "__typename": [
                1
            ]
        },
        "Store": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "homeCurrency": [
                549
            ],
            "__typename": [
                1
            ]
        },
        "StoreDateForLockingInput": {
            "companyId": [
                1
            ],
            "name": [
                1
            ],
            "dateForLocking": [
                581
            ],
            "periodDates": [
                1753
            ],
            "__typename": [
                1
            ]
        },
        "StoreOrderTransactionMatchType": {},
        "StorePaymentV2": {
            "id": [
                15
            ],
            "source": [
                1113
            ],
            "externalSourceId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "StoreV3": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "homeCurrency": [
                549
            ],
            "__typename": [
                1
            ]
        },
        "StoreValidationInput": {
            "validationTemplateId": [
                1
            ],
            "validationId": [
                1
            ],
            "validationCycleId": [
                1
            ],
            "result": [
                2116
            ],
            "__typename": [
                1
            ]
        },
        "StoreValidationResultDataInput": {
            "companyId": [
                1
            ],
            "domain": [
                470
            ],
            "type": [
                475
            ],
            "integrationAccountId": [
                1
            ],
            "account": [
                1
            ],
            "accountDisplayName": [
                1
            ],
            "isError": [
                7
            ],
            "metrics": [
                2117
            ],
            "dataUrl": [
                1
            ],
            "from": [
                581
            ],
            "to": [
                581
            ],
            "generatedBy": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "StoreValidationResultDataMeticItemInput": {
            "metricName": [
                472
            ],
            "value": [
                5
            ],
            "mode": [
                471
            ],
            "__typename": [
                1
            ]
        },
        "StripeCustomerIdsByCompanyIdsInput": {
            "companyIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "StripeCustomerIdsResponse": {
            "companyAndStripeIds": [
                446
            ],
            "__typename": [
                1
            ]
        },
        "SubmitTransactionsFileToBankTransactionsUploadInput": {
            "companyId": [
                15
            ],
            "bankTransactionsUploadId": [
                1
            ],
            "bucket": [
                1
            ],
            "key": [
                1
            ],
            "processorId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SubmitTransactionsFileToBankTransactionsUploadResponse": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "bankAccountId": [
                1
            ],
            "s3Bucket": [
                1
            ],
            "s3Key": [
                1
            ],
            "status": [
                301
            ],
            "__typename": [
                1
            ]
        },
        "SuccessResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "SuccessResult": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "SuggestBankTransactionClassificationInput": {
            "companyId": [
                15
            ],
            "bankTransactionIds": [
                15
            ],
            "userPrompt": [
                1
            ],
            "merchantId": [
                15
            ],
            "merchantType": [
                1415
            ],
            "__typename": [
                1
            ]
        },
        "SuspectedBankAccountDuplication": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "bankAccountId1": [
                1
            ],
            "bankAccountId2": [
                1
            ],
            "liveConnectionBankAccountId": [
                1
            ],
            "readyForMergingAt": [
                581
            ],
            "hubspotNotificationSentAt": [
                581
            ],
            "duplicateCheckStartedAt": [
                581
            ],
            "duplicateCheckCompletedAt": [
                581
            ],
            "duplicateCheckResult": [
                668
            ],
            "mergeStartedAt": [
                581
            ],
            "mergeCompletedAt": [
                581
            ],
            "mergeResult": [
                1425
            ],
            "fileLocationBucket": [
                1
            ],
            "fileLocationKey": [
                1
            ],
            "mergedBy": [
                38
            ],
            "mergedById": [
                1
            ],
            "totalMergedTransactionsChunks": [
                41
            ],
            "currentlyMergedTransactionsChunks": [
                41
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "SwitchCompanyArgs": {
            "companyId": [
                1
            ],
            "companyIdToSwitchTo": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "SwitchCompanyResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "SyncCompanyEventName": {},
        "SyncCompanyInput": {
            "eventName": [
                2128
            ],
            "body": [
                462
            ],
            "__typename": [
                1
            ]
        },
        "SyncDataPlatformIntegrationInput": {
            "companyId": [
                15
            ],
            "integrationType": [
                1113
            ],
            "integrationAccountId": [
                1
            ],
            "clientConfig": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "SyncDataPlatformIntegrationResponse": {
            "companyId": [
                15
            ],
            "integrationType": [
                1113
            ],
            "integrationAccountId": [
                1
            ],
            "isNewIntegration": [
                7
            ],
            "isUpdatedIntegration": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "SyncGtmSourceInput": {
            "companyId": [
                15
            ],
            "gtmSource": [
                1020
            ],
            "__typename": [
                1
            ]
        },
        "SyncInventoryIntegrationFulfillmentSettingInput": {
            "companyId": [
                15
            ],
            "source": [
                1
            ],
            "isEnabled": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "SyncReportInput": {
            "companyId": [
                15
            ],
            "reportType": [
                1907
            ],
            "__typename": [
                1
            ]
        },
        "SyncStripeOffersInput": {
            "subscriptionProductId": [
                1
            ],
            "transitionFeeProductId": [
                1
            ],
            "catchupProductId": [
                1
            ],
            "couponCode": [
                1
            ],
            "isStripeTest": [
                7
            ],
            "description": [
                1
            ],
            "title": [
                1
            ],
            "tier": [
                1470
            ],
            "__typename": [
                1
            ]
        },
        "SyncStripeTier1Offer": {
            "yearlySubscriptionPriceId": [
                1
            ],
            "monthlySubscriptionPriceId": [
                1
            ],
            "transitionFeePriceId": [
                1
            ],
            "catchupPriceId": [
                1
            ],
            "isStripeTest": [
                7
            ],
            "description": [
                1
            ],
            "title": [
                1
            ],
            "couponCode": [
                1
            ],
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Tax": {
            "id": [
                15
            ],
            "amount": [
                5
            ],
            "description": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Tax1099AffiliatedEntity": {
            "affiliatedEntity": [
                72
            ],
            "type": [
                2144
            ],
            "calendarYear": [
                41
            ],
            "totalPayments": [
                5
            ],
            "businessEvents": [
                1
            ],
            "sources": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Tax1099AffiliatedEntityDisqualifyReason": {},
        "Tax1099AffiliatedEntityGroup": {
            "id": [
                15
            ],
            "groupName": [
                1
            ],
            "isGroup": [
                7
            ],
            "type": [
                2144
            ],
            "calendarYear": [
                41
            ],
            "affiliatedEntities": [
                2138
            ],
            "totalPayments": [
                5
            ],
            "businessEvents": [
                1
            ],
            "sources": [
                1
            ],
            "disqualifyReason": [
                2139
            ],
            "file": [
                2141
            ],
            "markedAsDoneAt": [
                581
            ],
            "finaloopComment": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Tax1099AffiliatedEntityGroupFile": {
            "url": [
                1
            ],
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Tax1099AffiliatedEntityGroupFileInput": {
            "url": [
                1
            ],
            "name": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "Tax1099AffiliatedEntityGroupsByType": {
            "type": [
                2144
            ],
            "calendarYear": [
                41
            ],
            "affiliatedEntityGroups": [
                2140
            ],
            "__typename": [
                1
            ]
        },
        "Tax1099AffiliatedEntityType": {},
        "TaxInfo": {
            "amount": [
                5
            ],
            "description": [
                1
            ],
            "isTaxInclusive": [
                7
            ],
            "createdAt": [
                581
            ],
            "updatedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "TaxLineItemV3": {
            "id": [
                15
            ],
            "externalLineItemId": [
                1
            ],
            "name": [
                1
            ],
            "description": [
                1
            ],
            "amount": [
                107
            ],
            "parentId": [
                1
            ],
            "parentLineItemType": [
                1639
            ],
            "earliestPostedAt": [
                581
            ],
            "latestPostedAt": [
                581
            ],
            "type": [
                1549
            ],
            "taxType": [
                1546
            ],
            "externalName": [
                1
            ],
            "country": [
                1
            ],
            "region": [
                1
            ],
            "ratePercentage": [
                1
            ],
            "liableParty": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "TestSPSCommerceOrgConnectionInput": {
            "companyId": [
                1
            ],
            "organizationName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "TestSPSCommerceOrgConnectionResponse": {
            "success": [
                7
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "TikTokProduct": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "finaloopId": [
                1
            ],
            "lineOfBusinessId": [
                1
            ],
            "sku": [
                1
            ],
            "price": [
                5
            ],
            "displayName": [
                1
            ],
            "imageUrl": [
                1
            ],
            "listedChannels": [
                1940
            ],
            "appliedCosts": [
                1771
            ],
            "dailySalesData": [
                1942,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "totalSold": [
                41
            ],
            "avgCostPerUnit": [
                5
            ],
            "asin": [
                1
            ],
            "canEditLatestAppliedCost": [
                7
            ],
            "isFractional": [
                7
            ],
            "isHidden": [
                7
            ],
            "salesData": [
                1959,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "rawRecipes": [
                1861,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "componentOfProducts": [
                1769
            ],
            "isAmbiguousSku": [
                7
            ],
            "analyticsOverview": [
                1770,
                {
                    "input": [
                        110
                    ]
                }
            ],
            "warehousesAnalyticsOverview": [
                1837,
                {
                    "input": [
                        110
                    ]
                }
            ],
            "tags": [
                1
            ],
            "isCreatedManually": [
                7
            ],
            "isDataSyncing": [
                7
            ],
            "mergeHistory": [
                1799
            ],
            "isDropshipping": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "TimeBreakdownUnit": {},
        "TimeRange": {
            "fromUTC": [
                581
            ],
            "toUTC": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "TimeRangeInput": {
            "fromUTC": [
                581
            ],
            "toUTC": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "TipLineItemV3": {
            "id": [
                15
            ],
            "externalLineItemId": [
                1
            ],
            "name": [
                1
            ],
            "description": [
                1
            ],
            "amount": [
                107
            ],
            "parentId": [
                1
            ],
            "parentLineItemType": [
                1639
            ],
            "earliestPostedAt": [
                581
            ],
            "latestPostedAt": [
                581
            ],
            "type": [
                1549
            ],
            "__typename": [
                1
            ]
        },
        "ToggleBankTransactionAccrualInput": {
            "companyId": [
                15
            ],
            "bankTransactionId": [
                15
            ],
            "hasAccrual": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ToggleBankTransactionAccrualResult": {
            "companyId": [
                15
            ],
            "bankTransactionId": [
                15
            ],
            "hasAccrual": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ToggleBillHasAccrualInput": {
            "companyId": [
                15
            ],
            "billId": [
                15
            ],
            "hasAccrual": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ToggleOrdersZeroNetBalanceInput": {
            "companyId": [
                1
            ],
            "isZeroNetOrdersSupported": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ToggleRecognizeZeroNetOrdersAsGiveawaysInput": {
            "companyId": [
                15
            ],
            "shouldRecognizeZeroNetCogsAsGiveaways": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "Topup": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "amount": [
                5
            ],
            "amountInUsd": [
                5
            ],
            "currency": [
                1
            ],
            "eventTime": [
                581
            ],
            "deletedAt": [
                581
            ],
            "markedAsReconciliationDiscrepancyAt": [
                581
            ],
            "integrationType": [
                1113
            ],
            "pairedBankTransaction": [
                270
            ],
            "type": [
                1110
            ],
            "classification": [
                1099
            ],
            "integrationAccountId": [
                15
            ],
            "integrationAccountName": [
                1
            ],
            "pairedCompanyAffiliate": [
                422
            ],
            "link": [
                1
            ],
            "uploadedFileId": [
                1
            ],
            "failedAmountInUsd": [
                5
            ],
            "failedAt": [
                581
            ],
            "markedAsUnidentifiedAt": [
                581
            ],
            "rawEvent": [
                1241
            ],
            "__typename": [
                1
            ]
        },
        "TransactionDescription": {
            "description": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "TransactionItemToReconcile": {
            "companyId": [
                15
            ],
            "transactionId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "TransactionKind": {},
        "TransactionLoan": {
            "transaction": [
                270
            ],
            "loan": [
                453
            ],
            "isLocked": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "TransactionPaymentGatewayType": {},
        "TransactionPaymentType": {},
        "TransactionsImportStatus": {
            "stopImportFromDate": [
                1
            ],
            "changedBy": [
                1
            ],
            "changedAt": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "TransactionType": {},
        "TransactionUpdatedInput": {
            "companyId": [
                15
            ],
            "transactionId": [
                1
            ],
            "actorType": [
                38
            ],
            "__typename": [
                1
            ]
        },
        "TransactionWithMultipleClassificationsInput": {
            "transactionId": [
                1
            ],
            "merchant": [
                1320
            ],
            "classifications": [
                511
            ],
            "__typename": [
                1
            ]
        },
        "TransitionFeeInput": {
            "stripeId": [
                1
            ],
            "price": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "TriggerCOGSFromScratchInput": {
            "companyId": [
                15
            ],
            "managementMethod": [
                1366
            ],
            "productIds": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "TriggerFifoReconciliationInput": {
            "companyId": [
                15
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "eventIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "TriggerReconciliationInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "UnclassifyIntegrationTransferInput": {
            "ids": [
                15
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "UnconnectedAccount": {
            "vendor": [
                2375
            ],
            "__typename": [
                1
            ]
        },
        "UnidentifiedBankTransactionParty": {
            "on_BankAccount": [
                161
            ],
            "on_UnknownTransactionBank": [
                2200
            ],
            "on_UnknownTransactionAccount": [
                2199
            ],
            "on_UnconnectedAccount": [
                2175
            ],
            "on_Vendor": [
                2375
            ],
            "on_TransactionDescription": [
                2160
            ],
            "__typename": [
                1
            ]
        },
        "UnidentifiedBankTransactionsGroup": {
            "transactions": [
                270
            ],
            "payer": [
                2176
            ],
            "payee": [
                2176
            ],
            "groupId": [
                15
            ],
            "isProcessing": [
                7
            ],
            "action": [
                2180
            ],
            "tooltipText": [
                1
            ],
            "type": [
                2179
            ],
            "__typename": [
                1
            ]
        },
        "UnidentifiedBankTransactionsGroupsInput": {
            "companyId": [
                15
            ],
            "fromDate": [
                581
            ],
            "toDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "UnidentifiedBankTransactionsGroupType": {},
        "UnidentifiedTransfersGroupAction": {},
        "UnitBasedClosingBalance": {
            "missionType": [
                1194
            ],
            "status": [
                1193
            ],
            "historyLog": [
                1190
            ],
            "managementMethodPeriod": [
                1367
            ],
            "closingBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "UnitBasedClosingBalanceInput": {
            "closingBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "UnitBasedNegativeOnHands": {
            "missionType": [
                1194
            ],
            "status": [
                1193
            ],
            "historyLog": [
                1190
            ],
            "managementMethodPeriod": [
                1367
            ],
            "productsWithNegativeOnHands": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "UnitBasedNegativeOnHandsInput": {
            "productsWithNegativeOnHands": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "UnitBasedReportCogs": {
            "missionType": [
                1194
            ],
            "status": [
                1193
            ],
            "historyLog": [
                1190
            ],
            "managementMethodPeriod": [
                1367
            ],
            "__typename": [
                1
            ]
        },
        "UnitBasedVendorsNegativeBalance": {
            "missionType": [
                1194
            ],
            "status": [
                1193
            ],
            "historyLog": [
                1190
            ],
            "managementMethodPeriod": [
                1367
            ],
            "vendorsWithNegativeBalance": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "UnitBasedVendorsNegativeBalanceInput": {
            "vendorsWithNegativeBalance": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "UnitFoundAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UnitLostAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UnitsTrackingPhysicalCount": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "amountAdjustment": [
                5
            ],
            "lastAckAmountAdjustment": [
                5
            ],
            "amountAdjustmentWithPendingAdjustments": [
                5
            ],
            "date": [
                581
            ],
            "warehouse": [
                2396
            ],
            "attachments": [
                2191
            ],
            "closingBalance": [
                5
            ],
            "amount": [
                5
            ],
            "note": [
                1
            ],
            "isDraft": [
                7
            ],
            "deletedAt": [
                581
            ],
            "hasUnacknowledgedChanges": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UnitsTrackingPhysicalCountAttachment": {
            "name": [
                1
            ],
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UnitsTrackingPhysicalCountOverview": {
            "missingData": [
                5
            ],
            "count": [
                5
            ],
            "pendingChanges": [
                5
            ],
            "productQuantities": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "UnitsTrackingPhysicalCountProductQuantities": {
            "products": [
                2194
            ],
            "offset": [
                5
            ],
            "count": [
                5
            ],
            "hasUnacknowledgedChanges": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UnitsTrackingPhysicalCountProductQuantity": {
            "product": [
                1769
            ],
            "quantity": [
                5
            ],
            "avgCost": [
                5
            ],
            "lastAckAvgCost": [
                5
            ],
            "quantityAdjustment": [
                5
            ],
            "lastAckQuantityAdjustment": [
                5
            ],
            "amountAdjustment": [
                5
            ],
            "lastAckAmountAdjustment": [
                5
            ],
            "unitsOnHand": [
                5
            ],
            "lastAckUnitsOnHand": [
                5
            ],
            "hasUnacknowledgedChanges": [
                7
            ],
            "isPendingChange": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UnitsTrackingPhysicalCountsList": {
            "physicalCounts": [
                2190
            ],
            "offset": [
                41
            ],
            "count": [
                41
            ],
            "totalCount": [
                41
            ],
            "minAdjustment": [
                5
            ],
            "maxAdjustment": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "UnitType": {},
        "UnknownIntegrationTransferAccount": {
            "dummy": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UnknownIntegrationTransferBank": {
            "dummy": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UnknownTransactionAccount": {
            "vendor": [
                2375
            ],
            "__typename": [
                1
            ]
        },
        "UnknownTransactionBank": {
            "vendor": [
                2375
            ],
            "__typename": [
                1
            ]
        },
        "UnlockCompanyV2Input": {
            "companyId": [
                1
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "UnlockLoanResult": {
            "success": [
                7
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UnMarkOrdersAsCOGSInput": {
            "companyId": [
                15
            ],
            "orderIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "UnMarkOrdersAsCOGSResponse": {
            "orders": [
                1602
            ],
            "__typename": [
                1
            ]
        },
        "UnMarkOrdersAsGiveawayInput": {
            "companyId": [
                15
            ],
            "orderIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "UnMarkOrdersAsGiveawayResponse": {
            "orders": [
                1602
            ],
            "__typename": [
                1
            ]
        },
        "UnMarkOrdersAsOvercollectedInput": {
            "companyId": [
                15
            ],
            "orderIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "UnMarkOrdersAsOvercollectedResponse": {
            "orders": [
                1602
            ],
            "__typename": [
                1
            ]
        },
        "UnMarkOrdersAsUncollectibleInput": {
            "companyId": [
                15
            ],
            "orderIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "UnMarkOrdersAsUncollectibleResponse": {
            "orders": [
                1602
            ],
            "__typename": [
                1
            ]
        },
        "UnpaidAmountPerAffiliatedEntity": {
            "affiliatedEntity": [
                72
            ],
            "totalSum": [
                5
            ],
            "unpaidAmount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "UnpaidAmountsViaProvider": {
            "type": [
                2213
            ],
            "categoryGroup": [
                1700
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "UnpaidAmountsViaProviderType": {},
        "UnsignWorksheetRowInput": {
            "companyId": [
                1
            ],
            "name": [
                1
            ],
            "periodDates": [
                1753
            ],
            "__typename": [
                1
            ]
        },
        "UnvoidOrdersInput": {
            "companyId": [
                15
            ],
            "orderIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "UnvoidOrdersResponse": {
            "orders": [
                1602
            ],
            "failedIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "UpdateAssociatedBankTransactionsFileInput": {
            "bankTransactionId": [
                15
            ],
            "fileId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "UpdateAssociatedBankTransactionsFileResponse": {
            "success": [
                7
            ],
            "errorMessage": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateAuth0UserDetailsArgs": {
            "userEmail": [
                1
            ],
            "companyName": [
                1
            ],
            "userName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateAutomergeSettingsInput": {
            "companyId": [
                15
            ],
            "matchGroupType": [
                1807
            ],
            "isEnabled": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UpdateBalanceSheetSetupInput": {
            "companyId": [
                15
            ],
            "state": [
                1050
            ],
            "isUserUnresponsive": [
                7
            ],
            "isPreviewEnabled": [
                7
            ],
            "reason": [
                1
            ],
            "intercomLink": [
                1
            ],
            "email": [
                1
            ],
            "updaterType": [
                1053
            ],
            "__typename": [
                1
            ]
        },
        "UpdateBalanceSheetSetupItemInput": {
            "companyId": [
                15
            ],
            "itemType": [
                153
            ],
            "state": [
                1048
            ],
            "data": [
                1241
            ],
            "reason": [
                1
            ],
            "updaterType": [
                1053
            ],
            "__typename": [
                1
            ]
        },
        "UpdateBalanceSheetSetupItemResponse": {
            "success": [
                7
            ],
            "errorMessage": [
                156
            ],
            "__typename": [
                1
            ]
        },
        "UpdateBalanceSheetSetupResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UpdateBankAccountBalanceAdjustmentInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                15
            ],
            "balanceAdjustment": [
                5
            ],
            "balanceAdjustmentDate": [
                1
            ],
            "actorType": [
                162
            ],
            "actorId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateBankAccountClosingBalanceInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                15
            ],
            "closingBalance": [
                5
            ],
            "closingBalanceDate": [
                1
            ],
            "actorType": [
                165
            ],
            "actorId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateBankAccountInput": {
            "companyId": [
                15
            ],
            "id": [
                15
            ],
            "integrationAccountId": [
                1
            ],
            "currentBalance": [
                5
            ],
            "lastUpdateTime": [
                581
            ],
            "isHistoricalUpdateCompleted": [
                7
            ],
            "rawData": [
                1242
            ],
            "shouldUpdateAccountDetailsOnNextUpdate": [
                7
            ],
            "status": [
                187
            ],
            "forwardTransactionsToBankAccountId": [
                1
            ],
            "hasNotifiedUponNoHistoricalUpdate": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UpdateBankAccountsMergeStatusInput": {
            "companyId": [
                15
            ],
            "suspectedDuplicationId": [
                15
            ],
            "fileLocationBucket": [
                1
            ],
            "fileLocationKey": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateBankReconciliationRequestMessageInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "message": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateBankReconciliationRequestStatusInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "status": [
                263
            ],
            "__typename": [
                1
            ]
        },
        "UpdateBankStatementFileProcessingLogsInput": {
            "companyId": [
                15
            ],
            "fileId": [
                1
            ],
            "originFileId": [
                1
            ],
            "processingLog": [
                239
            ],
            "status": [
                243
            ],
            "__typename": [
                1
            ]
        },
        "UpdateBankStatementParsingResultStatus": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "bankTransactionsUploadId": [
                1
            ],
            "bankStatementFileId": [
                1
            ],
            "status": [
                256
            ],
            "__typename": [
                1
            ]
        },
        "UpdateBankTransactionMemoInput": {
            "companyId": [
                15
            ],
            "bankTransactionId": [
                15
            ],
            "text": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateBooksStartTimeArgs": {
            "companyId": [
                1
            ],
            "booksStartTime": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCheckDetails": {},
        "UpdateCheckTypes": {},
        "UpdateCommentsInput": {
            "companyId": [
                1
            ],
            "name": [
                1
            ],
            "comment": [
                1
            ],
            "attachmentUrl": [
                1
            ],
            "attachmentFileName": [
                1
            ],
            "periodDates": [
                1753
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCompaniesDomainStateInput": {
            "domain": [
                2490
            ],
            "year": [
                41
            ],
            "companiesState": [
                439
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCompanyAccountingMethodArgs": {
            "companyId": [
                1
            ],
            "accountingMethod": [
                561
            ],
            "flow": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCompanyAffiliateInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "name": [
                1
            ],
            "isForeignResident": [
                7
            ],
            "holdingsInPercentage": [
                5
            ],
            "status": [
                1043
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCompanyDomainStateResponse": {
            "companyId": [
                15
            ],
            "yearEndDomainStateId": [
                1
            ],
            "updateCheck": [
                2236
            ],
            "state": [
                2476
            ],
            "details": [
                2235
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCompanyFundedStatusInput": {
            "companyId": [
                15
            ],
            "hideBanner": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCompanyInput": {
            "companyId": [
                15
            ],
            "onboardingState": [
                1473
            ],
            "estimatedProjectedRevenue": [
                681
            ],
            "phoneNumber": [
                1
            ],
            "isOnboardingCompleted": [
                7
            ],
            "appsSelectedInPreOnboarding": [
                1
            ],
            "referralCode": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCompanyLoansInput": {
            "companyId": [
                15
            ],
            "loanIds": [
                15
            ],
            "data": [
                1340
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCompanyLoansResponse": {
            "loans": [
                1287
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCompanyNamesAndNotifyHandlerInput": {
            "companyId": [
                15
            ],
            "userName": [
                1
            ],
            "companyName": [
                1
            ],
            "estimatedProjectedRevenue": [
                681
            ],
            "phoneNumber": [
                1
            ],
            "appsSelectedInPreOnboarding": [
                1
            ],
            "referralCode": [
                1
            ],
            "accountingServices": [
                9
            ],
            "demo": [
                1
            ],
            "preOnboardingFunnelType": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCompanyPayingStatusInput": {
            "companyId": [
                1
            ],
            "isPaying": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCompanyTierInput": {
            "companyId": [
                1
            ],
            "tier": [
                463
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCompanyVendorExternalSourceIdVendorInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "externalSourceId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateCustomerArgs": {
            "id": [
                1
            ],
            "name": [
                1
            ],
            "companyName": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "source": [
                562
            ],
            "email": [
                1
            ],
            "phoneNumber": [
                1
            ],
            "billingAddress": [
                59
            ],
            "shippingAddress": [
                59
            ],
            "__typename": [
                1
            ]
        },
        "UpdatedLoans": {
            "loans": [
                1287
            ],
            "__typename": [
                1
            ]
        },
        "UpdateEmployeesOfficerStatusChange": {
            "employeeId": [
                15
            ],
            "isOfficer": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UpdateEmployeesOfficerStatusInput": {
            "companyId": [
                15
            ],
            "changes": [
                2252
            ],
            "__typename": [
                1
            ]
        },
        "UpdateEstimatedProjectedRevenueInput": {
            "companyId": [
                1
            ],
            "estimatedProjectedRevenue": [
                681
            ],
            "__typename": [
                1
            ]
        },
        "UpdateExpression": {
            "impactOnBooksSince": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateGlobalVendorLogo": {
            "id": [
                15
            ],
            "logoUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateGlobalVendorLogoInput": {
            "id": [
                15
            ],
            "logoUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateInstitutionDataConfigInput": {
            "institutionId": [
                15
            ],
            "dataConfig": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "UpdateInstitutionInput": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "preferredProvider": [
                1079
            ],
            "isMajor": [
                1
            ],
            "logoUrl": [
                1
            ],
            "websiteUrl": [
                1
            ],
            "csvInstructionsLink": [
                1
            ],
            "pdfInstructionsLink": [
                1
            ],
            "csvAvailable": [
                7
            ],
            "pdfAvailable": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UpdateInstitutionMappingInput": {
            "id": [
                15
            ],
            "source": [
                1078
            ],
            "externalSourceId": [
                1
            ],
            "externalSourceName": [
                1
            ],
            "institutionId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateInternalLoanInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "data": [
                1341
            ],
            "merchantRole": [
                427
            ],
            "__typename": [
                1
            ]
        },
        "UpdateInventoryPaymentGroupInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "postedAt": [
                581
            ],
            "affiliatedEntityId": [
                15
            ],
            "purchaseOrders": [
                1674
            ],
            "warehouseTransfers": [
                1687
            ],
            "inventoryPurchases": [
                1656
            ],
            "manualAssemblies": [
                1671
            ],
            "onDemandAssemblyVendorCosts": [
                1672
            ],
            "__typename": [
                1
            ]
        },
        "UpdateInventoryPaymentGroupResponse": {
            "inventoryPaymentGroup": [
                1118
            ],
            "__typename": [
                1
            ]
        },
        "UpdateInventoryPurchaseResponse": {
            "on_InventoryPurchase": [
                1131
            ],
            "on_InventoryPurchaseUpdateOutOfDateError": [
                1162
            ],
            "__typename": [
                1
            ]
        },
        "UpdateInventoryYearEndMissionInput": {
            "companyId": [
                15
            ],
            "missions": [
                1435
            ],
            "__typename": [
                1
            ]
        },
        "UpdateInvoicePaymentGroupInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "postedAt": [
                581
            ],
            "invoices": [
                1657
            ],
            "bankTransactions": [
                1651
            ],
            "expenses": [
                1654
            ],
            "actorType": [
                38
            ],
            "__typename": [
                1
            ]
        },
        "UpdateInvoicePaymentGroupResponse": {
            "paymentGroup": [
                1206
            ],
            "__typename": [
                1
            ]
        },
        "UpdateLoanAttachmentInput": {
            "id": [
                15
            ],
            "fileName": [
                1
            ],
            "url": [
                1
            ],
            "type": [
                1296
            ],
            "__typename": [
                1
            ]
        },
        "UpdateLoanAttachmentsInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "attachments": [
                2268
            ],
            "__typename": [
                1
            ]
        },
        "UpdateLoanInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "data": [
                1340
            ],
            "__typename": [
                1
            ]
        },
        "UpdateLoanManualAccountingEventInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "accountingEventId": [
                15
            ],
            "amount": [
                5
            ],
            "memo": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateLoansInput": {
            "loans": [
                2273
            ],
            "data": [
                1341
            ],
            "__typename": [
                1
            ]
        },
        "UpdateLoansInputLoan": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "UpdateManualAssemblyInput": {
            "companyId": [
                15
            ],
            "id": [
                1
            ],
            "productId": [
                1
            ],
            "displayName": [
                1
            ],
            "date": [
                581
            ],
            "warehouseId": [
                1
            ],
            "unitsToAssemble": [
                41
            ],
            "recipe": [
                2294
            ],
            "__typename": [
                1
            ]
        },
        "UpdateManualAssemblyResult": {
            "on_ManualAssembly": [
                1373
            ],
            "on_RecipeCirclesFoundError": [
                1867
            ],
            "on_RecipeAllocatedCostsError": [
                1864
            ],
            "__typename": [
                1
            ]
        },
        "UpdateManualLoanEventInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "loanEventId": [
                15
            ],
            "eventDefinitionId": [
                15
            ],
            "amount": [
                5
            ],
            "memo": [
                1
            ],
            "postedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "UpdateManualLoanEventInput2": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "loanEventId": [
                15
            ],
            "eventDefinitionId": [
                15
            ],
            "amount": [
                5
            ],
            "memo": [
                1
            ],
            "postedAt": [
                581
            ],
            "recurrenceSettings": [
                1887
            ],
            "spreadInput": [
                535
            ],
            "__typename": [
                1
            ]
        },
        "UpdateManualLoanEventResult": {
            "loan": [
                1287
            ],
            "__typename": [
                1
            ]
        },
        "UpdateManualLoanEventsResult": {
            "loan": [
                1287
            ],
            "__typename": [
                1
            ]
        },
        "UpdateNoUnitsPhysicalCountAttachmentInput": {
            "name": [
                1
            ],
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateNoUnitsPhysicalCountInput": {
            "id": [
                1
            ],
            "amount": [
                5
            ],
            "date": [
                581
            ],
            "companyId": [
                1
            ],
            "lastAckDiff": [
                5
            ],
            "lastAckClosingBalance": [
                5
            ],
            "attachments": [
                2280
            ],
            "note": [
                1
            ],
            "isDraft": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UpdateNoUnitsPhysicalCountProductQuantityPendingAdjustmentInput": {
            "productId": [
                1
            ],
            "quantity": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "UpdateNoUnitsPhysicalCountProductQuantityPendingAdjustmentsInput": {
            "physicalCountId": [
                1
            ],
            "companyId": [
                1
            ],
            "adjustments": [
                2282
            ],
            "__typename": [
                1
            ]
        },
        "UpdateOnboardingStatusInput": {
            "companyId": [
                15
            ],
            "scope": [
                1471
            ],
            "step": [
                1
            ],
            "status": [
                1476
            ],
            "__typename": [
                1
            ]
        },
        "UpdateOnDemandAssemblyCostsInput": {
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "UpdateOrderEntitiesInput": {
            "entityType": [
                1501
            ],
            "companyId": [
                1
            ],
            "entityIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "UpdateOrderGroupInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "postedAt": [
                581
            ],
            "orders": [
                1595
            ],
            "bankTransactions": [
                302
            ],
            "expenses": [
                1517
            ],
            "__typename": [
                1
            ]
        },
        "UpdateOrderGroupResponse": {
            "orderGroup": [
                1512
            ],
            "__typename": [
                1
            ]
        },
        "UpdateOrderPaymentGroupInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "postedAt": [
                581
            ],
            "orders": [
                1673
            ],
            "bankTransactions": [
                1651
            ],
            "expenses": [
                1654
            ],
            "__typename": [
                1
            ]
        },
        "UpdateOrderPaymentGroupResponse": {
            "paymentGroup": [
                1552
            ],
            "__typename": [
                1
            ]
        },
        "UpdatePayrollSettingsInput": {
            "companyId": [
                15
            ],
            "withCategoryMapping": [
                7
            ],
            "categoryMappingMode": [
                1703
            ],
            "categoryMappings": [
                1702
            ],
            "__typename": [
                1
            ]
        },
        "UpdateProductFractionalInput": {
            "companyId": [
                1
            ],
            "productId": [
                1
            ],
            "isFractional": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UpdateProductInput": {
            "companyId": [
                1
            ],
            "productId": [
                1
            ],
            "displayName": [
                1
            ],
            "imageUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateRecipeInput": {
            "companyId": [
                15
            ],
            "id": [
                1
            ],
            "from": [
                581
            ],
            "to": [
                581
            ],
            "isAssembledOnDemand": [
                7
            ],
            "productId": [
                1
            ],
            "warehouseId": [
                1
            ],
            "components": [
                1870
            ],
            "allocatedCosts": [
                1863
            ],
            "managementMethod": [
                1871
            ],
            "displayName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateRecipeResult": {
            "on_Recipe": [
                1861
            ],
            "on_RecipeCirclesFoundError": [
                1867
            ],
            "on_RecipeOverlappingError": [
                1872
            ],
            "on_RecipeAllocatedCostsError": [
                1864
            ],
            "__typename": [
                1
            ]
        },
        "UpdateSalesChannelInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "financialReportingStatus": [
                752
            ],
            "periods": [
                1949
            ],
            "__typename": [
                1
            ]
        },
        "UpdateSharedGoogleDriveFolder": {
            "companyId": [
                15
            ],
            "folderId": [
                15
            ],
            "folderName": [
                1
            ],
            "folderUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateUnitsTrackingPhysicalCountAttachmentInput": {
            "name": [
                1
            ],
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateUnitsTrackingPhysicalCountInput": {
            "id": [
                15
            ],
            "date": [
                581
            ],
            "warehouseId": [
                1
            ],
            "companyId": [
                1
            ],
            "attachments": [
                2298
            ],
            "note": [
                1
            ],
            "isDraft": [
                7
            ],
            "lastAckClosingBalance": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "UpdateUnitsTrackingPhysicalCountProductQuantityPendingAdjustmentInput": {
            "productId": [
                1
            ],
            "quantity": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "UpdateUnitsTrackingPhysicalCountProductQuantityPendingAdjustmentsInput": {
            "companyId": [
                1
            ],
            "physicalCountId": [
                1
            ],
            "adjustments": [
                2300
            ],
            "__typename": [
                1
            ]
        },
        "UpdateUserDetailsArgs": {
            "id": [
                15
            ],
            "email": [
                1
            ],
            "name": [
                1
            ],
            "auth0Id": [
                1
            ],
            "welcomeReportTransactionsMessageMarkedAsHiddenAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "UpdateUserDetailsResponse": {
            "user": [
                2333
            ],
            "__typename": [
                1
            ]
        },
        "UpdateUserRolesForCompanyArgs": {
            "email": [
                1
            ],
            "roles": [
                1
            ],
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateUserRolesForCompanyResponse": {
            "success": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UpdateVendorInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "source": [
                2386
            ],
            "name": [
                1
            ],
            "logoUrl": [
                1
            ],
            "labels": [
                1
            ],
            "subTypes": [
                2388
            ],
            "is1099Contractor": [
                7
            ],
            "externalSourceId": [
                1
            ],
            "contactEmail": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpdateWarehouseFieldsInput": {
            "name": [
                1
            ],
            "phone": [
                1
            ],
            "city": [
                1
            ],
            "province": [
                1
            ],
            "country": [
                1
            ],
            "zip": [
                1
            ],
            "address": [
                1
            ],
            "isDefault": [
                7
            ],
            "isActive": [
                7
            ],
            "userGivenName": [
                1
            ],
            "isDropshipping": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UpdateWarehouseInput": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "updateFields": [
                2307
            ],
            "__typename": [
                1
            ]
        },
        "UpdateWarehouseNegativesAdjustmentInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "productId": [
                1
            ],
            "warehouseId": [
                1
            ],
            "totalQuantity": [
                5
            ],
            "costPerUnit": [
                5
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "datesToFix": [
                585
            ],
            "__typename": [
                1
            ]
        },
        "UpdateWarehousesDefaultsInput": {
            "companyId": [
                15
            ],
            "defaults": [
                2427
            ],
            "__typename": [
                1
            ]
        },
        "UpdateWarehouseTransferInput": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "serialNumber": [
                41
            ],
            "displayName": [
                1
            ],
            "transit": [
                2464
            ],
            "lineItems": [
                2452
            ],
            "costLineItems": [
                2447
            ],
            "attachments": [
                2440
            ],
            "notes": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UploadableIntegrationType": {},
        "UploadBankStatementInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                15
            ],
            "s3Bucket": [
                1
            ],
            "s3Key": [
                1
            ],
            "fileName": [
                1
            ],
            "fileType": [
                182
            ],
            "system": [
                246
            ],
            "subSystem": [
                244
            ],
            "validationProvider": [
                245
            ],
            "uploadedBy": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UploadBankStatementResponse": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "bankAccount": [
                161
            ],
            "providerValidationResults": [
                267
            ],
            "__typename": [
                1
            ]
        },
        "UploadedInvoice": {
            "invoiceNumber": [
                1
            ],
            "externalSourceId": [
                1
            ],
            "invoiceId": [
                1
            ],
            "error": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UploadFileToBankReconciliationRequestInput": {
            "companyId": [
                15
            ],
            "requestId": [
                15
            ],
            "statementFile": [
                2107
            ],
            "originalFileId": [
                1
            ],
            "isAutomaticProcessing": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UploadInvoicesFromCSVInput": {
            "companyId": [
                1
            ],
            "csvLink": [
                1
            ],
            "shouldCreateInvoices": [
                7
            ],
            "newSource": [
                1447
            ],
            "newCompanyIntegration": [
                1445
            ],
            "existingCompanyIntegration": [
                686
            ],
            "fileExportDate": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UploadReportedTransactionsInput": {
            "companyId": [
                15
            ],
            "bankAccountId": [
                1
            ],
            "statementFiles": [
                2107
            ],
            "companyAffiliateType": [
                427
            ],
            "companyAffiliateId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpsertAccrualInput": {
            "companyId": [
                15
            ],
            "entityType": [
                21
            ],
            "entityId": [
                15
            ],
            "accrualsData": [
                19
            ],
            "categorizations": [
                16
            ],
            "__typename": [
                1
            ]
        },
        "UpsertBankTransactionLocalRuleInput": {
            "companyId": [
                15
            ],
            "bankTransactionId": [
                15
            ],
            "classification": [
                279
            ],
            "classifications": [
                279
            ],
            "moneyDirection": [
                2079
            ],
            "merchant": [
                1409
            ],
            "shouldAlwaysApplyMerchant": [
                7
            ],
            "shouldAlwaysApplyClassification": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UpsertCompanyAddressInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "isDefault": [
                7
            ],
            "deactivatedAt": [
                581
            ],
            "name": [
                1
            ],
            "source": [
                1
            ],
            "email": [
                1
            ],
            "phone": [
                1
            ],
            "line1": [
                1
            ],
            "line2": [
                1
            ],
            "city": [
                1
            ],
            "province": [
                1
            ],
            "provinceCode": [
                1
            ],
            "state": [
                1
            ],
            "stateCode": [
                1
            ],
            "country": [
                1
            ],
            "zip": [
                1
            ],
            "finaloopSubjectId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpsertCustomerAddressArgs": {
            "id": [
                1
            ],
            "customerId": [
                1
            ],
            "companyId": [
                1
            ],
            "line1": [
                1
            ],
            "line2": [
                1
            ],
            "city": [
                1
            ],
            "country": [
                1
            ],
            "countryCode": [
                1
            ],
            "province": [
                1
            ],
            "provinceCode": [
                1
            ],
            "zip": [
                1
            ],
            "state": [
                1
            ],
            "stateCode": [
                1
            ],
            "source": [
                562
            ],
            "integrationAccountId": [
                1
            ],
            "isBilling": [
                7
            ],
            "isShipping": [
                7
            ],
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "UpsertCustomerV2Args": {
            "id": [
                1
            ],
            "affiliatedEntityId": [
                1
            ],
            "companyId": [
                1
            ],
            "name": [
                1
            ],
            "email": [
                1
            ],
            "source": [
                562
            ],
            "integrationAccountId": [
                1
            ],
            "billingAddress": [
                556
            ],
            "shippingAddress": [
                556
            ],
            "billingIsSameAsShipping": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UpsertGlobalVendorInput": {
            "id": [
                15
            ],
            "name": [
                1
            ],
            "source": [
                2386
            ],
            "websiteUrl": [
                1
            ],
            "labels": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpsertHolderCapitalInvestmentInput": {
            "id": [
                15
            ],
            "holderId": [
                15
            ],
            "companyId": [
                15
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "UpsertHolderShareInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "holderId": [
                15
            ],
            "type": [
                2035
            ],
            "series": [
                1
            ],
            "amount": [
                5
            ],
            "parValue": [
                5
            ],
            "quantity": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "UpsertIntegrationCustomerArgs": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "name": [
                1
            ],
            "email": [
                1
            ],
            "source": [
                562
            ],
            "integrationAccountId": [
                1
            ],
            "finaloopSubjectId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpsertIntegrationInvoiceInput": {
            "companyId": [
                15
            ],
            "companyAddress": [
                1083
            ],
            "shippingAddress": [
                1087
            ],
            "billingAddress": [
                1087
            ],
            "customer": [
                1088
            ],
            "payments": [
                1097
            ],
            "refunds": [
                1097
            ],
            "paymentIndications": [
                1092
            ],
            "refundIndications": [
                1092
            ],
            "credits": [
                1097
            ],
            "externalSourceId": [
                15
            ],
            "externalSourceUrl": [
                1
            ],
            "source": [
                1096
            ],
            "integrationAccountId": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "displayName": [
                1
            ],
            "postedAt": [
                581
            ],
            "dueDate": [
                581
            ],
            "taxFixedAmount": [
                5
            ],
            "lineItems": [
                1094
            ],
            "discounts": [
                1089
            ],
            "customerNote": [
                1
            ],
            "issueInvoice": [
                7
            ],
            "voidedAt": [
                581
            ],
            "uncollectibleAt": [
                581
            ],
            "deletedAt": [
                581
            ],
            "currency": [
                549
            ],
            "__typename": [
                1
            ]
        },
        "UpsertInvoiceInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "companyAddressId": [
                15
            ],
            "customerId": [
                15
            ],
            "shippingAddressId": [
                15
            ],
            "billingAddressId": [
                15
            ],
            "displayName": [
                1
            ],
            "postedAt": [
                581
            ],
            "dueDate": [
                581
            ],
            "taxFixedAmount": [
                5
            ],
            "taxType": [
                1963
            ],
            "lineItems": [
                1924
            ],
            "discounts": [
                652
            ],
            "paymentMethodIds": [
                15
            ],
            "customerNote": [
                1
            ],
            "issueInvoice": [
                7
            ],
            "sendInvoice": [
                7
            ],
            "createPaymentLink": [
                7
            ],
            "source": [
                1961
            ],
            "currency": [
                549
            ],
            "uploadId": [
                1
            ],
            "uploadDate": [
                581
            ],
            "emailNote": [
                1
            ],
            "ccList": [
                1
            ],
            "purchaseOrderNumber": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UpsertInvoiceSettingsInput": {
            "companyId": [
                15
            ],
            "logoImageLocation": [
                1
            ],
            "currentAutoInvoiceNumber": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "UpsertManualEquityEventInput": {
            "id": [
                15
            ],
            "holderId": [
                15
            ],
            "companyId": [
                15
            ],
            "amount": [
                5
            ],
            "businessEvent": [
                1
            ],
            "configurationId": [
                15
            ],
            "memo": [
                1
            ],
            "postedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "UpsertPaymentMethodInput": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "type": [
                1691
            ],
            "isDefault": [
                7
            ],
            "deletedAt": [
                581
            ],
            "instructions": [
                1
            ],
            "bankName": [
                1
            ],
            "accountNumber": [
                1
            ],
            "routingNumber": [
                1
            ],
            "swift": [
                1
            ],
            "source": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "User": {
            "id": [
                15
            ],
            "email": [
                1
            ],
            "auth0Id": [
                1
            ],
            "name": [
                1
            ],
            "companies": [
                2340
            ],
            "permissions": [
                1756
            ],
            "globalRole": [
                1
            ],
            "welcomeReportTransactionsMessageMarkedAsHiddenAt": [
                581
            ],
            "intercomJwt": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UserAttachTransactionsToExistingLoanInput": {
            "companyId": [
                15
            ],
            "loanId": [
                15
            ],
            "transactions": [
                141
            ],
            "__typename": [
                1
            ]
        },
        "UserAttachTransactionsToLoansInput": {
            "companyId": [
                15
            ],
            "transactions": [
                2169
            ],
            "newLoans": [
                2336
            ],
            "__typename": [
                1
            ]
        },
        "UserAttachTransactionsToNewLoanData": {
            "loanId": [
                15
            ],
            "lenderId": [
                1
            ],
            "amount": [
                5
            ],
            "postedAt": [
                581
            ],
            "direction": [
                1307
            ],
            "isShortTerm": [
                7
            ],
            "type": [
                1339
            ],
            "userActionStatus": [
                1343
            ],
            "__typename": [
                1
            ]
        },
        "UserAttachTransactionsToNewLoanInput": {
            "companyId": [
                15
            ],
            "transactions": [
                141
            ],
            "merchant": [
                1320
            ],
            "newLoanData": [
                2336
            ],
            "__typename": [
                1
            ]
        },
        "UserByEmailArgs": {
            "email": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UserByEmailResponse": {
            "user": [
                2333
            ],
            "__typename": [
                1
            ]
        },
        "UserCompanies": {
            "company": [
                418
            ],
            "roles": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "UserFollowUp": {
            "type": [
                1344
            ],
            "data": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "UserFollowUpInput": {
            "type": [
                1344
            ],
            "data": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "userIdInput": {
            "email": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UserInvitation": {
            "id": [
                15
            ],
            "email": [
                1
            ],
            "companyId": [
                15
            ],
            "roles": [
                1
            ],
            "invitedByUserId": [
                1
            ],
            "invitationCode": [
                1
            ],
            "acceptedAt": [
                581
            ],
            "cancelledBy": [
                1
            ],
            "cancelledAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "UserInvitationArgs": {
            "invitationCode": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UserInvitationResponse": {
            "userInvitation": [
                2349
            ],
            "__typename": [
                1
            ]
        },
        "UserInvitationsByEmailArgs": {
            "email": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UserInvitationsByEmailResponse": {
            "userInvitations": [
                2349
            ],
            "__typename": [
                1
            ]
        },
        "UserInvitationWithCompany": {
            "id": [
                15
            ],
            "email": [
                1
            ],
            "company": [
                418
            ],
            "roles": [
                1
            ],
            "invitedByUserId": [
                1
            ],
            "invitationCode": [
                1
            ],
            "acceptedAt": [
                581
            ],
            "cancelledBy": [
                1
            ],
            "cancelledAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "UserManualProduct": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "finaloopId": [
                1
            ],
            "lineOfBusinessId": [
                1
            ],
            "sku": [
                1
            ],
            "price": [
                5
            ],
            "displayName": [
                1
            ],
            "imageUrl": [
                1
            ],
            "listedChannels": [
                1940
            ],
            "appliedCosts": [
                1771
            ],
            "dailySalesData": [
                1942,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "totalSold": [
                41
            ],
            "avgCostPerUnit": [
                5
            ],
            "canEditLatestAppliedCost": [
                7
            ],
            "isFractional": [
                7
            ],
            "isHidden": [
                7
            ],
            "salesData": [
                1959,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "rawRecipes": [
                1861,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "componentOfProducts": [
                1769
            ],
            "isAmbiguousSku": [
                7
            ],
            "analyticsOverview": [
                1770,
                {
                    "input": [
                        110
                    ]
                }
            ],
            "warehousesAnalyticsOverview": [
                1837,
                {
                    "input": [
                        110
                    ]
                }
            ],
            "tags": [
                1
            ],
            "isDataSyncing": [
                7
            ],
            "mergeHistory": [
                1799
            ],
            "isDropshipping": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "UserNameFromReferralCodeInput": {
            "referralCode": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UserNameFromReferralCodeResponse": {
            "userName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UserReferralLinkArgs": {
            "companyId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UserReferralLinkResponse": {
            "referralLink": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UserRole": {
            "id": [
                1
            ],
            "name": [
                1
            ],
            "description": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UserRolesResponse": {
            "userRoles": [
                2355
            ],
            "__typename": [
                1
            ]
        },
        "UsersByEmailsArgs": {
            "emails": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "UsersByEmailsResponse": {
            "users": [
                2333
            ],
            "__typename": [
                1
            ]
        },
        "UserUnresponsive": {
            "value": [
                7
            ],
            "history": [
                338
            ],
            "__typename": [
                1
            ]
        },
        "ValidateInventoryPaymentGroupByEntityInput": {
            "companyId": [
                15
            ],
            "purchaseOrderId": [
                1
            ],
            "warehouseTransferId": [
                1
            ],
            "inventoryPurchaseId": [
                1
            ],
            "bankTransactionId": [
                1
            ],
            "billId": [
                1
            ],
            "payrollId": [
                1
            ],
            "perVendorBreakdown": [
                1757
            ],
            "__typename": [
                1
            ]
        },
        "ValidateInventoryPaymentGroupByEntityResponse": {
            "canceledInventoryPaymentGroups": [
                1118
            ],
            "__typename": [
                1
            ]
        },
        "ValidateInventoryPaymentGroupOnEntityChangeInput": {
            "companyId": [
                15
            ],
            "purchaseOrderId": [
                15
            ],
            "warehouseTransferId": [
                15
            ],
            "inventoryPurchaseId": [
                15
            ],
            "manualAssemblyId": [
                15
            ],
            "onDemandAssemblyVendorCostId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "Validation": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "ValidationCycle": {
            "id": [
                1
            ],
            "status": [
                2365
            ],
            "executionId": [
                1
            ],
            "finishedCount": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "ValidationCycleStatus": {},
        "ValidationFailingCompany": {
            "company": [
                418
            ],
            "fiscalYear": [
                41
            ],
            "createdAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ValidationRemediation": {
            "company": [
                418
            ],
            "status": [
                1
            ],
            "validationFiscalYear": [
                41
            ],
            "buggyDateStatus": [
                1
            ],
            "buggyDate": [
                581
            ],
            "bugDescription": [
                1
            ],
            "updatedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "ValidationRemediationsResponse": {
            "validationRemediations": [
                2367
            ],
            "__typename": [
                1
            ]
        },
        "ValidationResult": {
            "companyId": [
                1
            ],
            "integrationType": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "currency": [
                1
            ],
            "accountRoles": [
                1
            ],
            "accountingMethod": [
                1
            ],
            "resultSet": [
                2370
            ],
            "__typename": [
                1
            ]
        },
        "ValidationResultSet": {
            "createdAt": [
                581
            ],
            "sampleDate": [
                581
            ],
            "sampleValue": [
                5
            ],
            "currentValue": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "ValidationsArgs": {
            "integrationType": [
                1
            ],
            "accountRole": [
                1
            ],
            "resultsLimit": [
                41
            ],
            "payingCompaniesOnly": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ValidationTemplate": {
            "id": [
                1
            ],
            "domain": [
                470
            ],
            "type": [
                475
            ],
            "endTime": [
                2373
            ],
            "isEnabled": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "ValidationTemplateEndTime": {},
        "ValueType": {},
        "Vendor": {
            "id": [
                15
            ],
            "integrationType": [
                1113
            ],
            "name": [
                1
            ],
            "companyId": [
                15
            ],
            "externalSourceId": [
                1
            ],
            "websiteUrl": [
                1
            ],
            "logoUrl": [
                1
            ],
            "source": [
                2386
            ],
            "labels": [
                1
            ],
            "contactEmail": [
                1
            ],
            "is1099Contractor": [
                7
            ],
            "type": [
                2389
            ],
            "subType": [
                2388
            ],
            "affiliatedEntityId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "VendorByAffiliatedEntityIdInput": {
            "affiliatedEntityId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "VendorByIdInput": {
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "VendorByNameInput": {
            "name": [
                1
            ],
            "companyId": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "VendorByPaymentGatewayInput": {
            "paymentGateway": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "VendorByPaymentGatewayResponse": {
            "vendor": [
                2375
            ],
            "__typename": [
                1
            ]
        },
        "VendorNotExistError": {
            "message": [
                1
            ],
            "id": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "VendorOrCustomer": {
            "on_Vendor": [
                2375
            ],
            "on_CustomerV2": [
                563
            ],
            "__typename": [
                1
            ]
        },
        "VendorsByIntegrationTypeInput": {
            "integrationType": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "VendorsInput": {
            "searchTerm": [
                1
            ],
            "limit": [
                41
            ],
            "companyId": [
                15
            ],
            "subTypes": [
                2388
            ],
            "__typename": [
                1
            ]
        },
        "VendorsNotificationInfoInput": {
            "subTypes": [
                2388
            ],
            "purchaseOrderId": [
                1
            ],
            "purchaseOrderGroup": [
                1
            ],
            "logrocketSessionUrl": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "VendorSource": {},
        "VendorsTransactionsCount": {
            "id": [
                1
            ],
            "amount": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "VendorSubType": {},
        "VendorType": {},
        "ViewTypes": {},
        "VoidOrderSettings": {
            "restrictedPaymentGateways": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "VoidOrdersInput": {
            "companyId": [
                15
            ],
            "orderIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "VoidOrdersResponse": {
            "orders": [
                1602
            ],
            "failedIds": [
                15
            ],
            "__typename": [
                1
            ]
        },
        "VoidStatus": {},
        "WalmartProduct": {
            "id": [
                1
            ],
            "companyId": [
                1
            ],
            "finaloopId": [
                1
            ],
            "lineOfBusinessId": [
                1
            ],
            "sku": [
                1
            ],
            "price": [
                5
            ],
            "displayName": [
                1
            ],
            "imageUrl": [
                1
            ],
            "listedChannels": [
                1940
            ],
            "appliedCosts": [
                1771
            ],
            "dailySalesData": [
                1942,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "totalSold": [
                41
            ],
            "avgCostPerUnit": [
                5
            ],
            "canEditLatestAppliedCost": [
                7
            ],
            "walmartId": [
                1
            ],
            "productUrl": [
                1
            ],
            "isFractional": [
                7
            ],
            "isHidden": [
                7
            ],
            "salesData": [
                1959,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "rawRecipes": [
                1861,
                {
                    "timeRange": [
                        1789,
                        "ProductDataTimeRangeInput!"
                    ]
                }
            ],
            "componentOfProducts": [
                1769
            ],
            "isAmbiguousSku": [
                7
            ],
            "analyticsOverview": [
                1770,
                {
                    "input": [
                        110
                    ]
                }
            ],
            "warehousesAnalyticsOverview": [
                1837,
                {
                    "input": [
                        110
                    ]
                }
            ],
            "tags": [
                1
            ],
            "isCreatedManually": [
                7
            ],
            "isDataSyncing": [
                7
            ],
            "mergeHistory": [
                1799
            ],
            "isDropshipping": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "Warehouse": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "name": [
                1
            ],
            "source": [
                1
            ],
            "phone": [
                1
            ],
            "city": [
                1
            ],
            "province": [
                1
            ],
            "country": [
                1
            ],
            "zip": [
                1
            ],
            "address": [
                1
            ],
            "isDeletable": [
                7
            ],
            "isActive": [
                7
            ],
            "primaryWarehouse": [
                2396
            ],
            "isDropshipping": [
                7
            ],
            "isDropshippingFrom": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "on_AdjustmentRestockingAction": [
                65
            ],
            "on_CommonAction": [
                416
            ],
            "on_DeadInventoryAction": [
                586
            ],
            "on_FulfillmentAction": [
                759
            ],
            "on_ManualAssemblyAction": [
                1374
            ],
            "on_OnDemandAssemblyAction": [
                1477
            ],
            "on_OpeningBalanceAction": [
                1486
            ],
            "on_OtherFbaAction": [
                1609
            ],
            "on_RestockingAction": [
                1911
            ],
            "on_ShipmentAction": [
                2037
            ],
            "on_UnitFoundAction": [
                2188
            ],
            "on_UnitLostAction": [
                2189
            ],
            "on_WarehouseNegativesAdjustmentAction": [
                2411
            ],
            "on_WarehouseTransferArrivalAction": [
                2437
            ],
            "on_WarehouseTransferShippingAction": [
                2455
            ],
            "on_WasteAction": [
                2466
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseActionSalesChannel": {
            "integrationType": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseCreateError": {
            "message": [
                1
            ],
            "type": [
                2400
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseCreateErrorTypeEnum": {},
        "WarehouseCreateResult": {
            "on_Warehouse": [
                2396
            ],
            "on_WarehouseCreateError": [
                2399
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseFilter": {
            "type": [
                2403
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseFilterType": {},
        "WarehouseIncomingInventoryBreakdownFiltersInput": {
            "hasUnavailable": [
                7
            ],
            "searchText": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseIncomingInventoryBreakdownInput": {
            "companyId": [
                15
            ],
            "productId": [
                1
            ],
            "warehouseId": [
                1
            ],
            "sort": [
                2433
            ],
            "limit": [
                41
            ],
            "offset": [
                41
            ],
            "filters": [
                2404
            ],
            "date": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseIncomingInventoryBreakdownResult": {
            "incomingBatches": [
                1060
            ],
            "totalBatches": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseIncomingInventoryOverviewInput": {
            "companyId": [
                15
            ],
            "productId": [
                1
            ],
            "date": [
                581
            ],
            "fromDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseIncomingInventoryOverviewResult": {
            "warehouse": [
                2396
            ],
            "analytics": [
                1062
            ],
            "inTransit": [
                41
            ],
            "openingBalance": [
                2413
            ],
            "totalBatches": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseMovements": {
            "warehouse": [
                2396
            ],
            "movements": [
                1439
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseNegativesAdjustment": {
            "id": [
                15
            ],
            "productId": [
                1
            ],
            "warehouseId": [
                1
            ],
            "totalQuantity": [
                5
            ],
            "costPerUnit": [
                5
            ],
            "datesToFix": [
                584
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseNegativesAdjustmentAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "warehouseNegativeAdjustment": [
                2410
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseNegativesAdjustmentBreakdown": {
            "warehouseNegativesAdjustment": [
                2410
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseOpeningBalance": {
            "id": [
                15
            ],
            "warehouse": [
                2396
            ],
            "product": [
                1769
            ],
            "quantity": [
                5
            ],
            "costPerUnit": [
                5
            ],
            "date": [
                581
            ],
            "isMissingUserInput": [
                7
            ],
            "attachmentId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseOpeningBalanceErrorItem": {
            "rowNumber": [
                41
            ],
            "cellNumber": [
                41
            ],
            "errorType": [
                2415
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseOpeningBalanceErrorItemType": {},
        "WarehouseOpeningBalanceItem": {
            "product": [
                1769
            ],
            "warehouseOpeningBalance": [
                2413
            ],
            "pendingWarehouseOpeningBalance": [
                1748
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseOpeningBalanceOverviewResponse": {
            "count": [
                41
            ],
            "pendingCount": [
                41
            ],
            "missingDataCount": [
                41
            ],
            "totalCost": [
                5
            ],
            "minQuantity": [
                5
            ],
            "maxQuantity": [
                5
            ],
            "minCostPerUnit": [
                5
            ],
            "maxCostPerUnit": [
                5
            ],
            "lastPendingChange": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseOpeningBalancesCsvResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseOpeningBalancesCsvTemplateResponse": {
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseOpeningBalanceSort": {
            "field": [
                2421
            ],
            "direction": [
                2094
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseOpeningBalanceSortField": {},
        "WarehouseOpeningBalancesResponse": {
            "items": [
                2416
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseResult": {
            "data": [
                2396
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseSalesData": {
            "warehouse": [
                2396
            ],
            "salesChannels": [
                1950
            ],
            "deadInventory": [
                587
            ],
            "giveaway": [
                1005
            ],
            "giveawayDropshipping": [
                1005
            ],
            "donation": [
                658
            ],
            "lostAndFound": [
                1358
            ],
            "otherFba": [
                1610
            ],
            "waste": [
                2467
            ],
            "supplierReturn": [
                1831
            ],
            "salesAdjustments": [
                1819
            ],
            "deadInventoryAdjustments": [
                1791
            ],
            "giveawayAdjustments": [
                1795
            ],
            "giveawayDropshippingAdjustments": [
                1795
            ],
            "donationAdjustments": [
                1793
            ],
            "lostAndFoundAdjustments": [
                1798
            ],
            "otherFbaAdjustments": [
                1812
            ],
            "supplierReturnAdjustments": [
                1835
            ],
            "__typename": [
                1
            ]
        },
        "WarehousesDefaults": {
            "integrationType": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "warehouse": [
                2396
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "WarehousesDefaultsError": {
            "errors": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "WarehousesDefaultsInput": {
            "integrationType": [
                1
            ],
            "integrationAccountName": [
                1
            ],
            "integrationAccountId": [
                1
            ],
            "warehouseId": [
                1
            ],
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "WarehousesDefaultsResponse": {
            "on_WarehousesDefaultsResult": [
                2429
            ],
            "on_WarehousesDefaultsError": [
                2426
            ],
            "__typename": [
                1
            ]
        },
        "WarehousesDefaultsResult": {
            "companyId": [
                15
            ],
            "defaults": [
                2425
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseSource": {},
        "WarehousesProductPurchasesBreakdownSortDirection": {},
        "WarehousesProductPurchasesBreakdownSortField": {},
        "WarehousesProductPurchasesBreakdownSortInput": {
            "field": [
                2432
            ],
            "direction": [
                2431
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTimeRangeInput": {
            "startDate": [
                581
            ],
            "endDate": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransfer": {
            "id": [
                15
            ],
            "companyId": [
                15
            ],
            "serialNumber": [
                41
            ],
            "displayName": [
                1
            ],
            "transit": [
                2463
            ],
            "lineItems": [
                2449
            ],
            "costLineItems": [
                2446
            ],
            "attachments": [
                2439
            ],
            "status": [
                2462
            ],
            "notes": [
                1
            ],
            "deletedAt": [
                581
            ],
            "productsCost": [
                5
            ],
            "transferCost": [
                5
            ],
            "totalCost": [
                5
            ],
            "isHistorical": [
                7
            ],
            "inventoryPaymentGroupLinks": [
                1121
            ],
            "unpaidAmounts": [
                2211
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferArrival": {
            "date": [
                581
            ],
            "warehouse": [
                2396
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferArrivalAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "warehouseTransfer": [
                2435
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferArrivalInput": {
            "date": [
                581
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferAttachment": {
            "filename": [
                1
            ],
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferAttachmentInput": {
            "filename": [
                1
            ],
            "url": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferBatchHistoryItem": {
            "action": [
                2397
            ],
            "landedCost": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferBreakdownBatch": {
            "quantity": [
                5
            ],
            "history": [
                2441
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferBreakdownItem": {
            "action": [
                2397
            ],
            "quantity": [
                5
            ],
            "landedCost": [
                5
            ],
            "batches": [
                2442
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferCostAllocation": {
            "costLineItemId": [
                1
            ],
            "costPerUnit": [
                5
            ],
            "lastUnitCost": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferCostAllocationInput": {
            "costLineItemId": [
                1
            ],
            "costPerUnit": [
                5
            ],
            "lastUnitCost": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferCostLineItem": {
            "id": [
                1
            ],
            "type": [
                2448
            ],
            "amount": [
                5
            ],
            "vendor": [
                2375
            ],
            "isManuallyAllocated": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferCostLineItemInput": {
            "id": [
                1
            ],
            "type": [
                2448
            ],
            "amount": [
                5
            ],
            "vendorId": [
                1
            ],
            "isManuallyAllocated": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferCostLineItemType": {},
        "WarehouseTransferLineItem": {
            "id": [
                1
            ],
            "product": [
                1769
            ],
            "quantity": [
                5
            ],
            "lineItemIdx": [
                41
            ],
            "costAllocations": [
                2444
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferLineItemFifoCost": {
            "directCost": [
                5
            ],
            "indirectCosts": [
                2451
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferLineItemFifoIndirectCost": {
            "type": [
                1068
            ],
            "amount": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferLineItemInput": {
            "id": [
                1
            ],
            "productId": [
                1
            ],
            "quantity": [
                5
            ],
            "lineItemIdx": [
                41
            ],
            "costAllocations": [
                2445
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferOverviewItem": {
            "status": [
                2462
            ],
            "count": [
                41
            ],
            "totalCost": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferShipping": {
            "date": [
                581
            ],
            "warehouse": [
                2396
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferShippingAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "warehouseTransfer": [
                2435
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferShippingInput": {
            "date": [
                581
            ],
            "warehouseId": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransfersOverview": {
            "items": [
                2453
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransfersResponse": {
            "warehouseTransfers": [
                2435
            ],
            "hasNext": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransfersSortDirection": {},
        "WarehouseTransfersSortField": {},
        "WarehouseTransfersSortInput": {
            "field": [
                2460
            ],
            "direction": [
                2459
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferStatus": {},
        "WarehouseTransferTransit": {
            "shipping": [
                2454
            ],
            "arrival": [
                2436
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferTransitInput": {
            "shipping": [
                2456
            ],
            "arrival": [
                2438
            ],
            "__typename": [
                1
            ]
        },
        "WarehouseTransferWithBreakdown": {
            "warehouseTransfer": [
                2435
            ],
            "date": [
                581
            ],
            "items": [
                2443
            ],
            "__typename": [
                1
            ]
        },
        "WasteAction": {
            "quantity": [
                5
            ],
            "id": [
                1
            ],
            "date": [
                581
            ],
            "type": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "WasteCogs": {
            "amount": [
                5
            ],
            "quantity": [
                5
            ],
            "monthlyBreakdown": [
                2469
            ],
            "__typename": [
                1
            ]
        },
        "WasteDailyBreakdown": {
            "date": [
                581
            ],
            "quantity": [
                5
            ],
            "__typename": [
                1
            ]
        },
        "WasteMonthlyBreakdown": {
            "date": [
                581
            ],
            "quantity": [
                5
            ],
            "dailyData": [
                2468
            ],
            "__typename": [
                1
            ]
        },
        "Worksheet": {
            "worksheetRows": [
                2471
            ],
            "__typename": [
                1
            ]
        },
        "WorksheetRow": {
            "companyId": [
                1
            ],
            "dateForLocking": [
                581
            ],
            "name": [
                1
            ],
            "amount": [
                5
            ],
            "signedAmount": [
                5
            ],
            "comment": [
                1
            ],
            "signedAt": [
                581
            ],
            "signedBy": [
                1
            ],
            "signedByName": [
                1
            ],
            "attachmentUrl": [
                1
            ],
            "attachmentFileName": [
                1
            ],
            "lockableEntity": [
                478
            ],
            "periodStart": [
                581
            ],
            "periodEnd": [
                581
            ],
            "isPnl": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDependencies": {
            "companyId": [
                15
            ],
            "balanceSheet": [
                151
            ],
            "yearEnd": [
                2473
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDependency": {
            "blocked": [
                7
            ],
            "year": [
                41
            ],
            "resolvedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainMode": {},
        "YearEndDomainsStates": {
            "banks": [
                2487
            ],
            "transactions": [
                2487
            ],
            "unclassified_transactions": [
                2487
            ],
            "unmatched_payouts_and_transfers": [
                2487
            ],
            "payments": [
                2487
            ],
            "inventory": [
                2487
            ],
            "loans": [
                2487
            ],
            "equity": [
                2487
            ],
            "payroll": [
                2487
            ],
            "sales_tax": [
                2487
            ],
            "investments": [
                2487
            ],
            "security_deposits": [
                2487
            ],
            "accounting_and_tax_information": [
                2487
            ],
            "orders": [
                2487
            ],
            "invoices": [
                2487
            ],
            "bills": [
                2487
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainState": {},
        "YearEndDomainStateChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                2507
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                2476
            ],
            "newValue": [
                2476
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainStateDataChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                2507
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                1242
            ],
            "newValue": [
                1242
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainStateDataDeleteInput": {
            "companyId": [
                15
            ],
            "domain": [
                2490
            ],
            "dataKey": [
                1
            ],
            "updaterType": [
                2507
            ],
            "updatedBy": [
                1
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainStateDataDeleteResponse": {
            "deletedAt": [
                581
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainStateDataInput": {
            "companyId": [
                15
            ],
            "domain": [
                2490
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainStateDataResponse": {
            "id": [
                15
            ],
            "dataKey": [
                1
            ],
            "data": [
                1242
            ],
            "history": [
                2478
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainStateDataUpdateInput": {
            "companyId": [
                15
            ],
            "domain": [
                2490
            ],
            "dataKey": [
                1
            ],
            "data": [
                1242
            ],
            "updaterType": [
                2507
            ],
            "updatedBy": [
                1
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainStateDataUpdateResponse": {
            "id": [
                15
            ],
            "data": [
                1242
            ],
            "dataKey": [
                1
            ],
            "historyLog": [
                2478
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainStateDatumInput": {
            "companyId": [
                15
            ],
            "domain": [
                2490
            ],
            "dataKey": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainStateErrors": {},
        "YearEndDomainStateResponse": {
            "state": [
                2476
            ],
            "canSubmit": [
                7
            ],
            "history": [
                2477
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainStateUpdateInput": {
            "companyId": [
                15
            ],
            "domain": [
                2490
            ],
            "state": [
                2476
            ],
            "updatedBy": [
                1
            ],
            "updaterType": [
                2507
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainStateUpdateResponse": {
            "state": [
                2476
            ],
            "canSubmit": [
                7
            ],
            "historyLog": [
                2477
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainTypes": {},
        "YearEndDomainUpToDateState": {
            "companyId": [
                15
            ],
            "state": [
                2476
            ],
            "isEnabled": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "YearEndDomainUpToDateStates": {
            "companyId": [
                15
            ],
            "banks": [
                2491
            ],
            "unclassifiedTransactions": [
                2491
            ],
            "unmatchedPayoutsAndTransfers": [
                2491
            ],
            "transactions": [
                2491
            ],
            "unclassified_transactions": [
                2491
            ],
            "unmatched_payouts_and_transfers": [
                2491
            ],
            "bills": [
                2491
            ],
            "inventory": [
                2491
            ],
            "loans": [
                2491
            ],
            "orders": [
                2491
            ],
            "paymentsMissions": [
                2491
            ],
            "invoices": [
                2491
            ],
            "accountingAndTaxInformation": [
                2491
            ],
            "payroll": [
                2491
            ],
            "salesTax": [
                2491
            ],
            "securityDeposits": [
                2491
            ],
            "investments": [
                2491
            ],
            "equity": [
                2491
            ],
            "__typename": [
                1
            ]
        },
        "YearEndEmail": {
            "yearEndStateId": [
                1
            ],
            "value": [
                1
            ],
            "history": [
                2494
            ],
            "__typename": [
                1
            ]
        },
        "YearEndEmailChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                2507
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                1
            ],
            "newValue": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "YearEndIntercomLink": {
            "yearEndStateId": [
                1
            ],
            "value": [
                1
            ],
            "history": [
                2496
            ],
            "__typename": [
                1
            ]
        },
        "YearEndIntercomLinkChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                2507
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                1
            ],
            "newValue": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "YearEndInventoryMission": {
            "missionType": [
                1194
            ],
            "status": [
                1193
            ],
            "historyLog": [
                1190
            ],
            "managementMethodPeriod": [
                1367
            ],
            "on_PurchaseBasedClosingBalance": [
                1839
            ],
            "on_PurchaseBasedOpeningBalance": [
                1841
            ],
            "on_PurchaseBasedPurchases": [
                1843
            ],
            "on_SalesBasedClosingBalance": [
                1930
            ],
            "on_SalesBasedMissingCostPerUnit": [
                1932
            ],
            "on_SalesBasedOpeningBalance": [
                1934
            ],
            "on_SalesBasedPurchases": [
                1936
            ],
            "on_SalesBasedReportCogs": [
                1938
            ],
            "on_UnitBasedClosingBalance": [
                2181
            ],
            "on_UnitBasedNegativeOnHands": [
                2183
            ],
            "on_UnitBasedReportCogs": [
                2185
            ],
            "on_UnitBasedVendorsNegativeBalance": [
                2186
            ],
            "__typename": [
                1
            ]
        },
        "YearEndState": {},
        "YearEndStateAdditionalData": {
            "companyId": [
                15
            ],
            "accountingMethod": [
                1
            ],
            "legalEntityType": [
                1
            ],
            "taxEntityType": [
                1
            ],
            "entityTypeDescription": [
                1
            ],
            "fiscalYearEndDate": [
                581
            ],
            "fiscalYearStartDate": [
                581
            ],
            "finaloopDeadline": [
                581
            ],
            "finaloopLastCall": [
                581
            ],
            "filingDeadline": [
                581
            ],
            "extensionFiled": [
                7
            ],
            "daysFromFiscalEndDateToFilingDeadline": [
                41
            ],
            "salesTaxLiabilityOpeningBalance": [
                5
            ],
            "salesTaxLiabilityClosingBalance": [
                5
            ],
            "netSalesTaxCollected": [
                5
            ],
            "salesTaxPaymentToAuthorities": [
                5
            ],
            "securityDepositsClosingBalance": [
                5
            ],
            "investmentsGeneralClosingBalance": [
                5
            ],
            "payroll": [
                1711
            ],
            "__typename": [
                1
            ]
        },
        "YearEndStateChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                2507
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                2498
            ],
            "newValue": [
                2498
            ],
            "__typename": [
                1
            ]
        },
        "YearEndStateErrors": {},
        "YearEndStateInput": {
            "companyId": [
                15
            ],
            "year": [
                41
            ],
            "isCurrentFiscalYear": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "YearEndStateResponse": {
            "id": [
                15
            ],
            "companyId": [
                1
            ],
            "state": [
                2498
            ],
            "year": [
                41
            ],
            "domainsStates": [
                2475
            ],
            "domainsUpToDateStates": [
                2492
            ],
            "additionalData": [
                2499
            ],
            "history": [
                2500
            ],
            "isQualified": [
                7
            ],
            "isUserUnresponsive": [
                7
            ],
            "email": [
                2493
            ],
            "intercomLink": [
                2495
            ],
            "userUnresponsive": [
                2514
            ],
            "dependencies": [
                2472
            ],
            "isUnderReview": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "YearEndStatesInput": {
            "companyId": [
                15
            ],
            "includeLegacy": [
                7
            ],
            "__typename": [
                1
            ]
        },
        "YearEndStateUpdateInput": {
            "companyId": [
                15
            ],
            "year": [
                41
            ],
            "state": [
                2498
            ],
            "updatedBy": [
                1
            ],
            "updaterType": [
                2507
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "YearEndStateUpdateResponse": {
            "state": [
                2498
            ],
            "__typename": [
                1
            ]
        },
        "YearEndStateUpdaterType": {},
        "YearEndUpdateAdditionalFieldsInput": {
            "companyId": [
                15
            ],
            "isUserUnresponsive": [
                7
            ],
            "email": [
                1
            ],
            "intercomLink": [
                1
            ],
            "updatedBy": [
                1
            ],
            "updaterType": [
                2507
            ],
            "reason": [
                1
            ],
            "year": [
                41
            ],
            "__typename": [
                1
            ]
        },
        "YearEndUpdateAdditionalFieldsResponse": {
            "userUnresponsiveResponse": [
                2513
            ],
            "emailResponse": [
                2510
            ],
            "intercomLinkResponse": [
                2511
            ],
            "__typename": [
                1
            ]
        },
        "YearEndUpdateEmailResponse": {
            "email": [
                1
            ],
            "historyLog": [
                2494
            ],
            "__typename": [
                1
            ]
        },
        "YearEndUpdateIntercomLinkResponse": {
            "intercomLink": [
                1
            ],
            "historyLog": [
                2494
            ],
            "__typename": [
                1
            ]
        },
        "YearEndUpdateUserUnresponsiveInput": {
            "companyId": [
                15
            ],
            "isUserUnresponsive": [
                7
            ],
            "updatedBy": [
                1
            ],
            "updaterType": [
                2507
            ],
            "reason": [
                1
            ],
            "__typename": [
                1
            ]
        },
        "YearEndUpdateUserUnresponsiveResponse": {
            "isUserUnresponsive": [
                7
            ],
            "historyLog": [
                2515
            ],
            "__typename": [
                1
            ]
        },
        "YearEndUserUnresponsive": {
            "yearEndStateId": [
                1
            ],
            "value": [
                7
            ],
            "history": [
                2515
            ],
            "__typename": [
                1
            ]
        },
        "YearEndUserUnresponsiveChangeLog": {
            "id": [
                15
            ],
            "createdAt": [
                581
            ],
            "updaterType": [
                2507
            ],
            "changedByUid": [
                1
            ],
            "reason": [
                1
            ],
            "oldValue": [
                7
            ],
            "newValue": [
                7
            ],
            "__typename": [
                1
            ]
        }
    }
}